[
  {
    "tag": "1",
    "name": "Account",
    "type": "String",
    "description": "Account mnemonic as agreed between buy and sell sides, e.g. broker and institution or investor/intermediary and fund manager."
  },
  {
    "tag": "2",
    "name": "AdvId",
    "type": "String",
    "description": "Unique identifier of advertisement message.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "3",
    "name": "AdvRefID",
    "type": "String",
    "description": "Reference identifier used with CANCEL and REPLACE transaction types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "4",
    "name": "AdvSide",
    "type": "char",
    "description": "Broker's side of advertised trade",
    "enum": [
      {
        "value": "B",
        "symbolicName": "Buy",
        "description": "Buy"
      },
      {
        "value": "S",
        "symbolicName": "Sell",
        "description": "Sell"
      },
      {
        "value": "T",
        "symbolicName": "Trade",
        "description": "Trade"
      },
      {
        "value": "X",
        "symbolicName": "Cross",
        "description": "Cross"
      }
    ]
  },
  {
    "tag": "5",
    "name": "AdvTransType",
    "type": "String",
    "description": "Identifies advertisement message transaction type",
    "enum": [
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "6",
    "name": "AvgPx",
    "type": "Price",
    "description": "Calculated average price of all fills on this order.\nFor Fixed Income trades AvgPx is always expressed as percent-of-par, regardless of the PriceType (423) of LastPx (31). I.e., AvgPx will contain an average of percent-of-par values (see LastParPx (669)) for issues traded in Yield, Spread or Discount."
  },
  {
    "tag": "7",
    "name": "BeginSeqNo",
    "type": "SeqNum",
    "description": "Message sequence number of first message in range to be resent"
  },
  {
    "tag": "8",
    "name": "BeginString",
    "type": "String",
    "description": "Identifies beginning of new message and protocol version. ALWAYS FIRST FIELD IN MESSAGE. (Always unencrypted)\nValid values:\nFIXT.1.1"
  },
  {
    "tag": "9",
    "name": "BodyLength",
    "type": "Length",
    "description": "Message length, in bytes, forward to the CheckSum field. ALWAYS SECOND FIELD IN MESSAGE. (Always unencrypted)"
  },
  {
    "tag": "10",
    "name": "CheckSum",
    "type": "String",
    "description": "Three byte, simple checksum (see Volume 2: \"Checksum Calculation\" for description). ALWAYS LAST FIELD IN MESSAGE; i.e. serves, with the trailing <SOH>, as the end-of-message delimiter. Always defined as three characters. (Always unencrypted)"
  },
  {
    "tag": "11",
    "name": "ClOrdID",
    "type": "String",
    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID (49) or OnBehalfOfCompID (5) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID field."
  },
  {
    "tag": "12",
    "name": "Commission",
    "type": "Amt",
    "description": "Commission. Note if CommType (13) is percentage, Commission of 5% should be represented as .05."
  },
  {
    "tag": "13",
    "name": "CommType",
    "type": "char",
    "description": "Commission type",
    "enum": [
      {
        "value": "1",
        "symbolicName": "PerUnit",
        "description": "Per Unit (implying shares, par, currency, etc.)"
      },
      {
        "value": "2",
        "symbolicName": "Percent",
        "description": "Percent"
      },
      {
        "value": "3",
        "symbolicName": "Absolute",
        "description": "Absolute (total monetary amount)"
      },
      {
        "value": "4",
        "symbolicName": "PercentageWaivedCashDiscount",
        "description": "Percentage waived - cash discount (for CIV buy orders)"
      },
      {
        "value": "5",
        "symbolicName": "PercentageWaivedEnhancedUnits",
        "description": "Percentage waived -= enhanced units (for CIV buy orders)"
      },
      {
        "value": "6",
        "symbolicName": "PointsPerBondOrContract",
        "description": "Points per bond or contract (supply ContractMultiplier (231) in the <Instrument> component block if the object security is denominated in a size other than the industry default - 1000 par for bonds)"
      }
    ]
  },
  {
    "tag": "14",
    "name": "CumQty",
    "type": "Qty",
    "description": "Total quantity (e.g. number of shares) filled.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "15",
    "name": "Currency",
    "type": "Currency",
    "description": "Identifies currency used for price. Absence of this field is interpreted as the default for the security. It is recommended that systems provide the currency value whenever possible. See \"Appendix 6-A: Valid Currency Codes\" for information on obtaining valid values."
  },
  {
    "tag": "16",
    "name": "EndSeqNo",
    "type": "SeqNum",
    "description": "Message sequence number of last message in range to be resent. If request is for a single message BeginSeqNo (7) = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = \"0\" (representing infinity)."
  },
  {
    "tag": "17",
    "name": "ExecID",
    "type": "String",
    "description": "Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n(Prior to FIX 4.1 this field was of type int)."
  },
  {
    "tag": "18",
    "name": "ExecInst",
    "type": "MultipleCharValue",
    "description": "Instructions for order handling on exchange trading floor. If more than one instruction is applicable to an order, this field can contain multiple instructions separated by space. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "0",
        "symbolicName": "StayOnOfferSide",
        "description": "Stay on offer side"
      },
      {
        "value": "1",
        "symbolicName": "NotHeld",
        "description": "Not held"
      },
      {
        "value": "2",
        "symbolicName": "Work",
        "description": "Work"
      },
      {
        "value": "3",
        "symbolicName": "GoAlong",
        "description": "Go along"
      },
      {
        "value": "4",
        "symbolicName": "OverTheDay",
        "description": "Over the day"
      },
      {
        "value": "5",
        "symbolicName": "Held",
        "description": "Held"
      },
      {
        "value": "6",
        "symbolicName": "ParticipateDoNotInitiate",
        "description": "Participate don't initiate"
      },
      {
        "value": "7",
        "symbolicName": "StrictScale",
        "description": "Strict scale"
      },
      {
        "value": "8",
        "symbolicName": "TryToScale",
        "description": "Try to scale"
      },
      {
        "value": "9",
        "symbolicName": "StayOnBidSide",
        "description": "Stay on bid side"
      },
      {
        "value": "A",
        "symbolicName": "NoCross",
        "description": "No cross (cross is forbidden)"
      },
      {
        "value": "B",
        "symbolicName": "OKToCross",
        "description": "OK to cross"
      },
      {
        "value": "C",
        "symbolicName": "CallFirst",
        "description": "Call first"
      },
      {
        "value": "D",
        "symbolicName": "PercentOfVolume",
        "description": "Percent of volume (indicates that the sender does not want to be all of the volume on the floor vs. a specific percentage)"
      },
      {
        "value": "E",
        "symbolicName": "DoNotIncrease",
        "description": "Do not increase - DNI"
      },
      {
        "value": "F",
        "symbolicName": "DoNotReduce",
        "description": "Do not reduce - DNR"
      },
      {
        "value": "G",
        "symbolicName": "AllOrNone",
        "description": "All or none - AON"
      },
      {
        "value": "H",
        "symbolicName": "ReinstateOnSystemFailure",
        "description": "Reinstate on system failure (mutually exclusive with Q and l)"
      },
      {
        "value": "I",
        "symbolicName": "InstitutionsOnly",
        "description": "Institutions only"
      },
      {
        "value": "J",
        "symbolicName": "ReinstateOnTradingHalt",
        "description": "Reinstate on Trading Halt (mutually exclusive with K and m)"
      },
      {
        "value": "K",
        "symbolicName": "CancelOnTradingHalt",
        "description": "Cancel on Trading Halt (mutually exclusive with J and m)"
      },
      {
        "value": "L",
        "symbolicName": "LastPeg",
        "description": "Last peg (last sale)"
      },
      {
        "value": "M",
        "symbolicName": "MidPricePeg",
        "description": "Mid-price peg (midprice of inside quote)"
      },
      {
        "value": "N",
        "symbolicName": "NonNegotiable",
        "description": "Non-negotiable"
      },
      {
        "value": "O",
        "symbolicName": "OpeningPeg",
        "description": "Opening peg"
      },
      {
        "value": "P",
        "symbolicName": "MarketPeg",
        "description": "Market peg"
      },
      {
        "value": "Q",
        "symbolicName": "CancelOnSystemFailure",
        "description": "Cancel on system failure (mutually exclusive with H and l)"
      },
      {
        "value": "R",
        "symbolicName": "PrimaryPeg",
        "description": "Primary peg (primary market - buy at bid/sell at offer)"
      },
      {
        "value": "S",
        "symbolicName": "Suspend",
        "description": "Suspend"
      },
      {
        "value": "T",
        "symbolicName": "FixedPegToLocalBestBidOrOfferAtTimeOfOrder",
        "description": "Fixed Peg to Local best bid or offer at time of order"
      },
      {
        "value": "U",
        "symbolicName": "CustomerDisplayInstruction",
        "description": "Customer Display Instruction (Rule 11Ac1-1/4)"
      },
      {
        "value": "V",
        "symbolicName": "Netting",
        "description": "Netting (for Forex)"
      },
      {
        "value": "W",
        "symbolicName": "PegToVWAP",
        "description": "Peg to VWAP"
      },
      {
        "value": "X",
        "symbolicName": "TradeAlong",
        "description": "Trade Along"
      },
      {
        "value": "Y",
        "symbolicName": "TryToStop",
        "description": "Try To Stop"
      },
      {
        "value": "Z",
        "symbolicName": "CancelIfNotBest",
        "description": "Cancel if not best"
      },
      {
        "value": "a",
        "symbolicName": "TrailingStopPeg",
        "description": "Trailing Stop Peg"
      },
      {
        "value": "b",
        "symbolicName": "StrictLimit",
        "description": "Strict Limit (No price improvement)"
      },
      {
        "value": "c",
        "symbolicName": "IgnorePriceValidityChecks",
        "description": "Ignore Price Validity Checks"
      },
      {
        "value": "d",
        "symbolicName": "PegToLimitPrice",
        "description": "Peg to Limit Price"
      },
      {
        "value": "e",
        "symbolicName": "WorkToTargetStrategy",
        "description": "Work to Target Strategy"
      },
      {
        "value": "f",
        "symbolicName": "IntermarketSweep",
        "description": "Intermarket Sweep"
      },
      {
        "value": "g",
        "symbolicName": "ExternalRoutingAllowed",
        "description": "External Routing Allowed"
      },
      {
        "value": "h",
        "symbolicName": "ExternalRoutingNotAllowed",
        "description": "External Routing Not Allowed"
      },
      {
        "value": "i",
        "symbolicName": "ImbalanceOnly",
        "description": "Imbalance Only"
      },
      {
        "value": "j",
        "symbolicName": "SingleExecutionRequestedForBlockTrade",
        "description": "Single execution requested for block trade"
      },
      {
        "value": "k",
        "symbolicName": "BestExecution",
        "description": "Best Execution"
      },
      {
        "value": "l",
        "symbolicName": "SuspendOnSystemFailure",
        "description": "Suspend on system failure (mutually exclusive with H and Q)"
      },
      {
        "value": "m",
        "symbolicName": "SuspendOnTradingHalt",
        "description": "Suspend on Trading Halt (mutually exclusive with J and K)"
      },
      {
        "value": "n",
        "symbolicName": "ReinstateOnConnectionLoss",
        "description": "Reinstate on connection loss (mutually exclusive with o and p)"
      },
      {
        "value": "o",
        "symbolicName": "CancelOnConnectionLoss",
        "description": "Cancel on connection loss (mutually exclusive with n and p)"
      },
      {
        "value": "p",
        "symbolicName": "SuspendOnConnectionLoss",
        "description": "Suspend on connection loss (mutually exclusive with n and o)"
      },
      {
        "value": "q",
        "symbolicName": "ReleaseFromSuspension",
        "description": "Release from suspension (mutually exclusive with S)"
      },
      {
        "value": "r",
        "symbolicName": "ExecuteAsDeltaNeutral",
        "description": "Execute as delta neutral using volatility provided"
      },
      {
        "value": "s",
        "symbolicName": "ExecuteAsDurationNeutral",
        "description": "Execute as duration neutral"
      },
      {
        "value": "t",
        "symbolicName": "ExecuteAsFXNeutral",
        "description": "Execute as FX neutral"
      }
    ]
  },
  {
    "tag": "19",
    "name": "ExecRefID",
    "type": "String",
    "description": "Reference identifier used with Trade, Trade Cancel and Trade Correct execution types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "21",
    "name": "HandlInst",
    "type": "char",
    "description": "Instructions for order handling on Broker trading floor",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AutomatedExecutionNoIntervention",
        "description": "Automated execution order, private, no Broker intervention"
      },
      {
        "value": "2",
        "symbolicName": "AutomatedExecutionInterventionOK",
        "description": "Automated execution order, public, Broker intervention OK"
      },
      {
        "value": "3",
        "symbolicName": "ManualOrder",
        "description": "Manual order, best execution"
      }
    ]
  },
  {
    "tag": "22",
    "name": "SecurityIDSource",
    "type": "String",
    "description": "Identifies class or source of the SecurityID (48) value. Required if SecurityID is specified.\n100+ are reserved for private security identifications",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CUSIP",
        "description": "CUSIP"
      },
      {
        "value": "2",
        "symbolicName": "SEDOL",
        "description": "SEDOL"
      },
      {
        "value": "3",
        "symbolicName": "QUIK",
        "description": "QUIK"
      },
      {
        "value": "4",
        "symbolicName": "ISINNumber",
        "description": "ISIN number"
      },
      {
        "value": "5",
        "symbolicName": "RICCode",
        "description": "RIC code"
      },
      {
        "value": "6",
        "symbolicName": "ISOCurrencyCode",
        "description": "ISO Currency Code"
      },
      {
        "value": "7",
        "symbolicName": "ISOCountryCode",
        "description": "ISO Country Code"
      },
      {
        "value": "8",
        "symbolicName": "ExchangeSymbol",
        "description": "Exchange Symbol"
      },
      {
        "value": "9",
        "symbolicName": "ConsolidatedTapeAssociation",
        "description": "Consolidated Tape Association (CTA) Symbol (SIAC CTS/CQS line format)"
      },
      {
        "value": "A",
        "symbolicName": "BloombergSymbol",
        "description": "Bloomberg Symbol"
      },
      {
        "value": "B",
        "symbolicName": "Wertpapier",
        "description": "Wertpapier"
      },
      {
        "value": "C",
        "symbolicName": "Dutch",
        "description": "Dutch"
      },
      {
        "value": "D",
        "symbolicName": "Valoren",
        "description": "Valoren"
      },
      {
        "value": "E",
        "symbolicName": "Sicovam",
        "description": "Sicovam"
      },
      {
        "value": "F",
        "symbolicName": "Belgian",
        "description": "Belgian"
      },
      {
        "value": "G",
        "symbolicName": "Common",
        "description": "\"Common\" (Clearstream and Euroclear)"
      },
      {
        "value": "H",
        "symbolicName": "ClearingHouse",
        "description": "Clearing House / Clearing Organization"
      },
      {
        "value": "I",
        "symbolicName": "ISDAFpMLSpecification",
        "description": "ISDA/FpML Product Specification (XML in EncodedSecurityDesc)"
      },
      {
        "value": "J",
        "symbolicName": "OptionPriceReportingAuthority",
        "description": "Option Price Reporting Authority"
      },
      {
        "value": "K",
        "symbolicName": "ISDAFpMLURL",
        "description": "ISDA/FpML Product URL (URL in SecurityID)"
      },
      {
        "value": "L",
        "symbolicName": "LetterOfCredit",
        "description": "Letter of Credit"
      },
      {
        "value": "M",
        "symbolicName": "MarketplaceAssignedIdentifier",
        "description": "Marketplace-assigned Identifier"
      }
    ]
  },
  {
    "tag": "23",
    "name": "IOIID",
    "type": "String",
    "description": "Unique identifier of IOI message.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "25",
    "name": "IOIQltyInd",
    "type": "char",
    "description": "Relative quality of indication",
    "enum": [
      {
        "value": "H",
        "symbolicName": "High",
        "description": "High"
      },
      {
        "value": "L",
        "symbolicName": "Low",
        "description": "Low"
      },
      {
        "value": "M",
        "symbolicName": "Medium",
        "description": "Medium"
      }
    ]
  },
  {
    "tag": "26",
    "name": "IOIRefID",
    "type": "String",
    "description": "Reference identifier used with CANCEL and REPLACE, transaction types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "27",
    "name": "IOIQty",
    "type": "String",
    "description": "Quantity (e.g. number of shares) in numeric form or relative size.",
    "enum": [
      {
        "value": "S",
        "symbolicName": "Small",
        "description": "Small"
      },
      {
        "value": "M",
        "symbolicName": "Medium",
        "description": "Medium"
      },
      {
        "value": "L",
        "symbolicName": "Large",
        "description": "Large"
      },
      {
        "value": "U",
        "symbolicName": "UndisclosedQuantity",
        "description": "Undisclosed Quantity"
      }
    ]
  },
  {
    "tag": "28",
    "name": "IOITransType",
    "type": "char",
    "description": "Identifies IOI message transaction type",
    "enum": [
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "29",
    "name": "LastCapacity",
    "type": "char",
    "description": "Broker capacity in order execution",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Agent",
        "description": "Agent"
      },
      {
        "value": "2",
        "symbolicName": "CrossAsAgent",
        "description": "Cross as agent"
      },
      {
        "value": "3",
        "symbolicName": "CrossAsPrincipal",
        "description": "Cross as principal"
      },
      {
        "value": "4",
        "symbolicName": "Principal",
        "description": "Principal"
      }
    ]
  },
  {
    "tag": "30",
    "name": "LastMkt",
    "type": "Exchange",
    "description": "Market of execution for last fill, or an indication of the market where an order was routed\nValid values:\nSee \"Appendix 6-C\""
  },
  {
    "tag": "31",
    "name": "LastPx",
    "type": "Price",
    "description": "Price of this (last) fill."
  },
  {
    "tag": "32",
    "name": "LastQty",
    "type": "Qty",
    "description": "Quantity (e.g. shares) bought/sold on this (last) fill.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "33",
    "name": "NoLinesOfText",
    "type": "NumInGroup",
    "description": "Identifies number of lines of text body"
  },
  {
    "tag": "34",
    "name": "MsgSeqNum",
    "type": "SeqNum",
    "description": "Integer message sequence number."
  },
  {
    "tag": "35",
    "name": "MsgType",
    "type": "String",
    "description": "Defines message type ALWAYS THIRD FIELD IN MESSAGE. (Always unencrypted)\nNote: A \"U\" as the first character in the MsgType field (i.e. U, U2, etc) indicates that the message format is privately defined between the sender and receiver.\n*** Note the use of lower case letters ***",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Heartbeat",
        "description": "Heartbeat"
      },
      {
        "value": "1",
        "symbolicName": "TestRequest",
        "description": "TestRequest"
      },
      {
        "value": "2",
        "symbolicName": "ResendRequest",
        "description": "ResendRequest"
      },
      {
        "value": "3",
        "symbolicName": "Reject",
        "description": "Reject"
      },
      {
        "value": "4",
        "symbolicName": "SequenceReset",
        "description": "SequenceReset"
      },
      {
        "value": "5",
        "symbolicName": "Logout",
        "description": "Logout"
      },
      {
        "value": "6",
        "symbolicName": "IOI",
        "description": "IOI"
      },
      {
        "value": "7",
        "symbolicName": "Advertisement",
        "description": "Advertisement"
      },
      {
        "value": "8",
        "symbolicName": "ExecutionReport",
        "description": "ExecutionReport"
      },
      {
        "value": "9",
        "symbolicName": "OrderCancelReject",
        "description": "OrderCancelReject"
      },
      {
        "value": "A",
        "symbolicName": "Logon",
        "description": "Logon"
      },
      {
        "value": "AA",
        "symbolicName": "DerivativeSecurityList",
        "description": "DerivativeSecurityList"
      },
      {
        "value": "AB",
        "symbolicName": "NewOrderMultileg",
        "description": "NewOrderMultileg"
      },
      {
        "value": "AC",
        "symbolicName": "MultilegOrderCancelReplace",
        "description": "MultilegOrderCancelReplace"
      },
      {
        "value": "AD",
        "symbolicName": "TradeCaptureReportRequest",
        "description": "TradeCaptureReportRequest"
      },
      {
        "value": "AE",
        "symbolicName": "TradeCaptureReport",
        "description": "TradeCaptureReport"
      },
      {
        "value": "AF",
        "symbolicName": "OrderMassStatusRequest",
        "description": "OrderMassStatusRequest"
      },
      {
        "value": "AG",
        "symbolicName": "QuoteRequestReject",
        "description": "QuoteRequestReject"
      },
      {
        "value": "AH",
        "symbolicName": "RFQRequest",
        "description": "RFQRequest"
      },
      {
        "value": "AI",
        "symbolicName": "QuoteStatusReport",
        "description": "QuoteStatusReport"
      },
      {
        "value": "AJ",
        "symbolicName": "QuoteResponse",
        "description": "QuoteResponse"
      },
      {
        "value": "AK",
        "symbolicName": "Confirmation",
        "description": "Confirmation"
      },
      {
        "value": "AL",
        "symbolicName": "PositionMaintenanceRequest",
        "description": "PositionMaintenanceRequest"
      },
      {
        "value": "AM",
        "symbolicName": "PositionMaintenanceReport",
        "description": "PositionMaintenanceReport"
      },
      {
        "value": "AN",
        "symbolicName": "RequestForPositions",
        "description": "RequestForPositions"
      },
      {
        "value": "AO",
        "symbolicName": "RequestForPositionsAck",
        "description": "RequestForPositionsAck"
      },
      {
        "value": "AP",
        "symbolicName": "PositionReport",
        "description": "PositionReport"
      },
      {
        "value": "AQ",
        "symbolicName": "TradeCaptureReportRequestAck",
        "description": "TradeCaptureReportRequestAck"
      },
      {
        "value": "AR",
        "symbolicName": "TradeCaptureReportAck",
        "description": "TradeCaptureReportAck"
      },
      {
        "value": "AS",
        "symbolicName": "AllocationReport",
        "description": "AllocationReport"
      },
      {
        "value": "AT",
        "symbolicName": "AllocationReportAck",
        "description": "AllocationReportAck"
      },
      {
        "value": "AU",
        "symbolicName": "ConfirmationAck",
        "description": "ConfirmationAck"
      },
      {
        "value": "AV",
        "symbolicName": "SettlementInstructionRequest",
        "description": "SettlementInstructionRequest"
      },
      {
        "value": "AW",
        "symbolicName": "AssignmentReport",
        "description": "AssignmentReport"
      },
      {
        "value": "AX",
        "symbolicName": "CollateralRequest",
        "description": "CollateralRequest"
      },
      {
        "value": "AY",
        "symbolicName": "CollateralAssignment",
        "description": "CollateralAssignment"
      },
      {
        "value": "AZ",
        "symbolicName": "CollateralResponse",
        "description": "CollateralResponse"
      },
      {
        "value": "B",
        "symbolicName": "News",
        "description": "News"
      },
      {
        "value": "BA",
        "symbolicName": "CollateralReport",
        "description": "CollateralReport"
      },
      {
        "value": "BB",
        "symbolicName": "CollateralInquiry",
        "description": "CollateralInquiry"
      },
      {
        "value": "BC",
        "symbolicName": "NetworkCounterpartySystemStatusRequest",
        "description": "NetworkCounterpartySystemStatusRequest"
      },
      {
        "value": "BD",
        "symbolicName": "NetworkCounterpartySystemStatusResponse",
        "description": "NetworkCounterpartySystemStatusResponse"
      },
      {
        "value": "BE",
        "symbolicName": "UserRequest",
        "description": "UserRequest"
      },
      {
        "value": "BF",
        "symbolicName": "UserResponse",
        "description": "UserResponse"
      },
      {
        "value": "BG",
        "symbolicName": "CollateralInquiryAck",
        "description": "CollateralInquiryAck"
      },
      {
        "value": "BH",
        "symbolicName": "ConfirmationRequest",
        "description": "ConfirmationRequest"
      },
      {
        "value": "BI",
        "symbolicName": "TradingSessionListRequest",
        "description": "TradingSessionListRequest"
      },
      {
        "value": "BJ",
        "symbolicName": "TradingSessionList",
        "description": "TradingSessionList"
      },
      {
        "value": "BK",
        "symbolicName": "SecurityListUpdateReport",
        "description": "SecurityListUpdateReport"
      },
      {
        "value": "BL",
        "symbolicName": "AdjustedPositionReport",
        "description": "AdjustedPositionReport"
      },
      {
        "value": "BM",
        "symbolicName": "AllocationInstructionAlert",
        "description": "AllocationInstructionAlert"
      },
      {
        "value": "BN",
        "symbolicName": "ExecutionAcknowledgement",
        "description": "ExecutionAcknowledgement"
      },
      {
        "value": "BO",
        "symbolicName": "ContraryIntentionReport",
        "description": "ContraryIntentionReport"
      },
      {
        "value": "BP",
        "symbolicName": "SecurityDefinitionUpdateReport",
        "description": "SecurityDefinitionUpdateReport"
      },
      {
        "value": "BQ",
        "symbolicName": "SettlementObligationReport",
        "description": "SettlementObligationReport"
      },
      {
        "value": "BR",
        "symbolicName": "DerivativeSecurityListUpdateReport",
        "description": "DerivativeSecurityListUpdateReport"
      },
      {
        "value": "BS",
        "symbolicName": "TradingSessionListUpdateReport",
        "description": "TradingSessionListUpdateReport"
      },
      {
        "value": "BT",
        "symbolicName": "MarketDefinitionRequest",
        "description": "MarketDefinitionRequest"
      },
      {
        "value": "BU",
        "symbolicName": "MarketDefinition",
        "description": "MarketDefinition"
      },
      {
        "value": "BV",
        "symbolicName": "MarketDefinitionUpdateReport",
        "description": "MarketDefinitionUpdateReport"
      },
      {
        "value": "BW",
        "symbolicName": "ApplicationMessageRequest",
        "description": "ApplicationMessageRequest"
      },
      {
        "value": "BX",
        "symbolicName": "ApplicationMessageRequestAck",
        "description": "ApplicationMessageRequestAck"
      },
      {
        "value": "BY",
        "symbolicName": "ApplicationMessageReport",
        "description": "ApplicationMessageReport"
      },
      {
        "value": "BZ",
        "symbolicName": "OrderMassActionReport",
        "description": "OrderMassActionReport"
      },
      {
        "value": "C",
        "symbolicName": "Email",
        "description": "Email"
      },
      {
        "value": "CA",
        "symbolicName": "OrderMassActionRequest",
        "description": "OrderMassActionRequest"
      },
      {
        "value": "CB",
        "symbolicName": "UserNotification",
        "description": "UserNotification"
      },
      {
        "value": "CC",
        "symbolicName": "StreamAssignmentRequest",
        "description": "StreamAssignmentRequest"
      },
      {
        "value": "CD",
        "symbolicName": "StreamAssignmentReport",
        "description": "StreamAssignmentReport"
      },
      {
        "value": "CE",
        "symbolicName": "StreamAssignmentReportACK",
        "description": "StreamAssignmentReportACK"
      },
      {
        "value": "D",
        "symbolicName": "NewOrderSingle",
        "description": "NewOrderSingle"
      },
      {
        "value": "E",
        "symbolicName": "NewOrderList",
        "description": "NewOrderList"
      },
      {
        "value": "F",
        "symbolicName": "OrderCancelRequest",
        "description": "OrderCancelRequest"
      },
      {
        "value": "G",
        "symbolicName": "OrderCancelReplaceRequest",
        "description": "OrderCancelReplaceRequest"
      },
      {
        "value": "H",
        "symbolicName": "OrderStatusRequest",
        "description": "OrderStatusRequest"
      },
      {
        "value": "J",
        "symbolicName": "AllocationInstruction",
        "description": "AllocationInstruction"
      },
      {
        "value": "K",
        "symbolicName": "ListCancelRequest",
        "description": "ListCancelRequest"
      },
      {
        "value": "L",
        "symbolicName": "ListExecute",
        "description": "ListExecute"
      },
      {
        "value": "M",
        "symbolicName": "ListStatusRequest",
        "description": "ListStatusRequest"
      },
      {
        "value": "N",
        "symbolicName": "ListStatus",
        "description": "ListStatus"
      },
      {
        "value": "P",
        "symbolicName": "AllocationInstructionAck",
        "description": "AllocationInstructionAck"
      },
      {
        "value": "Q",
        "symbolicName": "DontKnowTrade",
        "description": "DontKnowTrade"
      },
      {
        "value": "R",
        "symbolicName": "QuoteRequest",
        "description": "QuoteRequest"
      },
      {
        "value": "S",
        "symbolicName": "Quote",
        "description": "Quote"
      },
      {
        "value": "T",
        "symbolicName": "SettlementInstructions",
        "description": "SettlementInstructions"
      },
      {
        "value": "V",
        "symbolicName": "MarketDataRequest",
        "description": "MarketDataRequest"
      },
      {
        "value": "W",
        "symbolicName": "MarketDataSnapshotFullRefresh",
        "description": "MarketDataSnapshotFullRefresh"
      },
      {
        "value": "X",
        "symbolicName": "MarketDataIncrementalRefresh",
        "description": "MarketDataIncrementalRefresh"
      },
      {
        "value": "Y",
        "symbolicName": "MarketDataRequestReject",
        "description": "MarketDataRequestReject"
      },
      {
        "value": "Z",
        "symbolicName": "QuoteCancel",
        "description": "QuoteCancel"
      },
      {
        "value": "a",
        "symbolicName": "QuoteStatusRequest",
        "description": "QuoteStatusRequest"
      },
      {
        "value": "b",
        "symbolicName": "MassQuoteAcknowledgement",
        "description": "MassQuoteAcknowledgement"
      },
      {
        "value": "c",
        "symbolicName": "SecurityDefinitionRequest",
        "description": "SecurityDefinitionRequest"
      },
      {
        "value": "d",
        "symbolicName": "SecurityDefinition",
        "description": "SecurityDefinition"
      },
      {
        "value": "e",
        "symbolicName": "SecurityStatusRequest",
        "description": "SecurityStatusRequest"
      },
      {
        "value": "f",
        "symbolicName": "SecurityStatus",
        "description": "SecurityStatus"
      },
      {
        "value": "g",
        "symbolicName": "TradingSessionStatusRequest",
        "description": "TradingSessionStatusRequest"
      },
      {
        "value": "h",
        "symbolicName": "TradingSessionStatus",
        "description": "TradingSessionStatus"
      },
      {
        "value": "i",
        "symbolicName": "MassQuote",
        "description": "MassQuote"
      },
      {
        "value": "j",
        "symbolicName": "BusinessMessageReject",
        "description": "BusinessMessageReject"
      },
      {
        "value": "k",
        "symbolicName": "BidRequest",
        "description": "BidRequest"
      },
      {
        "value": "l",
        "symbolicName": "BidResponse",
        "description": "BidResponse"
      },
      {
        "value": "m",
        "symbolicName": "ListStrikePrice",
        "description": "ListStrikePrice"
      },
      {
        "value": "n",
        "symbolicName": "XMLnonFIX",
        "description": "XMLnonFIX"
      },
      {
        "value": "o",
        "symbolicName": "RegistrationInstructions",
        "description": "RegistrationInstructions"
      },
      {
        "value": "p",
        "symbolicName": "RegistrationInstructionsResponse",
        "description": "RegistrationInstructionsResponse"
      },
      {
        "value": "q",
        "symbolicName": "OrderMassCancelRequest",
        "description": "OrderMassCancelRequest"
      },
      {
        "value": "r",
        "symbolicName": "OrderMassCancelReport",
        "description": "OrderMassCancelReport"
      },
      {
        "value": "s",
        "symbolicName": "NewOrderCross",
        "description": "NewOrderCross"
      },
      {
        "value": "t",
        "symbolicName": "CrossOrderCancelReplaceRequest",
        "description": "CrossOrderCancelReplaceRequest"
      },
      {
        "value": "u",
        "symbolicName": "CrossOrderCancelRequest",
        "description": "CrossOrderCancelRequest"
      },
      {
        "value": "v",
        "symbolicName": "SecurityTypeRequest",
        "description": "SecurityTypeRequest"
      },
      {
        "value": "w",
        "symbolicName": "SecurityTypes",
        "description": "SecurityTypes"
      },
      {
        "value": "x",
        "symbolicName": "SecurityListRequest",
        "description": "SecurityListRequest"
      },
      {
        "value": "y",
        "symbolicName": "SecurityList",
        "description": "SecurityList"
      },
      {
        "value": "z",
        "symbolicName": "DerivativeSecurityListRequest",
        "description": "DerivativeSecurityListRequest"
      }
    ]
  },
  {
    "tag": "36",
    "name": "NewSeqNo",
    "type": "SeqNum",
    "description": "New sequence number"
  },
  {
    "tag": "37",
    "name": "OrderID",
    "type": "String",
    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
  },
  {
    "tag": "38",
    "name": "OrderQty",
    "type": "Qty",
    "description": "Quantity ordered. This represents the number of shares for equities or par, face or nominal value for FI instruments.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "39",
    "name": "OrdStatus",
    "type": "char",
    "description": "Identifies current status of order. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "PartiallyFilled",
        "description": "Partially filled"
      },
      {
        "value": "2",
        "symbolicName": "Filled",
        "description": "Filled"
      },
      {
        "value": "3",
        "symbolicName": "DoneForDay",
        "description": "Done for day"
      },
      {
        "value": "4",
        "symbolicName": "Canceled",
        "description": "Canceled"
      },
      {
        "value": "5",
        "symbolicName": "Replaced",
        "description": "Replaced (No longer used)"
      },
      {
        "value": "6",
        "symbolicName": "PendingCancel",
        "description": "Pending Cancel (i.e. result of Order Cancel Request)"
      },
      {
        "value": "7",
        "symbolicName": "Stopped",
        "description": "Stopped"
      },
      {
        "value": "8",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "9",
        "symbolicName": "Suspended",
        "description": "Suspended"
      },
      {
        "value": "A",
        "symbolicName": "PendingNew",
        "description": "Pending New"
      },
      {
        "value": "B",
        "symbolicName": "Calculated",
        "description": "Calculated"
      },
      {
        "value": "C",
        "symbolicName": "Expired",
        "description": "Expired"
      },
      {
        "value": "D",
        "symbolicName": "AcceptedForBidding",
        "description": "Accepted for Bidding"
      },
      {
        "value": "E",
        "symbolicName": "PendingReplace",
        "description": "Pending Replace (i.e. result of Order Cancel/Replace Request)"
      }
    ]
  },
  {
    "tag": "40",
    "name": "OrdType",
    "type": "char",
    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Market",
        "description": "Market"
      },
      {
        "value": "2",
        "symbolicName": "Limit",
        "description": "Limit"
      },
      {
        "value": "3",
        "symbolicName": "Stop",
        "description": "Stop / Stop Loss"
      },
      {
        "value": "4",
        "symbolicName": "StopLimit",
        "description": "Stop Limit"
      },
      {
        "value": "5",
        "symbolicName": "MarketOnClose",
        "description": "Market On Close (No longer used)"
      },
      {
        "value": "6",
        "symbolicName": "WithOrWithout",
        "description": "With Or Without"
      },
      {
        "value": "7",
        "symbolicName": "LimitOrBetter",
        "description": "Limit Or Better"
      },
      {
        "value": "8",
        "symbolicName": "LimitWithOrWithout",
        "description": "Limit With Or Without"
      },
      {
        "value": "9",
        "symbolicName": "OnBasis",
        "description": "On Basis"
      },
      {
        "value": "A",
        "symbolicName": "OnClose",
        "description": "On Close (No longer used)"
      },
      {
        "value": "B",
        "symbolicName": "LimitOnClose",
        "description": "Limit On Close (No longer used)"
      },
      {
        "value": "C",
        "symbolicName": "ForexMarket",
        "description": "Forex Market (No longer used)"
      },
      {
        "value": "D",
        "symbolicName": "PreviouslyQuoted",
        "description": "Previously Quoted"
      },
      {
        "value": "E",
        "symbolicName": "PreviouslyIndicated",
        "description": "Previously Indicated"
      },
      {
        "value": "F",
        "symbolicName": "ForexLimit",
        "description": "Forex Limit (No longer used)"
      },
      {
        "value": "G",
        "symbolicName": "ForexSwap",
        "description": "Forex Swap"
      },
      {
        "value": "H",
        "symbolicName": "ForexPreviouslyQuoted",
        "description": "Forex Previously Quoted (No longer used)"
      },
      {
        "value": "I",
        "symbolicName": "Funari",
        "description": "Funari (Limit day order with unexecuted portion handles as Market On Close. E.g. Japan)"
      },
      {
        "value": "J",
        "symbolicName": "MarketIfTouched",
        "description": "Market If Touched (MIT)"
      },
      {
        "value": "K",
        "symbolicName": "MarketWithLeftOverAsLimit",
        "description": "Market With Left Over as Limit (market order with unexecuted quantity becoming limit order at last price)"
      },
      {
        "value": "L",
        "symbolicName": "PreviousFundValuationPoint",
        "description": "Previous Fund Valuation Point (Historic pricing; for CIV)"
      },
      {
        "value": "M",
        "symbolicName": "NextFundValuationPoint",
        "description": "Next Fund Valuation Point (Forward pricing; for CIV)"
      },
      {
        "value": "P",
        "symbolicName": "Pegged",
        "description": "Pegged"
      },
      {
        "value": "Q",
        "symbolicName": "CounterOrderSelection",
        "description": "Counter-order selection"
      }
    ]
  },
  {
    "tag": "41",
    "name": "OrigClOrdID",
    "type": "String",
    "description": "ClOrdID (11) of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests."
  },
  {
    "tag": "42",
    "name": "OrigTime",
    "type": "UTCTimestamp",
    "description": "Time of message origination (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\"))"
  },
  {
    "tag": "43",
    "name": "PossDupFlag",
    "type": "Boolean",
    "description": "Indicates possible retransmission of message with this sequence number",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleDuplicate",
        "description": "Possible duplicate"
      }
    ]
  },
  {
    "tag": "44",
    "name": "Price",
    "type": "Price",
    "description": "Price per unit of quantity (e.g. per share)"
  },
  {
    "tag": "45",
    "name": "RefSeqNum",
    "type": "SeqNum",
    "description": "Reference message sequence number"
  },
  {
    "tag": "48",
    "name": "SecurityID",
    "type": "String",
    "description": "Security identifier value of SecurityIDSource (22) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires SecurityIDSource."
  },
  {
    "tag": "49",
    "name": "SenderCompID",
    "type": "String",
    "description": "Assigned value used to identify firm sending message."
  },
  {
    "tag": "50",
    "name": "SenderSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator (desk, trader, etc.)"
  },
  {
    "tag": "52",
    "name": "SendingTime",
    "type": "UTCTimestamp",
    "description": "Time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "53",
    "name": "Quantity",
    "type": "Qty",
    "description": "Overall/total quantity (e.g. number of shares)\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "54",
    "name": "Side",
    "type": "char",
    "description": "Side of order (see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Buy",
        "description": "Buy"
      },
      {
        "value": "2",
        "symbolicName": "Sell",
        "description": "Sell"
      },
      {
        "value": "3",
        "symbolicName": "BuyMinus",
        "description": "Buy minus"
      },
      {
        "value": "4",
        "symbolicName": "SellPlus",
        "description": "Sell plus"
      },
      {
        "value": "5",
        "symbolicName": "SellShort",
        "description": "Sell short"
      },
      {
        "value": "6",
        "symbolicName": "SellShortExempt",
        "description": "Sell short exempt"
      },
      {
        "value": "7",
        "symbolicName": "Undisclosed",
        "description": "Undisclosed (valid for IOI and List Order messages only)"
      },
      {
        "value": "8",
        "symbolicName": "Cross",
        "description": "Cross (orders where counterparty is an exchange, valid for all messages except IOIs)"
      },
      {
        "value": "9",
        "symbolicName": "CrossShort",
        "description": "Cross short"
      },
      {
        "value": "A",
        "symbolicName": "CrossShortExempt",
        "description": "Cross short exempt"
      },
      {
        "value": "B",
        "symbolicName": "AsDefined",
        "description": "\"As Defined\" (for use with multileg instruments)"
      },
      {
        "value": "C",
        "symbolicName": "Opposite",
        "description": "\"Opposite\" (for use with multileg instruments)"
      },
      {
        "value": "D",
        "symbolicName": "Subscribe",
        "description": "Subscribe (e.g. CIV)"
      },
      {
        "value": "E",
        "symbolicName": "Redeem",
        "description": "Redeem (e.g. CIV)"
      },
      {
        "value": "F",
        "symbolicName": "Lend",
        "description": "Lend (FINANCING - identifies direction of collateral)"
      },
      {
        "value": "G",
        "symbolicName": "Borrow",
        "description": "Borrow (FINANCING - identifies direction of collateral)"
      }
    ]
  },
  {
    "tag": "55",
    "name": "Symbol",
    "type": "String",
    "description": "Ticker symbol. Common, \"human understood\" representation of the security. SecurityID (48) value can be specified if no symbol exists (e.g. non-exchange traded Collective Investment Vehicles)\nUse \"[N/A]\" for products which do not have a symbol."
  },
  {
    "tag": "56",
    "name": "TargetCompID",
    "type": "String",
    "description": "Assigned value used to identify receiving firm."
  },
  {
    "tag": "57",
    "name": "TargetSubID",
    "type": "String",
    "description": "Assigned value used to identify specific individual or unit intended to receive message. \"ADMIN\" reserved for administrative messages not intended for a specific user."
  },
  {
    "tag": "58",
    "name": "Text",
    "type": "String",
    "description": "Free format text string\n(Note: this field does not have a specified maximum length)"
  },
  {
    "tag": "59",
    "name": "TimeInForce",
    "type": "char",
    "description": "Specifies how long the order remains in effect. Absence of this field is interpreted as DAY. NOTE not applicable to CIV Orders. (see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Day",
        "description": "Day (or session)"
      },
      {
        "value": "1",
        "symbolicName": "GoodTillCancel",
        "description": "Good Till Cancel (GTC)"
      },
      {
        "value": "2",
        "symbolicName": "AtTheOpening",
        "description": "At the Opening (OPG)"
      },
      {
        "value": "3",
        "symbolicName": "ImmediateOrCancel",
        "description": "Immediate Or Cancel (IOC)"
      },
      {
        "value": "4",
        "symbolicName": "FillOrKill",
        "description": "Fill Or Kill (FOK)"
      },
      {
        "value": "5",
        "symbolicName": "GoodTillCrossing",
        "description": "Good Till Crossing (GTX)"
      },
      {
        "value": "6",
        "symbolicName": "GoodTillDate",
        "description": "Good Till Date (GTD)"
      },
      {
        "value": "7",
        "symbolicName": "AtTheClose",
        "description": "At the Close"
      },
      {
        "value": "8",
        "symbolicName": "GoodThroughCrossing",
        "description": "Good Through Crossing"
      },
      {
        "value": "9",
        "symbolicName": "AtCrossing",
        "description": "At Crossing"
      }
    ]
  },
  {
    "tag": "60",
    "name": "TransactTime",
    "type": "UTCTimestamp",
    "description": "Timestamp when the business transaction represented by the message occurred."
  },
  {
    "tag": "61",
    "name": "Urgency",
    "type": "char",
    "description": "Urgency flag",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Normal",
        "description": "Normal"
      },
      {
        "value": "1",
        "symbolicName": "Flash",
        "description": "Flash"
      },
      {
        "value": "2",
        "symbolicName": "Background",
        "description": "Background"
      }
    ]
  },
  {
    "tag": "62",
    "name": "ValidUntilTime",
    "type": "UTCTimestamp",
    "description": "Indicates expiration time of indication message (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "63",
    "name": "SettlType",
    "type": "String",
    "description": "Indicates order settlement period. If present, SettlDate (64) overrides this field. If both SettlType (63) and SettDate (64) are omitted, the default for SettlType (63) is 0 (Regular)\nRegular is defined as the default settlement period for the particular security on the exchange of execution.\nIn Fixed Income the contents of this field may influence the instrument definition if the SecurityID (48) is ambiguous. In the US an active Treasury offering may be re-opened, and for a time one CUSIP will apply to both the current and \"when-issued\" securities. Supplying a value of \"7\" clarifies the instrument description; any other value or the absence of this field should cause the respondent to default to the active issue.\nAdditionally the following patterns may be uses as well as enum values\nDx = FX tenor expression for \"days\", e.g. \"D5\", where \"x\" is any integer > 0\nMx = FX tenor expression for \"months\", e.g. \"M3\", where \"x\" is any integer > 0\nWx = FX tenor expression for \"weeks\", e.g. \"W13\", where \"x\" is any integer > 0\nYx = FX tenor expression for \"years\", e.g. \"Y1\", where \"x\" is any integer > 0\nNoted that for FX the tenors expressed using Dx, Mx, Wx, and Yx values do not denote business days, but calendar days.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "Regular / FX Spot settlement (T+1 or T+2 depending on currency)"
      },
      {
        "value": "1",
        "symbolicName": "Cash",
        "description": "Cash (TOD / T+0)"
      },
      {
        "value": "2",
        "symbolicName": "NextDay",
        "description": "Next Day (TOM / T+1)"
      },
      {
        "value": "3",
        "symbolicName": "TPlus2",
        "description": "T+2"
      },
      {
        "value": "4",
        "symbolicName": "TPlus3",
        "description": "T+3"
      },
      {
        "value": "5",
        "symbolicName": "TPlus4",
        "description": "T+4"
      },
      {
        "value": "6",
        "symbolicName": "Future",
        "description": "Future"
      },
      {
        "value": "7",
        "symbolicName": "WhenAndIfIssued",
        "description": "When And If Issued"
      },
      {
        "value": "8",
        "symbolicName": "SellersOption",
        "description": "Sellers Option"
      },
      {
        "value": "9",
        "symbolicName": "TPlus5",
        "description": "T+5"
      },
      {
        "value": "B",
        "symbolicName": "BrokenDate",
        "description": "Broken date - for FX expressing non-standard tenor, SettlDate (64) must be specified"
      },
      {
        "value": "C",
        "symbolicName": "FXSpotNextSettlement",
        "description": "FX Spot Next settlement (Spot+1, aka next day)"
      }
    ]
  },
  {
    "tag": "64",
    "name": "SettlDate",
    "type": "LocalMktDate",
    "description": "Specific date of trade settlement (SettlementDate) in YYYYMMDD format.\nIf present, this field overrides SettlType (63). This field is required if the value of SettlType (63) is 6 (Future) or 8 (Sellers Option). This field must be omitted if the value of SettlType (63) is 7 (When and If Issued)\n(expressed in local time at place of settlement)"
  },
  {
    "tag": "65",
    "name": "SymbolSfx",
    "type": "String",
    "description": "Additional information about the security (e.g. preferred, warrants, etc.). Note also see SecurityType (167).\nAs defined in the NYSE Stock and bond Symbol Directory and in the AMEX Fitch Directory.",
    "enum": [
      {
        "value": "CD",
        "symbolicName": "EUCPWithLumpSumInterest",
        "description": "EUCP with lump-sum interest rather than discount price"
      },
      {
        "value": "WI",
        "symbolicName": "WhenIssued",
        "description": "\"When Issued\" for a security to be reissued under an old CUSIP or ISIN"
      }
    ]
  },
  {
    "tag": "66",
    "name": "ListID",
    "type": "String",
    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
  },
  {
    "tag": "67",
    "name": "ListSeqNo",
    "type": "int",
    "description": "Sequence of individual order within list (i.e. ListSeqNo of TotNoOrders (68), 2 of 25, 3 of 25, . . . )"
  },
  {
    "tag": "68",
    "name": "TotNoOrders",
    "type": "int",
    "description": "Total number of list order entries across all messages. Should be the sum of all NoOrders (73) in each message that has repeating list order entries related to the same ListID (66). Used to support fragmentation.\n(Prior to FIX 4.2 this field was named \"ListNoOrds\")"
  },
  {
    "tag": "69",
    "name": "ListExecInst",
    "type": "String",
    "description": "Free format text message containing list handling and execution instructions."
  },
  {
    "tag": "70",
    "name": "AllocID",
    "type": "String",
    "description": "Unique identifier for allocation message.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "71",
    "name": "AllocTransType",
    "type": "char",
    "description": "Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "2",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "3",
        "symbolicName": "Preliminary",
        "description": "Preliminary (without MiscFees and NetMoney) (Removed/Replaced)"
      },
      {
        "value": "4",
        "symbolicName": "Calculated",
        "description": "Calculated (includes MiscFees and NetMoney) (Removed/Replaced)"
      },
      {
        "value": "5",
        "symbolicName": "CalculatedWithoutPreliminary",
        "description": "Calculated without Preliminary (sent unsolicited by broker, includes MiscFees and NetMoney) (Removed/Replaced)"
      },
      {
        "value": "6",
        "symbolicName": "Reversal",
        "description": "Reversal"
      }
    ]
  },
  {
    "tag": "72",
    "name": "RefAllocID",
    "type": "String",
    "description": "Reference identifier to be used with AllocTransType (71) = Replace or Cancel.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "73",
    "name": "NoOrders",
    "type": "NumInGroup",
    "description": "Indicates number of orders to be combined for average pricing and allocation."
  },
  {
    "tag": "74",
    "name": "AvgPxPrecision",
    "type": "int",
    "description": "Indicates number of decimal places to be used for average pricing. Absence of this field indicates that default precision arranged by the broker/institution is to be used."
  },
  {
    "tag": "75",
    "name": "TradeDate",
    "type": "LocalMktDate",
    "description": "Indicates date of trade referenced in this message in YYYYMMDD format. Absence of this field indicates current day (expressed in local time at place of trade)."
  },
  {
    "tag": "77",
    "name": "PositionEffect",
    "type": "char",
    "description": "Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Close",
        "description": "Close"
      },
      {
        "value": "F",
        "symbolicName": "FIFO",
        "description": "FIFO"
      },
      {
        "value": "O",
        "symbolicName": "Open",
        "description": "Open"
      },
      {
        "value": "R",
        "symbolicName": "Rolled",
        "description": "Rolled"
      },
      {
        "value": "N",
        "symbolicName": "CloseButNotifyOnOpen",
        "description": "Close but notify on open"
      },
      {
        "value": "D",
        "symbolicName": "Default",
        "description": "Default"
      }
    ]
  },
  {
    "tag": "78",
    "name": "NoAllocs",
    "type": "NumInGroup",
    "description": "Number of repeating AllocAccount (79)/AllocPrice (366) entries."
  },
  {
    "tag": "79",
    "name": "AllocAccount",
    "type": "String",
    "description": "Sub-account mnemonic"
  },
  {
    "tag": "80",
    "name": "AllocQty",
    "type": "Qty",
    "description": "Quantity to be allocated to specific sub-account\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "81",
    "name": "ProcessCode",
    "type": "char",
    "description": "Processing code for sub-account. Absence of this field in AllocAccount (79) / AllocPrice (366) /AllocQty (80) / ProcessCode instance indicates regular trade.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "Regular"
      },
      {
        "value": "1",
        "symbolicName": "SoftDollar",
        "description": "Soft Dollar"
      },
      {
        "value": "2",
        "symbolicName": "StepIn",
        "description": "Step-In"
      },
      {
        "value": "3",
        "symbolicName": "StepOut",
        "description": "Step-Out"
      },
      {
        "value": "4",
        "symbolicName": "SoftDollarStepIn",
        "description": "Soft-dollar Step-In"
      },
      {
        "value": "5",
        "symbolicName": "SoftDollarStepOut",
        "description": "Soft-dollar Step-Out"
      },
      {
        "value": "6",
        "symbolicName": "PlanSponsor",
        "description": "Plan Sponsor"
      }
    ]
  },
  {
    "tag": "82",
    "name": "NoRpts",
    "type": "int",
    "description": "Total number of reports within series."
  },
  {
    "tag": "83",
    "name": "RptSeq",
    "type": "int",
    "description": "Sequence number of message within report series. Used to carry reporting sequence number of the fill as represented on the Trade Report Side."
  },
  {
    "tag": "84",
    "name": "CxlQty",
    "type": "Qty",
    "description": "Total quantity canceled for this order.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "85",
    "name": "NoDlvyInst",
    "type": "NumInGroup",
    "description": "Number of delivery instruction fields in repeating group.\nNote this field was removed in FIX 4.1 and reinstated in FIX 4.4."
  },
  {
    "tag": "87",
    "name": "AllocStatus",
    "type": "int",
    "description": "Identifies status of allocation.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "accepted (successfully processed)"
      },
      {
        "value": "1",
        "symbolicName": "BlockLevelReject",
        "description": "block level reject"
      },
      {
        "value": "2",
        "symbolicName": "AccountLevelReject",
        "description": "account level reject"
      },
      {
        "value": "3",
        "symbolicName": "Received",
        "description": "received (received, not yet processed)"
      },
      {
        "value": "4",
        "symbolicName": "Incomplete",
        "description": "incomplete"
      },
      {
        "value": "5",
        "symbolicName": "RejectedByIntermediary",
        "description": "rejected by intermediary"
      },
      {
        "value": "6",
        "symbolicName": "AllocationPending",
        "description": "allocation pending"
      },
      {
        "value": "7",
        "symbolicName": "Reversed",
        "description": "reversed"
      }
    ]
  },
  {
    "tag": "88",
    "name": "AllocRejCode",
    "type": "int",
    "description": "Identifies reason for rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnknownAccount",
        "description": "Unknown account(s)"
      },
      {
        "value": "1",
        "symbolicName": "IncorrectQuantity",
        "description": "Incorrect quantity"
      },
      {
        "value": "2",
        "symbolicName": "IncorrectAveragegPrice",
        "description": "Incorrect averageg price"
      },
      {
        "value": "3",
        "symbolicName": "UnknownExecutingBrokerMnemonic",
        "description": "Unknown executing broker mnemonic"
      },
      {
        "value": "4",
        "symbolicName": "CommissionDifference",
        "description": "Commission difference"
      },
      {
        "value": "5",
        "symbolicName": "UnknownOrderID",
        "description": "Unknown OrderID (37)"
      },
      {
        "value": "6",
        "symbolicName": "UnknownListID",
        "description": "Unknown ListID (66)"
      },
      {
        "value": "7",
        "symbolicName": "OtherSeeText",
        "description": "Other (further in Text (58))"
      },
      {
        "value": "8",
        "symbolicName": "IncorrectAllocatedQuantity",
        "description": "Incorrect allocated quantity"
      },
      {
        "value": "9",
        "symbolicName": "CalculationDifference",
        "description": "Calculation difference"
      },
      {
        "value": "10",
        "symbolicName": "UnknownOrStaleExecID",
        "description": "Unknown or stale ExecID"
      },
      {
        "value": "11",
        "symbolicName": "MismatchedData",
        "description": "Mismatched data"
      },
      {
        "value": "12",
        "symbolicName": "UnknownClOrdID",
        "description": "Unknown ClOrdID"
      },
      {
        "value": "13",
        "symbolicName": "WarehouseRequestRejected",
        "description": "Warehouse request rejected"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "89",
    "name": "Signature",
    "type": "data",
    "description": "Electronic signature"
  },
  {
    "tag": "90",
    "name": "SecureDataLen",
    "type": "Length",
    "description": "Length of encrypted message"
  },
  {
    "tag": "91",
    "name": "SecureData",
    "type": "data",
    "description": "Actual encrypted data stream"
  },
  {
    "tag": "93",
    "name": "SignatureLength",
    "type": "Length",
    "description": "Number of bytes in signature field"
  },
  {
    "tag": "94",
    "name": "EmailType",
    "type": "char",
    "description": "Email message type.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Reply",
        "description": "Reply"
      },
      {
        "value": "2",
        "symbolicName": "AdminReply",
        "description": "Admin Reply"
      }
    ]
  },
  {
    "tag": "95",
    "name": "RawDataLength",
    "type": "Length",
    "description": "Number of bytes in raw data field."
  },
  {
    "tag": "96",
    "name": "RawData",
    "type": "data",
    "description": "Unformatted raw data, can include bitmaps, word processor documents, etc."
  },
  {
    "tag": "97",
    "name": "PossResend",
    "type": "Boolean",
    "description": "Indicates that message may contain information that has been sent under another sequence number.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original Transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleResend",
        "description": "Possible Resend"
      }
    ]
  },
  {
    "tag": "98",
    "name": "EncryptMethod",
    "type": "int",
    "description": "Method of encryption.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "None / Other"
      },
      {
        "value": "1",
        "symbolicName": "PKCS",
        "description": "PKCS (Proprietary)"
      },
      {
        "value": "2",
        "symbolicName": "DES",
        "description": "DES (ECB Mode)"
      },
      {
        "value": "3",
        "symbolicName": "PKCSDES",
        "description": "PKCS / DES (Proprietary)"
      },
      {
        "value": "4",
        "symbolicName": "PGPDES",
        "description": "PGP / DES (Defunct)"
      },
      {
        "value": "5",
        "symbolicName": "PGPDESMD5",
        "description": "PGP / DES-MD5 (See app note on FIX web site)"
      },
      {
        "value": "6",
        "symbolicName": "PEM",
        "description": "PEM / DES-MD5 (see app note on FIX web site)"
      }
    ]
  },
  {
    "tag": "99",
    "name": "StopPx",
    "type": "Price",
    "description": "Price per unit of quantity (e.g. per share)"
  },
  {
    "tag": "100",
    "name": "ExDestination",
    "type": "Exchange",
    "description": "Execution destination as defined by institution when order is entered.\nValid values:\nSee \"Appendix 6-C\""
  },
  {
    "tag": "102",
    "name": "CxlRejReason",
    "type": "int",
    "description": "Code to identify reason for cancel rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "TooLateToCancel",
        "description": "Too late to cancel"
      },
      {
        "value": "1",
        "symbolicName": "UnknownOrder",
        "description": "Unknown order"
      },
      {
        "value": "2",
        "symbolicName": "BrokerCredit",
        "description": "Broker / Exchange Option"
      },
      {
        "value": "3",
        "symbolicName": "OrderAlreadyInPendingStatus",
        "description": "Order already in Pending Cancel or Pending Replace status"
      },
      {
        "value": "4",
        "symbolicName": "UnableToProcessOrderMassCancelRequest",
        "description": "Unable to process Order Mass Cancel Request"
      },
      {
        "value": "5",
        "symbolicName": "OrigOrdModTime",
        "description": "OrigOrdModTime (586) did not match last TransactTime (60) of order"
      },
      {
        "value": "6",
        "symbolicName": "DuplicateClOrdID",
        "description": "Duplicate ClOrdID (11) received"
      },
      {
        "value": "7",
        "symbolicName": "PriceExceedsCurrentPrice",
        "description": "Price exceeds current price"
      },
      {
        "value": "8",
        "symbolicName": "PriceExceedsCurrentPriceBand",
        "description": "Price exceeds current price band"
      },
      {
        "value": "18",
        "symbolicName": "InvalidPriceIncrement",
        "description": "Invalid price increment"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "103",
    "name": "OrdRejReason",
    "type": "int",
    "description": "Code to identify reason for order rejection. Note: Values 3, 4, and 5 will be used when rejecting an order due to pre-allocation information errors.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "BrokerCredit",
        "description": "Broker / Exchange option"
      },
      {
        "value": "1",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "2",
        "symbolicName": "ExchangeClosed",
        "description": "Exchange closed"
      },
      {
        "value": "3",
        "symbolicName": "OrderExceedsLimit",
        "description": "Order exceeds limit"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too late to enter"
      },
      {
        "value": "5",
        "symbolicName": "UnknownOrder",
        "description": "Unknown order"
      },
      {
        "value": "6",
        "symbolicName": "DuplicateOrder",
        "description": "Duplicate Order (e.g. dupe ClOrdID)"
      },
      {
        "value": "7",
        "symbolicName": "DuplicateOfAVerballyCommunicatedOrder",
        "description": "Duplicate of a verbally communicated order"
      },
      {
        "value": "8",
        "symbolicName": "StaleOrder",
        "description": "Stale order"
      },
      {
        "value": "9",
        "symbolicName": "TradeAlongRequired",
        "description": "Trade along required"
      },
      {
        "value": "10",
        "symbolicName": "InvalidInvestorID",
        "description": "Invalid Investor ID"
      },
      {
        "value": "11",
        "symbolicName": "UnsupportedOrderCharacteristic",
        "description": "Unsupported order characteristic"
      },
      {
        "value": "12",
        "symbolicName": "SurveillenceOption",
        "description": "Surveillence Option"
      },
      {
        "value": "13",
        "symbolicName": "IncorrectQuantity",
        "description": "Incorrect quantity"
      },
      {
        "value": "14",
        "symbolicName": "IncorrectAllocatedQuantity",
        "description": "Incorrect allocated quantity"
      },
      {
        "value": "15",
        "symbolicName": "UnknownAccount",
        "description": "Unknown account(s)"
      },
      {
        "value": "16",
        "symbolicName": "PriceExceedsCurrentPriceBand",
        "description": "Price exceeds current price band"
      },
      {
        "value": "18",
        "symbolicName": "InvalidPriceIncrement",
        "description": "Invalid price increment"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "104",
    "name": "IOIQualifier",
    "type": "char",
    "description": "Code to qualify IOI use. (see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "A",
        "symbolicName": "AllOrNone",
        "description": "All or None (AON)"
      },
      {
        "value": "B",
        "symbolicName": "MarketOnClose",
        "description": "Market On Close (MOC) (held to close)"
      },
      {
        "value": "C",
        "symbolicName": "AtTheClose",
        "description": "At the close (around/not held to close)"
      },
      {
        "value": "D",
        "symbolicName": "VWAP",
        "description": "VWAP (Volume Weighted Average Price)"
      },
      {
        "value": "I",
        "symbolicName": "InTouchWith",
        "description": "In touch with"
      },
      {
        "value": "L",
        "symbolicName": "Limit",
        "description": "Limit"
      },
      {
        "value": "M",
        "symbolicName": "MoreBehind",
        "description": "More Behind"
      },
      {
        "value": "O",
        "symbolicName": "AtTheOpen",
        "description": "At the Open"
      },
      {
        "value": "P",
        "symbolicName": "TakingAPosition",
        "description": "Taking a Position"
      },
      {
        "value": "Q",
        "symbolicName": "AtTheMarket",
        "description": "At the Market (previously called Current Quote)"
      },
      {
        "value": "R",
        "symbolicName": "ReadyToTrade",
        "description": "Ready to Trade"
      },
      {
        "value": "S",
        "symbolicName": "PortfolioShown",
        "description": "Portfolio Shown"
      },
      {
        "value": "T",
        "symbolicName": "ThroughTheDay",
        "description": "Through the Day"
      },
      {
        "value": "V",
        "symbolicName": "Versus",
        "description": "Versus"
      },
      {
        "value": "W",
        "symbolicName": "Indication",
        "description": "Indication - Working Away"
      },
      {
        "value": "X",
        "symbolicName": "CrossingOpportunity",
        "description": "Crossing Opportunity"
      },
      {
        "value": "Y",
        "symbolicName": "AtTheMidpoint",
        "description": "At the Midpoint"
      },
      {
        "value": "Z",
        "symbolicName": "PreOpen",
        "description": "Pre-open"
      }
    ]
  },
  {
    "tag": "106",
    "name": "Issuer",
    "type": "String",
    "description": "Name of security issuer (e.g. International Business Machines, GNMA).\nsee also Volume 7: \"PRODUCT: FIXED INCOME - Euro Issuer Values\""
  },
  {
    "tag": "107",
    "name": "SecurityDesc",
    "type": "String",
    "description": "Can be used to provide an optional textual description for a financial instrument."
  },
  {
    "tag": "108",
    "name": "HeartBtInt",
    "type": "int",
    "description": "Heartbeat interval (seconds)"
  },
  {
    "tag": "110",
    "name": "MinQty",
    "type": "Qty",
    "description": "Minimum quantity of an order to be executed.\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "111",
    "name": "MaxFloor",
    "type": "Qty",
    "description": "The quantity to be displayed . Required for reserve orders. On orders specifies the qty to be displayed, on execution reports the currently displayed quantity."
  },
  {
    "tag": "112",
    "name": "TestReqID",
    "type": "String",
    "description": "Identifier included in Test Request message to be returned in resulting Heartbeat"
  },
  {
    "tag": "113",
    "name": "ReportToExch",
    "type": "Boolean",
    "description": "Identifies party of trade responsible for exchange reporting.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SenderReports",
        "description": "Indicates the party sending message will report trade"
      },
      {
        "value": "Y",
        "symbolicName": "ReceiverReports",
        "description": "Indicates the party receiving message must report trade"
      }
    ]
  },
  {
    "tag": "114",
    "name": "LocateReqd",
    "type": "Boolean",
    "description": "Indicates whether the broker is to locate the stock in conjunction with a short sell order.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "Indicates the broker is not required to locate"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Indicates the broker is responsible for locating the stock"
      }
    ]
  },
  {
    "tag": "115",
    "name": "OnBehalfOfCompID",
    "type": "String",
    "description": "Assigned value used to identify firm originating message if the message was delivered by a third party i.e. the third party firm identifier would be delivered in the SenderCompID field and the firm originating the message in this field."
  },
  {
    "tag": "116",
    "name": "OnBehalfOfSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator (i.e. trader) if the message was delivered by a third party"
  },
  {
    "tag": "117",
    "name": "QuoteID",
    "type": "String",
    "description": "Unique identifier for quote"
  },
  {
    "tag": "118",
    "name": "NetMoney",
    "type": "Amt",
    "description": "Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution."
  },
  {
    "tag": "119",
    "name": "SettlCurrAmt",
    "type": "Amt",
    "description": "Total amount due expressed in settlement currency (includes the effect of the forex transaction)"
  },
  {
    "tag": "120",
    "name": "SettlCurrency",
    "type": "Currency",
    "description": "Currency code of settlement denomination."
  },
  {
    "tag": "121",
    "name": "ForexReq",
    "type": "Boolean",
    "description": "Indicates request for forex accommodation trade to be executed along with security transaction.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DoNotExecuteForexAfterSecurityTrade",
        "description": "Do Not Execute Forex After Security Trade"
      },
      {
        "value": "Y",
        "symbolicName": "ExecuteForexAfterSecurityTrade",
        "description": "Execute Forex After Security Trade"
      }
    ]
  },
  {
    "tag": "122",
    "name": "OrigSendingTime",
    "type": "UTCTimestamp",
    "description": "Original time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\") when transmitting orders as the result of a resend request."
  },
  {
    "tag": "123",
    "name": "GapFillFlag",
    "type": "Boolean",
    "description": "Indicates that the Sequence Reset message is replacing administrative or application messages which will not be resent.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SequenceReset",
        "description": "Sequence Reset, Ignore Msg Seq Num (N/A For FIXML - Not Used)"
      },
      {
        "value": "Y",
        "symbolicName": "GapFillMessage",
        "description": "Gap Fill Message, Msg Seq Num Field Valid"
      }
    ]
  },
  {
    "tag": "124",
    "name": "NoExecs",
    "type": "NumInGroup",
    "description": "No of execution repeating group entries to follow."
  },
  {
    "tag": "126",
    "name": "ExpireTime",
    "type": "UTCTimestamp",
    "description": "Time/Date of order expiration (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")\nThe meaning of expiration is specific to the context where the field is used.\nFor orders, this is the expiration time of a Good Til Date TimeInForce.\nFor Quotes - this is the expiration of the quote.\nExpiration time is provided across the quote message dialog to control the length of time of the overall quoting process.\nFor collateral requests, this is the time by which collateral must be assigned.\nFor collateral assignments, this is the time by which a response to the assignment is expected."
  },
  {
    "tag": "127",
    "name": "DKReason",
    "type": "char",
    "description": "Reason for execution rejection.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown Symbol"
      },
      {
        "value": "B",
        "symbolicName": "WrongSide",
        "description": "Wrong Side"
      },
      {
        "value": "C",
        "symbolicName": "QuantityExceedsOrder",
        "description": "Quantity Exceeds Order"
      },
      {
        "value": "D",
        "symbolicName": "NoMatchingOrder",
        "description": "No Matching Order"
      },
      {
        "value": "E",
        "symbolicName": "PriceExceedsLimit",
        "description": "Price Exceeds Limit"
      },
      {
        "value": "F",
        "symbolicName": "CalculationDifference",
        "description": "Calculation Difference"
      },
      {
        "value": "Z",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "128",
    "name": "DeliverToCompID",
    "type": "String",
    "description": "Assigned value used to identify the firm targeted to receive the message if the message is delivered by a third party i.e. the third party firm identifier would be delivered in the TargetCompID (56) field and the ultimate receiver firm ID in this field."
  },
  {
    "tag": "129",
    "name": "DeliverToSubID",
    "type": "String",
    "description": "Assigned value used to identify specific message recipient (i.e. trader) if the message is delivered by a third party"
  },
  {
    "tag": "130",
    "name": "IOINaturalFlag",
    "type": "Boolean",
    "description": "Indicates that IOI is the result of an existing agency order or a facilitation position resulting from an agency order, not from principal trading or order solicitation activity.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotNatural",
        "description": "Not Natural"
      },
      {
        "value": "Y",
        "symbolicName": "Natural",
        "description": "Natural"
      }
    ]
  },
  {
    "tag": "131",
    "name": "QuoteReqID",
    "type": "String",
    "description": "Unique identifier for quote request"
  },
  {
    "tag": "132",
    "name": "BidPx",
    "type": "Price",
    "description": "Bid price/rate"
  },
  {
    "tag": "133",
    "name": "OfferPx",
    "type": "Price",
    "description": "Offer price/rate"
  },
  {
    "tag": "134",
    "name": "BidSize",
    "type": "Qty",
    "description": "Quantity of bid\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "135",
    "name": "OfferSize",
    "type": "Qty",
    "description": "Quantity of offer\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "136",
    "name": "NoMiscFees",
    "type": "NumInGroup",
    "description": "Number of repeating groups of miscellaneous fees"
  },
  {
    "tag": "137",
    "name": "MiscFeeAmt",
    "type": "Amt",
    "description": "Miscellaneous fee value"
  },
  {
    "tag": "138",
    "name": "MiscFeeCurr",
    "type": "Currency",
    "description": "Currency of miscellaneous fee"
  },
  {
    "tag": "139",
    "name": "MiscFeeType",
    "type": "String",
    "description": "Indicates type of miscellaneous fee.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Regulatory",
        "description": "Regulatory (e.g. SEC)"
      },
      {
        "value": "2",
        "symbolicName": "Tax",
        "description": "Tax"
      },
      {
        "value": "3",
        "symbolicName": "LocalCommission",
        "description": "Local Commission"
      },
      {
        "value": "4",
        "symbolicName": "ExchangeFees",
        "description": "Exchange Fees"
      },
      {
        "value": "5",
        "symbolicName": "Stamp",
        "description": "Stamp"
      },
      {
        "value": "6",
        "symbolicName": "Levy",
        "description": "Levy"
      },
      {
        "value": "7",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "8",
        "symbolicName": "Markup",
        "description": "Markup"
      },
      {
        "value": "9",
        "symbolicName": "ConsumptionTax",
        "description": "Consumption Tax"
      },
      {
        "value": "10",
        "symbolicName": "PerTransaction",
        "description": "Per transaction"
      },
      {
        "value": "11",
        "symbolicName": "Conversion",
        "description": "Conversion"
      },
      {
        "value": "12",
        "symbolicName": "Agent",
        "description": "Agent"
      },
      {
        "value": "13",
        "symbolicName": "TransferFee",
        "description": "Transfer Fee"
      },
      {
        "value": "14",
        "symbolicName": "SecurityLending",
        "description": "Security Lending"
      }
    ]
  },
  {
    "tag": "140",
    "name": "PrevClosePx",
    "type": "Price",
    "description": "Previous closing price of security."
  },
  {
    "tag": "141",
    "name": "ResetSeqNumFlag",
    "type": "Boolean",
    "description": "Indicates that the both sides of the FIX session should reset sequence numbers.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "No"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Yes, reset sequence numbers"
      }
    ]
  },
  {
    "tag": "142",
    "name": "SenderLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator's location (i.e. geographic location and/or desk, trader)"
  },
  {
    "tag": "143",
    "name": "TargetLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message destination's location (i.e. geographic location and/or desk, trader)"
  },
  {
    "tag": "144",
    "name": "OnBehalfOfLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message originator's location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party"
  },
  {
    "tag": "145",
    "name": "DeliverToLocationID",
    "type": "String",
    "description": "Assigned value used to identify specific message recipient's location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party"
  },
  {
    "tag": "146",
    "name": "NoRelatedSym",
    "type": "NumInGroup",
    "description": "Specifies the number of repeating symbols specified."
  },
  {
    "tag": "147",
    "name": "Subject",
    "type": "String",
    "description": "The subject of an Email message"
  },
  {
    "tag": "148",
    "name": "Headline",
    "type": "String",
    "description": "The headline of a News message"
  },
  {
    "tag": "149",
    "name": "URLLink",
    "type": "String",
    "description": "A URI (Uniform Resource Identifier) or URL (Uniform Resource Locator) link to additional information (i.e. http://www.XYZ.com/research.html)\nSee \"Appendix 6-B FIX Fields Based Upon Other Standards\""
  },
  {
    "tag": "150",
    "name": "ExecType",
    "type": "char",
    "description": "Describes the specific ExecutionRpt (i.e. Pending Cancel) while OrdStatus (39) will always identify the current order status (i.e. Partially Filled) *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "3",
        "symbolicName": "DoneForDay",
        "description": "Done for day"
      },
      {
        "value": "4",
        "symbolicName": "Canceled",
        "description": "Canceled"
      },
      {
        "value": "5",
        "symbolicName": "Replaced",
        "description": "Replaced"
      },
      {
        "value": "6",
        "symbolicName": "PendingCancel",
        "description": "Pending Cancel (e.g. result of Order Cancel Request)"
      },
      {
        "value": "7",
        "symbolicName": "Stopped",
        "description": "Stopped"
      },
      {
        "value": "8",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "9",
        "symbolicName": "Suspended",
        "description": "Suspended"
      },
      {
        "value": "A",
        "symbolicName": "PendingNew",
        "description": "Pending New"
      },
      {
        "value": "B",
        "symbolicName": "Calculated",
        "description": "Calculated"
      },
      {
        "value": "C",
        "symbolicName": "Expired",
        "description": "Expired"
      },
      {
        "value": "D",
        "symbolicName": "Restated",
        "description": "Restated (Execution Report sent unsolicited by sellside, with ExecRestatementReason (378) set)"
      },
      {
        "value": "E",
        "symbolicName": "PendingReplace",
        "description": "Pending Replace (e.g. result of Order Cancel/Replace Request)"
      },
      {
        "value": "F",
        "symbolicName": "Trade",
        "description": "Trade (partial fill or fill)"
      },
      {
        "value": "G",
        "symbolicName": "TradeCorrect",
        "description": "Trade Correct"
      },
      {
        "value": "H",
        "symbolicName": "TradeCancel",
        "description": "Trade Cancel"
      },
      {
        "value": "I",
        "symbolicName": "OrderStatus",
        "description": "Order Status"
      },
      {
        "value": "J",
        "symbolicName": "TradeInAClearingHold",
        "description": "Trade in a Clearing Hold"
      },
      {
        "value": "K",
        "symbolicName": "TradeHasBeenReleasedToClearing",
        "description": "Trade has been released to Clearing"
      },
      {
        "value": "L",
        "symbolicName": "TriggeredOrActivatedBySystem",
        "description": "Triggered or Activated by System"
      }
    ]
  },
  {
    "tag": "151",
    "name": "LeavesQty",
    "type": "Qty",
    "description": "Quantity open for further execution. If the OrdStatus (39) is Canceled, DoneForTheDay, Expired, Calculated, or Rejected (in which case the order is no longer active) then LeavesQty could be 0, otherwise LeavesQty = OrderQty (38) - CumQty (14).\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "152",
    "name": "CashOrderQty",
    "type": "Qty",
    "description": "Specifies the approximate order quantity desired in total monetary units vs. as tradeable units (e.g. number of shares). The broker or fund manager (for CIV orders) would be responsible for converting and calculating a tradeable unit (e.g. share) quantity (OrderQty (38)) based upon this amount to be used for the actual order and subsequent messages."
  },
  {
    "tag": "153",
    "name": "AllocAvgPx",
    "type": "Price",
    "description": "AvgPx (6) for a specific AllocAccount (79)\nFor Fixed Income this is always expressed as \"percent of par\" price type."
  },
  {
    "tag": "154",
    "name": "AllocNetMoney",
    "type": "Amt",
    "description": "NetMoney (8) for a specific AllocAccount (79)"
  },
  {
    "tag": "155",
    "name": "SettlCurrFxRate",
    "type": "float",
    "description": "Foreign exchange rate used to compute SettlCurrAmt (9) from Currency (5) to SettlCurrency (20)"
  },
  {
    "tag": "156",
    "name": "SettlCurrFxRateCalc",
    "type": "char",
    "description": "Specifies whether or not SettlCurrFxRate (55) should be multiplied or divided.",
    "enum": [
      {
        "value": "M",
        "symbolicName": "Multiply",
        "description": "Multiply"
      },
      {
        "value": "D",
        "symbolicName": "Divide",
        "description": "Divide"
      }
    ]
  },
  {
    "tag": "157",
    "name": "NumDaysInterest",
    "type": "int",
    "description": "Number of Days of Interest for convertible bonds and fixed income. Note value may be negative."
  },
  {
    "tag": "158",
    "name": "AccruedInterestRate",
    "type": "Percentage",
    "description": "The amount the buyer compensates the seller for the portion of the next coupon interest payment the seller has earned but will not receive from the issuer because the issuer will send the next coupon payment to the buyer. Accrued Interest Rate is the annualized Accrued Interest amount divided by the purchase price of the bond."
  },
  {
    "tag": "159",
    "name": "AccruedInterestAmt",
    "type": "Amt",
    "description": "Amount of Accrued Interest for convertible bonds and fixed income"
  },
  {
    "tag": "160",
    "name": "SettlInstMode",
    "type": "char",
    "description": "Indicates mode used for Settlement Instructions message. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Default",
        "description": "Default (Replaced)"
      },
      {
        "value": "1",
        "symbolicName": "StandingInstructionsProvided",
        "description": "Standing Instructions Provided"
      },
      {
        "value": "2",
        "symbolicName": "SpecificAllocationAccountOverriding",
        "description": "Specific Allocation Account Overriding (Replaced)"
      },
      {
        "value": "3",
        "symbolicName": "SpecificAllocationAccountStanding",
        "description": "Specific Allocation Account Standing (Replaced)"
      },
      {
        "value": "4",
        "symbolicName": "SpecificOrderForASingleAccount",
        "description": "Specific Order for a single account (for CIV)"
      },
      {
        "value": "5",
        "symbolicName": "RequestReject",
        "description": "Request reject"
      }
    ]
  },
  {
    "tag": "161",
    "name": "AllocText",
    "type": "String",
    "description": "Free format text related to a specific AllocAccount (79)."
  },
  {
    "tag": "162",
    "name": "SettlInstID",
    "type": "String",
    "description": "Unique identifier for Settlement Instruction."
  },
  {
    "tag": "163",
    "name": "SettlInstTransType",
    "type": "char",
    "description": "Settlement Instructions message transaction type",
    "enum": [
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "T",
        "symbolicName": "Restate",
        "description": "Restate"
      }
    ]
  },
  {
    "tag": "164",
    "name": "EmailThreadID",
    "type": "String",
    "description": "Unique identifier for an email thread (new and chain of replies)"
  },
  {
    "tag": "165",
    "name": "SettlInstSource",
    "type": "char",
    "description": "Indicates source of Settlement Instructions",
    "enum": [
      {
        "value": "1",
        "symbolicName": "BrokerCredit",
        "description": "Broker's Instructions"
      },
      {
        "value": "2",
        "symbolicName": "Institution",
        "description": "Institution's Instructions"
      },
      {
        "value": "3",
        "symbolicName": "Investor",
        "description": "Investor (e.g. CIV use)"
      }
    ]
  },
  {
    "tag": "167",
    "name": "SecurityType",
    "type": "String",
    "description": "Indicates type of security. Security type enumerations are grouped by Product(460) field value. NOTE: Additional values may be used by mutual agreement of the counterparties.",
    "enum": [
      {
        "value": "UST",
        "symbolicName": "USTreasuryNoteOld",
        "description": "US Treasury Note (Deprecated Value Use TNOTE)"
      },
      {
        "value": "USTB",
        "symbolicName": "USTreasuryBillOld",
        "description": "US Treasury Bill (Deprecated Value Use TBILL)"
      },
      {
        "value": "EUSUPRA",
        "symbolicName": "EuroSupranationalCoupons",
        "description": "Euro Supranational Coupons *"
      },
      {
        "value": "FAC",
        "symbolicName": "FederalAgencyCoupon",
        "description": "Federal Agency Coupon"
      },
      {
        "value": "FADN",
        "symbolicName": "FederalAgencyDiscountNote",
        "description": "Federal Agency Discount Note"
      },
      {
        "value": "PEF",
        "symbolicName": "PrivateExportFunding",
        "description": "Private Export Funding *"
      },
      {
        "value": "SUPRA",
        "symbolicName": "USDSupranationalCoupons",
        "description": "USD Supranational Coupons *"
      },
      {
        "value": "CORP",
        "symbolicName": "CorporateBond",
        "description": "Corporate Bond"
      },
      {
        "value": "CPP",
        "symbolicName": "CorporatePrivatePlacement",
        "description": "Corporate Private Placement"
      },
      {
        "value": "CB",
        "symbolicName": "ConvertibleBond",
        "description": "Convertible Bond"
      },
      {
        "value": "DUAL",
        "symbolicName": "DualCurrency",
        "description": "Dual Currency"
      },
      {
        "value": "EUCORP",
        "symbolicName": "EuroCorporateBond",
        "description": "Euro Corporate Bond"
      },
      {
        "value": "EUFRN",
        "symbolicName": "EuroCorporateFloatingRateNotes",
        "description": "Euro Corporate Floating Rate Notes"
      },
      {
        "value": "FRN",
        "symbolicName": "USCorporateFloatingRateNotes",
        "description": "US Corporate Floating Rate Notes"
      },
      {
        "value": "XLINKD",
        "symbolicName": "IndexedLinked",
        "description": "Indexed Linked"
      },
      {
        "value": "STRUCT",
        "symbolicName": "StructuredNotes",
        "description": "Structured Notes"
      },
      {
        "value": "YANK",
        "symbolicName": "YankeeCorporateBond",
        "description": "Yankee Corporate Bond"
      },
      {
        "value": "FOR",
        "symbolicName": "ForeignExchangeContract",
        "description": "Foreign Exchange Contract"
      },
      {
        "value": "CDS",
        "symbolicName": "CreditDefaultSwap",
        "description": "Credit Default Swap"
      },
      {
        "value": "FUT",
        "symbolicName": "Future",
        "description": "Future"
      },
      {
        "value": "OPT",
        "symbolicName": "Option",
        "description": "Option"
      },
      {
        "value": "OOF",
        "symbolicName": "OptionsOnFutures",
        "description": "Options on Futures"
      },
      {
        "value": "OOP",
        "symbolicName": "OptionsOnPhysical",
        "description": "Options on Physical - use not recommended"
      },
      {
        "value": "IRS",
        "symbolicName": "InterestRateSwap",
        "description": "Interest Rate Swap"
      },
      {
        "value": "OOC",
        "symbolicName": "OptionsOnCombo",
        "description": "Options on Combo"
      },
      {
        "value": "CS",
        "symbolicName": "CommonStock",
        "description": "Common Stock"
      },
      {
        "value": "PS",
        "symbolicName": "PreferredStock",
        "description": "Preferred Stock"
      },
      {
        "value": "REPO",
        "symbolicName": "Repurchase",
        "description": "Repurchase"
      },
      {
        "value": "FORWARD",
        "symbolicName": "Forward",
        "description": "Forward"
      },
      {
        "value": "BUYSELL",
        "symbolicName": "BuySellback",
        "description": "Buy Sellback"
      },
      {
        "value": "SECLOAN",
        "symbolicName": "SecuritiesLoan",
        "description": "Securities Loan"
      },
      {
        "value": "SECPLEDGE",
        "symbolicName": "SecuritiesPledge",
        "description": "Securities Pledge"
      },
      {
        "value": "BRADY",
        "symbolicName": "BradyBond",
        "description": "Brady Bond"
      },
      {
        "value": "CAN",
        "symbolicName": "CanadianTreasuryNotes",
        "description": "Canadian Treasury Notes"
      },
      {
        "value": "CTB",
        "symbolicName": "CanadianTreasuryBills",
        "description": "Canadian Treasury Bills"
      },
      {
        "value": "EUSOV",
        "symbolicName": "EuroSovereigns",
        "description": "Euro Sovereigns *"
      },
      {
        "value": "PROV",
        "symbolicName": "CanadianProvincialBonds",
        "description": "Canadian Provincial Bonds"
      },
      {
        "value": "TB",
        "symbolicName": "TreasuryBill",
        "description": "Treasury Bill - non US"
      },
      {
        "value": "TBOND",
        "symbolicName": "USTreasuryBond",
        "description": "US Treasury Bond"
      },
      {
        "value": "TINT",
        "symbolicName": "InterestStripFromAnyBondOrNote",
        "description": "Interest Strip From Any Bond Or Note"
      },
      {
        "value": "TBILL",
        "symbolicName": "USTreasuryBill",
        "description": "US Treasury Bill"
      },
      {
        "value": "TIPS",
        "symbolicName": "TreasuryInflationProtectedSecurities",
        "description": "Treasury Inflation Protected Securities"
      },
      {
        "value": "TCAL",
        "symbolicName": "PrincipalStripOfACallableBondOrNote",
        "description": "Principal Strip Of A Callable Bond Or Note"
      },
      {
        "value": "TPRN",
        "symbolicName": "PrincipalStripFromANonCallableBondOrNote",
        "description": "Principal Strip From A Non-Callable Bond Or Note"
      },
      {
        "value": "TNOTE",
        "symbolicName": "USTreasuryNote",
        "description": "US Treasury Note"
      },
      {
        "value": "TERM",
        "symbolicName": "TermLoan",
        "description": "Term Loan"
      },
      {
        "value": "RVLV",
        "symbolicName": "RevolverLoan",
        "description": "Revolver Loan"
      },
      {
        "value": "RVLVTRM",
        "symbolicName": "Revolver",
        "description": "Revolver/Term Loan"
      },
      {
        "value": "BRIDGE",
        "symbolicName": "BridgeLoan",
        "description": "Bridge Loan"
      },
      {
        "value": "LOFC",
        "symbolicName": "LetterOfCredit",
        "description": "Letter Of Credit"
      },
      {
        "value": "SWING",
        "symbolicName": "SwingLineFacility",
        "description": "Swing Line Facility"
      },
      {
        "value": "DINP",
        "symbolicName": "DebtorInPossession",
        "description": "Debtor In Possession"
      },
      {
        "value": "DEFLTED",
        "symbolicName": "Defaulted",
        "description": "Defaulted"
      },
      {
        "value": "WITHDRN",
        "symbolicName": "Withdrawn",
        "description": "Withdrawn"
      },
      {
        "value": "REPLACD",
        "symbolicName": "Replaced",
        "description": "Replaced"
      },
      {
        "value": "MATURED",
        "symbolicName": "Matured",
        "description": "Matured"
      },
      {
        "value": "AMENDED",
        "symbolicName": "Amended",
        "description": "Amended & Restated"
      },
      {
        "value": "RETIRED",
        "symbolicName": "Retired",
        "description": "Retired"
      },
      {
        "value": "BA",
        "symbolicName": "BankersAcceptance",
        "description": "Bankers Acceptance"
      },
      {
        "value": "BDN",
        "symbolicName": "BankDepositoryNote",
        "description": "Bank Depository Note"
      },
      {
        "value": "BN",
        "symbolicName": "BankNotes",
        "description": "Bank Notes"
      },
      {
        "value": "BOX",
        "symbolicName": "BillOfExchanges",
        "description": "Bill Of Exchanges"
      },
      {
        "value": "CAMM",
        "symbolicName": "CanadianMoneyMarkets",
        "description": "Canadian Money Markets"
      },
      {
        "value": "CD",
        "symbolicName": "CertificateOfDeposit",
        "description": "Certificate Of Deposit"
      },
      {
        "value": "CL",
        "symbolicName": "CallLoans",
        "description": "Call Loans"
      },
      {
        "value": "CP",
        "symbolicName": "CommercialPaper",
        "description": "Commercial Paper"
      },
      {
        "value": "DN",
        "symbolicName": "DepositNotes",
        "description": "Deposit Notes"
      },
      {
        "value": "EUCD",
        "symbolicName": "EuroCertificateOfDeposit",
        "description": "Euro Certificate Of Deposit"
      },
      {
        "value": "EUCP",
        "symbolicName": "EuroCommercialPaper",
        "description": "Euro Commercial Paper"
      },
      {
        "value": "LQN",
        "symbolicName": "LiquidityNote",
        "description": "Liquidity Note"
      },
      {
        "value": "MTN",
        "symbolicName": "MediumTermNotes",
        "description": "Medium Term Notes"
      },
      {
        "value": "ONITE",
        "symbolicName": "Overnight",
        "description": "Overnight"
      },
      {
        "value": "PN",
        "symbolicName": "PromissoryNote",
        "description": "Promissory Note"
      },
      {
        "value": "STN",
        "symbolicName": "ShortTermLoanNote",
        "description": "Short Term Loan Note"
      },
      {
        "value": "PZFJ",
        "symbolicName": "PlazosFijos",
        "description": "Plazos Fijos"
      },
      {
        "value": "SLQN",
        "symbolicName": "SecuredLiquidityNote",
        "description": "Secured Liquidity Note"
      },
      {
        "value": "TD",
        "symbolicName": "TimeDeposit",
        "description": "Time Deposit"
      },
      {
        "value": "TLQN",
        "symbolicName": "TermLiquidityNote",
        "description": "Term Liquidity Note"
      },
      {
        "value": "XCN",
        "symbolicName": "ExtendedCommNote",
        "description": "Extended Comm Note"
      },
      {
        "value": "YCD",
        "symbolicName": "YankeeCertificateOfDeposit",
        "description": "Yankee Certificate Of Deposit"
      },
      {
        "value": "ABS",
        "symbolicName": "AssetBackedSecurities",
        "description": "Asset-backed Securities"
      },
      {
        "value": "CMB",
        "symbolicName": "CanadianMortgageBonds",
        "description": "Canadian Mortgage Bonds"
      },
      {
        "value": "CMBS",
        "symbolicName": "Corp",
        "description": "Corp. Mortgage-backed Securities"
      },
      {
        "value": "CMO",
        "symbolicName": "CollateralizedMortgageObligation",
        "description": "Collateralized Mortgage Obligation"
      },
      {
        "value": "IET",
        "symbolicName": "IOETTEMortgage",
        "description": "IOETTE Mortgage"
      },
      {
        "value": "MBS",
        "symbolicName": "MortgageBackedSecurities",
        "description": "Mortgage-backed Securities"
      },
      {
        "value": "MIO",
        "symbolicName": "MortgageInterestOnly",
        "description": "Mortgage Interest Only"
      },
      {
        "value": "MPO",
        "symbolicName": "MortgagePrincipalOnly",
        "description": "Mortgage Principal Only"
      },
      {
        "value": "MPP",
        "symbolicName": "MortgagePrivatePlacement",
        "description": "Mortgage Private Placement"
      },
      {
        "value": "MPT",
        "symbolicName": "MiscellaneousPassThrough",
        "description": "Miscellaneous Pass-through"
      },
      {
        "value": "PFAND",
        "symbolicName": "Pfandbriefe",
        "description": "Pfandbriefe *"
      },
      {
        "value": "TBA",
        "symbolicName": "ToBeAnnounced",
        "description": "To Be Announced"
      },
      {
        "value": "AN",
        "symbolicName": "OtherAnticipationNotes",
        "description": "Other Anticipation Notes (BAN, GAN, etc.)"
      },
      {
        "value": "COFO",
        "symbolicName": "CertificateOfObligation",
        "description": "Certificate Of Obligation"
      },
      {
        "value": "COFP",
        "symbolicName": "CertificateOfParticipation",
        "description": "Certificate Of Participation"
      },
      {
        "value": "GO",
        "symbolicName": "GeneralObligationBonds",
        "description": "General Obligation Bonds"
      },
      {
        "value": "MT",
        "symbolicName": "MandatoryTender",
        "description": "Mandatory Tender"
      },
      {
        "value": "RAN",
        "symbolicName": "RevenueAnticipationNote",
        "description": "Revenue Anticipation Note"
      },
      {
        "value": "REV",
        "symbolicName": "RevenueBonds",
        "description": "Revenue Bonds"
      },
      {
        "value": "SPCLA",
        "symbolicName": "SpecialAssessment",
        "description": "Special Assessment"
      },
      {
        "value": "SPCLO",
        "symbolicName": "SpecialObligation",
        "description": "Special Obligation"
      },
      {
        "value": "SPCLT",
        "symbolicName": "SpecialTax",
        "description": "Special Tax"
      },
      {
        "value": "TAN",
        "symbolicName": "TaxAnticipationNote",
        "description": "Tax Anticipation Note"
      },
      {
        "value": "TAXA",
        "symbolicName": "TaxAllocation",
        "description": "Tax Allocation"
      },
      {
        "value": "TECP",
        "symbolicName": "TaxExemptCommercialPaper",
        "description": "Tax Exempt Commercial Paper"
      },
      {
        "value": "TMCP",
        "symbolicName": "TaxableMunicipalCP",
        "description": "Taxable Municipal CP"
      },
      {
        "value": "TRAN",
        "symbolicName": "TaxRevenueAnticipationNote",
        "description": "Tax Revenue Anticipation Note"
      },
      {
        "value": "VRDN",
        "symbolicName": "VariableRateDemandNote",
        "description": "Variable Rate Demand Note"
      },
      {
        "value": "WAR",
        "symbolicName": "Warrant",
        "description": "Warrant"
      },
      {
        "value": "MF",
        "symbolicName": "MutualFund",
        "description": "Mutual Fund"
      },
      {
        "value": "MLEG",
        "symbolicName": "MultilegInstrument",
        "description": "Multileg Instrument"
      },
      {
        "value": "NONE",
        "symbolicName": "NoSecurityType",
        "description": "No Security Type"
      },
      {
        "value": "?",
        "symbolicName": "Wildcard",
        "description": "Wildcard entry for use on Security Definition Request"
      },
      {
        "value": "CASH",
        "symbolicName": "Cash",
        "description": "Cash"
      },
      {
        "value": "FXNDF",
        "symbolicName": "NonDeliverableForward",
        "description": "Non-deliverable forward"
      },
      {
        "value": "FXSPOT",
        "symbolicName": "FXSpot",
        "description": "FX Spot"
      },
      {
        "value": "FXFWD",
        "symbolicName": "FXForward",
        "description": "FX Forward"
      },
      {
        "value": "FXSWAP",
        "symbolicName": "FXSwap",
        "description": "FX Swap"
      }
    ]
  },
  {
    "tag": "168",
    "name": "EffectiveTime",
    "type": "UTCTimestamp",
    "description": "Time the details within the message should take effect (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "169",
    "name": "StandInstDbType",
    "type": "int",
    "description": "Identifies the Standing Instruction database used",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "1",
        "symbolicName": "DTCSID",
        "description": "DTC SID"
      },
      {
        "value": "2",
        "symbolicName": "ThomsonALERT",
        "description": "Thomson ALERT"
      },
      {
        "value": "3",
        "symbolicName": "AGlobalCustodian",
        "description": "A Global Custodian (StandInstDBName (70) must be provided)"
      },
      {
        "value": "4",
        "symbolicName": "AccountNet",
        "description": "AccountNet"
      }
    ]
  },
  {
    "tag": "170",
    "name": "StandInstDbName",
    "type": "String",
    "description": "Name of the Standing Instruction database represented with StandInstDbType (169) (i.e. the Global Custodian's name)."
  },
  {
    "tag": "171",
    "name": "StandInstDbID",
    "type": "String",
    "description": "Unique identifier used on the Standing Instructions database for the Standing Instructions to be referenced."
  },
  {
    "tag": "172",
    "name": "SettlDeliveryType",
    "type": "int",
    "description": "Identifies type of settlement",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Versus",
        "description": "\"Versus. Payment\": Deliver (if Sell) or Receive (if Buy) vs. (Against) Payment"
      },
      {
        "value": "1",
        "symbolicName": "Free",
        "description": "\"Free\": Deliver (if Sell) or Receive (if Buy) Free"
      },
      {
        "value": "2",
        "symbolicName": "TriParty",
        "description": "Tri-Party"
      },
      {
        "value": "3",
        "symbolicName": "HoldInCustody",
        "description": "Hold In Custody"
      }
    ]
  },
  {
    "tag": "188",
    "name": "BidSpotRate",
    "type": "Price",
    "description": "Bid F/X spot rate."
  },
  {
    "tag": "189",
    "name": "BidForwardPoints",
    "type": "PriceOffset",
    "description": "Bid F/X forward points added to spot rate. May be a negative value."
  },
  {
    "tag": "190",
    "name": "OfferSpotRate",
    "type": "Price",
    "description": "Offer F/X spot rate."
  },
  {
    "tag": "191",
    "name": "OfferForwardPoints",
    "type": "PriceOffset",
    "description": "Offer F/X forward points added to spot rate. May be a negative value."
  },
  {
    "tag": "192",
    "name": "OrderQty2",
    "type": "Qty",
    "description": "OrderQty (38) of the future part of a F/X swap order."
  },
  {
    "tag": "193",
    "name": "SettlDate2",
    "type": "LocalMktDate",
    "description": "SettDate (64) of the future part of a F/X swap order."
  },
  {
    "tag": "194",
    "name": "LastSpotRate",
    "type": "Price",
    "description": "F/X spot rate."
  },
  {
    "tag": "195",
    "name": "LastForwardPoints",
    "type": "PriceOffset",
    "description": "F/X forward points added to LastSpotRate (94). May be a negative value. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "196",
    "name": "AllocLinkID",
    "type": "String",
    "description": "Can be used to link two different Allocation messages (each with unique AllocID (70)) together, i.e. for F/X \"Netting\" or \"Swaps\". Should be unique."
  },
  {
    "tag": "197",
    "name": "AllocLinkType",
    "type": "int",
    "description": "Identifies the type of Allocation linkage when AllocLinkID (96) is used.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "FXNetting",
        "description": "FX Netting"
      },
      {
        "value": "1",
        "symbolicName": "FXSwap",
        "description": "FX Swap"
      }
    ]
  },
  {
    "tag": "198",
    "name": "SecondaryOrderID",
    "type": "String",
    "description": "Assigned by the party which accepts the order. Can be used to provide the OrderID (37) used by an exchange or executing system."
  },
  {
    "tag": "199",
    "name": "NoIOIQualifiers",
    "type": "NumInGroup",
    "description": "Number of repeating groups of IOIQualifiers (04)."
  },
  {
    "tag": "200",
    "name": "MaturityMonthYear",
    "type": "MonthYear",
    "description": "Can be used with standardized derivatives vs. the MaturityDate (54) field.  Month and Year of the maturity (used for standardized futures and options).\nFormat:\nYYYYMM (e.g. 199903)\nYYYYMMDD (e.g. 20030323)\nYYYYMMwN (e.g. 200303w) for week\nA specific date or can be appended to the MaturityMonthYear. For instance, if multiple standard products exist that mature in the same Year and Month, but actually mature at a different time, a value can be appended, such as \"w\" or \"w2\" to indicate week  as opposed to week 2 expiration. Likewise, the date (0-3) can be appended to indicate a specific expiration (maturity date)."
  },
  {
    "tag": "201",
    "name": "PutOrCall",
    "type": "int",
    "description": "Indicates whether an option contract is a put or call",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Put",
        "description": "Put"
      },
      {
        "value": "1",
        "symbolicName": "Call",
        "description": "Call"
      }
    ]
  },
  {
    "tag": "202",
    "name": "StrikePrice",
    "type": "Price",
    "description": "Strike Price for an Option."
  },
  {
    "tag": "203",
    "name": "CoveredOrUncovered",
    "type": "int",
    "description": "Used for derivative products, such as options",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Covered",
        "description": "Covered"
      },
      {
        "value": "1",
        "symbolicName": "Uncovered",
        "description": "Uncovered"
      }
    ]
  },
  {
    "tag": "206",
    "name": "OptAttribute",
    "type": "char",
    "description": "Provided to support versioning of option contracts as a result of corporate actions or events. Use of this field is defined by counterparty agreement or market conventions."
  },
  {
    "tag": "207",
    "name": "SecurityExchange",
    "type": "Exchange",
    "description": "Market used to help identify a security.\nValid values:\nSee \"Appendix 6-C\""
  },
  {
    "tag": "208",
    "name": "NotifyBrokerOfCredit",
    "type": "Boolean",
    "description": "Indicates whether or not details should be communicated to BrokerOfCredit (i.e. step-in broker).",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DetailsShouldNotBeCommunicated",
        "description": "Details should not be communicated"
      },
      {
        "value": "Y",
        "symbolicName": "DetailsShouldBeCommunicated",
        "description": "Details should be communicated"
      }
    ]
  },
  {
    "tag": "209",
    "name": "AllocHandlInst",
    "type": "int",
    "description": "Indicates how the receiver (i.e. third party) of Allocation message should handle/process the account details.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Match",
        "description": "Match"
      },
      {
        "value": "2",
        "symbolicName": "Forward",
        "description": "Forward"
      },
      {
        "value": "3",
        "symbolicName": "ForwardAndMatch",
        "description": "Forward and Match"
      }
    ]
  },
  {
    "tag": "210",
    "name": "MaxShow",
    "type": "Qty",
    "description": "Maximum quantity (e.g. number of shares) within an order to be shown to other customers (i.e. sent via an IOI).\n(Prior to FIX 4.2 this field was of type int)"
  },
  {
    "tag": "211",
    "name": "PegOffsetValue",
    "type": "float",
    "description": "Amount (signed) added to the peg for a pegged order in the context of the PegOffsetType (836)\n(Prior to FIX 4.4 this field was of type PriceOffset)"
  },
  {
    "tag": "212",
    "name": "XmlDataLen",
    "type": "Length",
    "description": "Length of the XmlData data block."
  },
  {
    "tag": "213",
    "name": "XmlData",
    "type": "data",
    "description": "Actual XML data stream (e.g. FIXML). See approriate XML reference (e.g. FIXML). Note: may contain embedded SOH characters."
  },
  {
    "tag": "214",
    "name": "SettlInstRefID",
    "type": "String",
    "description": "Reference identifier for the SettlInstID (162) with Cancel and Replace SettlInstTransType (163) transaction types."
  },
  {
    "tag": "215",
    "name": "NoRoutingIDs",
    "type": "NumInGroup",
    "description": "Number of repeating groups of RoutingID (217) and RoutingType (216) values.\nSee Volume 3: \"Pre-Trade Message Targeting/Routing\""
  },
  {
    "tag": "216",
    "name": "RoutingType",
    "type": "int",
    "description": "Indicates the type of RoutingID (217) specified.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "TargetFirm",
        "description": "Target Firm"
      },
      {
        "value": "2",
        "symbolicName": "TargetList",
        "description": "Target List"
      },
      {
        "value": "3",
        "symbolicName": "BlockFirm",
        "description": "Block Firm"
      },
      {
        "value": "4",
        "symbolicName": "BlockList",
        "description": "Block List"
      }
    ]
  },
  {
    "tag": "217",
    "name": "RoutingID",
    "type": "String",
    "description": "Assigned value used to identify a specific routing destination."
  },
  {
    "tag": "218",
    "name": "Spread",
    "type": "PriceOffset",
    "description": "For Fixed Income. Either Swap Spread or Spread to Benchmark depending upon the order type.\nSpread to Benchmark: Basis points relative to a benchmark. To be expressed as \"count of basis points\" (vs. an absolute value). E.g. High Grade Corporate Bonds may express price as basis points relative to benchmark (the BenchmarkCurveName (22) field). Note: Basis points can be negative.\nSwap Spread: Target spread for a swap."
  },
  {
    "tag": "220",
    "name": "BenchmarkCurveCurrency",
    "type": "Currency",
    "description": "Identifies currency used for benchmark curve. See \"Appendix 6-A: Valid Currency Codes\" for information on obtaining valid values.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "221",
    "name": "BenchmarkCurveName",
    "type": "String",
    "description": "Name of benchmark curve.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    "enum": [
      {
        "value": "EONIA",
        "symbolicName": "EONIA",
        "description": "EONIA"
      },
      {
        "value": "EUREPO",
        "symbolicName": "EUREPO",
        "description": "EUREPO"
      },
      {
        "value": "Euribor",
        "symbolicName": "Euribor",
        "description": "Euribor"
      },
      {
        "value": "FutureSWAP",
        "symbolicName": "FutureSWAP",
        "description": "FutureSWAP"
      },
      {
        "value": "LIBID",
        "symbolicName": "LIBID",
        "description": "LIBID"
      },
      {
        "value": "LIBOR",
        "symbolicName": "LIBOR",
        "description": "LIBOR (London Inter-Bank Offer)"
      },
      {
        "value": "MuniAAA",
        "symbolicName": "MuniAAA",
        "description": "MuniAAA"
      },
      {
        "value": "OTHER",
        "symbolicName": "OTHER",
        "description": "OTHER"
      },
      {
        "value": "Pfandbriefe",
        "symbolicName": "Pfandbriefe",
        "description": "Pfandbriefe"
      },
      {
        "value": "SONIA",
        "symbolicName": "SONIA",
        "description": "SONIA"
      },
      {
        "value": "SWAP",
        "symbolicName": "SWAP",
        "description": "SWAP"
      },
      {
        "value": "Treasury",
        "symbolicName": "Treasury",
        "description": "Treasury"
      }
    ]
  },
  {
    "tag": "222",
    "name": "BenchmarkCurvePoint",
    "type": "String",
    "description": "Point on benchmark curve. Free form values: e.g. \"Y\", \"7Y\", \"INTERPOLATED\".\nSample values:\nM = combination of a number between 1-12 and a \"M\" for month\nY = combination of number between 1-100 and a \"Y\" for year}\n10Y-OLD = see above, then add \"-OLD\" when appropriate\nINTERPOLATED = the point is mathematically derived\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon\nSee Fixed Income-specific documentation at http://www.fixprotocol.org for additional values.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "223",
    "name": "CouponRate",
    "type": "Percentage",
    "description": "The rate of interest that, when multiplied by the principal, par value, or face value of a bond, provides the currency amount of the periodic interest payment. The coupon is always cited, along with maturity, in any quotation of a bond's price."
  },
  {
    "tag": "224",
    "name": "CouponPaymentDate",
    "type": "LocalMktDate",
    "description": "Date interest is to be paid. Used in identifying Corporate Bond issues.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "225",
    "name": "IssueDate",
    "type": "LocalMktDate",
    "description": "The date on which a bond or stock offering is issued. It may or may not be the same as the effective date (\"Dated Date\") or the date on which interest begins to accrue (\"Interest Accrual Date\")\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "226",
    "name": "RepurchaseTerm",
    "type": "int",
    "description": "Number of business days before repurchase of a repo. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "227",
    "name": "RepurchaseRate",
    "type": "Percentage",
    "description": "Percent of par at which a Repo will be repaid. Represented as a percent, e.g. .9525 represents 95-/4 percent of par. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "228",
    "name": "Factor",
    "type": "float",
    "description": "For Fixed Income: Amorization Factor for deriving Current face from Original face for ABS or MBS securities, note the fraction may be greater than, equal to or less than . In TIPS securities this is the Inflation index.\nQty * Factor * Price = Gross Trade Amount\nFor Derivatives: Contract Value Factor by which price must be adjusted to determine the true nominal value of one futures/options contract.\n(Qty * Price) * Factor = Nominal Value\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "229",
    "name": "TradeOriginationDate",
    "type": "LocalMktDate",
    "description": "Used with Fixed Income for Muncipal New Issue Market. Agreement in principal between counter-parties prior to actual trade date.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "230",
    "name": "ExDate",
    "type": "LocalMktDate",
    "description": "The date when a distribution of interest is deducted from a securities assets or set aside for payment to bondholders. On the ex-date, the securities price drops by the amount of the distribution (plus or minus any market activity).\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "231",
    "name": "ContractMultiplier",
    "type": "float",
    "description": "Specifies the ratio or multiply factor to convert from \"nominal\" units (e.g. contracts) to total units (e.g. shares) (e.g. 1.0, 100, 1000, etc). Applicable For Fixed Income, Convertible Bonds, Derivatives, etc.\nIn general quantities for all calsses should be expressed in the basic unit of the instrument, e.g. shares for equities, norminal or par amount for bonds, currency for foreign exchange. When quantity is expressed in contracts, e.g. financing transactions and bond trade reporting, ContractMutliplier should contain the number of units in one contract and can be omitted if the multiplier is the default amount for the instrument, i.e. 1,000 par of bonds, 1,000,000 par for financing transactions."
  },
  {
    "tag": "232",
    "name": "NoStipulations",
    "type": "NumInGroup",
    "description": "Number of stipulation entries\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)."
  },
  {
    "tag": "233",
    "name": "StipulationType",
    "type": "String",
    "description": "For Fixed Income.\nType of Stipulation.\nOther types may be used by mutual agreement of the counterparties.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    "enum": [
      {
        "value": "AMT",
        "symbolicName": "AlternativeMinimumTax",
        "description": "Alternative Minimum Tax (Y/N)"
      },
      {
        "value": "AUTOREINV",
        "symbolicName": "AutoReinvestment",
        "description": "Auto Reinvestment at <rate> or better"
      },
      {
        "value": "BANKQUAL",
        "symbolicName": "BankQualified",
        "description": "Bank qualified (Y/N)"
      },
      {
        "value": "BGNCON",
        "symbolicName": "BargainConditions",
        "description": "Bargain conditions (see StipulationValue (234) for values)"
      },
      {
        "value": "COUPON",
        "symbolicName": "CouponRange",
        "description": "Coupon range"
      },
      {
        "value": "CURRENCY",
        "symbolicName": "ISOCurrencyCode",
        "description": "ISO Currency Code"
      },
      {
        "value": "CUSTOMDATE",
        "symbolicName": "CustomStart",
        "description": "Custom start/end date"
      },
      {
        "value": "GEOG",
        "symbolicName": "Geographics",
        "description": "Geographics and % range (ex. 234=CA 0-80 [minimum of 80% California assets])"
      },
      {
        "value": "HAIRCUT",
        "symbolicName": "ValuationDiscount",
        "description": "Valuation Discount"
      },
      {
        "value": "INSURED",
        "symbolicName": "Insured",
        "description": "Insured (Y/N)"
      },
      {
        "value": "ISSUE",
        "symbolicName": "IssueDate",
        "description": "Year Or Year/Month of Issue (ex. 234=2002/09)"
      },
      {
        "value": "ISSUER",
        "symbolicName": "Issuer",
        "description": "Issuer's ticker"
      },
      {
        "value": "ISSUESIZE",
        "symbolicName": "IssueSizeRange",
        "description": "issue size range"
      },
      {
        "value": "LOOKBACK",
        "symbolicName": "LookbackDays",
        "description": "Lookback Days"
      },
      {
        "value": "LOT",
        "symbolicName": "ExplicitLotIdentifier",
        "description": "Explicit lot identifier"
      },
      {
        "value": "LOTVAR",
        "symbolicName": "LotVariance",
        "description": "Lot Variance (value in percent maximum over- or under-allocation allowed)"
      },
      {
        "value": "MAT",
        "symbolicName": "MaturityYearAndMonth",
        "description": "Maturity Year And Month"
      },
      {
        "value": "MATURITY",
        "symbolicName": "MaturityRange",
        "description": "Maturity range"
      },
      {
        "value": "MAXSUBS",
        "symbolicName": "MaximumSubstitutions",
        "description": "Maximum substitutions (Repo)"
      },
      {
        "value": "MINDNOM",
        "symbolicName": "MinimumDenomination",
        "description": "Minimum denomination"
      },
      {
        "value": "MININCR",
        "symbolicName": "MinimumIncrement",
        "description": "Minimum increment"
      },
      {
        "value": "MINQTY",
        "symbolicName": "MinimumQuantity",
        "description": "Minimum quantity"
      },
      {
        "value": "PAYFREQ",
        "symbolicName": "PaymentFrequency",
        "description": "Payment frequency, calendar"
      },
      {
        "value": "PIECES",
        "symbolicName": "NumberOfPieces",
        "description": "Number Of Pieces"
      },
      {
        "value": "PMAX",
        "symbolicName": "PoolsMaximum",
        "description": "Pools Maximum"
      },
      {
        "value": "PPL",
        "symbolicName": "PoolsPerLot",
        "description": "Pools per Lot"
      },
      {
        "value": "PPM",
        "symbolicName": "PoolsPerMillion",
        "description": "Pools per Million"
      },
      {
        "value": "PPT",
        "symbolicName": "PoolsPerTrade",
        "description": "Pools per Trade"
      },
      {
        "value": "PRICE",
        "symbolicName": "PriceRange",
        "description": "Price Range"
      },
      {
        "value": "PRICEFREQ",
        "symbolicName": "PricingFrequency",
        "description": "Pricing frequency"
      },
      {
        "value": "PROD",
        "symbolicName": "ProductionYear",
        "description": "Production Year"
      },
      {
        "value": "PROTECT",
        "symbolicName": "CallProtection",
        "description": "Call protection"
      },
      {
        "value": "PURPOSE",
        "symbolicName": "Purpose",
        "description": "Purpose"
      },
      {
        "value": "PXSOURCE",
        "symbolicName": "BenchmarkPriceSource",
        "description": "Benchmark price source"
      },
      {
        "value": "RATING",
        "symbolicName": "RatingSourceAndRange",
        "description": "Rating source and range"
      },
      {
        "value": "REDEMPTION",
        "symbolicName": "TypeOfRedemption",
        "description": "Type Of Redemption - values are: NonCallable, Prefunded, EscrowedToMaturity, Putable, Convertible"
      },
      {
        "value": "RESTRICTED",
        "symbolicName": "Restricted",
        "description": "Restricted (Y/N)"
      },
      {
        "value": "SECTOR",
        "symbolicName": "MarketSector",
        "description": "Market Sector"
      },
      {
        "value": "SECTYPE",
        "symbolicName": "SecurityTypeIncludedOrExcluded",
        "description": "Security Type included or excluded"
      },
      {
        "value": "STRUCT",
        "symbolicName": "Structure",
        "description": "Structure"
      },
      {
        "value": "SUBSFREQ",
        "symbolicName": "SubstitutionsFrequency",
        "description": "Substitutions frequency (Repo)"
      },
      {
        "value": "SUBSLEFT",
        "symbolicName": "SubstitutionsLeft",
        "description": "Substitutions left (Repo)"
      },
      {
        "value": "TEXT",
        "symbolicName": "FreeformText",
        "description": "Freeform Text"
      },
      {
        "value": "TRDVAR",
        "symbolicName": "TradeVariance",
        "description": "Trade Variance (value in percent maximum over- or under-allocation allowed)"
      },
      {
        "value": "WAC",
        "symbolicName": "WeightedAverageCoupon",
        "description": "Weighted Average Coupon - value in percent (exact or range) plus \"Gross\" or \"Net\" of servicing spread (the default) (ex. 234=6.5-Net [minimum of 6.5% net of servicing fee])"
      },
      {
        "value": "WAL",
        "symbolicName": "WeightedAverageLifeCoupon",
        "description": "Weighted Average Life Coupon - value in percent (exact or range)"
      },
      {
        "value": "WALA",
        "symbolicName": "WeightedAverageLoanAge",
        "description": "Weighted Average Loan Age - value in months (exact or range)"
      },
      {
        "value": "WAM",
        "symbolicName": "WeightedAverageMaturity",
        "description": "Weighted Average Maturity - value in months (exact or range)"
      },
      {
        "value": "WHOLE",
        "symbolicName": "WholePool",
        "description": "Whole Pool (Y/N)"
      },
      {
        "value": "YIELD",
        "symbolicName": "YieldRange",
        "description": "Yield Range"
      },
      {
        "value": "AVFICO",
        "symbolicName": "AverageFICOScore",
        "description": "Average FICO Score"
      },
      {
        "value": "AVSIZE",
        "symbolicName": "AverageLoanSize",
        "description": "Average Loan Size"
      },
      {
        "value": "MAXBAL",
        "symbolicName": "MaximumLoanBalance",
        "description": "Maximum Loan Balance"
      },
      {
        "value": "POOL",
        "symbolicName": "PoolIdentifier",
        "description": "Pool Identifier"
      },
      {
        "value": "ROLLTYPE",
        "symbolicName": "TypeOfRollTrade",
        "description": "Type of Roll trade"
      },
      {
        "value": "REFTRADE",
        "symbolicName": "ReferenceToRollingOrClosingTrade",
        "description": "reference to rolling or closing trade"
      },
      {
        "value": "REFPRIN",
        "symbolicName": "PrincipalOfRollingOrClosingTrade",
        "description": "principal of rolling or closing trade"
      },
      {
        "value": "REFINT",
        "symbolicName": "InterestOfRollingOrClosingTrade",
        "description": "interest of rolling or closing trade"
      },
      {
        "value": "AVAILQTY",
        "symbolicName": "AvailableOfferQuantityToBeShownToTheStreet",
        "description": "Available offer quantity to be shown to the street"
      },
      {
        "value": "BROKERCREDIT",
        "symbolicName": "BrokerCredit",
        "description": "Broker's sales credit"
      },
      {
        "value": "INTERNALPX",
        "symbolicName": "OfferPriceToBeShownToInternalBrokers",
        "description": "Offer price to be shown to internal brokers"
      },
      {
        "value": "INTERNALQTY",
        "symbolicName": "OfferQuantityToBeShownToInternalBrokers",
        "description": "Offer quantity to be shown to internal brokers"
      },
      {
        "value": "LEAVEQTY",
        "symbolicName": "TheMinimumResidualOfferQuantity",
        "description": "The minimum residual offer quantity"
      },
      {
        "value": "MAXORDQTY",
        "symbolicName": "MaximumOrderSize",
        "description": "Maximum order size"
      },
      {
        "value": "ORDRINCR",
        "symbolicName": "OrderQuantityIncrement",
        "description": "Order quantity increment"
      },
      {
        "value": "PRIMARY",
        "symbolicName": "PrimaryOrSecondaryMarketIndicator",
        "description": "Primary or Secondary market indicator"
      },
      {
        "value": "SALESCREDITOVR",
        "symbolicName": "BrokerSalesCreditOverride",
        "description": "Broker sales credit override"
      },
      {
        "value": "TRADERCREDIT",
        "symbolicName": "TraderCredit",
        "description": "Trader's credit"
      },
      {
        "value": "DISCOUNT",
        "symbolicName": "DiscountRate",
        "description": "Discount Rate (when price is denominated in percent of par)"
      },
      {
        "value": "YTM",
        "symbolicName": "YieldToMaturity",
        "description": "Yield to Maturity (when YieldType(235) and Yield(236) show a different yield)"
      },
      {
        "value": "ABS",
        "symbolicName": "AbsolutePrepaymentSpeed",
        "description": "Absolute Prepayment Speed"
      },
      {
        "value": "CPP",
        "symbolicName": "ConstantPrepaymentPenalty",
        "description": "Constant Prepayment Penalty"
      },
      {
        "value": "CPR",
        "symbolicName": "ConstantPrepaymentRate",
        "description": "Constant Prepayment Rate"
      },
      {
        "value": "CPY",
        "symbolicName": "ConstantPrepaymentYield",
        "description": "Constant Prepayment Yield"
      },
      {
        "value": "HEP",
        "symbolicName": "FinalCPROfHomeEquityPrepaymentCurve",
        "description": "final CPR of Home Equity Prepayment Curve"
      },
      {
        "value": "MHP",
        "symbolicName": "PercentOfManufacturedHousingPrepaymentCurve",
        "description": "Percent of Manufactured Housing Prepayment Curve"
      },
      {
        "value": "MPR",
        "symbolicName": "MonthlyPrepaymentRate",
        "description": "Monthly Prepayment Rate"
      },
      {
        "value": "PPC",
        "symbolicName": "PercentOfProspectusPrepaymentCurve",
        "description": "Percent of Prospectus Prepayment Curve"
      },
      {
        "value": "PSA",
        "symbolicName": "PercentOfBMAPrepaymentCurve",
        "description": "Percent of BMA Prepayment Curve"
      },
      {
        "value": "SMM",
        "symbolicName": "SingleMonthlyMortality",
        "description": "Single Monthly Mortality"
      }
    ]
  },
  {
    "tag": "234",
    "name": "StipulationValue",
    "type": "String",
    "description": "For Fixed Income. Value of stipulation.\nThe expression can be an absolute single value or a combination of values and logical operators:\n< value\n> value\n<= value\n>= value\nvalue\nvalue - value2\nvalue OR value2\nvalue AND value2\nYES\nNO\nBargain conditions recognized by the London Stock Exchange - to be used when StipulationType is \"BGNCON\".\nCD = Special cum Dividend\nXD = Special ex Dividend\nCC = Special cum Coupon\nXC = Special ex Coupon\nCB = Special cum Bonus\nXB = Special ex Bonus\nCR = Special cum Rights\nXR = Special ex Rights\nCP = Special cum Capital Repayments\nXP = Special ex Capital Repayments\nCS = Cash Settlement\nSP = Special Price\nTR = Report for European Equity Market Securities in accordance with Chapter 8 of the Rules.\nGD = Guaranteed Delivery\nValues for StipulationType = \"PXSOURCE\":\nBB GENERIC\nBB FAIRVALUE\nBROKERTEC\nESPEED\nGOVPX\nHILLIARD FARBER\nICAP\nTRADEWEB\nTULLETT LIBERTY\nIf a particular side of the market is wanted append /BID /OFFER or /MID.\nplus appropriate combinations of the above and other expressions by mutual agreement of the counterparties.\nExamples: \">=60\", \".25\", \"ORANGE OR CONTRACOSTA\", etc.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "235",
    "name": "YieldType",
    "type": "String",
    "description": "Type of yield. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    "enum": [
      {
        "value": "AFTERTAX",
        "symbolicName": "AfterTaxYield",
        "description": "After Tax Yield (Municipals)"
      },
      {
        "value": "ANNUAL",
        "symbolicName": "AnnualYield",
        "description": "Annual Yield"
      },
      {
        "value": "ATISSUE",
        "symbolicName": "YieldAtIssue",
        "description": "Yield At Issue (Municipals)"
      },
      {
        "value": "AVGMATURITY",
        "symbolicName": "YieldToAverageMaturity",
        "description": "Yield To Avg Maturity"
      },
      {
        "value": "BOOK",
        "symbolicName": "BookYield",
        "description": "Book Yield"
      },
      {
        "value": "CALL",
        "symbolicName": "YieldToNextCall",
        "description": "Yield to Next Call"
      },
      {
        "value": "CHANGE",
        "symbolicName": "YieldChangeSinceClose",
        "description": "Yield Change Since Close"
      },
      {
        "value": "CLOSE",
        "symbolicName": "ClosingYield",
        "description": "Closing Yield"
      },
      {
        "value": "COMPOUND",
        "symbolicName": "CompoundYield",
        "description": "Compound Yield"
      },
      {
        "value": "CURRENT",
        "symbolicName": "CurrentYield",
        "description": "Current Yield"
      },
      {
        "value": "GOVTEQUIV",
        "symbolicName": "GvntEquivalentYield",
        "description": "Gvnt Equivalent Yield"
      },
      {
        "value": "GROSS",
        "symbolicName": "TrueGrossYield",
        "description": "True Gross Yield"
      },
      {
        "value": "INFLATION",
        "symbolicName": "YieldWithInflationAssumption",
        "description": "Yield with Inflation Assumption"
      },
      {
        "value": "INVERSEFLOATER",
        "symbolicName": "InverseFloaterBondYield",
        "description": "Inverse Floater Bond Yield"
      },
      {
        "value": "LASTCLOSE",
        "symbolicName": "MostRecentClosingYield",
        "description": "Most Recent Closing Yield"
      },
      {
        "value": "LASTMONTH",
        "symbolicName": "ClosingYieldMostRecentMonth",
        "description": "Closing Yield Most Recent Month"
      },
      {
        "value": "LASTQUARTER",
        "symbolicName": "ClosingYieldMostRecentQuarter",
        "description": "Closing Yield Most Recent Quarter"
      },
      {
        "value": "LASTYEAR",
        "symbolicName": "ClosingYieldMostRecentYear",
        "description": "Closing Yield Most Recent Year"
      },
      {
        "value": "LONGAVGLIFE",
        "symbolicName": "YieldToLongestAverageLife",
        "description": "Yield to Longest Average Life"
      },
      {
        "value": "MARK",
        "symbolicName": "MarkToMarketYield",
        "description": "Mark to Market Yield"
      },
      {
        "value": "MATURITY",
        "symbolicName": "YieldToMaturity",
        "description": "Yield to Maturity"
      },
      {
        "value": "NEXTREFUND",
        "symbolicName": "YieldToNextRefund",
        "description": "Yield to Next Refund (Sinking Fund Bonds)"
      },
      {
        "value": "OPENAVG",
        "symbolicName": "OpenAverageYield",
        "description": "Open Average Yield"
      },
      {
        "value": "PREVCLOSE",
        "symbolicName": "PreviousCloseYield",
        "description": "Previous Close Yield"
      },
      {
        "value": "PROCEEDS",
        "symbolicName": "ProceedsYield",
        "description": "Proceeds Yield"
      },
      {
        "value": "PUT",
        "symbolicName": "YieldToNextPut",
        "description": "Yield to Next Put"
      },
      {
        "value": "SEMIANNUAL",
        "symbolicName": "SemiAnnualYield",
        "description": "Semi-annual Yield"
      },
      {
        "value": "SHORTAVGLIFE",
        "symbolicName": "YieldToShortestAverageLife",
        "description": "Yield to Shortest Average Life"
      },
      {
        "value": "SIMPLE",
        "symbolicName": "SimpleYield",
        "description": "Simple Yield"
      },
      {
        "value": "TAXEQUIV",
        "symbolicName": "TaxEquivalentYield",
        "description": "Tax Equivalent Yield"
      },
      {
        "value": "TENDER",
        "symbolicName": "YieldToTenderDate",
        "description": "Yield to Tender Date"
      },
      {
        "value": "TRUE",
        "symbolicName": "TrueYield",
        "description": "True Yield"
      },
      {
        "value": "VALUE1_32",
        "symbolicName": "YieldValueOf32nds",
        "description": "Yield Value Of 1/32"
      },
      {
        "value": "WORST",
        "symbolicName": "YieldToWorst",
        "description": "Yield To Worst"
      }
    ]
  },
  {
    "tag": "236",
    "name": "Yield",
    "type": "Percentage",
    "description": "Yield percentage.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "237",
    "name": "TotalTakedown",
    "type": "Amt",
    "description": "The price at which the securities are distributed to the different members of an underwriting group for the primary market in Municipals, total gross underwriter's spread.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "238",
    "name": "Concession",
    "type": "Amt",
    "description": "Provides the reduction in price for the secondary market in Muncipals.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "239",
    "name": "RepoCollateralSecurityType",
    "type": "String",
    "description": "Identifies the collateral used in the transaction.\nValid values: see SecurityType (167) field (Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "240",
    "name": "RedemptionDate",
    "type": "LocalMktDate",
    "description": "Return of investor's principal in a security. Bond redemption can occur before maturity date.(Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "241",
    "name": "UnderlyingCouponPaymentDate",
    "type": "LocalMktDate",
    "description": "Underlying security's CouponPaymentDate.\nSee CouponPaymentDate (224) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "242",
    "name": "UnderlyingIssueDate",
    "type": "LocalMktDate",
    "description": "Underlying security's IssueDate.\nSee IssueDate (225) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "243",
    "name": "UnderlyingRepoCollateralSecurityType",
    "type": "String",
    "description": "Underlying security's RepoCollateralSecurityType. See RepoCollateralSecurityType (239) field for description.(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "244",
    "name": "UnderlyingRepurchaseTerm",
    "type": "int",
    "description": "Underlying security's RepurchaseTerm. See RepurchaseTerm (226) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "245",
    "name": "UnderlyingRepurchaseRate",
    "type": "Percentage",
    "description": "Underlying security's RepurchaseRate. See RepurchaseRate (227) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "246",
    "name": "UnderlyingFactor",
    "type": "float",
    "description": "Underlying security's Factor.\nSee Factor (228) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "247",
    "name": "UnderlyingRedemptionDate",
    "type": "LocalMktDate",
    "description": "Underlying security's RedemptionDate. See RedemptionDate (240) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "248",
    "name": "LegCouponPaymentDate",
    "type": "LocalMktDate",
    "description": "Multileg instrument's individual leg security's CouponPaymentDate.\nSee CouponPaymentDate (224) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "249",
    "name": "LegIssueDate",
    "type": "LocalMktDate",
    "description": "Multileg instrument's individual leg security's IssueDate.\nSee IssueDate (225) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "250",
    "name": "LegRepoCollateralSecurityType",
    "type": "String",
    "description": "Multileg instrument's individual leg security's RepoCollateralSecurityType. See RepoCollateralSecurityType (239) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "251",
    "name": "LegRepurchaseTerm",
    "type": "int",
    "description": "Multileg instrument's individual leg security's RepurchaseTerm. See RepurchaseTerm (226) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "252",
    "name": "LegRepurchaseRate",
    "type": "Percentage",
    "description": "Multileg instrument's individual leg security's RepurchaseRate. See RepurchaseRate (227) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "253",
    "name": "LegFactor",
    "type": "float",
    "description": "Multileg instrument's individual leg security's Factor.\nSee Factor (228) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "254",
    "name": "LegRedemptionDate",
    "type": "LocalMktDate",
    "description": "Multileg instrument's individual leg security's RedemptionDate. See RedemptionDate (240) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "255",
    "name": "CreditRating",
    "type": "String",
    "description": "An evaluation of a company's ability to repay obligations or its likelihood of not defaulting. These evaluation are provided by Credit Rating Agencies, i.e. S&P, Moody's.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "256",
    "name": "UnderlyingCreditRating",
    "type": "String",
    "description": "Underlying security's CreditRating.\nSee CreditRating (255) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "257",
    "name": "LegCreditRating",
    "type": "String",
    "description": "Multileg instrument's individual leg security's CreditRating.\nSee CreditRating (255) field for description\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "258",
    "name": "TradedFlatSwitch",
    "type": "Boolean",
    "description": "Driver and part of trade in the event that the Security Master file was wrong at the point of entry(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotTradedFlat",
        "description": "Not Traded Flat"
      },
      {
        "value": "Y",
        "symbolicName": "TradedFlat",
        "description": "Traded Flat"
      }
    ]
  },
  {
    "tag": "259",
    "name": "BasisFeatureDate",
    "type": "LocalMktDate",
    "description": "BasisFeatureDate allows requesting firms within fixed income the ability to request an alternative yield-to-worst, -maturity, -extended or other call. This flows through the confirm process.\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "260",
    "name": "BasisFeaturePrice",
    "type": "Price",
    "description": "Price for BasisFeatureDate.\nSee BasisFeatureDate (259)\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)"
  },
  {
    "tag": "262",
    "name": "MDReqID",
    "type": "String",
    "description": "Unique identifier for Market Data Request"
  },
  {
    "tag": "263",
    "name": "SubscriptionRequestType",
    "type": "char",
    "description": "Subscription Request Type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Snapshot",
        "description": "Snapshot"
      },
      {
        "value": "1",
        "symbolicName": "SnapshotAndUpdates",
        "description": "Snapshot + Updates (Subscribe)"
      },
      {
        "value": "2",
        "symbolicName": "DisablePreviousSnapshot",
        "description": "Disable previous Snapshot + Update Request (Unsubscribe)"
      }
    ]
  },
  {
    "tag": "264",
    "name": "MarketDepth",
    "type": "int",
    "description": "Depth of market for Book Snapshot / Incremental updates\n0 - full book depth\n1 - top of book\n2 and above - book depth (number of levels)"
  },
  {
    "tag": "265",
    "name": "MDUpdateType",
    "type": "int",
    "description": "Specifies the type of Market Data update.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "FullRefresh",
        "description": "Full refresh"
      },
      {
        "value": "1",
        "symbolicName": "IncrementalRefresh",
        "description": "Incremental refresh"
      }
    ]
  },
  {
    "tag": "266",
    "name": "AggregatedBook",
    "type": "Boolean",
    "description": "Specifies whether or not book entries should be aggregated. (Not specified) = broker option",
    "enum": [
      {
        "value": "Y",
        "symbolicName": "BookEntriesToBeAggregated",
        "description": "book entries to be aggregated"
      },
      {
        "value": "N",
        "symbolicName": "BookEntriesShouldNotBeAggregated",
        "description": "book entries should not be aggregated"
      }
    ]
  },
  {
    "tag": "267",
    "name": "NoMDEntryTypes",
    "type": "NumInGroup",
    "description": "Number of MDEntryType (269) fields requested."
  },
  {
    "tag": "268",
    "name": "NoMDEntries",
    "type": "NumInGroup",
    "description": "Number of entries in Market Data message."
  },
  {
    "tag": "269",
    "name": "MDEntryType",
    "type": "char",
    "description": "Type Market Data entry.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Bid",
        "description": "Bid"
      },
      {
        "value": "1",
        "symbolicName": "Offer",
        "description": "Offer"
      },
      {
        "value": "2",
        "symbolicName": "Trade",
        "description": "Trade"
      },
      {
        "value": "3",
        "symbolicName": "IndexValue",
        "description": "Index Value"
      },
      {
        "value": "4",
        "symbolicName": "OpeningPrice",
        "description": "Opening Price"
      },
      {
        "value": "5",
        "symbolicName": "ClosingPrice",
        "description": "Closing Price"
      },
      {
        "value": "6",
        "symbolicName": "SettlementPrice",
        "description": "Settlement Price"
      },
      {
        "value": "7",
        "symbolicName": "TradingSessionHighPrice",
        "description": "Trading Session High Price"
      },
      {
        "value": "8",
        "symbolicName": "TradingSessionLowPrice",
        "description": "Trading Session Low Price"
      },
      {
        "value": "9",
        "symbolicName": "TradingSessionVWAPPrice",
        "description": "Trading Session VWAP Price"
      },
      {
        "value": "A",
        "symbolicName": "Imbalance",
        "description": "Imbalance"
      },
      {
        "value": "B",
        "symbolicName": "TradeVolume",
        "description": "Trade Volume"
      },
      {
        "value": "C",
        "symbolicName": "OpenInterest",
        "description": "Open Interest"
      },
      {
        "value": "D",
        "symbolicName": "CompositeUnderlyingPrice",
        "description": "Composite Underlying Price"
      },
      {
        "value": "E",
        "symbolicName": "SimulatedSellPrice",
        "description": "Simulated Sell Price"
      },
      {
        "value": "F",
        "symbolicName": "SimulatedBuyPrice",
        "description": "Simulated Buy Price"
      },
      {
        "value": "G",
        "symbolicName": "MarginRate",
        "description": "Margin Rate"
      },
      {
        "value": "H",
        "symbolicName": "MidPrice",
        "description": "Mid Price"
      },
      {
        "value": "J",
        "symbolicName": "EmptyBook",
        "description": "Empty Book"
      },
      {
        "value": "K",
        "symbolicName": "SettleHighPrice",
        "description": "Settle High Price"
      },
      {
        "value": "L",
        "symbolicName": "SettleLowPrice",
        "description": "Settle Low Price"
      },
      {
        "value": "M",
        "symbolicName": "PriorSettlePrice",
        "description": "Prior Settle Price"
      },
      {
        "value": "N",
        "symbolicName": "SessionHighBid",
        "description": "Session High Bid"
      },
      {
        "value": "O",
        "symbolicName": "SessionLowOffer",
        "description": "Session Low Offer"
      },
      {
        "value": "P",
        "symbolicName": "EarlyPrices",
        "description": "Early Prices"
      },
      {
        "value": "Q",
        "symbolicName": "AuctionClearingPrice",
        "description": "Auction Clearing Price"
      },
      {
        "value": "S",
        "symbolicName": "SwapValueFactor",
        "description": "Swap Value Factor (SVP) for swaps cleared through a central counterparty (CCP)"
      },
      {
        "value": "R",
        "symbolicName": "DailyValueAdjustmentForLongPositions",
        "description": "Daily value adjustment for long positions"
      },
      {
        "value": "T",
        "symbolicName": "CumulativeValueAdjustmentForLongPositions",
        "description": "Cumulative Value Adjustment for long positions"
      },
      {
        "value": "U",
        "symbolicName": "DailyValueAdjustmentForShortPositions",
        "description": "Daily Value Adjustment for Short Positions"
      },
      {
        "value": "V",
        "symbolicName": "CumulativeValueAdjustmentForShortPositions",
        "description": "Cumulative Value Adjustment for Short Positions"
      },
      {
        "value": "Y",
        "symbolicName": "RecoveryRate",
        "description": "Recovery Rate"
      },
      {
        "value": "Z",
        "symbolicName": "RecoveryRateForLong",
        "description": "Recovery Rate for Long"
      },
      {
        "value": "a",
        "symbolicName": "RecoveryRateForShort",
        "description": "Recovery Rate for Short"
      },
      {
        "value": "W",
        "symbolicName": "FixingPrice",
        "description": "Fixing Price"
      },
      {
        "value": "X",
        "symbolicName": "CashRate",
        "description": "Cash Rate"
      }
    ]
  },
  {
    "tag": "270",
    "name": "MDEntryPx",
    "type": "Price",
    "description": "Price of the Market Data Entry."
  },
  {
    "tag": "271",
    "name": "MDEntrySize",
    "type": "Qty",
    "description": "Quantity or volume represented by the Market Data Entry."
  },
  {
    "tag": "272",
    "name": "MDEntryDate",
    "type": "UTCDateOnly",
    "description": "Date of Market Data Entry.\n(prior to FIX 4.4 field was of type UTCDate)"
  },
  {
    "tag": "273",
    "name": "MDEntryTime",
    "type": "UTCTimeOnly",
    "description": "Time of Market Data Entry."
  },
  {
    "tag": "274",
    "name": "TickDirection",
    "type": "char",
    "description": "Direction of the \"tick\".",
    "enum": [
      {
        "value": "0",
        "symbolicName": "PlusTick",
        "description": "Plus Tick"
      },
      {
        "value": "1",
        "symbolicName": "ZeroPlusTick",
        "description": "Zero-Plus Tick"
      },
      {
        "value": "2",
        "symbolicName": "MinusTick",
        "description": "Minus Tick"
      },
      {
        "value": "3",
        "symbolicName": "ZeroMinusTick",
        "description": "Zero-Minus Tick"
      }
    ]
  },
  {
    "tag": "275",
    "name": "MDMkt",
    "type": "Exchange",
    "description": "Market posting quote / trade.\nValid values:\nSee \"Appendix 6-C\""
  },
  {
    "tag": "276",
    "name": "QuoteCondition",
    "type": "MultipleStringValue",
    "description": "Space-delimited list of conditions describing a quote.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Open",
        "description": "Open/Active"
      },
      {
        "value": "B",
        "symbolicName": "Closed",
        "description": "Closed/Inactive"
      },
      {
        "value": "C",
        "symbolicName": "ExchangeBest",
        "description": "Exchange Best"
      },
      {
        "value": "D",
        "symbolicName": "ConsolidatedBest",
        "description": "Consolidated Best"
      },
      {
        "value": "E",
        "symbolicName": "Locked",
        "description": "Locked"
      },
      {
        "value": "F",
        "symbolicName": "Crossed",
        "description": "Crossed"
      },
      {
        "value": "G",
        "symbolicName": "Depth",
        "description": "Depth"
      },
      {
        "value": "H",
        "symbolicName": "FastTrading",
        "description": "Fast Trading"
      },
      {
        "value": "I",
        "symbolicName": "NonFirm",
        "description": "Non-Firm"
      },
      {
        "value": "L",
        "symbolicName": "Manual",
        "description": "Manual/Slow Quote"
      },
      {
        "value": "J",
        "symbolicName": "OutrightPrice",
        "description": "Outright Price"
      },
      {
        "value": "K",
        "symbolicName": "ImpliedPrice",
        "description": "Implied Price"
      },
      {
        "value": "M",
        "symbolicName": "DepthOnOffer",
        "description": "Depth on Offer"
      },
      {
        "value": "N",
        "symbolicName": "DepthOnBid",
        "description": "Depth on Bid"
      },
      {
        "value": "O",
        "symbolicName": "Closing",
        "description": "Closing"
      },
      {
        "value": "P",
        "symbolicName": "NewsDissemination",
        "description": "News Dissemination"
      },
      {
        "value": "Q",
        "symbolicName": "TradingRange",
        "description": "Trading Range"
      },
      {
        "value": "R",
        "symbolicName": "OrderInflux",
        "description": "Order Influx"
      },
      {
        "value": "S",
        "symbolicName": "DueToRelated",
        "description": "Due to Related"
      },
      {
        "value": "T",
        "symbolicName": "NewsPending",
        "description": "News Pending"
      },
      {
        "value": "U",
        "symbolicName": "AdditionalInfo",
        "description": "Additional Info"
      },
      {
        "value": "V",
        "symbolicName": "AdditionalInfoDueToRelated",
        "description": "Additional Info due to related"
      },
      {
        "value": "W",
        "symbolicName": "Resume",
        "description": "Resume"
      },
      {
        "value": "X",
        "symbolicName": "ViewOfCommon",
        "description": "View of Common"
      },
      {
        "value": "Y",
        "symbolicName": "VolumeAlert",
        "description": "Volume Alert"
      },
      {
        "value": "Z",
        "symbolicName": "OrderImbalance",
        "description": "Order Imbalance"
      },
      {
        "value": "a",
        "symbolicName": "EquipmentChangeover",
        "description": "Equipment Changeover"
      },
      {
        "value": "b",
        "symbolicName": "NoOpen",
        "description": "No Open / No Resume"
      },
      {
        "value": "c",
        "symbolicName": "RegularETH",
        "description": "Regular ETH"
      },
      {
        "value": "d",
        "symbolicName": "AutomaticExecution",
        "description": "Automatic Execution"
      },
      {
        "value": "e",
        "symbolicName": "AutomaticExecutionETH",
        "description": "Automatic Execution ETH"
      },
      {
        "value": "f",
        "symbolicName": "FastMarketETH",
        "description": "Fast Market ETH"
      },
      {
        "value": "g",
        "symbolicName": "InactiveETH",
        "description": "Inactive ETH"
      },
      {
        "value": "h",
        "symbolicName": "Rotation",
        "description": "Rotation"
      },
      {
        "value": "i",
        "symbolicName": "RotationETH",
        "description": "Rotation ETH"
      },
      {
        "value": "j",
        "symbolicName": "Halt",
        "description": "Halt"
      },
      {
        "value": "k",
        "symbolicName": "HaltETH",
        "description": "Halt ETH"
      },
      {
        "value": "l",
        "symbolicName": "DueToNewsDissemination",
        "description": "Due to News Dissemination"
      },
      {
        "value": "m",
        "symbolicName": "DueToNewsPending",
        "description": "Due to News Pending"
      },
      {
        "value": "n",
        "symbolicName": "TradingResume",
        "description": "Trading Resume"
      },
      {
        "value": "o",
        "symbolicName": "OutOfSequence",
        "description": "Out of Sequence"
      },
      {
        "value": "p",
        "symbolicName": "BidSpecialist",
        "description": "Bid Specialist"
      },
      {
        "value": "q",
        "symbolicName": "OfferSpecialist",
        "description": "Offer Specialist"
      },
      {
        "value": "r",
        "symbolicName": "BidOfferSpecialist",
        "description": "Bid Offer Specialist"
      },
      {
        "value": "s",
        "symbolicName": "EndOfDaySAM",
        "description": "End of Day SAM"
      },
      {
        "value": "t",
        "symbolicName": "ForbiddenSAM",
        "description": "Forbidden SAM"
      },
      {
        "value": "u",
        "symbolicName": "FrozenSAM",
        "description": "Frozen SAM"
      },
      {
        "value": "v",
        "symbolicName": "PreOpeningSAM",
        "description": "PreOpening SAM"
      },
      {
        "value": "w",
        "symbolicName": "OpeningSAM",
        "description": "Opening SAM"
      },
      {
        "value": "x",
        "symbolicName": "OpenSAM",
        "description": "Open SAM"
      },
      {
        "value": "y",
        "symbolicName": "SurveillanceSAM",
        "description": "Surveillance SAM"
      },
      {
        "value": "z",
        "symbolicName": "SuspendedSAM",
        "description": "Suspended SAM"
      },
      {
        "value": "0",
        "symbolicName": "ReservedSAM",
        "description": "Reserved SAM"
      },
      {
        "value": "1",
        "symbolicName": "NoActiveSAM",
        "description": "No Active SAM"
      },
      {
        "value": "2",
        "symbolicName": "Restricted",
        "description": "Restricted"
      },
      {
        "value": "3",
        "symbolicName": "RestOfBookVWAP",
        "description": "Rest of Book VWAP"
      },
      {
        "value": "4",
        "symbolicName": "BetterPricesInConditionalOrders",
        "description": "Better Prices in Conditional Orders"
      },
      {
        "value": "5",
        "symbolicName": "MedianPrice",
        "description": "Median Price"
      },
      {
        "value": "6",
        "symbolicName": "FullCurve",
        "description": "Full Curve"
      },
      {
        "value": "7",
        "symbolicName": "FlatCurve",
        "description": "Flat Curve"
      }
    ]
  },
  {
    "tag": "277",
    "name": "TradeCondition",
    "type": "MultipleStringValue",
    "description": "Space-delimited list of conditions describing a trade",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Cash",
        "description": "Cash (only) Market"
      },
      {
        "value": "B",
        "symbolicName": "AveragePriceTrade",
        "description": "Average Price Trade"
      },
      {
        "value": "C",
        "symbolicName": "CashTrade",
        "description": "Cash Trade (same day clearing)"
      },
      {
        "value": "D",
        "symbolicName": "NextDay",
        "description": "Next Day (only)Market"
      },
      {
        "value": "E",
        "symbolicName": "Opening",
        "description": "Opening/Reopening Trade Detail"
      },
      {
        "value": "F",
        "symbolicName": "IntradayTradeDetail",
        "description": "Intraday Trade Detail"
      },
      {
        "value": "G",
        "symbolicName": "Rule127Trade",
        "description": "Rule 127 Trade (NYSE)"
      },
      {
        "value": "H",
        "symbolicName": "Rule155Trade",
        "description": "Rule 155 Trade (AMEX)"
      },
      {
        "value": "I",
        "symbolicName": "SoldLast",
        "description": "Sold Last (late reporting)"
      },
      {
        "value": "J",
        "symbolicName": "NextDayTrade",
        "description": "Next Day Trade (next day clearing)"
      },
      {
        "value": "K",
        "symbolicName": "Opened",
        "description": "Opened (late report of opened trade)"
      },
      {
        "value": "L",
        "symbolicName": "Seller",
        "description": "Seller"
      },
      {
        "value": "M",
        "symbolicName": "Sold",
        "description": "Sold (out of sequence)"
      },
      {
        "value": "N",
        "symbolicName": "StoppedStock",
        "description": "Stopped Stock (guarantee of price but does not execute the order)"
      },
      {
        "value": "P",
        "symbolicName": "ImbalanceMoreBuyers",
        "description": "Imbalance More Buyers (cannot be used in combination with Q)"
      },
      {
        "value": "Q",
        "symbolicName": "ImbalanceMoreSellers",
        "description": "Imbalance More Sellers (cannot be used in combination with P)"
      },
      {
        "value": "R",
        "symbolicName": "OpeningPrice",
        "description": "Opening Price"
      },
      {
        "value": "S",
        "symbolicName": "BargainCondition",
        "description": "Bargain Condition (LSE)"
      },
      {
        "value": "T",
        "symbolicName": "ConvertedPriceIndicator",
        "description": "Converted Price Indicator"
      },
      {
        "value": "U",
        "symbolicName": "ExchangeLast",
        "description": "Exchange Last"
      },
      {
        "value": "V",
        "symbolicName": "FinalPriceOfSession",
        "description": "Final Price of Session"
      },
      {
        "value": "W",
        "symbolicName": "ExPit",
        "description": "Ex-pit"
      },
      {
        "value": "X",
        "symbolicName": "Crossed",
        "description": "Crossed"
      },
      {
        "value": "Y",
        "symbolicName": "TradesResultingFromManual",
        "description": "Trades resulting from manual/slow quote"
      },
      {
        "value": "Z",
        "symbolicName": "TradesResultingFromIntermarketSweep",
        "description": "Trades resulting from intermarket sweep"
      },
      {
        "value": "a",
        "symbolicName": "VolumeOnly",
        "description": "Volume Only"
      },
      {
        "value": "b",
        "symbolicName": "DirectPlus",
        "description": "Direct Plus"
      },
      {
        "value": "c",
        "symbolicName": "Acquisition",
        "description": "Acquisition"
      },
      {
        "value": "d",
        "symbolicName": "Bunched",
        "description": "Bunched"
      },
      {
        "value": "e",
        "symbolicName": "Distribution",
        "description": "Distribution"
      },
      {
        "value": "f",
        "symbolicName": "BunchedSale",
        "description": "Bunched Sale"
      },
      {
        "value": "g",
        "symbolicName": "SplitTrade",
        "description": "Split Trade"
      },
      {
        "value": "h",
        "symbolicName": "CancelStopped",
        "description": "Cancel Stopped"
      },
      {
        "value": "i",
        "symbolicName": "CancelETH",
        "description": "Cancel ETH"
      },
      {
        "value": "j",
        "symbolicName": "CancelStoppedETH",
        "description": "Cancel Stopped ETH"
      },
      {
        "value": "k",
        "symbolicName": "OutOfSequenceETH",
        "description": "Out of Sequence ETH"
      },
      {
        "value": "l",
        "symbolicName": "CancelLastETH",
        "description": "Cancel Last ETH"
      },
      {
        "value": "m",
        "symbolicName": "SoldLastSaleETH",
        "description": "Sold Last Sale ETH"
      },
      {
        "value": "n",
        "symbolicName": "CancelLast",
        "description": "Cancel Last"
      },
      {
        "value": "o",
        "symbolicName": "SoldLastSale",
        "description": "Sold Last Sale"
      },
      {
        "value": "p",
        "symbolicName": "CancelOpen",
        "description": "Cancel Open"
      },
      {
        "value": "q",
        "symbolicName": "CancelOpenETH",
        "description": "Cancel Open ETH"
      },
      {
        "value": "r",
        "symbolicName": "OpenedSaleETH",
        "description": "Opened Sale ETH"
      },
      {
        "value": "s",
        "symbolicName": "CancelOnly",
        "description": "Cancel Only"
      },
      {
        "value": "t",
        "symbolicName": "CancelOnlyETH",
        "description": "Cancel Only ETH"
      },
      {
        "value": "u",
        "symbolicName": "LateOpenETH",
        "description": "Late Open ETH"
      },
      {
        "value": "v",
        "symbolicName": "AutoExecutionETH",
        "description": "Auto Execution ETH"
      },
      {
        "value": "w",
        "symbolicName": "Reopen",
        "description": "Reopen"
      },
      {
        "value": "x",
        "symbolicName": "ReopenETH",
        "description": "Reopen ETH"
      },
      {
        "value": "y",
        "symbolicName": "Adjusted",
        "description": "Adjusted"
      },
      {
        "value": "z",
        "symbolicName": "AdjustedETH",
        "description": "Adjusted ETH"
      },
      {
        "value": "AA",
        "symbolicName": "Spread",
        "description": "Spread"
      },
      {
        "value": "AB",
        "symbolicName": "SpreadETH",
        "description": "Spread ETH"
      },
      {
        "value": "AC",
        "symbolicName": "Straddle",
        "description": "Straddle"
      },
      {
        "value": "AD",
        "symbolicName": "StraddleETH",
        "description": "Straddle ETH"
      },
      {
        "value": "AE",
        "symbolicName": "Stopped",
        "description": "Stopped"
      },
      {
        "value": "AF",
        "symbolicName": "StoppedETH",
        "description": "Stopped ETH"
      },
      {
        "value": "AG",
        "symbolicName": "RegularETH",
        "description": "Regular ETH"
      },
      {
        "value": "AH",
        "symbolicName": "Combo",
        "description": "Combo"
      },
      {
        "value": "AI",
        "symbolicName": "ComboETH",
        "description": "Combo ETH"
      },
      {
        "value": "AJ",
        "symbolicName": "OfficialClosingPrice",
        "description": "Official Closing Price"
      },
      {
        "value": "AK",
        "symbolicName": "PriorReferencePrice",
        "description": "Prior Reference Price"
      },
      {
        "value": "0",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "AL",
        "symbolicName": "StoppedSoldLast",
        "description": "Stopped Sold Last"
      },
      {
        "value": "AM",
        "symbolicName": "StoppedOutOfSequence",
        "description": "Stopped Out of Sequence"
      },
      {
        "value": "AN",
        "symbolicName": "OfficalClosingPrice",
        "description": "Offical Closing Price (duplicate enumeration - use 'AJ' instead)"
      },
      {
        "value": "AO",
        "symbolicName": "CrossedOld",
        "description": "Crossed (duplicate enumeration - use 'X' instead)"
      },
      {
        "value": "AP",
        "symbolicName": "FastMarket",
        "description": "Fast Market"
      },
      {
        "value": "AQ",
        "symbolicName": "AutomaticExecution",
        "description": "Automatic Execution"
      },
      {
        "value": "AR",
        "symbolicName": "FormT",
        "description": "Form T"
      },
      {
        "value": "AS",
        "symbolicName": "BasketIndex",
        "description": "Basket Index"
      },
      {
        "value": "AT",
        "symbolicName": "BurstBasket",
        "description": "Burst Basket"
      },
      {
        "value": "AV",
        "symbolicName": "OutsideSpread",
        "description": "Outside Spread"
      },
      {
        "value": "1",
        "symbolicName": "ImpliedTrade",
        "description": "Implied Trade"
      },
      {
        "value": "2",
        "symbolicName": "MarketplaceEnteredTrade",
        "description": "Marketplace entered trade"
      },
      {
        "value": "3",
        "symbolicName": "MultAssetClassMultilegTrade",
        "description": "Mult Asset Class Multileg Trade"
      },
      {
        "value": "4",
        "symbolicName": "MultilegToMultilegTrade",
        "description": "Multileg-to-Multileg Trade"
      }
    ]
  },
  {
    "tag": "278",
    "name": "MDEntryID",
    "type": "String",
    "description": "Unique Market Data Entry identifier."
  },
  {
    "tag": "279",
    "name": "MDUpdateAction",
    "type": "char",
    "description": "Type of Market Data update action.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Change",
        "description": "Change"
      },
      {
        "value": "2",
        "symbolicName": "Delete",
        "description": "Delete"
      },
      {
        "value": "3",
        "symbolicName": "DeleteThru",
        "description": "Delete Thru"
      },
      {
        "value": "4",
        "symbolicName": "DeleteFrom",
        "description": "Delete From"
      },
      {
        "value": "5",
        "symbolicName": "Overlay",
        "description": "Overlay"
      }
    ]
  },
  {
    "tag": "280",
    "name": "MDEntryRefID",
    "type": "String",
    "description": "Refers to a previous MDEntryID (278)."
  },
  {
    "tag": "281",
    "name": "MDReqRejReason",
    "type": "char",
    "description": "Reason for the rejection of a Market Data request.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "1",
        "symbolicName": "DuplicateMDReqID",
        "description": "Duplicate MDReqID"
      },
      {
        "value": "2",
        "symbolicName": "InsufficientBandwidth",
        "description": "Insufficient Bandwidth"
      },
      {
        "value": "3",
        "symbolicName": "InsufficientPermissions",
        "description": "Insufficient Permissions"
      },
      {
        "value": "4",
        "symbolicName": "UnsupportedSubscriptionRequestType",
        "description": "Unsupported SubscriptionRequestType"
      },
      {
        "value": "5",
        "symbolicName": "UnsupportedMarketDepth",
        "description": "Unsupported MarketDepth"
      },
      {
        "value": "6",
        "symbolicName": "UnsupportedMDUpdateType",
        "description": "Unsupported MDUpdateType"
      },
      {
        "value": "7",
        "symbolicName": "UnsupportedAggregatedBook",
        "description": "Unsupported AggregatedBook"
      },
      {
        "value": "8",
        "symbolicName": "UnsupportedMDEntryType",
        "description": "Unsupported MDEntryType"
      },
      {
        "value": "9",
        "symbolicName": "UnsupportedTradingSessionID",
        "description": "Unsupported TradingSessionID"
      },
      {
        "value": "A",
        "symbolicName": "UnsupportedScope",
        "description": "Unsupported Scope"
      },
      {
        "value": "B",
        "symbolicName": "UnsupportedOpenCloseSettleFlag",
        "description": "Unsupported OpenCloseSettleFlag"
      },
      {
        "value": "C",
        "symbolicName": "UnsupportedMDImplicitDelete",
        "description": "Unsupported MDImplicitDelete"
      },
      {
        "value": "D",
        "symbolicName": "InsufficientCredit",
        "description": "Insufficient credit"
      }
    ]
  },
  {
    "tag": "282",
    "name": "MDEntryOriginator",
    "type": "String",
    "description": "Originator of a Market Data Entry"
  },
  {
    "tag": "283",
    "name": "LocationID",
    "type": "String",
    "description": "Identification of a Market Maker's location"
  },
  {
    "tag": "284",
    "name": "DeskID",
    "type": "String",
    "description": "Identification of a Market Maker's desk"
  },
  {
    "tag": "285",
    "name": "DeleteReason",
    "type": "char",
    "description": "Reason for deletion.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Cancellation",
        "description": "Cancellation / Trade Bust"
      },
      {
        "value": "1",
        "symbolicName": "Error",
        "description": "Error"
      }
    ]
  },
  {
    "tag": "286",
    "name": "OpenCloseSettlFlag",
    "type": "MultipleCharValue",
    "description": "Flag that identifies a market data entry. (Prior to FIX 4.3 this field was of type char)",
    "enum": [
      {
        "value": "0",
        "symbolicName": "DailyOpen",
        "description": "Daily Open / Close / Settlement entry"
      },
      {
        "value": "1",
        "symbolicName": "SessionOpen",
        "description": "Session Open / Close / Settlement entry"
      },
      {
        "value": "2",
        "symbolicName": "DeliverySettlementEntry",
        "description": "Delivery Settlement entry"
      },
      {
        "value": "3",
        "symbolicName": "ExpectedEntry",
        "description": "Expected entry"
      },
      {
        "value": "4",
        "symbolicName": "EntryFromPreviousBusinessDay",
        "description": "Entry from previous business day"
      },
      {
        "value": "5",
        "symbolicName": "TheoreticalPriceValue",
        "description": "Theoretical Price value"
      }
    ]
  },
  {
    "tag": "287",
    "name": "SellerDays",
    "type": "int",
    "description": "Specifies the number of days that may elapse before delivery of the security"
  },
  {
    "tag": "288",
    "name": "MDEntryBuyer",
    "type": "String",
    "description": "Buying party in a trade"
  },
  {
    "tag": "289",
    "name": "MDEntrySeller",
    "type": "String",
    "description": "Selling party in a trade"
  },
  {
    "tag": "290",
    "name": "MDEntryPositionNo",
    "type": "int",
    "description": "Display position of a bid or offer, numbered from most competitive to least competitive, per market side, beginning with ."
  },
  {
    "tag": "291",
    "name": "FinancialStatus",
    "type": "MultipleCharValue",
    "description": "Identifies a firm's or a security's financial status",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Bankrupt",
        "description": "Bankrupt"
      },
      {
        "value": "2",
        "symbolicName": "PendingDelisting",
        "description": "Pending delisting"
      },
      {
        "value": "3",
        "symbolicName": "Restricted",
        "description": "Restricted"
      }
    ]
  },
  {
    "tag": "292",
    "name": "CorporateAction",
    "type": "MultipleCharValue",
    "description": "Identifies the type of Corporate Action.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "ExDividend",
        "description": "Ex-Dividend"
      },
      {
        "value": "B",
        "symbolicName": "ExDistribution",
        "description": "Ex-Distribution"
      },
      {
        "value": "C",
        "symbolicName": "ExRights",
        "description": "Ex-Rights"
      },
      {
        "value": "D",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "E",
        "symbolicName": "ExInterest",
        "description": "Ex-Interest"
      },
      {
        "value": "F",
        "symbolicName": "CashDividend",
        "description": "Cash Dividend"
      },
      {
        "value": "G",
        "symbolicName": "StockDividend",
        "description": "Stock Dividend"
      },
      {
        "value": "H",
        "symbolicName": "NonIntegerStockSplit",
        "description": "Non-Integer Stock Split"
      },
      {
        "value": "I",
        "symbolicName": "ReverseStockSplit",
        "description": "Reverse Stock Split"
      },
      {
        "value": "J",
        "symbolicName": "StandardIntegerStockSplit",
        "description": "Standard-Integer Stock Split"
      },
      {
        "value": "K",
        "symbolicName": "PositionConsolidation",
        "description": "Position Consolidation"
      },
      {
        "value": "L",
        "symbolicName": "LiquidationReorganization",
        "description": "Liquidation Reorganization"
      },
      {
        "value": "M",
        "symbolicName": "MergerReorganization",
        "description": "Merger Reorganization"
      },
      {
        "value": "N",
        "symbolicName": "RightsOffering",
        "description": "Rights Offering"
      },
      {
        "value": "O",
        "symbolicName": "ShareholderMeeting",
        "description": "Shareholder Meeting"
      },
      {
        "value": "P",
        "symbolicName": "Spinoff",
        "description": "Spinoff"
      },
      {
        "value": "Q",
        "symbolicName": "TenderOffer",
        "description": "Tender Offer"
      },
      {
        "value": "R",
        "symbolicName": "Warrant",
        "description": "Warrant"
      },
      {
        "value": "S",
        "symbolicName": "SpecialAction",
        "description": "Special Action"
      },
      {
        "value": "T",
        "symbolicName": "SymbolConversion",
        "description": "Symbol Conversion"
      },
      {
        "value": "U",
        "symbolicName": "CUSIP",
        "description": "CUSIP / Name Change"
      },
      {
        "value": "V",
        "symbolicName": "LeapRollover",
        "description": "Leap Rollover"
      },
      {
        "value": "W",
        "symbolicName": "SuccessionEvent",
        "description": "Succession Event"
      }
    ]
  },
  {
    "tag": "293",
    "name": "DefBidSize",
    "type": "Qty",
    "description": "Default Bid Size."
  },
  {
    "tag": "294",
    "name": "DefOfferSize",
    "type": "Qty",
    "description": "Default Offer Size."
  },
  {
    "tag": "295",
    "name": "NoQuoteEntries",
    "type": "NumInGroup",
    "description": "The number of quote entries for a QuoteSet."
  },
  {
    "tag": "296",
    "name": "NoQuoteSets",
    "type": "NumInGroup",
    "description": "The number of sets of quotes in the message."
  },
  {
    "tag": "297",
    "name": "QuoteStatus",
    "type": "int",
    "description": "Identifies the status of the quote acknowledgement.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "1",
        "symbolicName": "CancelForSymbol",
        "description": "Cancel for Symbol(s)"
      },
      {
        "value": "2",
        "symbolicName": "CanceledForSecurityType",
        "description": "Canceled for Security Type(s)"
      },
      {
        "value": "3",
        "symbolicName": "CanceledForUnderlying",
        "description": "Canceled for Underlying"
      },
      {
        "value": "4",
        "symbolicName": "CanceledAll",
        "description": "Canceled All"
      },
      {
        "value": "5",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "6",
        "symbolicName": "RemovedFromMarket",
        "description": "Removed from Market"
      },
      {
        "value": "7",
        "symbolicName": "Expired",
        "description": "Expired"
      },
      {
        "value": "8",
        "symbolicName": "Query",
        "description": "Query"
      },
      {
        "value": "9",
        "symbolicName": "QuoteNotFound",
        "description": "Quote Not Found"
      },
      {
        "value": "10",
        "symbolicName": "Pending",
        "description": "Pending"
      },
      {
        "value": "11",
        "symbolicName": "Pass",
        "description": "Pass"
      },
      {
        "value": "12",
        "symbolicName": "LockedMarketWarning",
        "description": "Locked Market Warning"
      },
      {
        "value": "13",
        "symbolicName": "CrossMarketWarning",
        "description": "Cross Market Warning"
      },
      {
        "value": "14",
        "symbolicName": "CanceledDueToLockMarket",
        "description": "Canceled Due To Lock Market"
      },
      {
        "value": "15",
        "symbolicName": "CanceledDueToCrossMarket",
        "description": "Canceled Due To Cross Market"
      },
      {
        "value": "16",
        "symbolicName": "Active",
        "description": "Active"
      },
      {
        "value": "17",
        "symbolicName": "Canceled",
        "description": "Canceled"
      },
      {
        "value": "18",
        "symbolicName": "UnsolicitedQuoteReplenishment",
        "description": "Unsolicited Quote Replenishment"
      },
      {
        "value": "19",
        "symbolicName": "PendingEndTrade",
        "description": "Pending End Trade"
      },
      {
        "value": "20",
        "symbolicName": "TooLateToEnd",
        "description": "Too Late to End"
      }
    ]
  },
  {
    "tag": "298",
    "name": "QuoteCancelType",
    "type": "int",
    "description": "Identifies the type of quote cancel.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CancelForOneOrMoreSecurities",
        "description": "Cancel for one or more securities"
      },
      {
        "value": "2",
        "symbolicName": "CancelForSecurityType",
        "description": "Cancel for Security Type(s)"
      },
      {
        "value": "3",
        "symbolicName": "CancelForUnderlyingSecurity",
        "description": "Cancel for underlying security"
      },
      {
        "value": "4",
        "symbolicName": "CancelAllQuotes",
        "description": "Cancel All Quotes"
      },
      {
        "value": "5",
        "symbolicName": "CancelQuoteSpecifiedInQuoteID",
        "description": "Cancel quote specified in QuoteID"
      },
      {
        "value": "6",
        "symbolicName": "CancelByQuoteType",
        "description": "Cancel by QuoteType(537)"
      },
      {
        "value": "7",
        "symbolicName": "CancelForSecurityIssuer",
        "description": "Cancel for Security Issuer"
      },
      {
        "value": "8",
        "symbolicName": "CancelForIssuerOfUnderlyingSecurity",
        "description": "Cancel for Issuer of Underlying Security"
      }
    ]
  },
  {
    "tag": "299",
    "name": "QuoteEntryID",
    "type": "String",
    "description": "Unique identifier for a quote. The QuoteEntryID stays with the quote as a static identifier even if the quote is updated."
  },
  {
    "tag": "300",
    "name": "QuoteRejectReason",
    "type": "int",
    "description": "Reason Quote was rejected:",
    "enum": [
      {
        "value": "1",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown Symbol (security)"
      },
      {
        "value": "2",
        "symbolicName": "Exchange",
        "description": "Exchange (Security) closed"
      },
      {
        "value": "3",
        "symbolicName": "QuoteRequestExceedsLimit",
        "description": "Quote Request exceeds limit"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too late to enter"
      },
      {
        "value": "5",
        "symbolicName": "UnknownQuote",
        "description": "Unknown Quote"
      },
      {
        "value": "6",
        "symbolicName": "DuplicateQuote",
        "description": "Duplicate Quote"
      },
      {
        "value": "7",
        "symbolicName": "InvalidBid",
        "description": "Invalid bid/ask spread"
      },
      {
        "value": "8",
        "symbolicName": "InvalidPrice",
        "description": "Invalid price"
      },
      {
        "value": "9",
        "symbolicName": "NotAuthorizedToQuoteSecurity",
        "description": "Not authorized to quote security"
      },
      {
        "value": "10",
        "symbolicName": "PriceExceedsCurrentPriceBand",
        "description": "Price exceeds current price band"
      },
      {
        "value": "11",
        "symbolicName": "QuoteLocked",
        "description": "Quote Locked - Unable to Update/Cancel"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "12",
        "symbolicName": "InvalidOrUnknownSecurityIssuer",
        "description": "Invalid or unknown Security Issuer"
      },
      {
        "value": "13",
        "symbolicName": "InvalidOrUnknownIssuerOfUnderlyingSecurity",
        "description": "Invalid or unknown Issuer of Underlying Security"
      }
    ]
  },
  {
    "tag": "301",
    "name": "QuoteResponseLevel",
    "type": "int",
    "description": "Level of Response requested from receiver of quote messages. A default value should be bilaterally agreed.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NoAcknowledgement",
        "description": "No Acknowledgement"
      },
      {
        "value": "1",
        "symbolicName": "AcknowledgeOnlyNegativeOrErroneousQuotes",
        "description": "Acknowledge only negative or erroneous quotes"
      },
      {
        "value": "2",
        "symbolicName": "AcknowledgeEachQuoteMessage",
        "description": "Acknowledge each quote message"
      },
      {
        "value": "3",
        "symbolicName": "SummaryAcknowledgement",
        "description": "Summary Acknowledgement"
      }
    ]
  },
  {
    "tag": "302",
    "name": "QuoteSetID",
    "type": "String",
    "description": "Unique id for the Quote Set."
  },
  {
    "tag": "303",
    "name": "QuoteRequestType",
    "type": "int",
    "description": "Indicates the type of Quote Request being generated",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Manual",
        "description": "Manual"
      },
      {
        "value": "2",
        "symbolicName": "Automatic",
        "description": "Automatic"
      }
    ]
  },
  {
    "tag": "304",
    "name": "TotNoQuoteEntries",
    "type": "int",
    "description": "Total number of quotes for the quote set."
  },
  {
    "tag": "305",
    "name": "UnderlyingSecurityIDSource",
    "type": "String",
    "description": "Underlying security's SecurityIDSource.\nValid values: see SecurityIDSource (22) field"
  },
  {
    "tag": "306",
    "name": "UnderlyingIssuer",
    "type": "String",
    "description": "Underlying security's Issuer.\nSee Issuer (06) field for description"
  },
  {
    "tag": "307",
    "name": "UnderlyingSecurityDesc",
    "type": "String",
    "description": "Description of the Underlying security.\nSee SecurityDesc(107)."
  },
  {
    "tag": "308",
    "name": "UnderlyingSecurityExchange",
    "type": "Exchange",
    "description": "Underlying security's SecurityExchange. Can be used to identify the underlying security.\nValid values: see SecurityExchange (207)"
  },
  {
    "tag": "309",
    "name": "UnderlyingSecurityID",
    "type": "String",
    "description": "Underlying security's SecurityID.\nSee SecurityID (48) field for description"
  },
  {
    "tag": "310",
    "name": "UnderlyingSecurityType",
    "type": "String",
    "description": "Underlying security's SecurityType.\nValid values: see SecurityType (167) field\n(see below for details concerning this fields use in conjunction with SecurityType=REPO)\nThe following applies when used in conjunction with SecurityType=REPO\nRepresents the general or specific type of security that underlies a financing agreement\nValid values for SecurityType=REPO:\nIf bonds of a particular issuer or country are wanted in an Order or are in the basket of an Execution and the SecurityType is not granular enough, include the UnderlyingIssuer (306), UnderlyingCountryOfIssue (592), UnderlyingProgram, UnderlyingRegType and/or < UnderlyingStipulations > block e.g.:"
  },
  {
    "tag": "311",
    "name": "UnderlyingSymbol",
    "type": "String",
    "description": "Underlying security's Symbol.\nSee Symbol (55) field for description"
  },
  {
    "tag": "312",
    "name": "UnderlyingSymbolSfx",
    "type": "String",
    "description": "Underlying security's SymbolSfx.\nSee SymbolSfx (65) field for description"
  },
  {
    "tag": "313",
    "name": "UnderlyingMaturityMonthYear",
    "type": "MonthYear",
    "description": "Underlying security's MaturityMonthYear. Can be used with standardized derivatives vs. the UnderlyingMaturityDate (542) field.\nSee MaturityMonthYear (200) field for description"
  },
  {
    "tag": "315",
    "name": "UnderlyingPutOrCall",
    "type": "int",
    "description": "Put or call indicator of the underlying security.\nSee PutOrCall(201)."
  },
  {
    "tag": "316",
    "name": "UnderlyingStrikePrice",
    "type": "Price",
    "description": "Underlying security's StrikePrice.\nSee StrikePrice (202) field for description"
  },
  {
    "tag": "317",
    "name": "UnderlyingOptAttribute",
    "type": "char",
    "description": "Underlying security's OptAttribute.\nSee OptAttribute (206) field for description"
  },
  {
    "tag": "318",
    "name": "UnderlyingCurrency",
    "type": "Currency",
    "description": "Underlying security's Currency.\nSee Currency (5) field for description and valid values"
  },
  {
    "tag": "320",
    "name": "SecurityReqID",
    "type": "String",
    "description": "Unique ID of a Security Definition Request."
  },
  {
    "tag": "321",
    "name": "SecurityRequestType",
    "type": "int",
    "description": "Type of Security Definition Request.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "RequestSecurityIdentityAndSpecifications",
        "description": "Request Security identity and specifications"
      },
      {
        "value": "1",
        "symbolicName": "RequestSecurityIdentityForSpecifications",
        "description": "Request Security identity for the specifications provided (name of the security is not supplied)"
      },
      {
        "value": "2",
        "symbolicName": "RequestListSecurityTypes",
        "description": "Request List Security Types"
      },
      {
        "value": "3",
        "symbolicName": "RequestListSecurities",
        "description": "Request List Securities (can be qualified with Symbol, SecurityType, TradingSessionID, SecurityExchange. If provided then only list Securities for the specific type.)"
      },
      {
        "value": "4",
        "symbolicName": "Symbol",
        "description": "Symbol"
      },
      {
        "value": "5",
        "symbolicName": "SecurityTypeAndOrCFICode",
        "description": "SecurityType and or CFICode"
      },
      {
        "value": "6",
        "symbolicName": "Product",
        "description": "Product"
      },
      {
        "value": "7",
        "symbolicName": "TradingSessionID",
        "description": "TradingSessionID"
      },
      {
        "value": "8",
        "symbolicName": "AllSecurities",
        "description": "All Securities"
      },
      {
        "value": "9",
        "symbolicName": "MarketIDOrMarketID",
        "description": "MarketID or MarketID + MarketSegmentID"
      }
    ]
  },
  {
    "tag": "322",
    "name": "SecurityResponseID",
    "type": "String",
    "description": "Unique ID of a Security Definition message."
  },
  {
    "tag": "323",
    "name": "SecurityResponseType",
    "type": "int",
    "description": "Type of Security Definition message response.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AcceptAsIs",
        "description": "Accept security proposal as-is"
      },
      {
        "value": "2",
        "symbolicName": "AcceptWithRevisions",
        "description": "Accept security proposal with revisions as indicated in the message"
      },
      {
        "value": "3",
        "symbolicName": "ListOfSecurityTypesReturnedPerRequest",
        "description": "List of security types returned per request"
      },
      {
        "value": "4",
        "symbolicName": "ListOfSecuritiesReturnedPerRequest",
        "description": "List of securities returned per request"
      },
      {
        "value": "5",
        "symbolicName": "RejectSecurityProposal",
        "description": "Reject security proposal"
      },
      {
        "value": "6",
        "symbolicName": "CannotMatchSelectionCriteria",
        "description": "Cannot match selection criteria"
      }
    ]
  },
  {
    "tag": "324",
    "name": "SecurityStatusReqID",
    "type": "String",
    "description": "Unique ID of a Security Status Request message."
  },
  {
    "tag": "325",
    "name": "UnsolicitedIndicator",
    "type": "Boolean",
    "description": "Indicates whether or not message is being sent as a result of a subscription request or not.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "MessageIsBeingSentAsAResultOfAPriorRequest",
        "description": "Message is being sent as a result of a prior request"
      },
      {
        "value": "Y",
        "symbolicName": "MessageIsBeingSentUnsolicited",
        "description": "Message is being sent unsolicited"
      }
    ]
  },
  {
    "tag": "326",
    "name": "SecurityTradingStatus",
    "type": "int",
    "description": "Identifies the trading status applicable to the transaction.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OpeningDelay",
        "description": "Opening delay"
      },
      {
        "value": "2",
        "symbolicName": "TradingHalt",
        "description": "Trading halt"
      },
      {
        "value": "3",
        "symbolicName": "Resume",
        "description": "Resume"
      },
      {
        "value": "4",
        "symbolicName": "NoOpen",
        "description": "No Open / No Resume"
      },
      {
        "value": "5",
        "symbolicName": "PriceIndication",
        "description": "Price indication"
      },
      {
        "value": "6",
        "symbolicName": "TradingRangeIndication",
        "description": "Trading Range Indication"
      },
      {
        "value": "7",
        "symbolicName": "MarketImbalanceBuy",
        "description": "Market Imbalance Buy"
      },
      {
        "value": "8",
        "symbolicName": "MarketImbalanceSell",
        "description": "Market Imbalance Sell"
      },
      {
        "value": "9",
        "symbolicName": "MarketOnCloseImbalanceBuy",
        "description": "Market on Close Imbalance Buy"
      },
      {
        "value": "10",
        "symbolicName": "MarketOnCloseImbalanceSell",
        "description": "Market on Close Imbalance Sell"
      },
      {
        "value": "12",
        "symbolicName": "NoMarketImbalance",
        "description": "No Market Imbalance"
      },
      {
        "value": "13",
        "symbolicName": "NoMarketOnCloseImbalance",
        "description": "No Market on Close Imbalance"
      },
      {
        "value": "14",
        "symbolicName": "ITSPreOpening",
        "description": "ITS Pre-opening"
      },
      {
        "value": "15",
        "symbolicName": "NewPriceIndication",
        "description": "New Price Indication"
      },
      {
        "value": "16",
        "symbolicName": "TradeDisseminationTime",
        "description": "Trade Dissemination Time"
      },
      {
        "value": "17",
        "symbolicName": "ReadyToTrade",
        "description": "Ready to trade (start of session)"
      },
      {
        "value": "18",
        "symbolicName": "NotAvailableForTrading",
        "description": "Not available for trading (end of session)"
      },
      {
        "value": "19",
        "symbolicName": "NotTradedOnThisMarket",
        "description": "Not traded on this market"
      },
      {
        "value": "20",
        "symbolicName": "UnknownOrInvalid",
        "description": "Unknown or Invalid"
      },
      {
        "value": "21",
        "symbolicName": "PreOpen",
        "description": "Pre-open"
      },
      {
        "value": "22",
        "symbolicName": "OpeningRotation",
        "description": "Opening Rotation"
      },
      {
        "value": "23",
        "symbolicName": "FastMarket",
        "description": "Fast Market"
      },
      {
        "value": "24",
        "symbolicName": "PreCross",
        "description": "Pre-Cross - system is in a pre-cross state allowing market to respond to either side of cross"
      },
      {
        "value": "25",
        "symbolicName": "Cross",
        "description": "Cross - system has crossed a percentage of the orders and allows market to respond prior to crossing remaining portion"
      },
      {
        "value": "26",
        "symbolicName": "PostClose",
        "description": "Post-close"
      }
    ]
  },
  {
    "tag": "327",
    "name": "HaltReason",
    "type": "int",
    "description": "Denotes the reason for the Opening Delay or Trading Halt.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NewsDissemination",
        "description": "News Dissemination"
      },
      {
        "value": "1",
        "symbolicName": "OrderInflux",
        "description": "Order Influx"
      },
      {
        "value": "2",
        "symbolicName": "OrderImbalance",
        "description": "Order Imbalance"
      },
      {
        "value": "3",
        "symbolicName": "AdditionalInformation",
        "description": "Additional Information"
      },
      {
        "value": "4",
        "symbolicName": "NewsPending",
        "description": "News Pending"
      },
      {
        "value": "5",
        "symbolicName": "EquipmentChangeover",
        "description": "Equipment Changeover"
      }
    ]
  },
  {
    "tag": "328",
    "name": "InViewOfCommon",
    "type": "Boolean",
    "description": "Indicates whether or not the halt was due to Common Stock trading being halted.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "HaltWasNotRelatedToAHaltOfTheCommonStock",
        "description": "Halt was not related to a halt of the common stock"
      },
      {
        "value": "Y",
        "symbolicName": "HaltWasDueToCommonStockBeingHalted",
        "description": "Halt was due to common stock being halted"
      }
    ]
  },
  {
    "tag": "329",
    "name": "DueToRelated",
    "type": "Boolean",
    "description": "Indicates whether or not the halt was due to the Related Security being halted.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotRelatedToSecurityHalt",
        "description": "Halt was not related to a halt of the related security"
      },
      {
        "value": "Y",
        "symbolicName": "RelatedToSecurityHalt",
        "description": "Halt was due to related security being halted"
      }
    ]
  },
  {
    "tag": "330",
    "name": "BuyVolume",
    "type": "Qty",
    "description": "Quantity bought."
  },
  {
    "tag": "331",
    "name": "SellVolume",
    "type": "Qty",
    "description": "Quantity sold."
  },
  {
    "tag": "332",
    "name": "HighPx",
    "type": "Price",
    "description": "Represents an indication of the high end of the price range for a security prior to the open or reopen"
  },
  {
    "tag": "333",
    "name": "LowPx",
    "type": "Price",
    "description": "Represents an indication of the low end of the price range for a security prior to the open or reopen"
  },
  {
    "tag": "334",
    "name": "Adjustment",
    "type": "int",
    "description": "Identifies the type of adjustment.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "2",
        "symbolicName": "Error",
        "description": "Error"
      },
      {
        "value": "3",
        "symbolicName": "Correction",
        "description": "Correction"
      }
    ]
  },
  {
    "tag": "335",
    "name": "TradSesReqID",
    "type": "String",
    "description": "Unique ID of a Trading Session Status message."
  },
  {
    "tag": "336",
    "name": "TradingSessionID",
    "type": "String",
    "description": "Identifier for Trading Session\nA trading session spans an extended period of time that can also be expressed informally in terms of the trading day. Usage is determined by market or counterparties.\nTo specify good for session where session spans more than one calendar day, use TimeInForce = Day in conjunction with TradingSessionID.\nBilaterally agreed values of data type \"String\" that start with a character can be used for backward compatibility.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Day",
        "description": "Day"
      },
      {
        "value": "2",
        "symbolicName": "HalfDay",
        "description": "HalfDay"
      },
      {
        "value": "3",
        "symbolicName": "Morning",
        "description": "Morning"
      },
      {
        "value": "4",
        "symbolicName": "Afternoon",
        "description": "Afternoon"
      },
      {
        "value": "5",
        "symbolicName": "Evening",
        "description": "Evening"
      },
      {
        "value": "6",
        "symbolicName": "AfterHours",
        "description": "After-hours"
      }
    ]
  },
  {
    "tag": "337",
    "name": "ContraTrader",
    "type": "String",
    "description": "Identifies the trader (e.g. \"badge number\") of the ContraBroker."
  },
  {
    "tag": "338",
    "name": "TradSesMethod",
    "type": "int",
    "description": "Method of trading",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Electronic",
        "description": "Electronic"
      },
      {
        "value": "2",
        "symbolicName": "OpenOutcry",
        "description": "Open Outcry"
      },
      {
        "value": "3",
        "symbolicName": "TwoParty",
        "description": "Two Party"
      }
    ]
  },
  {
    "tag": "339",
    "name": "TradSesMode",
    "type": "int",
    "description": "Trading Session Mode",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Testing",
        "description": "Testing"
      },
      {
        "value": "2",
        "symbolicName": "Simulated",
        "description": "Simulated"
      },
      {
        "value": "3",
        "symbolicName": "Production",
        "description": "Production"
      }
    ]
  },
  {
    "tag": "340",
    "name": "TradSesStatus",
    "type": "int",
    "description": "State of the trading session.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Unknown",
        "description": "Unknown"
      },
      {
        "value": "1",
        "symbolicName": "Halted",
        "description": "Halted"
      },
      {
        "value": "2",
        "symbolicName": "Open",
        "description": "Open"
      },
      {
        "value": "3",
        "symbolicName": "Closed",
        "description": "Closed"
      },
      {
        "value": "4",
        "symbolicName": "PreOpen",
        "description": "Pre-Open"
      },
      {
        "value": "5",
        "symbolicName": "PreClose",
        "description": "Pre-Close"
      },
      {
        "value": "6",
        "symbolicName": "RequestRejected",
        "description": "Request Rejected"
      }
    ]
  },
  {
    "tag": "341",
    "name": "TradSesStartTime",
    "type": "UTCTimestamp",
    "description": "Starting time of the trading session"
  },
  {
    "tag": "342",
    "name": "TradSesOpenTime",
    "type": "UTCTimestamp",
    "description": "Time of the opening of the trading session"
  },
  {
    "tag": "343",
    "name": "TradSesPreCloseTime",
    "type": "UTCTimestamp",
    "description": "Time of the pre-closed of the trading session"
  },
  {
    "tag": "344",
    "name": "TradSesCloseTime",
    "type": "UTCTimestamp",
    "description": "Closing time of the trading session"
  },
  {
    "tag": "345",
    "name": "TradSesEndTime",
    "type": "UTCTimestamp",
    "description": "End time of the trading session"
  },
  {
    "tag": "346",
    "name": "NumberOfOrders",
    "type": "int",
    "description": "Number of orders in the market."
  },
  {
    "tag": "347",
    "name": "MessageEncoding",
    "type": "String",
    "description": "Type of message encoding (non-ASCII (non-English) characters) used in a message's \"Encoded\" fields."
  },
  {
    "tag": "348",
    "name": "EncodedIssuerLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedIssuer (349) field."
  },
  {
    "tag": "349",
    "name": "EncodedIssuer",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Issuer field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Issuer field."
  },
  {
    "tag": "350",
    "name": "EncodedSecurityDescLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedSecurityDesc (351) field."
  },
  {
    "tag": "351",
    "name": "EncodedSecurityDesc",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the SecurityDesc (107) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the SecurityDesc field."
  },
  {
    "tag": "352",
    "name": "EncodedListExecInstLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedListExecInst (353) field."
  },
  {
    "tag": "353",
    "name": "EncodedListExecInst",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the ListExecInst (69) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ListExecInst field."
  },
  {
    "tag": "354",
    "name": "EncodedTextLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedText (355) field."
  },
  {
    "tag": "355",
    "name": "EncodedText",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Text (58) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Text field."
  },
  {
    "tag": "356",
    "name": "EncodedSubjectLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedSubject (357) field."
  },
  {
    "tag": "357",
    "name": "EncodedSubject",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Subject (147) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Subject field."
  },
  {
    "tag": "358",
    "name": "EncodedHeadlineLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedHeadline (359) field."
  },
  {
    "tag": "359",
    "name": "EncodedHeadline",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the Headline (148) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Headline field."
  },
  {
    "tag": "360",
    "name": "EncodedAllocTextLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedAllocText (361) field."
  },
  {
    "tag": "361",
    "name": "EncodedAllocText",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the AllocText (161) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the AllocText field."
  },
  {
    "tag": "362",
    "name": "EncodedUnderlyingIssuerLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedUnderlyingIssuer (363) field."
  },
  {
    "tag": "363",
    "name": "EncodedUnderlyingIssuer",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the UnderlyingIssuer (306) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingIssuer field."
  },
  {
    "tag": "364",
    "name": "EncodedUnderlyingSecurityDescLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedUnderlyingSecurityDesc (365) field."
  },
  {
    "tag": "365",
    "name": "EncodedUnderlyingSecurityDesc",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the UnderlyingSecurityDesc (307) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingSecurityeDesc field."
  },
  {
    "tag": "366",
    "name": "AllocPrice",
    "type": "Price",
    "description": "Executed price for an AllocAccount (79) entry used when using \"executed price\" vs. \"average price\" allocations (e.g. Japan)."
  },
  {
    "tag": "367",
    "name": "QuoteSetValidUntilTime",
    "type": "UTCTimestamp",
    "description": "Indicates expiration time of this particular QuoteSet (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "368",
    "name": "QuoteEntryRejectReason",
    "type": "int",
    "description": "Reason Quote Entry was rejected:"
  },
  {
    "tag": "369",
    "name": "LastMsgSeqNumProcessed",
    "type": "SeqNum",
    "description": "The last MsgSeqNum (34) value received by the FIX engine and processed by downstream application, such as trading engine or order routing system. Can be specified on every message sent. Useful for detecting a backlog with a counterparty."
  },
  {
    "tag": "371",
    "name": "RefTagID",
    "type": "int",
    "description": "The tag number of the FIX field being referenced."
  },
  {
    "tag": "372",
    "name": "RefMsgType",
    "type": "String",
    "description": "The MsgType (35) of the FIX message being referenced."
  },
  {
    "tag": "373",
    "name": "SessionRejectReason",
    "type": "int",
    "description": "Code to identify reason for a session-level Reject message.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "InvalidTagNumber",
        "description": "Invalid Tag Number"
      },
      {
        "value": "1",
        "symbolicName": "RequiredTagMissing",
        "description": "Required Tag Missing"
      },
      {
        "value": "2",
        "symbolicName": "TagNotDefinedForThisMessageType",
        "description": "Tag not defined for this message type"
      },
      {
        "value": "3",
        "symbolicName": "UndefinedTag",
        "description": "Undefined tag"
      },
      {
        "value": "4",
        "symbolicName": "TagSpecifiedWithoutAValue",
        "description": "Tag specified without a value"
      },
      {
        "value": "5",
        "symbolicName": "ValueIsIncorrect",
        "description": "Value is incorrect (out of range) for this tag"
      },
      {
        "value": "6",
        "symbolicName": "IncorrectDataFormatForValue",
        "description": "Incorrect data format for value"
      },
      {
        "value": "7",
        "symbolicName": "DecryptionProblem",
        "description": "Decryption problem"
      },
      {
        "value": "8",
        "symbolicName": "SignatureProblem",
        "description": "Signature problem"
      },
      {
        "value": "9",
        "symbolicName": "CompIDProblem",
        "description": "CompID problem"
      },
      {
        "value": "10",
        "symbolicName": "SendingTimeAccuracyProblem",
        "description": "SendingTime Accuracy Problem"
      },
      {
        "value": "11",
        "symbolicName": "InvalidMsgType",
        "description": "Invalid MsgType"
      },
      {
        "value": "12",
        "symbolicName": "XMLValidationError",
        "description": "XML Validation Error"
      },
      {
        "value": "13",
        "symbolicName": "TagAppearsMoreThanOnce",
        "description": "Tag appears more than once"
      },
      {
        "value": "14",
        "symbolicName": "TagSpecifiedOutOfRequiredOrder",
        "description": "Tag specified out of required order"
      },
      {
        "value": "15",
        "symbolicName": "RepeatingGroupFieldsOutOfOrder",
        "description": "Repeating group fields out of order"
      },
      {
        "value": "16",
        "symbolicName": "IncorrectNumInGroupCountForRepeatingGroup",
        "description": "Incorrect NumInGroup count for repeating group"
      },
      {
        "value": "17",
        "symbolicName": "Non",
        "description": "Non \"Data\" value includes field delimiter (<SOH> character)"
      },
      {
        "value": "18",
        "symbolicName": "Invalid",
        "description": "Invalid/Unsupported Application Version"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "374",
    "name": "BidRequestTransType",
    "type": "char",
    "description": "Identifies the Bid Request message type.",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      }
    ]
  },
  {
    "tag": "375",
    "name": "ContraBroker",
    "type": "String",
    "description": "Identifies contra broker. Standard NASD market-maker mnemonic is preferred."
  },
  {
    "tag": "376",
    "name": "ComplianceID",
    "type": "String",
    "description": "ID used to represent this transaction for compliance purposes (e.g. OATS reporting)."
  },
  {
    "tag": "377",
    "name": "SolicitedFlag",
    "type": "Boolean",
    "description": "Indicates whether or not the order was solicited.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "WasNotSolicited",
        "description": "Was not solicited"
      },
      {
        "value": "Y",
        "symbolicName": "WasSolicited",
        "description": "Was solicited"
      }
    ]
  },
  {
    "tag": "378",
    "name": "ExecRestatementReason",
    "type": "int",
    "description": "Code to identify reason for an ExecutionRpt message sent with ExecType=Restated or used when communicating an unsolicited cancel.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "GTCorporateAction",
        "description": "GT corporate action"
      },
      {
        "value": "1",
        "symbolicName": "GTRenewal",
        "description": "GT renewal / restatement (no corporate action)"
      },
      {
        "value": "2",
        "symbolicName": "VerbalChange",
        "description": "Verbal change"
      },
      {
        "value": "3",
        "symbolicName": "RepricingOfOrder",
        "description": "Repricing of order"
      },
      {
        "value": "4",
        "symbolicName": "BrokerOption",
        "description": "Broker option"
      },
      {
        "value": "5",
        "symbolicName": "PartialDeclineOfOrderQty",
        "description": "Partial decline of OrderQty (e.g. exchange initiated partial cancel)"
      },
      {
        "value": "6",
        "symbolicName": "CancelOnTradingHalt",
        "description": "Cancel on Trading Halt"
      },
      {
        "value": "7",
        "symbolicName": "CancelOnSystemFailure",
        "description": "Cancel on System Failure"
      },
      {
        "value": "8",
        "symbolicName": "Market",
        "description": "Market (Exchange) option"
      },
      {
        "value": "9",
        "symbolicName": "Canceled",
        "description": "Canceled, not best"
      },
      {
        "value": "10",
        "symbolicName": "WarehouseRecap",
        "description": "Warehouse Recap"
      },
      {
        "value": "11",
        "symbolicName": "PegRefresh",
        "description": "Peg Refresh"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "379",
    "name": "BusinessRejectRefID",
    "type": "String",
    "description": "The value of the business-level \"ID\" field on the message being referenced."
  },
  {
    "tag": "380",
    "name": "BusinessRejectReason",
    "type": "int",
    "description": "Code to identify reason for a Business Message Reject message.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "1",
        "symbolicName": "UnknownID",
        "description": "Unknown ID"
      },
      {
        "value": "2",
        "symbolicName": "UnknownSecurity",
        "description": "Unknown Security"
      },
      {
        "value": "3",
        "symbolicName": "UnsupportedMessageType",
        "description": "Unsupported Message Type"
      },
      {
        "value": "4",
        "symbolicName": "ApplicationNotAvailable",
        "description": "Application not available"
      },
      {
        "value": "5",
        "symbolicName": "ConditionallyRequiredFieldMissing",
        "description": "Conditionally required field missing"
      },
      {
        "value": "6",
        "symbolicName": "NotAuthorized",
        "description": "Not Authorized"
      },
      {
        "value": "7",
        "symbolicName": "DeliverToFirmNotAvailableAtThisTime",
        "description": "DeliverTo firm not available at this time"
      },
      {
        "value": "18",
        "symbolicName": "InvalidPriceIncrement",
        "description": "Invalid price increment"
      }
    ]
  },
  {
    "tag": "381",
    "name": "GrossTradeAmt",
    "type": "Amt",
    "description": "Total amount traded (i.e. quantity * price) expressed in units of currency. For FX Futures this is used to express the notional value of a fill when quantity fields are expressed in terms of contract size (i.e. quantity * price * contract size)."
  },
  {
    "tag": "382",
    "name": "NoContraBrokers",
    "type": "NumInGroup",
    "description": "The number of ContraBroker (375) entries."
  },
  {
    "tag": "383",
    "name": "MaxMessageSize",
    "type": "Length",
    "description": "Maximum number of bytes supported for a single message."
  },
  {
    "tag": "384",
    "name": "NoMsgTypes",
    "type": "NumInGroup",
    "description": "Number of MsgTypes (35) in repeating group."
  },
  {
    "tag": "385",
    "name": "MsgDirection",
    "type": "char",
    "description": "Specifies the direction of the messsage.",
    "enum": [
      {
        "value": "R",
        "symbolicName": "Receive",
        "description": "Receive"
      },
      {
        "value": "S",
        "symbolicName": "Send",
        "description": "Send"
      }
    ]
  },
  {
    "tag": "386",
    "name": "NoTradingSessions",
    "type": "NumInGroup",
    "description": "Number of TradingSessionIDs (336) in repeating group."
  },
  {
    "tag": "387",
    "name": "TotalVolumeTraded",
    "type": "Qty",
    "description": "Total volume (quantity) traded."
  },
  {
    "tag": "388",
    "name": "DiscretionInst",
    "type": "char",
    "description": "Code to identify the price a DiscretionOffsetValue (389) is related to and should be mathematically added to.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "RelatedToDisplayedPrice",
        "description": "Related to displayed price"
      },
      {
        "value": "1",
        "symbolicName": "RelatedToMarketPrice",
        "description": "Related to market price"
      },
      {
        "value": "2",
        "symbolicName": "RelatedToPrimaryPrice",
        "description": "Related to primary price"
      },
      {
        "value": "3",
        "symbolicName": "RelatedToLocalPrimaryPrice",
        "description": "Related to local primary price"
      },
      {
        "value": "4",
        "symbolicName": "RelatedToMidpointPrice",
        "description": "Related to midpoint price"
      },
      {
        "value": "5",
        "symbolicName": "RelatedToLastTradePrice",
        "description": "Related to last trade price"
      },
      {
        "value": "6",
        "symbolicName": "RelatedToVWAP",
        "description": "Related to VWAP"
      },
      {
        "value": "7",
        "symbolicName": "AveragePriceGuarantee",
        "description": "Average Price Guarantee"
      }
    ]
  },
  {
    "tag": "389",
    "name": "DiscretionOffsetValue",
    "type": "float",
    "description": "Amount (signed) added to the \"related to\" price specified via DiscretionInst (388), in the context of DiscretionOffsetType (842)\n(Prior to FIX 4.4 this field was of type PriceOffset)"
  },
  {
    "tag": "390",
    "name": "BidID",
    "type": "String",
    "description": "Unique identifier for Bid Response as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day."
  },
  {
    "tag": "391",
    "name": "ClientBidID",
    "type": "String",
    "description": "Unique identifier for a Bid Request as assigned by institution. Uniqueness must be guaranteed within a single trading day."
  },
  {
    "tag": "392",
    "name": "ListName",
    "type": "String",
    "description": "Descriptive name for list order."
  },
  {
    "tag": "393",
    "name": "TotNoRelatedSym",
    "type": "int",
    "description": "Total number of securities.\n(Prior to FIX 4.4 this field was named TotalNumSecurities)"
  },
  {
    "tag": "394",
    "name": "BidType",
    "type": "int",
    "description": "Code to identify the type of Bid Request.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "NonDisclosed",
        "description": "\"Non Disclosed\" style (e.g. US/European)"
      },
      {
        "value": "2",
        "symbolicName": "Disclosed",
        "description": "\"Disclosed\" sytle (e.g. Japanese)"
      },
      {
        "value": "3",
        "symbolicName": "NoBiddingProcess",
        "description": "No bidding process"
      }
    ]
  },
  {
    "tag": "395",
    "name": "NumTickets",
    "type": "int",
    "description": "Total number of tickets."
  },
  {
    "tag": "396",
    "name": "SideValue1",
    "type": "Amt",
    "description": "Amounts in currency"
  },
  {
    "tag": "397",
    "name": "SideValue2",
    "type": "Amt",
    "description": "Amounts in currency"
  },
  {
    "tag": "398",
    "name": "NoBidDescriptors",
    "type": "NumInGroup",
    "description": "Number of BidDescriptor (400) entries."
  },
  {
    "tag": "399",
    "name": "BidDescriptorType",
    "type": "int",
    "description": "Code to identify the type of BidDescriptor (400).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Sector",
        "description": "Sector"
      },
      {
        "value": "2",
        "symbolicName": "Country",
        "description": "Country"
      },
      {
        "value": "3",
        "symbolicName": "Index",
        "description": "Index"
      }
    ]
  },
  {
    "tag": "400",
    "name": "BidDescriptor",
    "type": "String",
    "description": "BidDescriptor value. Usage depends upon BidDescriptorTyp (399).\nIf BidDescriptorType = 1\nIndustrials etc - Free text\nIf BidDescriptorType = 2\n\"FR\" etc - ISO Country Codes\nIf BidDescriptorType = 3\nFT00, FT250, STOX - Free text"
  },
  {
    "tag": "401",
    "name": "SideValueInd",
    "type": "int",
    "description": "Code to identify which \"SideValue\" the value refers to. SideValue1 and SideValue2 are used as opposed to Buy or Sell so that the basket can be quoted either way as Buy or Sell.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "SideValue1",
        "description": "Side Value 1"
      },
      {
        "value": "2",
        "symbolicName": "SideValue2",
        "description": "Side Value 2"
      }
    ]
  },
  {
    "tag": "402",
    "name": "LiquidityPctLow",
    "type": "Percentage",
    "description": "Liquidity indicator or lower limit if TotalNumSecurities (393) > 1. Represented as a percentage."
  },
  {
    "tag": "403",
    "name": "LiquidityPctHigh",
    "type": "Percentage",
    "description": "Upper liquidity indicator if TotalNumSecurities (393) > 1. Represented as a percentage."
  },
  {
    "tag": "404",
    "name": "LiquidityValue",
    "type": "Amt",
    "description": "Value between LiquidityPctLow (402) and LiquidityPctHigh (403) in Currency"
  },
  {
    "tag": "405",
    "name": "EFPTrackingError",
    "type": "Percentage",
    "description": "Eg Used in EFP trades 2% (EFP - Exchange for Physical ). Represented as a percentage."
  },
  {
    "tag": "406",
    "name": "FairValue",
    "type": "Amt",
    "description": "Used in EFP trades"
  },
  {
    "tag": "407",
    "name": "OutsideIndexPct",
    "type": "Percentage",
    "description": "Used in EFP trades. Represented as a percentage."
  },
  {
    "tag": "408",
    "name": "ValueOfFutures",
    "type": "Amt",
    "description": "Used in EFP trades"
  },
  {
    "tag": "409",
    "name": "LiquidityIndType",
    "type": "int",
    "description": "Code to identify the type of liquidity indicator.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "FiveDayMovingAverage",
        "description": "5-day moving average"
      },
      {
        "value": "2",
        "symbolicName": "TwentyDayMovingAverage",
        "description": "20-day moving average"
      },
      {
        "value": "3",
        "symbolicName": "NormalMarketSize",
        "description": "Normal market size"
      },
      {
        "value": "4",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "410",
    "name": "WtAverageLiquidity",
    "type": "Percentage",
    "description": "Overall weighted average liquidity expressed as a % of average daily volume. Represented as a percentage."
  },
  {
    "tag": "411",
    "name": "ExchangeForPhysical",
    "type": "Boolean",
    "description": "Indicates whether or not to exchange for phsyical.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "False",
        "description": "False"
      },
      {
        "value": "Y",
        "symbolicName": "True",
        "description": "True"
      }
    ]
  },
  {
    "tag": "412",
    "name": "OutMainCntryUIndex",
    "type": "Amt",
    "description": "Value of stocks in Currency"
  },
  {
    "tag": "413",
    "name": "CrossPercent",
    "type": "Percentage",
    "description": "Percentage of program that crosses in Currency. Represented as a percentage."
  },
  {
    "tag": "414",
    "name": "ProgRptReqs",
    "type": "int",
    "description": "Code to identify the desired frequency of progress reports.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "BuySideRequests",
        "description": "Buy-side explicitly requests status using Statue Request (default), the sell-side firm can, however, send a DONE status List STatus Response in an unsolicited fashion"
      },
      {
        "value": "2",
        "symbolicName": "SellSideSends",
        "description": "Sell-side periodically sends status using List Status. Period optionally specified in ProgressPeriod."
      },
      {
        "value": "3",
        "symbolicName": "RealTimeExecutionReports",
        "description": "Real-time execution reports (to be discourage)"
      }
    ]
  },
  {
    "tag": "415",
    "name": "ProgPeriodInterval",
    "type": "int",
    "description": "Time in minutes between each ListStatus report sent by SellSide. Zero means don't send status."
  },
  {
    "tag": "416",
    "name": "IncTaxInd",
    "type": "int",
    "description": "Code to represent whether value is net (inclusive of tax) or gross.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Net",
        "description": "Net"
      },
      {
        "value": "2",
        "symbolicName": "Gross",
        "description": "Gross"
      }
    ]
  },
  {
    "tag": "417",
    "name": "NumBidders",
    "type": "int",
    "description": "Indicates the total number of bidders on the list"
  },
  {
    "tag": "418",
    "name": "BidTradeType",
    "type": "char",
    "description": "Code to represent the type of trade.\n(Prior to FIX 4.4 this field was named \"TradeType\")",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Agency",
        "description": "Agency"
      },
      {
        "value": "G",
        "symbolicName": "VWAPGuarantee",
        "description": "VWAP Guarantee"
      },
      {
        "value": "J",
        "symbolicName": "GuaranteedClose",
        "description": "Guaranteed Close"
      },
      {
        "value": "R",
        "symbolicName": "RiskTrade",
        "description": "Risk Trade"
      }
    ]
  },
  {
    "tag": "419",
    "name": "BasisPxType",
    "type": "char",
    "description": "Code to represent the basis price type.",
    "enum": [
      {
        "value": "2",
        "symbolicName": "ClosingPriceAtMorningSession",
        "description": "Closing price at morning session"
      },
      {
        "value": "3",
        "symbolicName": "ClosingPrice",
        "description": "Closing price"
      },
      {
        "value": "4",
        "symbolicName": "CurrentPrice",
        "description": "Current price"
      },
      {
        "value": "5",
        "symbolicName": "SQ",
        "description": "SQ"
      },
      {
        "value": "6",
        "symbolicName": "VWAPThroughADay",
        "description": "VWAP through a day"
      },
      {
        "value": "7",
        "symbolicName": "VWAPThroughAMorningSession",
        "description": "VWAP through a morning session"
      },
      {
        "value": "8",
        "symbolicName": "VWAPThroughAnAfternoonSession",
        "description": "VWAP through an afternoon session"
      },
      {
        "value": "9",
        "symbolicName": "VWAPThroughADayExcept",
        "description": "VWAP through a day except \"YORI\" (an opening auction)"
      },
      {
        "value": "A",
        "symbolicName": "VWAPThroughAMorningSessionExcept",
        "description": "VWAP through a morning session except \"YORI\" (an opening auction)"
      },
      {
        "value": "B",
        "symbolicName": "VWAPThroughAnAfternoonSessionExcept",
        "description": "VWAP through an afternoon session except \"YORI\" (an opening auction)"
      },
      {
        "value": "C",
        "symbolicName": "Strike",
        "description": "Strike"
      },
      {
        "value": "D",
        "symbolicName": "Open",
        "description": "Open"
      },
      {
        "value": "Z",
        "symbolicName": "Others",
        "description": "Others"
      }
    ]
  },
  {
    "tag": "420",
    "name": "NoBidComponents",
    "type": "NumInGroup",
    "description": "Indicates the number of list entries."
  },
  {
    "tag": "421",
    "name": "Country",
    "type": "Country",
    "description": "ISO Country Code in field"
  },
  {
    "tag": "422",
    "name": "TotNoStrikes",
    "type": "int",
    "description": "Total number of strike price entries across all messages. Should be the sum of all NoStrikes (428) in each message that has repeating strike price entries related to the same ListID (66). Used to support fragmentation."
  },
  {
    "tag": "423",
    "name": "PriceType",
    "type": "int",
    "description": "Code to represent the price type.\n(For Financing transactions PriceType implies the \"repo type\" - Fixed or Floating - 9 (Yield) or 6 (Spread) respectively - and Price (44) gives the corresponding \"repo rate\".\nSee Volume : \"Glossary\" for further value definitions)",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Percentage",
        "description": "Percentage (i.e. percent of par) (often called \"dollar price\" for fixed income)"
      },
      {
        "value": "2",
        "symbolicName": "PerUnit",
        "description": "Per unit (i.e. per share or contract)"
      },
      {
        "value": "3",
        "symbolicName": "FixedAmount",
        "description": "Fixed amount (absolute value)"
      },
      {
        "value": "4",
        "symbolicName": "Discount",
        "description": "Discount - percentage points below par"
      },
      {
        "value": "5",
        "symbolicName": "Premium",
        "description": "Premium - percentage points over par"
      },
      {
        "value": "6",
        "symbolicName": "Spread",
        "description": "Spread (basis points spread)"
      },
      {
        "value": "7",
        "symbolicName": "TEDPrice",
        "description": "TED Price"
      },
      {
        "value": "8",
        "symbolicName": "TEDYield",
        "description": "TED Yield"
      },
      {
        "value": "9",
        "symbolicName": "Yield",
        "description": "Yield"
      },
      {
        "value": "10",
        "symbolicName": "FixedCabinetTradePrice",
        "description": "Fixed cabinet trade price (primarily for listed futures and options)"
      },
      {
        "value": "11",
        "symbolicName": "VariableCabinetTradePrice",
        "description": "Variable cabinet trade price (primarily for listed futures and options)"
      },
      {
        "value": "13",
        "symbolicName": "ProductTicksInHalfs",
        "description": "Product ticks in halfs"
      },
      {
        "value": "14",
        "symbolicName": "ProductTicksInFourths",
        "description": "Product ticks in fourths"
      },
      {
        "value": "15",
        "symbolicName": "ProductTicksInEights",
        "description": "Product ticks in eights"
      },
      {
        "value": "16",
        "symbolicName": "ProductTicksInSixteenths",
        "description": "Product ticks in sixteenths"
      },
      {
        "value": "17",
        "symbolicName": "ProductTicksInThirtySeconds",
        "description": "Product ticks in thirty-seconds"
      },
      {
        "value": "18",
        "symbolicName": "ProductTicksInSixtyForths",
        "description": "Product ticks in sixty-forths"
      },
      {
        "value": "19",
        "symbolicName": "ProductTicksInOneTwentyEights",
        "description": "Product ticks in one-twenty-eights"
      }
    ]
  },
  {
    "tag": "424",
    "name": "DayOrderQty",
    "type": "Qty",
    "description": "For GT orders, the OrderQty (38) less all quantity (adjusted for stock splits) that traded on previous days. DayOrderQty (424) = OrderQty - (CumQty (14) - DayCumQty (425))"
  },
  {
    "tag": "425",
    "name": "DayCumQty",
    "type": "Qty",
    "description": "Quantity on a GT order that has traded today."
  },
  {
    "tag": "426",
    "name": "DayAvgPx",
    "type": "Price",
    "description": "The average price for quantity on a GT order that has traded today."
  },
  {
    "tag": "427",
    "name": "GTBookingInst",
    "type": "int",
    "description": "Code to identify whether to book out executions on a part-filled GT order on the day of execution or to accumulate.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "BookOutAllTradesOnDayOfExecution",
        "description": "Book out all trades on day of execution"
      },
      {
        "value": "1",
        "symbolicName": "AccumulateUntilFilledOrExpired",
        "description": "Accumulate executions until order is filled or expires"
      },
      {
        "value": "2",
        "symbolicName": "AccumulateUntilVerballyNotifiedOtherwise",
        "description": "Accumulate until verbally notified otherwise"
      }
    ]
  },
  {
    "tag": "428",
    "name": "NoStrikes",
    "type": "NumInGroup",
    "description": "Number of list strike price entries."
  },
  {
    "tag": "429",
    "name": "ListStatusType",
    "type": "int",
    "description": "Code to represent the status type.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Ack",
        "description": "Ack"
      },
      {
        "value": "2",
        "symbolicName": "Response",
        "description": "Response"
      },
      {
        "value": "3",
        "symbolicName": "Timed",
        "description": "Timed"
      },
      {
        "value": "4",
        "symbolicName": "ExecStarted",
        "description": "Exec Started"
      },
      {
        "value": "5",
        "symbolicName": "AllDone",
        "description": "All Done"
      },
      {
        "value": "6",
        "symbolicName": "Alert",
        "description": "Alert"
      }
    ]
  },
  {
    "tag": "430",
    "name": "NetGrossInd",
    "type": "int",
    "description": "Code to represent whether value is net (inclusive of tax) or gross.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Net",
        "description": "Net"
      },
      {
        "value": "2",
        "symbolicName": "Gross",
        "description": "Gross"
      }
    ]
  },
  {
    "tag": "431",
    "name": "ListOrderStatus",
    "type": "int",
    "description": "Code to represent the status of a list order.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "InBiddingProcess",
        "description": "In bidding process"
      },
      {
        "value": "2",
        "symbolicName": "ReceivedForExecution",
        "description": "Received for execution"
      },
      {
        "value": "3",
        "symbolicName": "Executing",
        "description": "Executing"
      },
      {
        "value": "4",
        "symbolicName": "Cancelling",
        "description": "Cancelling"
      },
      {
        "value": "5",
        "symbolicName": "Alert",
        "description": "Alert"
      },
      {
        "value": "6",
        "symbolicName": "AllDone",
        "description": "All Done"
      },
      {
        "value": "7",
        "symbolicName": "Reject",
        "description": "Reject"
      }
    ]
  },
  {
    "tag": "432",
    "name": "ExpireDate",
    "type": "LocalMktDate",
    "description": "Date of order expiration (last day the order can trade), always expressed in terms of the local market date. The time at which the order expires is determined by the local market's business practices"
  },
  {
    "tag": "433",
    "name": "ListExecInstType",
    "type": "char",
    "description": "Identifies the type of ListExecInst (69).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Immediate",
        "description": "Immediate"
      },
      {
        "value": "2",
        "symbolicName": "WaitForInstruction",
        "description": "Wait for Execut Instruction (i.e. a List Execut message or phone call before proceeding with execution of the list)"
      },
      {
        "value": "3",
        "symbolicName": "SellDriven",
        "description": "Exchange/switch CIV order - Sell driven"
      },
      {
        "value": "4",
        "symbolicName": "BuyDrivenCashTopUp",
        "description": "Exchange/switch CIV order - Buy driven, cash top-up (i.e. additional cash will be provided to fulfill the order)"
      },
      {
        "value": "5",
        "symbolicName": "BuyDrivenCashWithdraw",
        "description": "Exchange/switch CIV order - Buy driven, cash withdraw (i.e. additional cash will not be provided to fulfill the order)"
      }
    ]
  },
  {
    "tag": "434",
    "name": "CxlRejResponseTo",
    "type": "char",
    "description": "Identifies the type of request that a Cancel Reject is in response to.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OrderCancelRequest",
        "description": "Order cancel request"
      },
      {
        "value": "2",
        "symbolicName": "OrderCancel",
        "description": "Order cancel/replace request"
      }
    ]
  },
  {
    "tag": "435",
    "name": "UnderlyingCouponRate",
    "type": "Percentage",
    "description": "Underlying security's CouponRate.\nSee CouponRate (223) field for description"
  },
  {
    "tag": "436",
    "name": "UnderlyingContractMultiplier",
    "type": "float",
    "description": "Underlying security's ContractMultiplier.\nSee ContractMultiplier (231) field for description"
  },
  {
    "tag": "437",
    "name": "ContraTradeQty",
    "type": "Qty",
    "description": "Quantity traded with the ContraBroker (375)."
  },
  {
    "tag": "438",
    "name": "ContraTradeTime",
    "type": "UTCTimestamp",
    "description": "Identifes the time of the trade with the ContraBroker (375). (always expressed in UTC (Universal Time Coordinated, also known as \"GMT\")"
  },
  {
    "tag": "441",
    "name": "LiquidityNumSecurities",
    "type": "int",
    "description": "Number of Securites between LiquidityPctLow (402) and LiquidityPctHigh (403) in Currency."
  },
  {
    "tag": "442",
    "name": "MultiLegReportingType",
    "type": "char",
    "description": "Used to indicate what an Execution Report represents (e.g. used with multi-leg securities, such as option strategies, spreads, etc.).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "SingleSecurity",
        "description": "Single security (default if not specified)"
      },
      {
        "value": "2",
        "symbolicName": "IndividualLegOfAMultiLegSecurity",
        "description": "Individual leg of a multi-leg security"
      },
      {
        "value": "3",
        "symbolicName": "MultiLegSecurity",
        "description": "Multi-leg security"
      }
    ]
  },
  {
    "tag": "443",
    "name": "StrikeTime",
    "type": "UTCTimestamp",
    "description": "The time at which current market prices are used to determine the value of a basket."
  },
  {
    "tag": "444",
    "name": "ListStatusText",
    "type": "String",
    "description": "Free format text string related to List Status."
  },
  {
    "tag": "445",
    "name": "EncodedListStatusTextLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedListStatusText (446) field."
  },
  {
    "tag": "446",
    "name": "EncodedListStatusText",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the ListStatusText (444) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ListStatusText field."
  },
  {
    "tag": "447",
    "name": "PartyIDSource",
    "type": "char",
    "description": "Identifies class or source of the PartyID (448) value. Required if PartyID is specified. Note: applicable values depend upon PartyRole (452) specified.\nSee \"Appendix 6-G - Use of <Parties> Component Block\"",
    "enum": [
      {
        "value": "6",
        "symbolicName": "UKNationalInsuranceOrPensionNumber",
        "description": "UK National Insurance or Pension Number"
      },
      {
        "value": "7",
        "symbolicName": "USSocialSecurityNumber",
        "description": "US Social Security Number"
      },
      {
        "value": "8",
        "symbolicName": "USEmployerOrTaxIDNumber",
        "description": "US Employer or Tax ID Number"
      },
      {
        "value": "9",
        "symbolicName": "AustralianBusinessNumber",
        "description": "Australian Business Number"
      },
      {
        "value": "A",
        "symbolicName": "AustralianTaxFileNumber",
        "description": "Australian Tax File Number"
      },
      {
        "value": "1",
        "symbolicName": "KoreanInvestorID",
        "description": "Korean Investor ID"
      },
      {
        "value": "2",
        "symbolicName": "TaiwaneseForeignInvestorID",
        "description": "Taiwanese Qualified Foreign Investor ID QFII/FID"
      },
      {
        "value": "3",
        "symbolicName": "TaiwaneseTradingAcct",
        "description": "Taiwanese Trading Acct"
      },
      {
        "value": "4",
        "symbolicName": "MalaysianCentralDepository",
        "description": "Malaysian Central Depository (MCD) number"
      },
      {
        "value": "5",
        "symbolicName": "ChineseInvestorID",
        "description": "Chinese Investor ID"
      },
      {
        "value": "I",
        "symbolicName": "ISITCAcronym",
        "description": "Directed broker three character acronym as defined in ISITC \"ETC Best Practice\" guidelines document"
      },
      {
        "value": "B",
        "symbolicName": "BIC",
        "description": "BIC (Bank Identification Code - SWIFT managed) code (ISO9362 - See \"Appendix 6-B\")"
      },
      {
        "value": "C",
        "symbolicName": "GeneralIdentifier",
        "description": "Generally accepted market participant identifier (e.g. NASD mnemonic)"
      },
      {
        "value": "D",
        "symbolicName": "Proprietary",
        "description": "Proprietary / Custom code"
      },
      {
        "value": "E",
        "symbolicName": "ISOCountryCode",
        "description": "ISO Country Code"
      },
      {
        "value": "F",
        "symbolicName": "SettlementEntityLocation",
        "description": "Settlement Entity Location (note if Local Market Settlement use \"E=ISO Country Code\") (see \"Appendix 6-G\" for valid values)"
      },
      {
        "value": "G",
        "symbolicName": "MIC",
        "description": "MIC (ISO 10383 - Market Identificer Code) (See \"Appendix 6-C\")"
      },
      {
        "value": "H",
        "symbolicName": "CSDParticipant",
        "description": "CSD participant/member code (e.g.. Euroclear, DTC, CREST or Kassenverein number)"
      }
    ]
  },
  {
    "tag": "448",
    "name": "PartyID",
    "type": "String",
    "description": "Party identifier/code. See PartyIDSource (447) and PartyRole (452).\nSee \"Appendix 6-G - Use of <Parties> Component Block\""
  },
  {
    "tag": "451",
    "name": "NetChgPrevDay",
    "type": "PriceOffset",
    "description": "Net change from previous day's closing price vs. last traded price."
  },
  {
    "tag": "452",
    "name": "PartyRole",
    "type": "int",
    "description": "Identifies the type or role of the PartyID (448) specified.\nSee \"Appendix 6-G - Use of <Parties> Component Block\"\n(see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "1",
        "symbolicName": "ExecutingFirm",
        "description": "Executing Firm (formerly FIX 4.2 ExecBroker)"
      },
      {
        "value": "2",
        "symbolicName": "BrokerOfCredit",
        "description": "Broker of Credit (formerly FIX 4.2 BrokerOfCredit)"
      },
      {
        "value": "3",
        "symbolicName": "ClientID",
        "description": "Client ID (formerly FIX 4.2 ClientID)"
      },
      {
        "value": "4",
        "symbolicName": "ClearingFirm",
        "description": "Clearing Firm (formerly FIX 4.2 ClearingFirm)"
      },
      {
        "value": "5",
        "symbolicName": "InvestorID",
        "description": "Investor ID"
      },
      {
        "value": "6",
        "symbolicName": "IntroducingFirm",
        "description": "Introducing Firm"
      },
      {
        "value": "7",
        "symbolicName": "EnteringFirm",
        "description": "Entering Firm"
      },
      {
        "value": "8",
        "symbolicName": "Locate",
        "description": "Locate / Lending Firm (for short-sales)"
      },
      {
        "value": "9",
        "symbolicName": "FundManagerClientID",
        "description": "Fund Manager Client ID (for CIV)"
      },
      {
        "value": "10",
        "symbolicName": "SettlementLocation",
        "description": "Settlement Location (formerly FIX 4.2 SettlLocation)"
      },
      {
        "value": "11",
        "symbolicName": "OrderOriginationTrader",
        "description": "Order Origination Trader (associated with Order Origination Firm - i.e. trader who initiates/submits the order)"
      },
      {
        "value": "12",
        "symbolicName": "ExecutingTrader",
        "description": "Executing Trader (associated with Executing Firm - actually executes)"
      },
      {
        "value": "13",
        "symbolicName": "OrderOriginationFirm",
        "description": "Order Origination Firm (e.g. buy-side firm)"
      },
      {
        "value": "14",
        "symbolicName": "GiveupClearingFirm",
        "description": "Giveup Clearing Firm (firm to which trade is given up)"
      },
      {
        "value": "15",
        "symbolicName": "CorrespondantClearingFirm",
        "description": "Correspondant Clearing Firm"
      },
      {
        "value": "16",
        "symbolicName": "ExecutingSystem",
        "description": "Executing System"
      },
      {
        "value": "17",
        "symbolicName": "ContraFirm",
        "description": "Contra Firm"
      },
      {
        "value": "18",
        "symbolicName": "ContraClearingFirm",
        "description": "Contra Clearing Firm"
      },
      {
        "value": "19",
        "symbolicName": "SponsoringFirm",
        "description": "Sponsoring Firm"
      },
      {
        "value": "20",
        "symbolicName": "UnderlyingContraFirm",
        "description": "Underlying Contra Firm"
      },
      {
        "value": "21",
        "symbolicName": "ClearingOrganization",
        "description": "Clearing Organization"
      },
      {
        "value": "22",
        "symbolicName": "Exchange",
        "description": "Exchange"
      },
      {
        "value": "24",
        "symbolicName": "CustomerAccount",
        "description": "Customer Account"
      },
      {
        "value": "25",
        "symbolicName": "CorrespondentClearingOrganization",
        "description": "Correspondent Clearing Organization"
      },
      {
        "value": "26",
        "symbolicName": "CorrespondentBroker",
        "description": "Correspondent Broker"
      },
      {
        "value": "27",
        "symbolicName": "Buyer",
        "description": "Buyer/Seller (Receiver/Deliverer)"
      },
      {
        "value": "28",
        "symbolicName": "Custodian",
        "description": "Custodian"
      },
      {
        "value": "29",
        "symbolicName": "Intermediary",
        "description": "Intermediary"
      },
      {
        "value": "30",
        "symbolicName": "Agent",
        "description": "Agent"
      },
      {
        "value": "31",
        "symbolicName": "SubCustodian",
        "description": "Sub-custodian"
      },
      {
        "value": "32",
        "symbolicName": "Beneficiary",
        "description": "Beneficiary"
      },
      {
        "value": "33",
        "symbolicName": "InterestedParty",
        "description": "Interested party"
      },
      {
        "value": "34",
        "symbolicName": "RegulatoryBody",
        "description": "Regulatory body"
      },
      {
        "value": "35",
        "symbolicName": "LiquidityProvider",
        "description": "Liquidity provider"
      },
      {
        "value": "36",
        "symbolicName": "EnteringTrader",
        "description": "Entering trader"
      },
      {
        "value": "37",
        "symbolicName": "ContraTrader",
        "description": "Contra trader"
      },
      {
        "value": "38",
        "symbolicName": "PositionAccount",
        "description": "Position account"
      },
      {
        "value": "39",
        "symbolicName": "ContraInvestorID",
        "description": "Contra Investor ID"
      },
      {
        "value": "40",
        "symbolicName": "TransferToFirm",
        "description": "Transfer to Firm"
      },
      {
        "value": "41",
        "symbolicName": "ContraPositionAccount",
        "description": "Contra Position Account"
      },
      {
        "value": "42",
        "symbolicName": "ContraExchange",
        "description": "Contra Exchange"
      },
      {
        "value": "43",
        "symbolicName": "InternalCarryAccount",
        "description": "Internal Carry Account"
      },
      {
        "value": "44",
        "symbolicName": "OrderEntryOperatorID",
        "description": "Order Entry Operator ID"
      },
      {
        "value": "45",
        "symbolicName": "SecondaryAccountNumber",
        "description": "Secondary Account Number"
      },
      {
        "value": "46",
        "symbolicName": "ForeignFirm",
        "description": "Foreign Firm"
      },
      {
        "value": "47",
        "symbolicName": "ThirdPartyAllocationFirm",
        "description": "Third Party Allocation Firm"
      },
      {
        "value": "48",
        "symbolicName": "ClaimingAccount",
        "description": "Claiming Account"
      },
      {
        "value": "49",
        "symbolicName": "AssetManager",
        "description": "Asset Manager"
      },
      {
        "value": "50",
        "symbolicName": "PledgorAccount",
        "description": "Pledgor Account"
      },
      {
        "value": "51",
        "symbolicName": "PledgeeAccount",
        "description": "Pledgee Account"
      },
      {
        "value": "52",
        "symbolicName": "LargeTraderReportableAccount",
        "description": "Large Trader Reportable Account"
      },
      {
        "value": "53",
        "symbolicName": "TraderMnemonic",
        "description": "Trader mnemonic"
      },
      {
        "value": "54",
        "symbolicName": "SenderLocation",
        "description": "Sender Location"
      },
      {
        "value": "55",
        "symbolicName": "SessionID",
        "description": "Session ID"
      },
      {
        "value": "56",
        "symbolicName": "AcceptableCounterparty",
        "description": "Acceptable Counterparty"
      },
      {
        "value": "57",
        "symbolicName": "UnacceptableCounterparty",
        "description": "Unacceptable Counterparty"
      },
      {
        "value": "58",
        "symbolicName": "EnteringUnit",
        "description": "Entering Unit"
      },
      {
        "value": "59",
        "symbolicName": "ExecutingUnit",
        "description": "Executing Unit"
      },
      {
        "value": "60",
        "symbolicName": "IntroducingBroker",
        "description": "Introducing Broker"
      },
      {
        "value": "61",
        "symbolicName": "QuoteOriginator",
        "description": "Quote originator"
      },
      {
        "value": "62",
        "symbolicName": "ReportOriginator",
        "description": "Report originator"
      },
      {
        "value": "63",
        "symbolicName": "SystematicInternaliser",
        "description": "Systematic internaliser (SI)"
      },
      {
        "value": "64",
        "symbolicName": "MultilateralTradingFacility",
        "description": "Multilateral Trading Facility (MTF)"
      },
      {
        "value": "65",
        "symbolicName": "RegulatedMarket",
        "description": "Regulated Market (RM)"
      },
      {
        "value": "66",
        "symbolicName": "MarketMaker",
        "description": "Market Maker"
      },
      {
        "value": "67",
        "symbolicName": "InvestmentFirm",
        "description": "Investment Firm"
      },
      {
        "value": "68",
        "symbolicName": "HostCompetentAuthority",
        "description": "Host Competent Authority (Host CA)"
      },
      {
        "value": "69",
        "symbolicName": "HomeCompetentAuthority",
        "description": "Home Competent Authority (Home CA)"
      },
      {
        "value": "70",
        "symbolicName": "CompetentAuthorityLiquidity",
        "description": "Competent Authority of the most relevant market in terms of liquidity (CAL)"
      },
      {
        "value": "71",
        "symbolicName": "CompetentAuthorityTransactionVenue",
        "description": "Competent Authority of the Transaction (Execution) Venue (CATV)"
      },
      {
        "value": "72",
        "symbolicName": "ReportingIntermediary",
        "description": "Reporting intermediary (medium/vendor via which report has been published)"
      },
      {
        "value": "73",
        "symbolicName": "ExecutionVenue",
        "description": "Execution Venue"
      },
      {
        "value": "74",
        "symbolicName": "MarketDataEntryOriginator",
        "description": "Market data entry originator"
      },
      {
        "value": "75",
        "symbolicName": "LocationID",
        "description": "Location ID"
      },
      {
        "value": "76",
        "symbolicName": "DeskID",
        "description": "Desk ID"
      },
      {
        "value": "77",
        "symbolicName": "MarketDataMarket",
        "description": "Market data market"
      },
      {
        "value": "78",
        "symbolicName": "AllocationEntity",
        "description": "Allocation Entity"
      },
      {
        "value": "79",
        "symbolicName": "PrimeBroker",
        "description": "Prime Broker providing General Trade Services"
      },
      {
        "value": "80",
        "symbolicName": "StepOutFirm",
        "description": "Step-Out Firm (Prime Broker)"
      },
      {
        "value": "81",
        "symbolicName": "BrokerClearingID",
        "description": "BrokerClearingID"
      },
      {
        "value": "82",
        "symbolicName": "CentralRegistrationDepository",
        "description": "Central Registration Depository (CRD)"
      },
      {
        "value": "83",
        "symbolicName": "ClearingAccount",
        "description": "Clearing Account"
      },
      {
        "value": "84",
        "symbolicName": "AcceptableSettlingCounterparty",
        "description": "Acceptable Settling Counterparty"
      },
      {
        "value": "85",
        "symbolicName": "UnacceptableSettlingCounterparty",
        "description": "Unacceptable Settling Counterparty"
      }
    ]
  },
  {
    "tag": "453",
    "name": "NoPartyIDs",
    "type": "NumInGroup",
    "description": "Number of PartyID (448), PartyIDSource (447), and PartyRole (452) entries"
  },
  {
    "tag": "454",
    "name": "NoSecurityAltID",
    "type": "NumInGroup",
    "description": "Number of SecurityAltID (455) entries."
  },
  {
    "tag": "455",
    "name": "SecurityAltID",
    "type": "String",
    "description": "Alternate Security identifier value for this security of SecurityAltIDSource (456) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires SecurityAltIDSource."
  },
  {
    "tag": "456",
    "name": "SecurityAltIDSource",
    "type": "String",
    "description": "Identifies class or source of the SecurityAltID (455) value. Required if SecurityAltID is specified.\nValid values:\nSame valid values as the SecurityIDSource (22) field"
  },
  {
    "tag": "457",
    "name": "NoUnderlyingSecurityAltID",
    "type": "NumInGroup",
    "description": "Number of UnderlyingSecurityAltID (458) entries."
  },
  {
    "tag": "458",
    "name": "UnderlyingSecurityAltID",
    "type": "String",
    "description": "Alternate Security identifier value for this underlying security of UnderlyingSecurityAltIDSource (459) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires UnderlyingSecurityAltIDSource."
  },
  {
    "tag": "459",
    "name": "UnderlyingSecurityAltIDSource",
    "type": "String",
    "description": "Identifies class or source of the UnderlyingSecurityAltID (458) value. Required if UnderlyingSecurityAltID is specified.\nValid values:\nSame valid values as the SecurityIDSource (22) field"
  },
  {
    "tag": "460",
    "name": "Product",
    "type": "int",
    "description": "Indicates the type of product the security is associated with. See also the CFICode (461) and SecurityType (167) fields.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AGENCY",
        "description": "AGENCY"
      },
      {
        "value": "2",
        "symbolicName": "COMMODITY",
        "description": "COMMODITY"
      },
      {
        "value": "3",
        "symbolicName": "CORPORATE",
        "description": "CORPORATE"
      },
      {
        "value": "4",
        "symbolicName": "CURRENCY",
        "description": "CURRENCY"
      },
      {
        "value": "5",
        "symbolicName": "EQUITY",
        "description": "EQUITY"
      },
      {
        "value": "6",
        "symbolicName": "GOVERNMENT",
        "description": "GOVERNMENT"
      },
      {
        "value": "7",
        "symbolicName": "INDEX",
        "description": "INDEX"
      },
      {
        "value": "8",
        "symbolicName": "LOAN",
        "description": "LOAN"
      },
      {
        "value": "9",
        "symbolicName": "MONEYMARKET",
        "description": "MONEYMARKET"
      },
      {
        "value": "10",
        "symbolicName": "MORTGAGE",
        "description": "MORTGAGE"
      },
      {
        "value": "11",
        "symbolicName": "MUNICIPAL",
        "description": "MUNICIPAL"
      },
      {
        "value": "12",
        "symbolicName": "OTHER",
        "description": "OTHER"
      },
      {
        "value": "13",
        "symbolicName": "FINANCING",
        "description": "FINANCING"
      }
    ]
  },
  {
    "tag": "461",
    "name": "CFICode",
    "type": "String",
    "description": "Indicates the type of security using ISO 10962 standard, Classification of Financial Instruments (CFI code) values. ISO 10962 is maintained by ANNA (Association of National Numbering Agencies) acting as Registration Authority. See \"Appendix 6-B FIX Fields Based Upon Other Standards\". See also the Product (460) and SecurityType (167) fields. It is recommended that CFICode be used instead of SecurityType (167) for non-Fixed Income instruments.\nA subset of possible values applicable to FIX usage are identified in \"Appendix 6-D CFICode Usage - ISO 10962 Classification of Financial Instruments (CFI code)\""
  },
  {
    "tag": "462",
    "name": "UnderlyingProduct",
    "type": "int",
    "description": "Underlying security's Product.\nValid values: see Product(460) field"
  },
  {
    "tag": "463",
    "name": "UnderlyingCFICode",
    "type": "String",
    "description": "Underlying security's CFICode.\nValid values: see CFICode (461) field"
  },
  {
    "tag": "464",
    "name": "TestMessageIndicator",
    "type": "Boolean",
    "description": "Indicates whether or not this FIX Session is a \"test\" vs. \"production\" connection. Useful for preventing \"accidents\".",
    "enum": [
      {
        "value": "N",
        "symbolicName": "Fales",
        "description": "Fales (Production)"
      },
      {
        "value": "Y",
        "symbolicName": "True",
        "description": "True (Test)"
      }
    ]
  },
  {
    "tag": "466",
    "name": "BookingRefID",
    "type": "String",
    "description": "Common reference passed to a post-trade booking process (e.g. industry matching utility)."
  },
  {
    "tag": "467",
    "name": "IndividualAllocID",
    "type": "String",
    "description": "Unique identifier for a specific NoAllocs (78) repeating group instance (e.g. for an AllocAccount)."
  },
  {
    "tag": "468",
    "name": "RoundingDirection",
    "type": "char",
    "description": "Specifies which direction to round For CIV - indicates whether or not the quantity of shares/units is to be rounded and in which direction where CashOrdQty (152) or (for CIV only) OrderPercent (516) are specified on an order.\nThe default is for rounding to be at the discretion of the executing broker or fund manager.\ne.g. for an order specifying CashOrdQty or OrderPercent if the calculated number of shares/units was 325.76 and RoundingModulus (469) was 0 - \"round down\" would give 320 units, 1 - \"round up\" would give 330 units and \"round to nearest\" would give 320 units.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "RoundToNearest",
        "description": "Round to nearest"
      },
      {
        "value": "1",
        "symbolicName": "RoundDown",
        "description": "Round down"
      },
      {
        "value": "2",
        "symbolicName": "RoundUp",
        "description": "Round up"
      }
    ]
  },
  {
    "tag": "469",
    "name": "RoundingModulus",
    "type": "float",
    "description": "For CIV - a float value indicating the value to which rounding is required.\ni.e. 0 means round to a multiple of 0 units/shares; 0.5 means round to a multiple of 0.5 units/shares.\nThe default, if RoundingDirection (468) is specified without RoundingModulus, is to round to a whole unit/share."
  },
  {
    "tag": "470",
    "name": "CountryOfIssue",
    "type": "Country",
    "description": "ISO Country code of instrument issue (e.g. the country portion typically used in ISIN). Can be used in conjunction with non-ISIN SecurityID (48) (e.g. CUSIP for Municipal Bonds without ISIN) to provide uniqueness."
  },
  {
    "tag": "471",
    "name": "StateOrProvinceOfIssue",
    "type": "String",
    "description": "A two-character state or province abbreviation."
  },
  {
    "tag": "472",
    "name": "LocaleOfIssue",
    "type": "String",
    "description": "Identifies the locale. For Municipal Security Issuers other than state or province. Refer to\nhttp://www.atmos.albany.edu/cgi/stagrep-cgi\nReference the IATA city codes for values.\nNote IATA (International Air Transport Association) maintains the codes at www.iata.org."
  },
  {
    "tag": "473",
    "name": "NoRegistDtls",
    "type": "NumInGroup",
    "description": "The number of registration details on a Registration Instructions message"
  },
  {
    "tag": "474",
    "name": "MailingDtls",
    "type": "String",
    "description": "Set of Correspondence address details, possibly including phone, fax, etc."
  },
  {
    "tag": "475",
    "name": "InvestorCountryOfResidence",
    "type": "Country",
    "description": "The ISO 366 Country code (2 character) identifying which country the beneficial investor is resident for tax purposes."
  },
  {
    "tag": "476",
    "name": "PaymentRef",
    "type": "String",
    "description": "\"Settlement Payment Reference\" - A free format Payment reference to assist with reconciliation, e.g. a Client and/or Order ID number."
  },
  {
    "tag": "477",
    "name": "DistribPaymentMethod",
    "type": "int",
    "description": "A code identifying the payment method for a (fractional) distribution.\n13 through 998 are reserved for future use\nValues above 1000 are available for use by private agreement among counterparties",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CREST",
        "description": "CREST"
      },
      {
        "value": "2",
        "symbolicName": "NSCC",
        "description": "NSCC"
      },
      {
        "value": "3",
        "symbolicName": "Euroclear",
        "description": "Euroclear"
      },
      {
        "value": "4",
        "symbolicName": "Clearstream",
        "description": "Clearstream"
      },
      {
        "value": "5",
        "symbolicName": "Cheque",
        "description": "Cheque"
      },
      {
        "value": "6",
        "symbolicName": "TelegraphicTransfer",
        "description": "Telegraphic Transfer"
      },
      {
        "value": "7",
        "symbolicName": "FedWire",
        "description": "Fed Wire"
      },
      {
        "value": "8",
        "symbolicName": "DirectCredit",
        "description": "Direct Credit (BECS, BACS)"
      },
      {
        "value": "9",
        "symbolicName": "ACHCredit",
        "description": "ACH Credit"
      },
      {
        "value": "10",
        "symbolicName": "BPAY",
        "description": "BPAY"
      },
      {
        "value": "11",
        "symbolicName": "HighValueClearingSystemHVACS",
        "description": "High Value Clearing System HVACS"
      },
      {
        "value": "12",
        "symbolicName": "ReinvestInFund",
        "description": "Reinvest In Fund"
      }
    ]
  },
  {
    "tag": "478",
    "name": "CashDistribCurr",
    "type": "Currency",
    "description": "Specifies currency to be used for Cash Distributions see \"Appendix 6-A Valid Currency Codes\"."
  },
  {
    "tag": "479",
    "name": "CommCurrency",
    "type": "Currency",
    "description": "Specifies currency to be use for Commission (12) if the Commission currency is different from the Deal Currency - see \"Appendix 6-A; Valid Currency Codes\"."
  },
  {
    "tag": "480",
    "name": "CancellationRights",
    "type": "char",
    "description": "For CIV - A one character code identifying whether Cancellation rights/Cooling off period applies.",
    "enum": [
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Yes"
      },
      {
        "value": "N",
        "symbolicName": "NoExecutionOnly",
        "description": "No - Execution Only"
      },
      {
        "value": "M",
        "symbolicName": "NoWaiverAgreement",
        "description": "No - Waiver agreement"
      },
      {
        "value": "O",
        "symbolicName": "NoInstitutional",
        "description": "No - Institutional"
      }
    ]
  },
  {
    "tag": "481",
    "name": "MoneyLaunderingStatus",
    "type": "char",
    "description": "A one character code identifying Money laundering status.",
    "enum": [
      {
        "value": "Y",
        "symbolicName": "Passed",
        "description": "Passed"
      },
      {
        "value": "N",
        "symbolicName": "NotChecked",
        "description": "Not Checked"
      },
      {
        "value": "1",
        "symbolicName": "ExemptBelowLimit",
        "description": "Exempt - Below the Limit"
      },
      {
        "value": "2",
        "symbolicName": "ExemptMoneyType",
        "description": "Exempt - Client Money Type exemption"
      },
      {
        "value": "3",
        "symbolicName": "ExemptAuthorised",
        "description": "Exempt - Authorised Credit or financial institution"
      }
    ]
  },
  {
    "tag": "482",
    "name": "MailingInst",
    "type": "String",
    "description": "Free format text to specify mailing instruction requirements, e.g. \"no third party mailings\"."
  },
  {
    "tag": "483",
    "name": "TransBkdTime",
    "type": "UTCTimestamp",
    "description": "For CIV A date and time stamp to indicate the time a CIV order was booked by the fund manager.\nFor derivatives a date and time stamp to indicate when this order was booked with the agent prior to submission to the VMU. Indicates the time at which the order was finalized between the buyer and seller prior to submission."
  },
  {
    "tag": "484",
    "name": "ExecPriceType",
    "type": "char",
    "description": "For CIV - Identifies how the execution price LastPx (31) was calculated from the fund unit/share price(s) calculated at the fund valuation point.",
    "enum": [
      {
        "value": "B",
        "symbolicName": "BidPrice",
        "description": "Bid price"
      },
      {
        "value": "C",
        "symbolicName": "CreationPrice",
        "description": "Creation price"
      },
      {
        "value": "D",
        "symbolicName": "CreationPricePlusAdjustmentPercent",
        "description": "Creation price plus adjustment percent"
      },
      {
        "value": "E",
        "symbolicName": "CreationPricePlusAdjustmentAmount",
        "description": "Creation price plus adjustment amount"
      },
      {
        "value": "O",
        "symbolicName": "OfferPrice",
        "description": "Offer price"
      },
      {
        "value": "P",
        "symbolicName": "OfferPriceMinusAdjustmentPercent",
        "description": "Offer price minus adjustment percent"
      },
      {
        "value": "Q",
        "symbolicName": "OfferPriceMinusAdjustmentAmount",
        "description": "Offer price minus adjustment amount"
      },
      {
        "value": "S",
        "symbolicName": "SinglePrice",
        "description": "Single price"
      }
    ]
  },
  {
    "tag": "485",
    "name": "ExecPriceAdjustment",
    "type": "float",
    "description": "For CIV the amount or percentage by which the fund unit/share price was adjusted, as indicated by ExecPriceType (484)"
  },
  {
    "tag": "486",
    "name": "DateOfBirth",
    "type": "LocalMktDate",
    "description": "The date of birth applicable to the individual, e.g. required to open some types of tax-exempt account."
  },
  {
    "tag": "487",
    "name": "TradeReportTransType",
    "type": "int",
    "description": "Identifies Trade Report message transaction type\n(Prior to FIX 4.4 this field was of type char)",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "2",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "3",
        "symbolicName": "Release",
        "description": "Release"
      },
      {
        "value": "4",
        "symbolicName": "Reverse",
        "description": "Reverse"
      },
      {
        "value": "5",
        "symbolicName": "CancelDueToBackOutOfTrade",
        "description": "Cancel Due To Back Out of Trade"
      }
    ]
  },
  {
    "tag": "488",
    "name": "CardHolderName",
    "type": "String",
    "description": "The name of the payment card holder as specified on the card being used for payment."
  },
  {
    "tag": "489",
    "name": "CardNumber",
    "type": "String",
    "description": "The number of the payment card as specified on the card being used for payment."
  },
  {
    "tag": "490",
    "name": "CardExpDate",
    "type": "LocalMktDate",
    "description": "The expiry date of the payment card as specified on the card being used for payment."
  },
  {
    "tag": "491",
    "name": "CardIssNum",
    "type": "String",
    "description": "The issue number of the payment card as specified on the card being used for payment. This is only applicable to certain types of card."
  },
  {
    "tag": "492",
    "name": "PaymentMethod",
    "type": "int",
    "description": "A code identifying the Settlement payment method. 16 through 998 are reserved for future use\nValues above 1000 are available for use by private agreement among counterparties",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CREST",
        "description": "CREST"
      },
      {
        "value": "2",
        "symbolicName": "NSCC",
        "description": "NSCC"
      },
      {
        "value": "3",
        "symbolicName": "Euroclear",
        "description": "Euroclear"
      },
      {
        "value": "4",
        "symbolicName": "Clearstream",
        "description": "Clearstream"
      },
      {
        "value": "5",
        "symbolicName": "Cheque",
        "description": "Cheque"
      },
      {
        "value": "6",
        "symbolicName": "TelegraphicTransfer",
        "description": "Telegraphic Transfer"
      },
      {
        "value": "7",
        "symbolicName": "FedWire",
        "description": "Fed Wire"
      },
      {
        "value": "8",
        "symbolicName": "DebitCard",
        "description": "Debit Card"
      },
      {
        "value": "9",
        "symbolicName": "DirectDebit",
        "description": "Direct Debit (BECS)"
      },
      {
        "value": "10",
        "symbolicName": "DirectCredit",
        "description": "Direct Credit (BECS)"
      },
      {
        "value": "11",
        "symbolicName": "CreditCard",
        "description": "Credit Card"
      },
      {
        "value": "12",
        "symbolicName": "ACHDebit",
        "description": "ACH Debit"
      },
      {
        "value": "13",
        "symbolicName": "ACHCredit",
        "description": "ACH Credit"
      },
      {
        "value": "14",
        "symbolicName": "BPAY",
        "description": "BPAY"
      },
      {
        "value": "15",
        "symbolicName": "HighValueClearingSystem",
        "description": "High Value Clearing System (HVACS)"
      }
    ]
  },
  {
    "tag": "493",
    "name": "RegistAcctType",
    "type": "String",
    "description": "For CIV - a fund manager-defined code identifying which of the fund manager's account types is required."
  },
  {
    "tag": "494",
    "name": "Designation",
    "type": "String",
    "description": "Free format text defining the designation to be associated with a holding on the register. Used to identify assets of a specific underlying investor using a common registration, e.g. a broker's nominee or street name."
  },
  {
    "tag": "495",
    "name": "TaxAdvantageType",
    "type": "int",
    "description": "For CIV - a code identifying the type of tax exempt account in which purchased shares/units are to be held.\n30 - 998 are reserved for future use by recognized taxation authorities\n999=Other\nvalues above 1000 are available for use by private agreement among counterparties",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "None/Not Applicable (default)"
      },
      {
        "value": "1",
        "symbolicName": "MaxiISA",
        "description": "Maxi ISA (UK)"
      },
      {
        "value": "2",
        "symbolicName": "TESSA",
        "description": "TESSA (UK)"
      },
      {
        "value": "3",
        "symbolicName": "MiniCashISA",
        "description": "Mini Cash ISA (UK)"
      },
      {
        "value": "4",
        "symbolicName": "MiniStocksAndSharesISA",
        "description": "Mini Stocks And Shares ISA (UK)"
      },
      {
        "value": "5",
        "symbolicName": "MiniInsuranceISA",
        "description": "Mini Insurance ISA (UK)"
      },
      {
        "value": "6",
        "symbolicName": "CurrentYearPayment",
        "description": "Current Year Payment (US)"
      },
      {
        "value": "7",
        "symbolicName": "PriorYearPayment",
        "description": "Prior Year Payment (US)"
      },
      {
        "value": "8",
        "symbolicName": "AssetTransfer",
        "description": "Asset Transfer (US)"
      },
      {
        "value": "9",
        "symbolicName": "EmployeePriorYear",
        "description": "Employee - prior year (US)"
      },
      {
        "value": "10",
        "symbolicName": "EmployeeCurrentYear",
        "description": "Employee - current year (US)"
      },
      {
        "value": "11",
        "symbolicName": "EmployerPriorYear",
        "description": "Employer - prior year (US)"
      },
      {
        "value": "12",
        "symbolicName": "EmployerCurrentYear",
        "description": "Employer - current year (US)"
      },
      {
        "value": "13",
        "symbolicName": "NonFundPrototypeIRA",
        "description": "Non-fund prototype IRA (US)"
      },
      {
        "value": "14",
        "symbolicName": "NonFundQualifiedPlan",
        "description": "Non-fund qualified plan (US)"
      },
      {
        "value": "15",
        "symbolicName": "DefinedContributionPlan",
        "description": "Defined contribution plan (US)"
      },
      {
        "value": "16",
        "symbolicName": "IRA",
        "description": "Individual Retirement Account (US)"
      },
      {
        "value": "17",
        "symbolicName": "IRARollover",
        "description": "Individual Retirement Account - Rollover (US)"
      },
      {
        "value": "18",
        "symbolicName": "KEOGH",
        "description": "KEOGH (US)"
      },
      {
        "value": "19",
        "symbolicName": "ProfitSharingPlan",
        "description": "Profit Sharing Plan (US)"
      },
      {
        "value": "20",
        "symbolicName": "US401K",
        "description": "401(k) (US)"
      },
      {
        "value": "21",
        "symbolicName": "SelfDirectedIRA",
        "description": "Self-directed IRA (US)"
      },
      {
        "value": "22",
        "symbolicName": "US403b",
        "description": "403(b) (US)"
      },
      {
        "value": "23",
        "symbolicName": "US457",
        "description": "457 (US)"
      },
      {
        "value": "24",
        "symbolicName": "RothIRAPrototype",
        "description": "Roth IRA (Fund Prototype) (US)"
      },
      {
        "value": "25",
        "symbolicName": "RothIRANonPrototype",
        "description": "Roth IRA (Non-prototype) (US)"
      },
      {
        "value": "26",
        "symbolicName": "RothConversionIRAPrototype",
        "description": "Roth Conversion IRA (Fund Prototype) (US)"
      },
      {
        "value": "27",
        "symbolicName": "RothConversionIRANonPrototype",
        "description": "Roth Conversion IRA (Non-prototype) (US)"
      },
      {
        "value": "28",
        "symbolicName": "EducationIRAPrototype",
        "description": "Education IRA (Fund Prototype) (US)"
      },
      {
        "value": "29",
        "symbolicName": "EducationIRANonPrototype",
        "description": "Education IRA (Non-prototype) (US)"
      },
      {
        "value": "999",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "496",
    "name": "RegistRejReasonText",
    "type": "String",
    "description": "Text indicating reason(s) why a Registration Instruction has been rejected."
  },
  {
    "tag": "497",
    "name": "FundRenewWaiv",
    "type": "char",
    "description": "A one character code identifying whether the Fund based renewal commission is to be waived.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "No"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Yes"
      }
    ]
  },
  {
    "tag": "498",
    "name": "CashDistribAgentName",
    "type": "String",
    "description": "Name of local agent bank if for cash distributions"
  },
  {
    "tag": "499",
    "name": "CashDistribAgentCode",
    "type": "String",
    "description": "BIC (Bank Identification Code--Swift managed) code of agent bank for cash distributions"
  },
  {
    "tag": "500",
    "name": "CashDistribAgentAcctNumber",
    "type": "String",
    "description": "Account number at agent bank for distributions."
  },
  {
    "tag": "501",
    "name": "CashDistribPayRef",
    "type": "String",
    "description": "Free format Payment reference to assist with reconciliation of distributions."
  },
  {
    "tag": "502",
    "name": "CashDistribAgentAcctName",
    "type": "String",
    "description": "Name of account at agent bank for distributions."
  },
  {
    "tag": "503",
    "name": "CardStartDate",
    "type": "LocalMktDate",
    "description": "The start date of the card as specified on the card being used for payment."
  },
  {
    "tag": "504",
    "name": "PaymentDate",
    "type": "LocalMktDate",
    "description": "The date written on a cheque or date payment should be submitted to the relevant clearing system."
  },
  {
    "tag": "505",
    "name": "PaymentRemitterID",
    "type": "String",
    "description": "Identifies sender of a payment, e.g. the payment remitter or a customer reference number."
  },
  {
    "tag": "506",
    "name": "RegistStatus",
    "type": "char",
    "description": "Registration status as returned by the broker or (for CIV) the fund manager:",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "R",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "H",
        "symbolicName": "Held",
        "description": "Held"
      },
      {
        "value": "N",
        "symbolicName": "Reminder",
        "description": "Reminder - i.e. Registration Instructions are still outstanding"
      }
    ]
  },
  {
    "tag": "507",
    "name": "RegistRejReasonCode",
    "type": "int",
    "description": "Reason(s) why Registration Instructions has been rejected.\nThe reason may be further amplified in the RegistRejReasonCode field.\nPossible values of reason code include:",
    "enum": [
      {
        "value": "1",
        "symbolicName": "InvalidAccountType",
        "description": "Invalid/unacceptable Account Type"
      },
      {
        "value": "2",
        "symbolicName": "InvalidTaxExemptType",
        "description": "Invalid/unacceptable Tax Exempt Type"
      },
      {
        "value": "3",
        "symbolicName": "InvalidOwnershipType",
        "description": "Invalid/unacceptable Ownership Type"
      },
      {
        "value": "4",
        "symbolicName": "NoRegDetails",
        "description": "Invalid/unacceptable No Reg Details"
      },
      {
        "value": "5",
        "symbolicName": "InvalidRegSeqNo",
        "description": "Invalid/unacceptable Reg Seq No"
      },
      {
        "value": "6",
        "symbolicName": "InvalidRegDetails",
        "description": "Invalid/unacceptable Reg Details"
      },
      {
        "value": "7",
        "symbolicName": "InvalidMailingDetails",
        "description": "Invalid/unacceptable Mailing Details"
      },
      {
        "value": "8",
        "symbolicName": "InvalidMailingInstructions",
        "description": "Invalid/unacceptable Mailing Instructions"
      },
      {
        "value": "9",
        "symbolicName": "InvalidInvestorID",
        "description": "Invalid/unacceptable Investor ID"
      },
      {
        "value": "10",
        "symbolicName": "InvalidInvestorIDSource",
        "description": "Invalid/unaceeptable Investor ID Source"
      },
      {
        "value": "11",
        "symbolicName": "InvalidDateOfBirth",
        "description": "Invalid/unacceptable Date Of Birth"
      },
      {
        "value": "12",
        "symbolicName": "InvalidCountry",
        "description": "Invalid/unacceptable Investor Country Of Residence"
      },
      {
        "value": "13",
        "symbolicName": "InvalidDistribInstns",
        "description": "Invalid/unacceptable No Distrib Instns"
      },
      {
        "value": "14",
        "symbolicName": "InvalidPercentage",
        "description": "Invalid/unacceptable Distrib Percentage"
      },
      {
        "value": "15",
        "symbolicName": "InvalidPaymentMethod",
        "description": "Invalid/unacceptable Distrib Payment Method"
      },
      {
        "value": "16",
        "symbolicName": "InvalidAccountName",
        "description": "Invalid/unacceptable Cash Distrib Agent Acct Name"
      },
      {
        "value": "17",
        "symbolicName": "InvalidAgentCode",
        "description": "Invalid/unacceptable Cash Distrib Agent Code"
      },
      {
        "value": "18",
        "symbolicName": "InvalidAccountNum",
        "description": "Invalid/unacceptable Cash Distrib Agent Acct Num"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "508",
    "name": "RegistRefID",
    "type": "String",
    "description": "Reference identifier for the RegistID (53) with Cancel and Replace RegistTransType (54) transaction types."
  },
  {
    "tag": "509",
    "name": "RegistDtls",
    "type": "String",
    "description": "Set of Registration name and address details, possibly including phone, fax etc."
  },
  {
    "tag": "510",
    "name": "NoDistribInsts",
    "type": "NumInGroup",
    "description": "The number of Distribution Instructions on a Registration Instructions message"
  },
  {
    "tag": "511",
    "name": "RegistEmail",
    "type": "String",
    "description": "Email address relating to Registration name and address details"
  },
  {
    "tag": "512",
    "name": "DistribPercentage",
    "type": "Percentage",
    "description": "The amount of each distribution to go to this beneficiary, expressed as a percentage"
  },
  {
    "tag": "513",
    "name": "RegistID",
    "type": "String",
    "description": "Unique identifier of the registration details as assigned by institution or intermediary."
  },
  {
    "tag": "514",
    "name": "RegistTransType",
    "type": "char",
    "description": "Identifies Registration Instructions transaction type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "2",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "1",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "515",
    "name": "ExecValuationPoint",
    "type": "UTCTimestamp",
    "description": "For CIV - a date and time stamp to indicate the fund valuation point with respect to which a order was priced by the fund manager."
  },
  {
    "tag": "516",
    "name": "OrderPercent",
    "type": "Percentage",
    "description": "For CIV specifies the approximate order quantity desired. For a CIV Sale it specifies percentage of investor's total holding to be sold. For a CIV switch/exchange it specifies percentage of investor's cash realised from sales to be re-invested. The executing broker, intermediary or fund manager is responsible for converting and calculating OrderQty (38) in shares/units for subsequent messages."
  },
  {
    "tag": "517",
    "name": "OwnershipType",
    "type": "char",
    "description": "The relationship between Registration parties.",
    "enum": [
      {
        "value": "J",
        "symbolicName": "JointInvestors",
        "description": "Joint Investors"
      },
      {
        "value": "T",
        "symbolicName": "TenantsInCommon",
        "description": "Tenants in Common"
      },
      {
        "value": "2",
        "symbolicName": "JointTrustees",
        "description": "Joint Trustees"
      }
    ]
  },
  {
    "tag": "518",
    "name": "NoContAmts",
    "type": "NumInGroup",
    "description": "The number of Contract Amount details on an Execution Report message"
  },
  {
    "tag": "519",
    "name": "ContAmtType",
    "type": "int",
    "description": "Type of ContAmtValue (520).\nNOTE That Commission Amount / % in Contract Amounts is the commission actually charged, rather than the commission instructions given in Fields 2/3.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CommissionAmount",
        "description": "Commission amount (actual)"
      },
      {
        "value": "2",
        "symbolicName": "CommissionPercent",
        "description": "Commission percent (actual)"
      },
      {
        "value": "3",
        "symbolicName": "InitialChargeAmount",
        "description": "Initial Charge Amount"
      },
      {
        "value": "4",
        "symbolicName": "InitialChargePercent",
        "description": "Initial Charge Percent"
      },
      {
        "value": "5",
        "symbolicName": "DiscountAmount",
        "description": "Discount Amount"
      },
      {
        "value": "6",
        "symbolicName": "DiscountPercent",
        "description": "Discount Percent"
      },
      {
        "value": "7",
        "symbolicName": "DilutionLevyAmount",
        "description": "Dilution Levy Amount"
      },
      {
        "value": "8",
        "symbolicName": "DilutionLevyPercent",
        "description": "Dilution Levy Percent"
      },
      {
        "value": "9",
        "symbolicName": "ExitChargeAmount",
        "description": "Exit Charge Amount"
      },
      {
        "value": "10",
        "symbolicName": "ExitChargePercent",
        "description": "Exit Charge Percent"
      },
      {
        "value": "11",
        "symbolicName": "FundBasedRenewalCommissionPercent",
        "description": "Fund-Based Renewal Commission Percent (a.k.a. Trail commission)"
      },
      {
        "value": "12",
        "symbolicName": "ProjectedFundValue",
        "description": "Projected Fund Value (i.e. for investments intended to realise or exceed a specific future value)"
      },
      {
        "value": "13",
        "symbolicName": "FundBasedRenewalCommissionOnOrder",
        "description": "Fund-Based Renewal Commission Amount (based on Order value)"
      },
      {
        "value": "14",
        "symbolicName": "FundBasedRenewalCommissionOnFund",
        "description": "Fund-Based Renewal Commission Amount (based on Projected Fund value)"
      },
      {
        "value": "15",
        "symbolicName": "NetSettlementAmount",
        "description": "Net Settlement Amount"
      }
    ]
  },
  {
    "tag": "520",
    "name": "ContAmtValue",
    "type": "float",
    "description": "Value of Contract Amount, e.g. a financial amount or percentage as indicated by ContAmtType (519)."
  },
  {
    "tag": "521",
    "name": "ContAmtCurr",
    "type": "Currency",
    "description": "Specifies currency for the Contract amount if different from the Deal Currency - see \"Appendix 6-A; Valid Currency Codes\"."
  },
  {
    "tag": "522",
    "name": "OwnerType",
    "type": "int",
    "description": "Identifies the type of owner.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "IndividualInvestor",
        "description": "Individual Investor"
      },
      {
        "value": "2",
        "symbolicName": "PublicCompany",
        "description": "Public Company"
      },
      {
        "value": "3",
        "symbolicName": "PrivateCompany",
        "description": "Private Company"
      },
      {
        "value": "4",
        "symbolicName": "IndividualTrustee",
        "description": "Individual Trustee"
      },
      {
        "value": "5",
        "symbolicName": "CompanyTrustee",
        "description": "Company Trustee"
      },
      {
        "value": "6",
        "symbolicName": "PensionPlan",
        "description": "Pension Plan"
      },
      {
        "value": "7",
        "symbolicName": "CustodianUnderGiftsToMinorsAct",
        "description": "Custodian Under Gifts to Minors Act"
      },
      {
        "value": "8",
        "symbolicName": "Trusts",
        "description": "Trusts"
      },
      {
        "value": "9",
        "symbolicName": "Fiduciaries",
        "description": "Fiduciaries"
      },
      {
        "value": "10",
        "symbolicName": "NetworkingSubAccount",
        "description": "Networking Sub-account"
      },
      {
        "value": "11",
        "symbolicName": "NonProfitOrganization",
        "description": "Non-profit organization"
      },
      {
        "value": "12",
        "symbolicName": "CorporateBody",
        "description": "Corporate Body"
      },
      {
        "value": "13",
        "symbolicName": "Nominee",
        "description": "Nominee"
      }
    ]
  },
  {
    "tag": "523",
    "name": "PartySubID",
    "type": "String",
    "description": "Sub-identifier (e.g. Clearing Account for PartyRole (452)=Clearing Firm, Locate ID # for PartyRole=Locate/Lending Firm, etc). Not required when using PartyID (448), PartyIDSource (447), and PartyRole."
  },
  {
    "tag": "524",
    "name": "NestedPartyID",
    "type": "String",
    "description": "PartyID value within a nested repeating group.\nSame values as PartyID (448)"
  },
  {
    "tag": "525",
    "name": "NestedPartyIDSource",
    "type": "char",
    "description": "PartyIDSource value within a nested repeating group.\nSame values as PartyIDSource (447)"
  },
  {
    "tag": "526",
    "name": "SecondaryClOrdID",
    "type": "String",
    "description": "Assigned by the party which originates the order. Can be used to provide the ClOrdID (11) used by an exchange or executing system."
  },
  {
    "tag": "527",
    "name": "SecondaryExecID",
    "type": "String",
    "description": "Assigned by the party which accepts the order. Can be used to provide the ExecID (17) used by an exchange or executing system."
  },
  {
    "tag": "528",
    "name": "OrderCapacity",
    "type": "char",
    "description": "Designates the capacity of the firm placing the order.\n(as of FIX 4.3, this field replaced Rule80A (tag 47) --used in conjunction with OrderRestrictions (529) field)\n(see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Agency",
        "description": "Agency"
      },
      {
        "value": "G",
        "symbolicName": "Proprietary",
        "description": "Proprietary"
      },
      {
        "value": "I",
        "symbolicName": "Individual",
        "description": "Individual"
      },
      {
        "value": "P",
        "symbolicName": "Principal",
        "description": "Principal (Note for CMS purposes, \"Principal\" includes \"Proprietary\")"
      },
      {
        "value": "R",
        "symbolicName": "RisklessPrincipal",
        "description": "Riskless Principal"
      },
      {
        "value": "W",
        "symbolicName": "AgentForOtherMember",
        "description": "Agent for Other Member"
      }
    ]
  },
  {
    "tag": "529",
    "name": "OrderRestrictions",
    "type": "MultipleCharValue",
    "description": "Restrictions associated with an order. If more than one restriction is applicable to an order, this field can contain multiple instructions separated by space.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "ProgramTrade",
        "description": "Program Trade"
      },
      {
        "value": "2",
        "symbolicName": "IndexArbitrage",
        "description": "Index Arbitrage"
      },
      {
        "value": "3",
        "symbolicName": "NonIndexArbitrage",
        "description": "Non-Index Arbitrage"
      },
      {
        "value": "4",
        "symbolicName": "CompetingMarketMaker",
        "description": "Competing Market Maker"
      },
      {
        "value": "5",
        "symbolicName": "ActingAsMarketMakerOrSpecialistInSecurity",
        "description": "Acting as Market Maker or Specialist in the security"
      },
      {
        "value": "6",
        "symbolicName": "ActingAsMarketMakerOrSpecialistInUnderlying",
        "description": "Acting as Market Maker or Specialist in the underlying security of a derivative security"
      },
      {
        "value": "7",
        "symbolicName": "ForeignEntity",
        "description": "Foreign Entity (of foreign government or regulatory jurisdiction)"
      },
      {
        "value": "8",
        "symbolicName": "ExternalMarketParticipant",
        "description": "External Market Participant"
      },
      {
        "value": "9",
        "symbolicName": "ExternalInterConnectedMarketLinkage",
        "description": "External Inter-connected Market Linkage"
      },
      {
        "value": "A",
        "symbolicName": "RisklessArbitrage",
        "description": "Riskless Arbitrage"
      },
      {
        "value": "B",
        "symbolicName": "IssuerHolding",
        "description": "Issuer Holding"
      },
      {
        "value": "C",
        "symbolicName": "IssuePriceStabilization",
        "description": "Issue Price Stabilization"
      },
      {
        "value": "D",
        "symbolicName": "NonAlgorithmic",
        "description": "Non-algorithmic"
      },
      {
        "value": "E",
        "symbolicName": "Algorithmic",
        "description": "Algorithmic"
      },
      {
        "value": "F",
        "symbolicName": "Cross",
        "description": "Cross"
      }
    ]
  },
  {
    "tag": "530",
    "name": "MassCancelRequestType",
    "type": "char",
    "description": "Specifies scope of Order Mass Cancel Request.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CancelOrdersForASecurity",
        "description": "Cancel orders for a security"
      },
      {
        "value": "2",
        "symbolicName": "CancelOrdersForAnUnderlyingSecurity",
        "description": "Cancel orders for an underlying security"
      },
      {
        "value": "3",
        "symbolicName": "CancelOrdersForAProduct",
        "description": "Cancel orders for a Product"
      },
      {
        "value": "4",
        "symbolicName": "CancelOrdersForACFICode",
        "description": "Cancel orders for a CFICode"
      },
      {
        "value": "5",
        "symbolicName": "CancelOrdersForASecurityType",
        "description": "Cancel orders for a SecurityType"
      },
      {
        "value": "6",
        "symbolicName": "CancelOrdersForATradingSession",
        "description": "Cancel orders for a trading session"
      },
      {
        "value": "7",
        "symbolicName": "CancelAllOrders",
        "description": "Cancel all orders"
      },
      {
        "value": "8",
        "symbolicName": "CancelOrdersForAMarket",
        "description": "Cancel orders for a market"
      },
      {
        "value": "9",
        "symbolicName": "CancelOrdersForAMarketSegment",
        "description": "Cancel orders for a market segment"
      },
      {
        "value": "A",
        "symbolicName": "CancelOrdersForASecurityGroup",
        "description": "Cancel orders for a security group"
      },
      {
        "value": "B",
        "symbolicName": "CancelOrdersForSecurityIssuer",
        "description": "Cancel for Security Issuer"
      },
      {
        "value": "C",
        "symbolicName": "CancelForIssuerOfUnderlyingSecurity",
        "description": "Cancel for Issuer of Underlying Security"
      }
    ]
  },
  {
    "tag": "531",
    "name": "MassCancelResponse",
    "type": "char",
    "description": "Specifies the action taken by counterparty order handling system as a result of the Order Mass Cancel Request",
    "enum": [
      {
        "value": "0",
        "symbolicName": "CancelRequestRejected",
        "description": "Cancel Request Rejected - See MassCancelRejectReason (532)"
      },
      {
        "value": "1",
        "symbolicName": "CancelOrdersForASecurity",
        "description": "Cancel orders for a security"
      },
      {
        "value": "2",
        "symbolicName": "CancelOrdersForAnUnderlyingSecurity",
        "description": "Cancel orders for an Underlying Security"
      },
      {
        "value": "3",
        "symbolicName": "CancelOrdersForAProduct",
        "description": "Cancel orders for a Product"
      },
      {
        "value": "4",
        "symbolicName": "CancelOrdersForACFICode",
        "description": "Cancel orders for a CFICode"
      },
      {
        "value": "5",
        "symbolicName": "CancelOrdersForASecurityType",
        "description": "Cancel orders for a SecurityType"
      },
      {
        "value": "6",
        "symbolicName": "CancelOrdersForATradingSession",
        "description": "Cancel orders for a trading session"
      },
      {
        "value": "7",
        "symbolicName": "CancelAllOrders",
        "description": "Cancel All Orders"
      },
      {
        "value": "8",
        "symbolicName": "CancelOrdersForAMarket",
        "description": "Cancel orders for a market"
      },
      {
        "value": "9",
        "symbolicName": "CancelOrdersForAMarketSegment",
        "description": "Cancel orders for a market segment"
      },
      {
        "value": "A",
        "symbolicName": "CancelOrdersForASecurityGroup",
        "description": "Cancel orders for a security group"
      },
      {
        "value": "B",
        "symbolicName": "CancelOrdersForASecuritiesIssuer",
        "description": "Cancel Orders for a Securities Issuer"
      },
      {
        "value": "C",
        "symbolicName": "CancelOrdersForIssuerOfUnderlyingSecurity",
        "description": "Cancel Orders for Issuer of Underlying Security"
      }
    ]
  },
  {
    "tag": "532",
    "name": "MassCancelRejectReason",
    "type": "int",
    "description": "Reason Order Mass Cancel Request was rejected",
    "enum": [
      {
        "value": "0",
        "symbolicName": "MassCancelNotSupported",
        "description": "Mass Cancel Not Supported"
      },
      {
        "value": "1",
        "symbolicName": "InvalidOrUnknownSecurity",
        "description": "Invalid or Unknown Security"
      },
      {
        "value": "2",
        "symbolicName": "InvalidOrUnkownUnderlyingSecurity",
        "description": "Invalid or Unkown Underlying security"
      },
      {
        "value": "3",
        "symbolicName": "InvalidOrUnknownProduct",
        "description": "Invalid or Unknown Product"
      },
      {
        "value": "4",
        "symbolicName": "InvalidOrUnknownCFICode",
        "description": "Invalid or Unknown CFICode"
      },
      {
        "value": "5",
        "symbolicName": "InvalidOrUnknownSecurityType",
        "description": "Invalid or Unknown SecurityType"
      },
      {
        "value": "6",
        "symbolicName": "InvalidOrUnknownTradingSession",
        "description": "Invalid or Unknown Trading Session"
      },
      {
        "value": "7",
        "symbolicName": "InvalidOrUnknownMarket",
        "description": "Invalid or unknown Market"
      },
      {
        "value": "8",
        "symbolicName": "InvalidOrUnkownMarketSegment",
        "description": "Invalid or unkown Market Segment"
      },
      {
        "value": "9",
        "symbolicName": "InvalidOrUnknownSecurityGroup",
        "description": "Invalid or unknown Security Group"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "10",
        "symbolicName": "InvalidOrUnknownSecurityIssuer",
        "description": "Invalid or unknown Security Issuer"
      },
      {
        "value": "11",
        "symbolicName": "InvalidOrUnknownIssuerOfUnderlyingSecurity",
        "description": "Invalid or unknown Issuer of Underlying Security"
      }
    ]
  },
  {
    "tag": "533",
    "name": "TotalAffectedOrders",
    "type": "int",
    "description": "Total number of orders affected by either the OrderMassActionRequest(MsgType=CA) or OrderMassCancelRequest(MsgType=Q)."
  },
  {
    "tag": "534",
    "name": "NoAffectedOrders",
    "type": "NumInGroup",
    "description": "Number of affected orders in the repeating group of order ids."
  },
  {
    "tag": "535",
    "name": "AffectedOrderID",
    "type": "String",
    "description": "OrderID (37) of an order affected by a mass cancel request."
  },
  {
    "tag": "536",
    "name": "AffectedSecondaryOrderID",
    "type": "String",
    "description": "SecondaryOrderID (198) of an order affected by a mass cancel request."
  },
  {
    "tag": "537",
    "name": "QuoteType",
    "type": "int",
    "description": "Identifies the type of quote.\nAn indicative quote is used to inform a counterparty of a market. An indicative quote does not result directly in a trade.\nA tradeable quote is submitted to a market and will result directly in a trade against other orders and quotes in a market.\nA restricted tradeable quote is submitted to a market and within a certain restriction (possibly based upon price or quantity) will automatically trade against orders. Order that do not comply with restrictions are sent to the quote issuer who can choose to accept or decline the order.\nA counter quote is used in the negotiation model. See Volume 7 - Product: Fixed Income for example usage.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Indicative",
        "description": "Indicative"
      },
      {
        "value": "1",
        "symbolicName": "Tradeable",
        "description": "Tradeable"
      },
      {
        "value": "2",
        "symbolicName": "RestrictedTradeable",
        "description": "Restricted Tradeable"
      },
      {
        "value": "3",
        "symbolicName": "Counter",
        "description": "Counter (tradeable)"
      }
    ]
  },
  {
    "tag": "538",
    "name": "NestedPartyRole",
    "type": "int",
    "description": "PartyRole value within a nested repeating group.\nSame values as PartyRole (452)"
  },
  {
    "tag": "539",
    "name": "NoNestedPartyIDs",
    "type": "NumInGroup",
    "description": "Number of NestedPartyID (524), NestedPartyIDSource (525), and NestedPartyRole (538) entries"
  },
  {
    "tag": "540",
    "name": "TotalAccruedInterestAmt",
    "type": "Amt",
    "description": "Total Amount of Accrued Interest for convertible bonds and fixed income"
  },
  {
    "tag": "541",
    "name": "MaturityDate",
    "type": "LocalMktDate",
    "description": "Date of maturity."
  },
  {
    "tag": "542",
    "name": "UnderlyingMaturityDate",
    "type": "LocalMktDate",
    "description": "Underlying security's maturity date.\nSee MaturityDate (541) field for description"
  },
  {
    "tag": "543",
    "name": "InstrRegistry",
    "type": "String",
    "description": "Values may include BIC for the depository or custodian who maintain ownership records, the ISO country code for the location of the record, or the value \"ZZ\" to specify physical ownership of the security (e.g. stock certificate)."
  },
  {
    "tag": "544",
    "name": "CashMargin",
    "type": "char",
    "description": "Identifies whether an order is a margin order or a non-margin order. This is primarily used when sending orders to Japanese exchanges to indicate sell margin or buy to cover. The same tag could be assigned also by buy-side to indicate the intent to sell or buy margin and the sell-side to accept or reject (base on some validation criteria) the margin request.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Cash",
        "description": "Cash"
      },
      {
        "value": "2",
        "symbolicName": "MarginOpen",
        "description": "Margin Open"
      },
      {
        "value": "3",
        "symbolicName": "MarginClose",
        "description": "Margin Close"
      }
    ]
  },
  {
    "tag": "545",
    "name": "NestedPartySubID",
    "type": "String",
    "description": "PartySubID value within a nested repeating group.\nSame values as PartySubID (523)"
  },
  {
    "tag": "546",
    "name": "Scope",
    "type": "MultipleCharValue",
    "description": "Specifies the market scope of the market data.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "LocalMarket",
        "description": "Local Market (Exchange, ECN, ATS)"
      },
      {
        "value": "2",
        "symbolicName": "National",
        "description": "National"
      },
      {
        "value": "3",
        "symbolicName": "Global",
        "description": "Global"
      }
    ]
  },
  {
    "tag": "547",
    "name": "MDImplicitDelete",
    "type": "Boolean",
    "description": "Defines how a server handles distribution of a truncated book. Defaults to broker option.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "Server must send an explicit delete for bids or offers falling outside the requested MarketDepth of the request"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Client has responsibility for implicitly deleting bids or offers falling outside the MarketDepth of the request"
      }
    ]
  },
  {
    "tag": "548",
    "name": "CrossID",
    "type": "String",
    "description": "Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders."
  },
  {
    "tag": "549",
    "name": "CrossType",
    "type": "int",
    "description": "Type of cross being submitted to a market",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CrossAON",
        "description": "Cross AON - cross trade which is executed completely or not. Both sides are treated in the same manner. This is equivalent to an \"All or None\"."
      },
      {
        "value": "2",
        "symbolicName": "CrossIOC",
        "description": "Cross IOC - cross trade which is executed partially and the rest is cancelled. One side is fully executed, the other side is partially executed with the remainder being cancelled. This is equivalent to an IOC on the other side. Note: CrossPrioritization(550) field may be used to indicate which side should fully execute in this scenario."
      },
      {
        "value": "3",
        "symbolicName": "CrossOneSide",
        "description": "Cross One Side - cross trade which is partially executed with the unfilled portions remaining active. One side of the cross is fully executed (as denoted by the CrossPrioritization (550) field), but the unfilled portion remains active."
      },
      {
        "value": "4",
        "symbolicName": "CrossSamePrice",
        "description": "Cross Same Price - cross trade is executed with existing orders with the same price. In this case other orders exist with the same price, the quantity of the Cross is executed against the existing orders and quotes, the remainder of the cross is executed against the other side of the cross. The two sides potentially have different quantities."
      }
    ]
  },
  {
    "tag": "550",
    "name": "CrossPrioritization",
    "type": "int",
    "description": "Indicates if one side or the other of a cross order should be prioritized.\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected).",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "None"
      },
      {
        "value": "1",
        "symbolicName": "BuySideIsPrioritized",
        "description": "Buy side is prioritized"
      },
      {
        "value": "2",
        "symbolicName": "SellSideIsPrioritized",
        "description": "Sell side is prioritized"
      }
    ]
  },
  {
    "tag": "551",
    "name": "OrigCrossID",
    "type": "String",
    "description": "CrossID of the previous cross order (NOT the initial cross order of the day) as assigned by the institution, used to identify the previous cross order in Cross Cancel and Cross Cancel/Replace Requests."
  },
  {
    "tag": "552",
    "name": "NoSides",
    "type": "NumInGroup",
    "description": "Number of Side repeating group instances.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OneSide",
        "description": "One Side"
      },
      {
        "value": "2",
        "symbolicName": "BothSides",
        "description": "Both Sides"
      }
    ]
  },
  {
    "tag": "553",
    "name": "Username",
    "type": "String",
    "description": "Userid or username."
  },
  {
    "tag": "554",
    "name": "Password",
    "type": "String",
    "description": "Password or passphrase."
  },
  {
    "tag": "555",
    "name": "NoLegs",
    "type": "NumInGroup",
    "description": "Number of InstrumentLeg repeating group instances."
  },
  {
    "tag": "556",
    "name": "LegCurrency",
    "type": "Currency",
    "description": "Currency associated with a particular Leg's quantity"
  },
  {
    "tag": "557",
    "name": "TotNoSecurityTypes",
    "type": "int",
    "description": "Used to support fragmentation. Indicates total number of security types when multiple Security Type messages are used to return results."
  },
  {
    "tag": "558",
    "name": "NoSecurityTypes",
    "type": "NumInGroup",
    "description": "Number of Security Type repeating group instances."
  },
  {
    "tag": "559",
    "name": "SecurityListRequestType",
    "type": "int",
    "description": "Identifies the type/criteria of Security List Request",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Symbol",
        "description": "Symbol"
      },
      {
        "value": "1",
        "symbolicName": "SecurityTypeAnd",
        "description": "SecurityType and/or CFICode"
      },
      {
        "value": "2",
        "symbolicName": "Product",
        "description": "Product"
      },
      {
        "value": "3",
        "symbolicName": "TradingSessionID",
        "description": "TradingSessionID"
      },
      {
        "value": "4",
        "symbolicName": "AllSecurities",
        "description": "All Securities"
      },
      {
        "value": "5",
        "symbolicName": "MarketIDOrMarketID",
        "description": "MarketID or MarketID + MarketSegmentID"
      }
    ]
  },
  {
    "tag": "560",
    "name": "SecurityRequestResult",
    "type": "int",
    "description": "The results returned to a Security Request message",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ValidRequest",
        "description": "Valid request"
      },
      {
        "value": "1",
        "symbolicName": "InvalidOrUnsupportedRequest",
        "description": "Invalid or unsupported request"
      },
      {
        "value": "2",
        "symbolicName": "NoInstrumentsFound",
        "description": "No instruments found that match selection criteria"
      },
      {
        "value": "3",
        "symbolicName": "NotAuthorizedToRetrieveInstrumentData",
        "description": "Not authorized to retrieve instrument data"
      },
      {
        "value": "4",
        "symbolicName": "InstrumentDataTemporarilyUnavailable",
        "description": "Instrument data temporarily unavailable"
      },
      {
        "value": "5",
        "symbolicName": "RequestForInstrumentDataNotSupported",
        "description": "Request for instrument data not supported"
      }
    ]
  },
  {
    "tag": "561",
    "name": "RoundLot",
    "type": "Qty",
    "description": "The trading lot size of a security"
  },
  {
    "tag": "562",
    "name": "MinTradeVol",
    "type": "Qty",
    "description": "The minimum trading volume for a security"
  },
  {
    "tag": "563",
    "name": "MultiLegRptTypeReq",
    "type": "int",
    "description": "Indicates the method of execution reporting requested by issuer of the order.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ReportByMulitlegSecurityOnly",
        "description": "Report by mulitleg security only (do not report legs)"
      },
      {
        "value": "1",
        "symbolicName": "ReportByMultilegSecurityAndInstrumentLegs",
        "description": "Report by multileg security and by instrument legs belonging to the multileg security"
      },
      {
        "value": "2",
        "symbolicName": "ReportByInstrumentLegsOnly",
        "description": "Report by instrument legs belonging to the multileg security only (do not report status of multileg security)"
      }
    ]
  },
  {
    "tag": "564",
    "name": "LegPositionEffect",
    "type": "char",
    "description": "PositionEffect for leg of a multileg\nSee PositionEffect (77) field for description"
  },
  {
    "tag": "565",
    "name": "LegCoveredOrUncovered",
    "type": "int",
    "description": "CoveredOrUncovered for leg of a multileg\nSee CoveredOrUncovered (203) field for description"
  },
  {
    "tag": "566",
    "name": "LegPrice",
    "type": "Price",
    "description": "Price for leg of a multileg\nSee Price (44) field for description"
  },
  {
    "tag": "567",
    "name": "TradSesStatusRejReason",
    "type": "int",
    "description": "Indicates the reason a Trading Session Status Request was rejected.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "UnknownOrInvalidTradingSessionID",
        "description": "Unknown or invalid TradingSessionID"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "568",
    "name": "TradeRequestID",
    "type": "String",
    "description": "Trade Capture Report Request ID"
  },
  {
    "tag": "569",
    "name": "TradeRequestType",
    "type": "int",
    "description": "Type of Trade Capture Report.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "AllTrades",
        "description": "All Trades"
      },
      {
        "value": "1",
        "symbolicName": "MatchedTradesMatchingCriteria",
        "description": "Matched trades matching criteria provided on request (Parties, ExecID, TradeID, OrderID, Instrument, InputSource, etc.)"
      },
      {
        "value": "2",
        "symbolicName": "UnmatchedTradesThatMatchCriteria",
        "description": "Unmatched trades that match criteria"
      },
      {
        "value": "3",
        "symbolicName": "UnreportedTradesThatMatchCriteria",
        "description": "Unreported trades that match criteria"
      },
      {
        "value": "4",
        "symbolicName": "AdvisoriesThatMatchCriteria",
        "description": "Advisories that match criteria"
      }
    ]
  },
  {
    "tag": "570",
    "name": "PreviouslyReported",
    "type": "Boolean",
    "description": "Indicates if the trade capture report was previously reported to the counterparty",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotReportedToCounterparty",
        "description": "Not reported to counterparty"
      },
      {
        "value": "Y",
        "symbolicName": "PerviouslyReportedToCounterparty",
        "description": "Perviously reported to counterparty"
      }
    ]
  },
  {
    "tag": "571",
    "name": "TradeReportID",
    "type": "String",
    "description": "Unique identifier of trade capture report"
  },
  {
    "tag": "572",
    "name": "TradeReportRefID",
    "type": "String",
    "description": "Reference identifier used with CANCEL and REPLACE transaction types."
  },
  {
    "tag": "573",
    "name": "MatchStatus",
    "type": "char",
    "description": "The status of this trade with respect to matching or comparison.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Compared",
        "description": "Compared, matched or affirmed"
      },
      {
        "value": "1",
        "symbolicName": "Uncompared",
        "description": "Uncompared, unmatched, or unaffirmed"
      },
      {
        "value": "2",
        "symbolicName": "AdvisoryOrAlert",
        "description": "Advisory or alert"
      }
    ]
  },
  {
    "tag": "574",
    "name": "MatchType",
    "type": "String",
    "description": "The point in the matching process at which this trade was matched.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OnePartyTradeReport",
        "description": "One-Party Trade Report (privately negotiated trade)"
      },
      {
        "value": "2",
        "symbolicName": "TwoPartyTradeReport",
        "description": "Two-Party Trade Report (privately negotiated trade)"
      },
      {
        "value": "3",
        "symbolicName": "ConfirmedTradeReport",
        "description": "Confirmed Trade Report (reporting from recognized markets)"
      },
      {
        "value": "4",
        "symbolicName": "AutoMatch",
        "description": "Auto-match"
      },
      {
        "value": "5",
        "symbolicName": "CrossAuction",
        "description": "Cross Auction"
      },
      {
        "value": "6",
        "symbolicName": "CounterOrderSelection",
        "description": "Counter-Order Selection"
      },
      {
        "value": "7",
        "symbolicName": "CallAuction",
        "description": "Call Auction"
      },
      {
        "value": "8",
        "symbolicName": "Issuing",
        "description": "Issuing/Buy Back Auction"
      },
      {
        "value": "M3",
        "symbolicName": "ACTAcceptedTrade",
        "description": "ACT Accepted Trade"
      },
      {
        "value": "M4",
        "symbolicName": "ACTDefaultTrade",
        "description": "ACT Default Trade"
      },
      {
        "value": "M5",
        "symbolicName": "ACTDefaultAfterM2",
        "description": "ACT Default After M2"
      },
      {
        "value": "M6",
        "symbolicName": "ACTM6Match",
        "description": "ACT M6 Match"
      },
      {
        "value": "A1",
        "symbolicName": "ExactMatchPlus4BadgesExecTime",
        "description": "Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator plus four badges and execution time (within two-minute window)"
      },
      {
        "value": "A2",
        "symbolicName": "ExactMatchPlus4Badges",
        "description": "Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus four badges"
      },
      {
        "value": "A3",
        "symbolicName": "ExactMatchPlus2BadgesExecTime",
        "description": "Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus two badges and execution time (within two-minute window)"
      },
      {
        "value": "A4",
        "symbolicName": "ExactMatchPlus2Badges",
        "description": "Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus two badges"
      },
      {
        "value": "A5",
        "symbolicName": "ExactMatchPlusExecTime",
        "description": "Exact match on Trade Date, Stock Symbol, Quantity, Price, TradeType, and Special Trade Indicator plus execution time (within two-minute window)"
      },
      {
        "value": "AQ",
        "symbolicName": "StampedAdvisoriesOrSpecialistAccepts",
        "description": "Compared records resulting from stamped advisories or specialist accepts/pair-offs"
      },
      {
        "value": "S1",
        "symbolicName": "A1ExactMatchSummarizedQuantity",
        "description": "Summarized match using A1 exact match criteria except quantity is summaried"
      },
      {
        "value": "S2",
        "symbolicName": "A2ExactMatchSummarizedQuantity",
        "description": "Summarized match using A2 exact match criteria except quantity is summarized"
      },
      {
        "value": "S3",
        "symbolicName": "A3ExactMatchSummarizedQuantity",
        "description": "Summarized match using A3 exact match criteria except quantity is summarized"
      },
      {
        "value": "S4",
        "symbolicName": "A4ExactMatchSummarizedQuantity",
        "description": "Summarized match using A4 exact match criteria except quantity is summarized"
      },
      {
        "value": "S5",
        "symbolicName": "A5ExactMatchSummarizedQuantity",
        "description": "Summarized match using A5 exact match criteria except quantity is summarized"
      },
      {
        "value": "M1",
        "symbolicName": "ExactMatchMinusBadgesTimes",
        "description": "Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator minus badges And times: ACT M1 match"
      },
      {
        "value": "M2",
        "symbolicName": "SummarizedMatchMinusBadgesTimes",
        "description": "Summarized match minus badges and times: ACT M2 Match"
      },
      {
        "value": "MT",
        "symbolicName": "OCSLockedIn",
        "description": "OCS Locked In: Non-ACT"
      }
    ]
  },
  {
    "tag": "575",
    "name": "OddLot",
    "type": "Boolean",
    "description": "This trade is to be treated as an odd lot\nIf this field is not specified, the default will be \"N\"",
    "enum": [
      {
        "value": "N",
        "symbolicName": "TreatAsRoundLot",
        "description": "Treat as round lot (default)"
      },
      {
        "value": "Y",
        "symbolicName": "TreatAsOddLot",
        "description": "Treat as odd lot"
      }
    ]
  },
  {
    "tag": "576",
    "name": "NoClearingInstructions",
    "type": "NumInGroup",
    "description": "Number of clearing instructions"
  },
  {
    "tag": "577",
    "name": "ClearingInstruction",
    "type": "int",
    "description": "Eligibility of this trade for clearing and central counterparty processing\nvalues above 4000 are reserved for agreement between parties",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ProcessNormally",
        "description": "Process normally"
      },
      {
        "value": "1",
        "symbolicName": "ExcludeFromAllNetting",
        "description": "Exclude from all netting"
      },
      {
        "value": "2",
        "symbolicName": "BilateralNettingOnly",
        "description": "Bilateral netting only"
      },
      {
        "value": "3",
        "symbolicName": "ExClearing",
        "description": "Ex clearing"
      },
      {
        "value": "4",
        "symbolicName": "SpecialTrade",
        "description": "Special trade"
      },
      {
        "value": "5",
        "symbolicName": "MultilateralNetting",
        "description": "Multilateral netting"
      },
      {
        "value": "6",
        "symbolicName": "ClearAgainstCentralCounterparty",
        "description": "Clear against central counterparty"
      },
      {
        "value": "7",
        "symbolicName": "ExcludeFromCentralCounterparty",
        "description": "Exclude from central counterparty"
      },
      {
        "value": "8",
        "symbolicName": "ManualMode",
        "description": "Manual mode (pre-posting and/or pre-giveup)"
      },
      {
        "value": "9",
        "symbolicName": "AutomaticPostingMode",
        "description": "Automatic posting mode (trade posting to the position account number specified)"
      },
      {
        "value": "10",
        "symbolicName": "AutomaticGiveUpMode",
        "description": "Automatic give-up mode (trade give-up to the give-up destination number specified)"
      },
      {
        "value": "11",
        "symbolicName": "QualifiedServiceRepresentativeQSR",
        "description": "Qualified Service Representative QSR"
      },
      {
        "value": "12",
        "symbolicName": "CustomerTrade",
        "description": "Customer trade"
      },
      {
        "value": "13",
        "symbolicName": "SelfClearing",
        "description": "Self clearing"
      }
    ]
  },
  {
    "tag": "578",
    "name": "TradeInputSource",
    "type": "String",
    "description": "Type of input device or system from which the trade was entered."
  },
  {
    "tag": "579",
    "name": "TradeInputDevice",
    "type": "String",
    "description": "Specific device number, terminal number or station where trade was entered"
  },
  {
    "tag": "580",
    "name": "NoDates",
    "type": "NumInGroup",
    "description": "Number of Date fields provided in date range"
  },
  {
    "tag": "581",
    "name": "AccountType",
    "type": "int",
    "description": "Type of account associated with an order",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CarriedCustomerSide",
        "description": "Account is carried on customer side of the books"
      },
      {
        "value": "2",
        "symbolicName": "CarriedNonCustomerSide",
        "description": "Account is carried on non-customer side of books"
      },
      {
        "value": "3",
        "symbolicName": "HouseTrader",
        "description": "House Trader"
      },
      {
        "value": "4",
        "symbolicName": "FloorTrader",
        "description": "Floor Trader"
      },
      {
        "value": "6",
        "symbolicName": "CarriedNonCustomerSideCrossMargined",
        "description": "Account is carried on non-customer side of books and is cross margined"
      },
      {
        "value": "7",
        "symbolicName": "HouseTraderCrossMargined",
        "description": "Account is house trader and is cross margined"
      },
      {
        "value": "8",
        "symbolicName": "JointBackOfficeAccount",
        "description": "Joint back office account (JBO)"
      }
    ]
  },
  {
    "tag": "582",
    "name": "CustOrderCapacity",
    "type": "int",
    "description": "Capacity of customer placing the order\nPrimarily used by futures exchanges to indicate the CTICode (customer type indicator) as required by the US CFTC (Commodity Futures Trading Commission).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "MemberTradingForTheirOwnAccount",
        "description": "Member trading for their own account"
      },
      {
        "value": "2",
        "symbolicName": "ClearingFirmTradingForItsProprietaryAccount",
        "description": "Clearing Firm trading for its proprietary account"
      },
      {
        "value": "3",
        "symbolicName": "MemberTradingForAnotherMember",
        "description": "Member trading for another member"
      },
      {
        "value": "4",
        "symbolicName": "AllOther",
        "description": "All other"
      }
    ]
  },
  {
    "tag": "583",
    "name": "ClOrdLinkID",
    "type": "String",
    "description": "Permits order originators to tie together groups of orders in which trades resulting from orders are associated for a specific purpose, for example the calculation of average execution price for a customer or to associate lists submitted to a broker as waves of a larger program trade."
  },
  {
    "tag": "584",
    "name": "MassStatusReqID",
    "type": "String",
    "description": "Value assigned by issuer of Mass Status Request to uniquely identify the request"
  },
  {
    "tag": "585",
    "name": "MassStatusReqType",
    "type": "int",
    "description": "Mass Status Request Type",
    "enum": [
      {
        "value": "1",
        "symbolicName": "StatusForOrdersForASecurity",
        "description": "Status for orders for a Security"
      },
      {
        "value": "2",
        "symbolicName": "StatusForOrdersForAnUnderlyingSecurity",
        "description": "Status for orders for an Underlying Security"
      },
      {
        "value": "3",
        "symbolicName": "StatusForOrdersForAProduct",
        "description": "Status for orders for a Product"
      },
      {
        "value": "4",
        "symbolicName": "StatusForOrdersForACFICode",
        "description": "Status for orders for a CFICode"
      },
      {
        "value": "5",
        "symbolicName": "StatusForOrdersForASecurityType",
        "description": "Status for orders for a SecurityType"
      },
      {
        "value": "6",
        "symbolicName": "StatusForOrdersForATradingSession",
        "description": "Status for orders for a trading session"
      },
      {
        "value": "7",
        "symbolicName": "StatusForAllOrders",
        "description": "Status for all orders"
      },
      {
        "value": "8",
        "symbolicName": "StatusForOrdersForAPartyID",
        "description": "Status for orders for a PartyID"
      },
      {
        "value": "9",
        "symbolicName": "StatusForSecurityIssuer",
        "description": "Status for Security Issuer"
      },
      {
        "value": "10",
        "symbolicName": "StatusForIssuerOfUnderlyingSecurity",
        "description": "Status for Issuer of Underlying Security"
      }
    ]
  },
  {
    "tag": "586",
    "name": "OrigOrdModTime",
    "type": "UTCTimestamp",
    "description": "The most recent (or current) modification TransactTime (tag 60) reported on an Execution Report for the order. The OrigOrdModTime is provided as an optional field on Order Cancel Request and Order Cancel Replace Requests to identify that the state of the order has not changed since the request was issued. The use of this approach is not recommended."
  },
  {
    "tag": "587",
    "name": "LegSettlType",
    "type": "char",
    "description": "Refer to values for SettlType[63]"
  },
  {
    "tag": "588",
    "name": "LegSettlDate",
    "type": "LocalMktDate",
    "description": "Refer to description for SettlDate[64]"
  },
  {
    "tag": "589",
    "name": "DayBookingInst",
    "type": "char",
    "description": "Indicates whether or not automatic booking can occur.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Auto",
        "description": "Can trigger booking without reference to the order initiator (\"auto\")"
      },
      {
        "value": "1",
        "symbolicName": "SpeakWithOrderInitiatorBeforeBooking",
        "description": "Speak with order initiator before booking (\"speak first\")"
      },
      {
        "value": "2",
        "symbolicName": "Accumulate",
        "description": "Accumulate"
      }
    ]
  },
  {
    "tag": "590",
    "name": "BookingUnit",
    "type": "char",
    "description": "Indicates what constitutes a bookable unit.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "EachPartialExecutionIsABookableUnit",
        "description": "Each partial execution is a bookable unit"
      },
      {
        "value": "1",
        "symbolicName": "AggregatePartialExecutionsOnThisOrder",
        "description": "Aggregate partial executions on this order, and book one trade per order"
      },
      {
        "value": "2",
        "symbolicName": "AggregateExecutionsForThisSymbol",
        "description": "Aggregate executions for this symbol, side, and settlement date"
      }
    ]
  },
  {
    "tag": "591",
    "name": "PreallocMethod",
    "type": "char",
    "description": "Indicates the method of preallocation.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ProRata",
        "description": "Pro rata"
      },
      {
        "value": "1",
        "symbolicName": "DoNotProRata",
        "description": "Do not pro-rata - discuss first"
      }
    ]
  },
  {
    "tag": "592",
    "name": "UnderlyingCountryOfIssue",
    "type": "Country",
    "description": "Underlying security's CountryOfIssue.\nSee CountryOfIssue (470) field for description"
  },
  {
    "tag": "593",
    "name": "UnderlyingStateOrProvinceOfIssue",
    "type": "String",
    "description": "Underlying security's StateOrProvinceOfIssue.\nSee StateOrProvinceOfIssue (471) field for description"
  },
  {
    "tag": "594",
    "name": "UnderlyingLocaleOfIssue",
    "type": "String",
    "description": "Underlying security's LocaleOfIssue.\nSee LocaleOfIssue (472) field for description"
  },
  {
    "tag": "595",
    "name": "UnderlyingInstrRegistry",
    "type": "String",
    "description": "Underlying security's InstrRegistry.\nSee InstrRegistry (543) field for description"
  },
  {
    "tag": "596",
    "name": "LegCountryOfIssue",
    "type": "Country",
    "description": "Multileg instrument's individual leg security's CountryOfIssue.\nSee CountryOfIssue (470) field for description"
  },
  {
    "tag": "597",
    "name": "LegStateOrProvinceOfIssue",
    "type": "String",
    "description": "Multileg instrument's individual leg security's StateOrProvinceOfIssue.\nSee StateOrProvinceOfIssue (471) field for description"
  },
  {
    "tag": "598",
    "name": "LegLocaleOfIssue",
    "type": "String",
    "description": "Multileg instrument's individual leg security's LocaleOfIssue.\nSee LocaleOfIssue (472) field for description"
  },
  {
    "tag": "599",
    "name": "LegInstrRegistry",
    "type": "String",
    "description": "Multileg instrument's individual leg security's InstrRegistry.\nSee InstrRegistry (543) field for description"
  },
  {
    "tag": "600",
    "name": "LegSymbol",
    "type": "String",
    "description": "Multileg instrument's individual security's Symbol.\nSee Symbol (55) field for description"
  },
  {
    "tag": "601",
    "name": "LegSymbolSfx",
    "type": "String",
    "description": "Multileg instrument's individual security's SymbolSfx.\nSee SymbolSfx (65) field for description"
  },
  {
    "tag": "602",
    "name": "LegSecurityID",
    "type": "String",
    "description": "Multileg instrument's individual security's SecurityID.\nSee SecurityID (48) field for description"
  },
  {
    "tag": "603",
    "name": "LegSecurityIDSource",
    "type": "String",
    "description": "Multileg instrument's individual security's SecurityIDSource.\nSee SecurityIDSource (22) field for description"
  },
  {
    "tag": "604",
    "name": "NoLegSecurityAltID",
    "type": "NumInGroup",
    "description": "Multileg instrument's individual security's NoSecurityAltID.\nSee NoSecurityAltID (454) field for description"
  },
  {
    "tag": "605",
    "name": "LegSecurityAltID",
    "type": "String",
    "description": "Multileg instrument's individual security's SecurityAltID.\nSee SecurityAltID (455) field for description"
  },
  {
    "tag": "606",
    "name": "LegSecurityAltIDSource",
    "type": "String",
    "description": "Multileg instrument's individual security's SecurityAltIDSource.\nSee SecurityAltIDSource (456) field for description"
  },
  {
    "tag": "607",
    "name": "LegProduct",
    "type": "int",
    "description": "Multileg instrument's individual security's Product.\nSee Product (460) field for description"
  },
  {
    "tag": "608",
    "name": "LegCFICode",
    "type": "String",
    "description": "Multileg instrument's individual security's CFICode.\nSee CFICode (461) field for description"
  },
  {
    "tag": "609",
    "name": "LegSecurityType",
    "type": "String",
    "description": "Refer to definition of SecurityType(167)"
  },
  {
    "tag": "610",
    "name": "LegMaturityMonthYear",
    "type": "MonthYear",
    "description": "Multileg instrument's individual security's MaturityMonthYear.\nSee MaturityMonthYear (200) field for description"
  },
  {
    "tag": "611",
    "name": "LegMaturityDate",
    "type": "LocalMktDate",
    "description": "Multileg instrument's individual security's MaturityDate.\nSee MaturityDate (54) field for description"
  },
  {
    "tag": "612",
    "name": "LegStrikePrice",
    "type": "Price",
    "description": "Multileg instrument's individual security's StrikePrice.\nSee StrikePrice (202) field for description"
  },
  {
    "tag": "613",
    "name": "LegOptAttribute",
    "type": "char",
    "description": "Multileg instrument's individual security's OptAttribute.\nSee OptAttribute (206) field for description"
  },
  {
    "tag": "614",
    "name": "LegContractMultiplier",
    "type": "float",
    "description": "Multileg instrument's individual security's ContractMultiplier.\nSee ContractMultiplier (23) field for description"
  },
  {
    "tag": "615",
    "name": "LegCouponRate",
    "type": "Percentage",
    "description": "Multileg instrument's individual security's CouponRate.\nSee CouponRate (223) field for description"
  },
  {
    "tag": "616",
    "name": "LegSecurityExchange",
    "type": "Exchange",
    "description": "Multileg instrument's individual security's SecurityExchange.\nSee SecurityExchange (207) field for description"
  },
  {
    "tag": "617",
    "name": "LegIssuer",
    "type": "String",
    "description": "Multileg instrument's individual security's Issuer.\nSee Issuer (106) field for description"
  },
  {
    "tag": "618",
    "name": "EncodedLegIssuerLen",
    "type": "Length",
    "description": "Multileg instrument's individual security's EncodedIssuerLen.\nSee EncodedIssuerLen (348) field for description"
  },
  {
    "tag": "619",
    "name": "EncodedLegIssuer",
    "type": "data",
    "description": "Multileg instrument's individual security's EncodedIssuer.\nSee EncodedIssuer (349) field for description"
  },
  {
    "tag": "620",
    "name": "LegSecurityDesc",
    "type": "String",
    "description": "Description of a leg of a multileg instrument.\nSee SecurityDesc(107)."
  },
  {
    "tag": "621",
    "name": "EncodedLegSecurityDescLen",
    "type": "Length",
    "description": "Multileg instrument's individual security's EncodedSecurityDescLen.\nSee EncodedSecurityDescLen (350) field for description"
  },
  {
    "tag": "622",
    "name": "EncodedLegSecurityDesc",
    "type": "data",
    "description": "Multileg instrument's individual security's EncodedSecurityDesc.\nSee EncodedSecurityDesc (35) field for description"
  },
  {
    "tag": "623",
    "name": "LegRatioQty",
    "type": "float",
    "description": "The ratio of quantity for this individual leg relative to the entire multileg security."
  },
  {
    "tag": "624",
    "name": "LegSide",
    "type": "char",
    "description": "The side of this individual leg (multileg security).\nSee Side (54) field for description and values"
  },
  {
    "tag": "625",
    "name": "TradingSessionSubID",
    "type": "String",
    "description": "Optional market assigned sub identifier for a trading phase within a trading session. Usage is determined by market or counterparties. Used by US based futures markets to identify exchange specific execution time bracket codes as required by US market regulations. Bilaterally agreed values of data type \"String\" that start with a character can be used for backward compatibility",
    "enum": [
      {
        "value": "1",
        "symbolicName": "PreTrading",
        "description": "Pre-Trading"
      },
      {
        "value": "2",
        "symbolicName": "OpeningOrOpeningAuction",
        "description": "Opening or opening auction"
      },
      {
        "value": "3",
        "symbolicName": "Continuous",
        "description": "(Continuous) Trading"
      },
      {
        "value": "4",
        "symbolicName": "ClosingOrClosingAuction",
        "description": "Closing or closing auction"
      },
      {
        "value": "5",
        "symbolicName": "PostTrading",
        "description": "Post-Trading"
      },
      {
        "value": "6",
        "symbolicName": "IntradayAuction",
        "description": "Intraday Auction"
      },
      {
        "value": "7",
        "symbolicName": "Quiescent",
        "description": "Quiescent"
      }
    ]
  },
  {
    "tag": "626",
    "name": "AllocType",
    "type": "int",
    "description": "Describes the specific type or purpose of an Allocation message (i.e. \"Buyside Calculated\")\n(see Volume : \"Glossary\" for value definitions)\n*** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Calculated",
        "description": "Calculated (includes MiscFees and NetMoney)"
      },
      {
        "value": "2",
        "symbolicName": "Preliminary",
        "description": "Preliminary (without MiscFees and NetMoney)"
      },
      {
        "value": "3",
        "symbolicName": "SellsideCalculatedUsingPreliminary",
        "description": "Sellside Calculated Using Preliminary (includes MiscFees and NetMoney) (Replaced)"
      },
      {
        "value": "4",
        "symbolicName": "SellsideCalculatedWithoutPreliminary",
        "description": "Sellside Calculated Without Preliminary (sent unsolicited by sellside, includes MiscFees and NetMoney) (Replaced)"
      },
      {
        "value": "5",
        "symbolicName": "ReadyToBook",
        "description": "Ready-To-Book - Single Order"
      },
      {
        "value": "6",
        "symbolicName": "BuysideReadyToBook",
        "description": "Buyside Ready-To-Book - Combined Set of Orders (Replaced)"
      },
      {
        "value": "7",
        "symbolicName": "WarehouseInstruction",
        "description": "Warehouse Instruction"
      },
      {
        "value": "8",
        "symbolicName": "RequestToIntermediary",
        "description": "Request to Intermediary"
      },
      {
        "value": "9",
        "symbolicName": "Accept",
        "description": "Accept"
      },
      {
        "value": "10",
        "symbolicName": "Reject",
        "description": "Reject"
      },
      {
        "value": "11",
        "symbolicName": "AcceptPending",
        "description": "Accept Pending"
      },
      {
        "value": "12",
        "symbolicName": "IncompleteGroup",
        "description": "Incomplete Group"
      },
      {
        "value": "13",
        "symbolicName": "CompleteGroup",
        "description": "Complete Group"
      },
      {
        "value": "14",
        "symbolicName": "ReversalPending",
        "description": "Reversal Pending"
      }
    ]
  },
  {
    "tag": "627",
    "name": "NoHops",
    "type": "NumInGroup",
    "description": "Number of HopCompID entries in repeating group."
  },
  {
    "tag": "628",
    "name": "HopCompID",
    "type": "String",
    "description": "Assigned value used to identify the third party firm which delivered a specific message either from the firm which originated the message or from another third party (if multiple \"hops\" are performed). It is recommended that this value be the SenderCompID (49) of the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or \"hubs\". Only applicable if OnBehalfOfCompID (115) is being used."
  },
  {
    "tag": "629",
    "name": "HopSendingTime",
    "type": "UTCTimestamp",
    "description": "Time that HopCompID (628) sent the message. It is recommended that this value be the SendingTime (52) of the message sent by the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or \"hubs\". Only applicable if OnBehalfOfCompID (115) is being used."
  },
  {
    "tag": "630",
    "name": "HopRefID",
    "type": "SeqNum",
    "description": "Reference identifier assigned by HopCompID (628) associated with the message sent. It is recommended that this value be the MsgSeqNum (34) of the message sent by the third party.\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or \"hubs\". Only applicable if OnBehalfOfCompID (115) is being used."
  },
  {
    "tag": "631",
    "name": "MidPx",
    "type": "Price",
    "description": "Mid price/rate"
  },
  {
    "tag": "632",
    "name": "BidYield",
    "type": "Percentage",
    "description": "Bid yield"
  },
  {
    "tag": "633",
    "name": "MidYield",
    "type": "Percentage",
    "description": "Mid yield"
  },
  {
    "tag": "634",
    "name": "OfferYield",
    "type": "Percentage",
    "description": "Offer yield"
  },
  {
    "tag": "635",
    "name": "ClearingFeeIndicator",
    "type": "String",
    "description": "Indicates type of fee being assessed of the customer for trade executions at an exchange. Applicable for futures markets only at this time.\n(Values source CBOT, CME, NYBOT, and NYMEX):",
    "enum": [
      {
        "value": "1",
        "symbolicName": "FirstYearDelegate",
        "description": "1st year delegate trading for own account"
      },
      {
        "value": "2",
        "symbolicName": "SecondYearDelegate",
        "description": "2nd year delegate trading for own account"
      },
      {
        "value": "3",
        "symbolicName": "ThirdYearDelegate",
        "description": "3rd year delegate trading for own account"
      },
      {
        "value": "4",
        "symbolicName": "FourthYearDelegate",
        "description": "4th year delegate trading for own account"
      },
      {
        "value": "5",
        "symbolicName": "FifthYearDelegate",
        "description": "5th year delegate trading for own account"
      },
      {
        "value": "9",
        "symbolicName": "SixthYearDelegate",
        "description": "6th year delegate trading for own account"
      },
      {
        "value": "B",
        "symbolicName": "CBOEMember",
        "description": "CBOE Member"
      },
      {
        "value": "C",
        "symbolicName": "NonMemberAndCustomer",
        "description": "Non-member and Customer"
      },
      {
        "value": "E",
        "symbolicName": "EquityMemberAndClearingMember",
        "description": "Equity Member and Clearing Member"
      },
      {
        "value": "F",
        "symbolicName": "FullAndAssociateMember",
        "description": "Full and Associate Member trading for own account and as floor brokers"
      },
      {
        "value": "H",
        "symbolicName": "Firms106HAnd106J",
        "description": "106.H and 106.J firms"
      },
      {
        "value": "I",
        "symbolicName": "GIM",
        "description": "GIM, IDEM and COM Membership Interest Holders"
      },
      {
        "value": "L",
        "symbolicName": "Lessee106FEmployees",
        "description": "Lessee 106.F Employees"
      },
      {
        "value": "M",
        "symbolicName": "AllOtherOwnershipTypes",
        "description": "All other ownership types"
      }
    ]
  },
  {
    "tag": "636",
    "name": "WorkingIndicator",
    "type": "Boolean",
    "description": "Indicates if the order is currently being worked. Applicable only for OrdStatus = \"New\". For open outcry markets this indicates that the order is being worked in the crowd. For electronic markets it indicates that the order has transitioned from a contingent order to a market order.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotWorking",
        "description": "Order has been accepted but not yet in a working state"
      },
      {
        "value": "Y",
        "symbolicName": "Working",
        "description": "Order is currently being worked"
      }
    ]
  },
  {
    "tag": "637",
    "name": "LegLastPx",
    "type": "Price",
    "description": "Execution price assigned to a leg of a multileg instrument.\nSee LastPx (31) field for description and values"
  },
  {
    "tag": "638",
    "name": "PriorityIndicator",
    "type": "int",
    "description": "Indicates if a Cancel/Replace has caused an order to lose book priority.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "PriorityUnchanged",
        "description": "Priority unchanged"
      },
      {
        "value": "1",
        "symbolicName": "LostPriorityAsResultOfOrderChange",
        "description": "Lost Priority as result of order change"
      }
    ]
  },
  {
    "tag": "639",
    "name": "PriceImprovement",
    "type": "PriceOffset",
    "description": "Amount of price improvement."
  },
  {
    "tag": "640",
    "name": "Price2",
    "type": "Price",
    "description": "Price of the future part of a F/X swap order.\nSee Price (44) for description."
  },
  {
    "tag": "641",
    "name": "LastForwardPoints2",
    "type": "PriceOffset",
    "description": "F/X forward points of the future part of a F/X swap order added to LastSpotRate (94). May be a negative value."
  },
  {
    "tag": "642",
    "name": "BidForwardPoints2",
    "type": "PriceOffset",
    "description": "Bid F/X forward points of the future portion of a F/X swap quote added to spot rate. May be a negative value."
  },
  {
    "tag": "643",
    "name": "OfferForwardPoints2",
    "type": "PriceOffset",
    "description": "Offer F/X forward points of the future portion of a F/X swap quote added to spot rate. May be a negative value."
  },
  {
    "tag": "644",
    "name": "RFQReqID",
    "type": "String",
    "description": "RFQ Request ID - used to identify an RFQ Request."
  },
  {
    "tag": "645",
    "name": "MktBidPx",
    "type": "Price",
    "description": "Used to indicate the best bid in a market"
  },
  {
    "tag": "646",
    "name": "MktOfferPx",
    "type": "Price",
    "description": "Used to indicate the best offer in a market"
  },
  {
    "tag": "647",
    "name": "MinBidSize",
    "type": "Qty",
    "description": "Used to indicate a minimum quantity for a bid. If this field is used the BidSize (134) field is interpreted as the maximum bid size"
  },
  {
    "tag": "648",
    "name": "MinOfferSize",
    "type": "Qty",
    "description": "Used to indicate a minimum quantity for an offer. If this field is used the OfferSize (135) field is interpreted as the maximum offer size."
  },
  {
    "tag": "649",
    "name": "QuoteStatusReqID",
    "type": "String",
    "description": "Unique identifier for Quote Status Request."
  },
  {
    "tag": "650",
    "name": "LegalConfirm",
    "type": "Boolean",
    "description": "Indicates that this message is to serve as the final and legal confirmation.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DoesNotConsituteALegalConfirm",
        "description": "Does not consitute a Legal Confirm"
      },
      {
        "value": "Y",
        "symbolicName": "LegalConfirm",
        "description": "Legal Confirm"
      }
    ]
  },
  {
    "tag": "651",
    "name": "UnderlyingLastPx",
    "type": "Price",
    "description": "The calculated or traded price for the underlying instrument that corresponds to a derivative. Used for transactions that include the cash instrument and the derivative."
  },
  {
    "tag": "652",
    "name": "UnderlyingLastQty",
    "type": "Qty",
    "description": "The calculated or traded quantity for the underlying instrument that corresponds to a derivative. Used for transactions that include the cash instrument and the derivative."
  },
  {
    "tag": "654",
    "name": "LegRefID",
    "type": "String",
    "description": "Unique indicator for a specific leg."
  },
  {
    "tag": "655",
    "name": "ContraLegRefID",
    "type": "String",
    "description": "Unique indicator for a specific leg for the ContraBroker (375)."
  },
  {
    "tag": "656",
    "name": "SettlCurrBidFxRate",
    "type": "float",
    "description": "Foreign exchange rate used to compute the bid \"SettlCurrAmt\" (119) from Currency (15) to SettlCurrency (120)"
  },
  {
    "tag": "657",
    "name": "SettlCurrOfferFxRate",
    "type": "float",
    "description": "Foreign exchange rate used to compute the offer \"SettlCurrAmt\" (119) from Currency (15) to SettlCurrency (120)"
  },
  {
    "tag": "658",
    "name": "QuoteRequestRejectReason",
    "type": "int",
    "description": "Reason Quote was rejected:",
    "enum": [
      {
        "value": "1",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown Symbol (Security)"
      },
      {
        "value": "2",
        "symbolicName": "Exchange",
        "description": "Exchange (Security) Closed"
      },
      {
        "value": "3",
        "symbolicName": "QuoteRequestExceedsLimit",
        "description": "Quote Request Exceeds Limit"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too Late to enter"
      },
      {
        "value": "5",
        "symbolicName": "InvalidPrice",
        "description": "Invalid Price"
      },
      {
        "value": "6",
        "symbolicName": "NotAuthorizedToRequestQuote",
        "description": "Not Authorized To Request Quote"
      },
      {
        "value": "7",
        "symbolicName": "NoMatchForInquiry",
        "description": "No Match For Inquiry"
      },
      {
        "value": "8",
        "symbolicName": "NoMarketForInstrument",
        "description": "No Market For Instrument"
      },
      {
        "value": "9",
        "symbolicName": "NoInventory",
        "description": "No Inventory"
      },
      {
        "value": "10",
        "symbolicName": "Pass",
        "description": "Pass"
      },
      {
        "value": "11",
        "symbolicName": "InsufficientCredit",
        "description": "Insufficient credit"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "659",
    "name": "SideComplianceID",
    "type": "String",
    "description": "ID within repeating group of sides which is used to represent this transaction for compliance purposes (e.g. OATS reporting)."
  },
  {
    "tag": "660",
    "name": "AcctIDSource",
    "type": "int",
    "description": "Used to identify the source of the Account (1) code. This is especially useful if the account is a new account that the Respondent may not have setup yet in their system.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "BIC",
        "description": "BIC"
      },
      {
        "value": "2",
        "symbolicName": "SIDCode",
        "description": "SID Code"
      },
      {
        "value": "3",
        "symbolicName": "TFM",
        "description": "TFM (GSPTA)"
      },
      {
        "value": "4",
        "symbolicName": "OMGEO",
        "description": "OMGEO (Alert ID)"
      },
      {
        "value": "5",
        "symbolicName": "DTCCCode",
        "description": "DTCC Code"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other (custom or proprietary)"
      }
    ]
  },
  {
    "tag": "661",
    "name": "AllocAcctIDSource",
    "type": "int",
    "description": "Used to identify the source of the AllocAccount (79) code.\nSee AcctIDSource (660) for valid values."
  },
  {
    "tag": "662",
    "name": "BenchmarkPrice",
    "type": "Price",
    "description": "Specifies the price of the benchmark."
  },
  {
    "tag": "663",
    "name": "BenchmarkPriceType",
    "type": "int",
    "description": "Identifies type of BenchmarkPrice (662).\nSee PriceType (423) for valid values."
  },
  {
    "tag": "664",
    "name": "ConfirmID",
    "type": "String",
    "description": "Message reference for Confirmation"
  },
  {
    "tag": "665",
    "name": "ConfirmStatus",
    "type": "int",
    "description": "Identifies the status of the Confirmation.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Received",
        "description": "Received"
      },
      {
        "value": "2",
        "symbolicName": "MismatchedAccount",
        "description": "Mismatched Account"
      },
      {
        "value": "3",
        "symbolicName": "MissingSettlementInstructions",
        "description": "Missing Settlement Instructions"
      },
      {
        "value": "4",
        "symbolicName": "Confirmed",
        "description": "Confirmed"
      },
      {
        "value": "5",
        "symbolicName": "RequestRejected",
        "description": "Request Rejected"
      }
    ]
  },
  {
    "tag": "666",
    "name": "ConfirmTransType",
    "type": "int",
    "description": "Identifies the Confirmation transaction type.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "2",
        "symbolicName": "Cancel",
        "description": "Cancel"
      }
    ]
  },
  {
    "tag": "667",
    "name": "ContractSettlMonth",
    "type": "MonthYear",
    "description": "Specifies when the contract (i.e. MBS/TBA) will settle."
  },
  {
    "tag": "668",
    "name": "DeliveryForm",
    "type": "int",
    "description": "Identifies the form of delivery.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "BookEntry",
        "description": "Book Entry (default)"
      },
      {
        "value": "2",
        "symbolicName": "Bearer",
        "description": "Bearer"
      }
    ]
  },
  {
    "tag": "669",
    "name": "LastParPx",
    "type": "Price",
    "description": "Last price expressed in percent-of-par. Conditionally required for Fixed Income trades when LastPx (31) is expressed in Yield, Spread, Discount or any other type.\nUsage: Execution Report and Allocation Report repeating executions block (from sellside)."
  },
  {
    "tag": "670",
    "name": "NoLegAllocs",
    "type": "NumInGroup",
    "description": "Number of Allocations for the leg"
  },
  {
    "tag": "671",
    "name": "LegAllocAccount",
    "type": "String",
    "description": "Allocation Account for the leg\nSee AllocAccount (79) for description and valid values."
  },
  {
    "tag": "672",
    "name": "LegIndividualAllocID",
    "type": "String",
    "description": "Reference for the individual allocation ticket\nSee IndividualAllocID (467) for description and valid values."
  },
  {
    "tag": "673",
    "name": "LegAllocQty",
    "type": "Qty",
    "description": "Leg allocation quantity.\nSee AllocQty (80) for description and valid values."
  },
  {
    "tag": "674",
    "name": "LegAllocAcctIDSource",
    "type": "String",
    "description": "The source of the LegAllocAccount (671)\nSee AllocAcctIDSource (661) for description and valid values."
  },
  {
    "tag": "675",
    "name": "LegSettlCurrency",
    "type": "Currency",
    "description": "Identifies settlement currency for the Leg.\nSee SettlCurrency (20) for description and valid values"
  },
  {
    "tag": "676",
    "name": "LegBenchmarkCurveCurrency",
    "type": "Currency",
    "description": "LegBenchmarkPrice (679) currency\nSee BenchmarkCurveCurrency (220) for description and valid values."
  },
  {
    "tag": "677",
    "name": "LegBenchmarkCurveName",
    "type": "String",
    "description": "Name of the Leg Benchmark Curve.\nSee BenchmarkCurveName (22) for description and valid values."
  },
  {
    "tag": "678",
    "name": "LegBenchmarkCurvePoint",
    "type": "String",
    "description": "Identifies the point on the Leg Benchmark Curve.\nSee BenchmarkCurvePoint (222) for description and valid values."
  },
  {
    "tag": "679",
    "name": "LegBenchmarkPrice",
    "type": "Price",
    "description": "Used to identify the price of the benchmark security.\nSee BenchmarkPrice (662) for description and valid values."
  },
  {
    "tag": "680",
    "name": "LegBenchmarkPriceType",
    "type": "int",
    "description": "The price type of the LegBenchmarkPrice.\nSee BenchmarkPriceType (663) for description and valid values."
  },
  {
    "tag": "681",
    "name": "LegBidPx",
    "type": "Price",
    "description": "Bid price of this leg.\nSee BidPx (32) for description and valid values."
  },
  {
    "tag": "682",
    "name": "LegIOIQty",
    "type": "String",
    "description": "Leg-specific IOI quantity.\nSee IOIQty (27) for description and valid values"
  },
  {
    "tag": "683",
    "name": "NoLegStipulations",
    "type": "NumInGroup",
    "description": "Number of leg stipulation entries"
  },
  {
    "tag": "684",
    "name": "LegOfferPx",
    "type": "Price",
    "description": "Offer price of this leg.\nSee OfferPx (133) for description and valid values"
  },
  {
    "tag": "685",
    "name": "LegOrderQty",
    "type": "Qty",
    "description": "Quantity ordered of this leg.\nSee OrderQty (38) for description and valid values"
  },
  {
    "tag": "686",
    "name": "LegPriceType",
    "type": "int",
    "description": "The price type of the LegBidPx (681) and/or LegOfferPx (684).\nSee PriceType (423) for description and valid values"
  },
  {
    "tag": "687",
    "name": "LegQty",
    "type": "Qty",
    "description": "Quantity of this leg, e.g. in Quote dialog.\nSee Quantity (53) for description and valid values"
  },
  {
    "tag": "688",
    "name": "LegStipulationType",
    "type": "String",
    "description": "For Fixed Income, type of Stipulation for this leg.\nSee StipulationType (233) for description and valid values"
  },
  {
    "tag": "689",
    "name": "LegStipulationValue",
    "type": "String",
    "description": "For Fixed Income, value of stipulation.\nSee StipulationValue (234) for description and valid values"
  },
  {
    "tag": "690",
    "name": "LegSwapType",
    "type": "int",
    "description": "For Fixed Income, used instead of LegQty (687) or LegOrderQty (685) to requests the respondent to calculate the quantity based on the quantity on the opposite side of the swap.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "ParForPar",
        "description": "Par For Par"
      },
      {
        "value": "2",
        "symbolicName": "ModifiedDuration",
        "description": "Modified Duration"
      },
      {
        "value": "4",
        "symbolicName": "Risk",
        "description": "Risk"
      },
      {
        "value": "5",
        "symbolicName": "Proceeds",
        "description": "Proceeds"
      }
    ]
  },
  {
    "tag": "691",
    "name": "Pool",
    "type": "String",
    "description": "For Fixed Income, identifies MBS / ABS pool."
  },
  {
    "tag": "692",
    "name": "QuotePriceType",
    "type": "int",
    "description": "Code to represent price type requested in Quote.\nIf the Quote Request is for a Swap values 1-8 apply to all legs.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Percent",
        "description": "Percent (percent of par)"
      },
      {
        "value": "2",
        "symbolicName": "PerShare",
        "description": "Per Share (e.g. cents per share)"
      },
      {
        "value": "3",
        "symbolicName": "FixedAmount",
        "description": "Fixed Amount (absolute value)"
      },
      {
        "value": "4",
        "symbolicName": "Discount",
        "description": "Discount - percentage points below par"
      },
      {
        "value": "5",
        "symbolicName": "Premium",
        "description": "Premium - percentage points over par"
      },
      {
        "value": "6",
        "symbolicName": "Spread",
        "description": "Spread - basis points relative to benchmark"
      },
      {
        "value": "7",
        "symbolicName": "TEDPrice",
        "description": "TED Price"
      },
      {
        "value": "8",
        "symbolicName": "TEDYield",
        "description": "TED Yield"
      },
      {
        "value": "9",
        "symbolicName": "YieldSpread",
        "description": "Yield Spread (swaps)"
      },
      {
        "value": "10",
        "symbolicName": "Yield",
        "description": "Yield"
      }
    ]
  },
  {
    "tag": "693",
    "name": "QuoteRespID",
    "type": "String",
    "description": "Message reference for Quote Response"
  },
  {
    "tag": "694",
    "name": "QuoteRespType",
    "type": "int",
    "description": "Identifies the type of Quote Response.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Hit",
        "description": "Hit/Lift"
      },
      {
        "value": "2",
        "symbolicName": "Counter",
        "description": "Counter"
      },
      {
        "value": "3",
        "symbolicName": "Expired",
        "description": "Expired"
      },
      {
        "value": "4",
        "symbolicName": "Cover",
        "description": "Cover"
      },
      {
        "value": "5",
        "symbolicName": "DoneAway",
        "description": "Done Away"
      },
      {
        "value": "6",
        "symbolicName": "Pass",
        "description": "Pass"
      },
      {
        "value": "7",
        "symbolicName": "EndTrade",
        "description": "End Trade"
      },
      {
        "value": "8",
        "symbolicName": "TimedOut",
        "description": "Timed Out"
      }
    ]
  },
  {
    "tag": "695",
    "name": "QuoteQualifier",
    "type": "char",
    "description": "Code to qualify Quote use\nSee IOIQualifier (104) for description and valid values."
  },
  {
    "tag": "696",
    "name": "YieldRedemptionDate",
    "type": "LocalMktDate",
    "description": "Date to which the yield has been calculated (i.e. maturity, par call or current call, pre-refunded date)."
  },
  {
    "tag": "697",
    "name": "YieldRedemptionPrice",
    "type": "Price",
    "description": "Price to which the yield has been calculated."
  },
  {
    "tag": "698",
    "name": "YieldRedemptionPriceType",
    "type": "int",
    "description": "The price type of the YieldRedemptionPrice (697)\nSee PriceType (423) for description and valid values."
  },
  {
    "tag": "699",
    "name": "BenchmarkSecurityID",
    "type": "String",
    "description": "The identifier of the benchmark security, e.g. Treasury against Corporate bond.\nSee SecurityID (tag 48) for description and valid values."
  },
  {
    "tag": "700",
    "name": "ReversalIndicator",
    "type": "Boolean",
    "description": "Indicates a trade that reverses a previous trade."
  },
  {
    "tag": "701",
    "name": "YieldCalcDate",
    "type": "LocalMktDate",
    "description": "Include as needed to clarify yield irregularities associated with date, e.g. when it falls on a non-business day."
  },
  {
    "tag": "702",
    "name": "NoPositions",
    "type": "NumInGroup",
    "description": "Number of position entries."
  },
  {
    "tag": "703",
    "name": "PosType",
    "type": "String",
    "description": "Used to identify the type of quantity that is being returned.",
    "enum": [
      {
        "value": "ALC",
        "symbolicName": "AllocationTradeQty",
        "description": "Allocation Trade Qty"
      },
      {
        "value": "AS",
        "symbolicName": "OptionAssignment",
        "description": "Option Assignment"
      },
      {
        "value": "ASF",
        "symbolicName": "AsOfTradeQty",
        "description": "As-of Trade Qty"
      },
      {
        "value": "DLV",
        "symbolicName": "DeliveryQty",
        "description": "Delivery Qty"
      },
      {
        "value": "ETR",
        "symbolicName": "ElectronicTradeQty",
        "description": "Electronic Trade Qty"
      },
      {
        "value": "EX",
        "symbolicName": "OptionExerciseQty",
        "description": "Option Exercise Qty"
      },
      {
        "value": "FIN",
        "symbolicName": "EndOfDayQty",
        "description": "End-of-Day Qty"
      },
      {
        "value": "IAS",
        "symbolicName": "IntraSpreadQty",
        "description": "Intra-spread Qty"
      },
      {
        "value": "IES",
        "symbolicName": "InterSpreadQty",
        "description": "Inter-spread Qty"
      },
      {
        "value": "PA",
        "symbolicName": "AdjustmentQty",
        "description": "Adjustment Qty"
      },
      {
        "value": "PIT",
        "symbolicName": "PitTradeQty",
        "description": "Pit Trade Qty"
      },
      {
        "value": "SOD",
        "symbolicName": "StartOfDayQty",
        "description": "Start-of-Day Qty"
      },
      {
        "value": "SPL",
        "symbolicName": "IntegralSplit",
        "description": "Integral Split"
      },
      {
        "value": "TA",
        "symbolicName": "TransactionFromAssignment",
        "description": "Transaction from Assignment"
      },
      {
        "value": "TOT",
        "symbolicName": "TotalTransactionQty",
        "description": "Total Transaction Qty"
      },
      {
        "value": "TQ",
        "symbolicName": "TransactionQuantity",
        "description": "Transaction Quantity"
      },
      {
        "value": "TRF",
        "symbolicName": "TransferTradeQty",
        "description": "Transfer Trade Qty"
      },
      {
        "value": "TX",
        "symbolicName": "TransactionFromExercise",
        "description": "Transaction from Exercise"
      },
      {
        "value": "XM",
        "symbolicName": "CrossMarginQty",
        "description": "Cross Margin Qty"
      },
      {
        "value": "RCV",
        "symbolicName": "ReceiveQuantity",
        "description": "Receive Quantity"
      },
      {
        "value": "CAA",
        "symbolicName": "CorporateActionAdjustment",
        "description": "Corporate Action Adjustment"
      },
      {
        "value": "DN",
        "symbolicName": "DeliveryNoticeQty",
        "description": "Delivery Notice Qty"
      },
      {
        "value": "EP",
        "symbolicName": "ExchangeForPhysicalQty",
        "description": "Exchange for Physical Qty"
      },
      {
        "value": "PNTN",
        "symbolicName": "PrivatelyNegotiatedTradeQty",
        "description": "Privately negotiated Trade Qty (Non-regulated)"
      },
      {
        "value": "DLT",
        "symbolicName": "NetDeltaQty",
        "description": "Net Delta Qty"
      },
      {
        "value": "CEA",
        "symbolicName": "CreditEventAdjustment",
        "description": "Credit Event Adjustment"
      },
      {
        "value": "SEA",
        "symbolicName": "SuccessionEventAdjustment",
        "description": "Succession Event Adjustment"
      }
    ]
  },
  {
    "tag": "704",
    "name": "LongQty",
    "type": "Qty",
    "description": "Long Quantity"
  },
  {
    "tag": "705",
    "name": "ShortQty",
    "type": "Qty",
    "description": "Short Quantity"
  },
  {
    "tag": "706",
    "name": "PosQtyStatus",
    "type": "int",
    "description": "Status of this position.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Submitted",
        "description": "Submitted"
      },
      {
        "value": "1",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "2",
        "symbolicName": "Rejected",
        "description": "Rejected"
      }
    ]
  },
  {
    "tag": "707",
    "name": "PosAmtType",
    "type": "String",
    "description": "Type of Position amount",
    "enum": [
      {
        "value": "CASH",
        "symbolicName": "CashAmount",
        "description": "Cash Amount (Corporate Event)"
      },
      {
        "value": "CRES",
        "symbolicName": "CashResidualAmount",
        "description": "Cash Residual Amount"
      },
      {
        "value": "FMTM",
        "symbolicName": "FinalMarkToMarketAmount",
        "description": "Final Mark-to-Market Amount"
      },
      {
        "value": "IMTM",
        "symbolicName": "IncrementalMarkToMarketAmount",
        "description": "Incremental Mark-to-Market Amount"
      },
      {
        "value": "PREM",
        "symbolicName": "PremiumAmount",
        "description": "Premium Amount"
      },
      {
        "value": "SMTM",
        "symbolicName": "StartOfDayMarkToMarketAmount",
        "description": "Start-of-Day Mark-to-Market Amount"
      },
      {
        "value": "TVAR",
        "symbolicName": "TradeVariationAmount",
        "description": "Trade Variation Amount"
      },
      {
        "value": "VADJ",
        "symbolicName": "ValueAdjustedAmount",
        "description": "Value Adjusted Amount"
      },
      {
        "value": "SETL",
        "symbolicName": "SettlementValue",
        "description": "Settlement Value"
      },
      {
        "value": "ICPN",
        "symbolicName": "InitialTradeCouponAmount",
        "description": "Initial Trade Coupon Amount"
      },
      {
        "value": "ACPN",
        "symbolicName": "AccruedCouponAmount",
        "description": "Accrued Coupon Amount"
      },
      {
        "value": "CPN",
        "symbolicName": "CouponAmount",
        "description": "Coupon Amount"
      },
      {
        "value": "IACPN",
        "symbolicName": "IncrementalAccruedCoupon",
        "description": "Incremental Accrued Coupon"
      },
      {
        "value": "CMTM",
        "symbolicName": "CollateralizedMarkToMarket",
        "description": "Collateralized Mark to Market"
      },
      {
        "value": "ICMTM",
        "symbolicName": "IncrementalCollateralizedMarkToMarket",
        "description": "Incremental Collateralized Mark to market"
      },
      {
        "value": "DLV",
        "symbolicName": "CompensationAmount",
        "description": "Compensation Amount"
      },
      {
        "value": "BANK",
        "symbolicName": "TotalBankedAmount",
        "description": "Total Banked Amount"
      },
      {
        "value": "COLAT",
        "symbolicName": "TotalCollateralizedAmount",
        "description": "Total Collateralized Amount"
      }
    ]
  },
  {
    "tag": "708",
    "name": "PosAmt",
    "type": "Amt",
    "description": "Position amount"
  },
  {
    "tag": "709",
    "name": "PosTransType",
    "type": "int",
    "description": "Identifies the type of position transaction",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Exercise",
        "description": "Exercise"
      },
      {
        "value": "2",
        "symbolicName": "DoNotExercise",
        "description": "Do Not Exercise"
      },
      {
        "value": "3",
        "symbolicName": "PositionAdjustment",
        "description": "Position Adjustment"
      },
      {
        "value": "4",
        "symbolicName": "PositionChangeSubmission",
        "description": "Position Change Submission/Margin Disposition"
      },
      {
        "value": "5",
        "symbolicName": "Pledge",
        "description": "Pledge"
      },
      {
        "value": "6",
        "symbolicName": "LargeTraderSubmission",
        "description": "Large Trader Submission"
      }
    ]
  },
  {
    "tag": "710",
    "name": "PosReqID",
    "type": "String",
    "description": "Unique identifier for the position maintenance request as assigned by the submitter"
  },
  {
    "tag": "711",
    "name": "NoUnderlyings",
    "type": "NumInGroup",
    "description": "Number of underlying legs that make up the security."
  },
  {
    "tag": "712",
    "name": "PosMaintAction",
    "type": "int",
    "description": "Maintenance Action to be performed.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "New",
        "description": "New - used to increment the overall transaction quantity"
      },
      {
        "value": "2",
        "symbolicName": "Replace",
        "description": "Replace - used to override the overall transaction quantity or specifi add messages based on the reference ID"
      },
      {
        "value": "3",
        "symbolicName": "Cancel",
        "description": "Cancel - used to remove the overall transaction or specific add messages based on reference ID"
      },
      {
        "value": "4",
        "symbolicName": "Reverse",
        "description": "Reverse - used to completelly back-out the transaction such that the transaction never existed"
      }
    ]
  },
  {
    "tag": "713",
    "name": "OrigPosReqRefID",
    "type": "String",
    "description": "Reference to the PosReqID (710) of a previous maintenance request that is being replaced or canceled."
  },
  {
    "tag": "714",
    "name": "PosMaintRptRefID",
    "type": "String",
    "description": "Reference to a PosMaintRptID (721) from a previous Position Maintenance Report that is being replaced or canceled."
  },
  {
    "tag": "715",
    "name": "ClearingBusinessDate",
    "type": "LocalMktDate",
    "description": "The \"Clearing Business Date\" referred to by this maintenance request."
  },
  {
    "tag": "716",
    "name": "SettlSessID",
    "type": "String",
    "description": "Identifies a specific settlement session",
    "enum": [
      {
        "value": "ITD",
        "symbolicName": "Intraday",
        "description": "Intraday"
      },
      {
        "value": "RTH",
        "symbolicName": "RegularTradingHours",
        "description": "Regular Trading Hours"
      },
      {
        "value": "ETH",
        "symbolicName": "ElectronicTradingHours",
        "description": "Electronic Trading Hours"
      },
      {
        "value": "EOD",
        "symbolicName": "EndOfDay",
        "description": "End Of Day"
      }
    ]
  },
  {
    "tag": "717",
    "name": "SettlSessSubID",
    "type": "String",
    "description": "SubID value associated with SettlSessID(716)"
  },
  {
    "tag": "718",
    "name": "AdjustmentType",
    "type": "int",
    "description": "Type of adjustment to be applied, used for PCS and PAJ",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ProcessRequestAsMarginDisposition",
        "description": "Process Request As Margin Disposition"
      },
      {
        "value": "1",
        "symbolicName": "DeltaPlus",
        "description": "Delta Plus"
      },
      {
        "value": "2",
        "symbolicName": "DeltaMinus",
        "description": "Delta Minus"
      },
      {
        "value": "3",
        "symbolicName": "Final",
        "description": "Final"
      }
    ]
  },
  {
    "tag": "719",
    "name": "ContraryInstructionIndicator",
    "type": "Boolean",
    "description": "Used to indicate when a contrary instruction for exercise or abandonment is being submitted"
  },
  {
    "tag": "720",
    "name": "PriorSpreadIndicator",
    "type": "Boolean",
    "description": "Indicates if requesting a rollover of prior day's spread submissions."
  },
  {
    "tag": "721",
    "name": "PosMaintRptID",
    "type": "String",
    "description": "Unique identifier for this position report"
  },
  {
    "tag": "722",
    "name": "PosMaintStatus",
    "type": "int",
    "description": "Status of Position Maintenance Request",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "1",
        "symbolicName": "AcceptedWithWarnings",
        "description": "Accepted With Warnings"
      },
      {
        "value": "2",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "3",
        "symbolicName": "Completed",
        "description": "Completed"
      },
      {
        "value": "4",
        "symbolicName": "CompletedWithWarnings",
        "description": "Completed With Warnings"
      }
    ]
  },
  {
    "tag": "723",
    "name": "PosMaintResult",
    "type": "int",
    "description": "Result of Position Maintenance Request.\n4000+ Reserved and available for bi-laterally agreed upon user-defined values",
    "enum": [
      {
        "value": "0",
        "symbolicName": "SuccessfulCompletion",
        "description": "Successful Completion - no warnings or errors"
      },
      {
        "value": "1",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "724",
    "name": "PosReqType",
    "type": "int",
    "description": "Used to specify the type of position request being made.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Positions",
        "description": "Positions"
      },
      {
        "value": "1",
        "symbolicName": "Trades",
        "description": "Trades"
      },
      {
        "value": "2",
        "symbolicName": "Exercises",
        "description": "Exercises"
      },
      {
        "value": "3",
        "symbolicName": "Assignments",
        "description": "Assignments"
      },
      {
        "value": "4",
        "symbolicName": "SettlementActivity",
        "description": "Settlement Activity"
      },
      {
        "value": "5",
        "symbolicName": "BackoutMessage",
        "description": "Backout Message"
      },
      {
        "value": "6",
        "symbolicName": "DeltaPositions",
        "description": "Delta Positions"
      }
    ]
  },
  {
    "tag": "725",
    "name": "ResponseTransportType",
    "type": "int",
    "description": "Identifies how the response to the request should be transmitted.\nDetails specified via ResponseDestination (726).",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Inband",
        "description": "Inband - transport the request was sent over (default)"
      },
      {
        "value": "1",
        "symbolicName": "OutOfBand",
        "description": "Out of Band - pre-arranged out-of-band delivery mechanizm (i.e. FTP, HTTP, NDM, etc.) between counterparties. Details specified via ResponseDestination (726)."
      }
    ]
  },
  {
    "tag": "726",
    "name": "ResponseDestination",
    "type": "String",
    "description": "URI (Uniform Resource Identifier) for details) or other pre-arranged value. Used in conjunction with ResponseTransportType (725) value of Out-of-Band to identify the out-of-band destination.\nSee \"Appendix 6-B FIX Fields Based Upon Other Standards\""
  },
  {
    "tag": "727",
    "name": "TotalNumPosReports",
    "type": "int",
    "description": "Total number of Position Reports being returned."
  },
  {
    "tag": "728",
    "name": "PosReqResult",
    "type": "int",
    "description": "Result of Request for Position\n4000+ Reserved and available for bi-laterally agreed upon user-defined values",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ValidRequest",
        "description": "Valid request"
      },
      {
        "value": "1",
        "symbolicName": "InvalidOrUnsupportedRequest",
        "description": "Invalid or unsupported request"
      },
      {
        "value": "2",
        "symbolicName": "NoPositionsFoundThatMatchCriteria",
        "description": "No positions found that match criteria"
      },
      {
        "value": "3",
        "symbolicName": "NotAuthorizedToRequestPositions",
        "description": "Not authorized to request positions"
      },
      {
        "value": "4",
        "symbolicName": "RequestForPositionNotSupported",
        "description": "Request for position not supported"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other (use Text (58) in conjunction with this code for an explaination)"
      }
    ]
  },
  {
    "tag": "729",
    "name": "PosReqStatus",
    "type": "int",
    "description": "Status of Request for Positions",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Completed",
        "description": "Completed"
      },
      {
        "value": "1",
        "symbolicName": "CompletedWithWarnings",
        "description": "Completed With Warnings"
      },
      {
        "value": "2",
        "symbolicName": "Rejected",
        "description": "Rejected"
      }
    ]
  },
  {
    "tag": "730",
    "name": "SettlPrice",
    "type": "Price",
    "description": "Settlement price"
  },
  {
    "tag": "731",
    "name": "SettlPriceType",
    "type": "int",
    "description": "Type of settlement price",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Final",
        "description": "Final"
      },
      {
        "value": "2",
        "symbolicName": "Theoretical",
        "description": "Theoretical"
      }
    ]
  },
  {
    "tag": "732",
    "name": "UnderlyingSettlPrice",
    "type": "Price",
    "description": "Underlying security's SettlPrice.\nSee SettlPrice (730) field for description"
  },
  {
    "tag": "733",
    "name": "UnderlyingSettlPriceType",
    "type": "int",
    "description": "Underlying security's SettlPriceType.\nSee SettlPriceType (731) field for description"
  },
  {
    "tag": "734",
    "name": "PriorSettlPrice",
    "type": "Price",
    "description": "Previous settlement price"
  },
  {
    "tag": "735",
    "name": "NoQuoteQualifiers",
    "type": "NumInGroup",
    "description": "Number of repeating groups of QuoteQualifiers (695)."
  },
  {
    "tag": "736",
    "name": "AllocSettlCurrency",
    "type": "Currency",
    "description": "Currency code of settlement denomination for a specific AllocAccount (79)."
  },
  {
    "tag": "737",
    "name": "AllocSettlCurrAmt",
    "type": "Amt",
    "description": "Total amount due expressed in settlement currency (includes the effect of the forex transaction) for a specific AllocAccount (79)."
  },
  {
    "tag": "738",
    "name": "InterestAtMaturity",
    "type": "Amt",
    "description": "Amount of interest (i.e. lump-sum) at maturity."
  },
  {
    "tag": "739",
    "name": "LegDatedDate",
    "type": "LocalMktDate",
    "description": "The effective date of a new securities issue determined by its underwriters. Often but not always the same as the Issue Date and the Interest Accrual Date"
  },
  {
    "tag": "740",
    "name": "LegPool",
    "type": "String",
    "description": "For Fixed Income, identifies MBS / ABS pool for a specific leg of a multi-leg instrument.\nSee Pool (691) for description and valid values."
  },
  {
    "tag": "741",
    "name": "AllocInterestAtMaturity",
    "type": "Amt",
    "description": "Amount of interest (i.e. lump-sum) at maturity at the account-level."
  },
  {
    "tag": "742",
    "name": "AllocAccruedInterestAmt",
    "type": "Amt",
    "description": "Amount of Accrued Interest for convertible bonds and fixed income at the allocation-level."
  },
  {
    "tag": "743",
    "name": "DeliveryDate",
    "type": "LocalMktDate",
    "description": "Date of delivery."
  },
  {
    "tag": "744",
    "name": "AssignmentMethod",
    "type": "char",
    "description": "Method by which short positions are assigned to an exercise notice during exercise and assignment processing",
    "enum": [
      {
        "value": "P",
        "symbolicName": "ProRata",
        "description": "Pro rata"
      },
      {
        "value": "R",
        "symbolicName": "Random",
        "description": "Random"
      }
    ]
  },
  {
    "tag": "745",
    "name": "AssignmentUnit",
    "type": "Qty",
    "description": "Quantity Increment used in performing assignment."
  },
  {
    "tag": "746",
    "name": "OpenInterest",
    "type": "Amt",
    "description": "Open interest that was eligible for assignment."
  },
  {
    "tag": "747",
    "name": "ExerciseMethod",
    "type": "char",
    "description": "Exercise Method used to in performing assignment.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Automatic",
        "description": "Automatic"
      },
      {
        "value": "M",
        "symbolicName": "Manual",
        "description": "Manual"
      }
    ]
  },
  {
    "tag": "748",
    "name": "TotNumTradeReports",
    "type": "int",
    "description": "Total number of trade reports returned."
  },
  {
    "tag": "749",
    "name": "TradeRequestResult",
    "type": "int",
    "description": "Result of Trade Request",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Successful",
        "description": "Successful (default)"
      },
      {
        "value": "1",
        "symbolicName": "InvalidOrUnknownInstrument",
        "description": "Invalid or unknown instrument"
      },
      {
        "value": "2",
        "symbolicName": "InvalidTypeOfTradeRequested",
        "description": "Invalid type of trade requested"
      },
      {
        "value": "3",
        "symbolicName": "InvalidParties",
        "description": "Invalid parties"
      },
      {
        "value": "4",
        "symbolicName": "InvalidTransportTypeRequested",
        "description": "Invalid transport type requested"
      },
      {
        "value": "5",
        "symbolicName": "InvalidDestinationRequested",
        "description": "Invalid destination requested"
      },
      {
        "value": "8",
        "symbolicName": "TradeRequestTypeNotSupported",
        "description": "TradeRequestType not supported"
      },
      {
        "value": "9",
        "symbolicName": "NotAuthorized",
        "description": "Not authorized"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "750",
    "name": "TradeRequestStatus",
    "type": "int",
    "description": "Status of Trade Request.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "1",
        "symbolicName": "Completed",
        "description": "Completed"
      },
      {
        "value": "2",
        "symbolicName": "Rejected",
        "description": "Rejected"
      }
    ]
  },
  {
    "tag": "751",
    "name": "TradeReportRejectReason",
    "type": "int",
    "description": "Reason Trade Capture Request was rejected.\n100+ Reserved and available for bi-laterally agreed upon user-defined values",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Successful",
        "description": "Successful (default)"
      },
      {
        "value": "1",
        "symbolicName": "InvalidPartyOnformation",
        "description": "Invalid party onformation"
      },
      {
        "value": "2",
        "symbolicName": "UnknownInstrument",
        "description": "Unknown instrument"
      },
      {
        "value": "3",
        "symbolicName": "UnauthorizedToReportTrades",
        "description": "Unauthorized to report trades"
      },
      {
        "value": "4",
        "symbolicName": "InvalidTradeType",
        "description": "Invalid trade type"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "752",
    "name": "SideMultiLegReportingType",
    "type": "int",
    "description": "Used to indicate if the side being reported on Trade Capture Report represents a leg of a multileg instrument or a single security.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "SingleSecurity",
        "description": "Single Security (default if not specified)"
      },
      {
        "value": "2",
        "symbolicName": "IndividualLegOfAMultilegSecurity",
        "description": "Individual leg of a multileg security"
      },
      {
        "value": "3",
        "symbolicName": "MultilegSecurity",
        "description": "Multileg Security"
      }
    ]
  },
  {
    "tag": "753",
    "name": "NoPosAmt",
    "type": "NumInGroup",
    "description": "Number of position amount entries."
  },
  {
    "tag": "754",
    "name": "AutoAcceptIndicator",
    "type": "Boolean",
    "description": "Identifies whether or not an allocation has been automatically accepted on behalf of the Carry Firm by the Clearing House."
  },
  {
    "tag": "755",
    "name": "AllocReportID",
    "type": "String",
    "description": "Unique identifier for Allocation Report message."
  },
  {
    "tag": "756",
    "name": "NoNested2PartyIDs",
    "type": "NumInGroup",
    "description": "Number of Nested2PartyID (757), Nested2PartyIDSource (758), and Nested2PartyRole (759) entries"
  },
  {
    "tag": "757",
    "name": "Nested2PartyID",
    "type": "String",
    "description": "PartyID value within a \"second instance\" Nested repeating group.\nSame values as PartyID (448)"
  },
  {
    "tag": "758",
    "name": "Nested2PartyIDSource",
    "type": "char",
    "description": "PartyIDSource value within a \"second instance\" Nested repeating group.\nSame values as PartyIDSource (447)"
  },
  {
    "tag": "759",
    "name": "Nested2PartyRole",
    "type": "int",
    "description": "PartyRole value within a \"second instance\" Nested repeating group.\nSame values as PartyRole (452)"
  },
  {
    "tag": "760",
    "name": "Nested2PartySubID",
    "type": "String",
    "description": "PartySubID value within a \"second instance\" Nested repeating group.\nSame values as PartySubID (523)"
  },
  {
    "tag": "761",
    "name": "BenchmarkSecurityIDSource",
    "type": "String",
    "description": "Identifies class or source of the BenchmarkSecurityID (699) value. Required if BenchmarkSecurityID is specified.\nSame values as the SecurityIDSource (22) field"
  },
  {
    "tag": "762",
    "name": "SecuritySubType",
    "type": "String",
    "description": "Sub-type qualification/identification of the SecurityType. As an example for SecurityType(167)=\"REPO\", the SecuritySubType=\"General Collateral\" can be used to further specify the type of REPO.\nIf SecuritySubType is used then SecurityType is required.\nFor SecurityType=\"MLEG\" a name of the option or futures strategy name can be specified, such as \"Calendar\", \"Vertical\", \"Butterfly\"."
  },
  {
    "tag": "763",
    "name": "UnderlyingSecuritySubType",
    "type": "String",
    "description": "Underlying security's SecuritySubType.\nSee SecuritySubType (762) field for description"
  },
  {
    "tag": "764",
    "name": "LegSecuritySubType",
    "type": "String",
    "description": "SecuritySubType of the leg instrument.\nSee SecuritySubType (762) field for description"
  },
  {
    "tag": "765",
    "name": "AllowableOneSidednessPct",
    "type": "Percentage",
    "description": "The maximum percentage that execution of one side of a program trade can exceed execution of the other."
  },
  {
    "tag": "766",
    "name": "AllowableOneSidednessValue",
    "type": "Amt",
    "description": "The maximum amount that execution of one side of a program trade can exceed execution of the other."
  },
  {
    "tag": "767",
    "name": "AllowableOneSidednessCurr",
    "type": "Currency",
    "description": "The currency that AllowableOneSidednessValue (766) is expressed in if AllowableOneSidednessValue is used."
  },
  {
    "tag": "768",
    "name": "NoTrdRegTimestamps",
    "type": "NumInGroup",
    "description": "Number of TrdRegTimestamp (769) entries"
  },
  {
    "tag": "769",
    "name": "TrdRegTimestamp",
    "type": "UTCTimestamp",
    "description": "Traded / Regulatory timestamp value. Use to store time information required by government regulators or self regulatory organizations (such as an exchange or clearing house)."
  },
  {
    "tag": "770",
    "name": "TrdRegTimestampType",
    "type": "int",
    "description": "Traded / Regulatory timestamp type.\nNote of Applicability: values are required in US futures markets by the CFTC to support computerized trade reconstruction.\n(see Volume : \"Glossary\" for value definitions)",
    "enum": [
      {
        "value": "1",
        "symbolicName": "ExecutionTime",
        "description": "Execution Time"
      },
      {
        "value": "2",
        "symbolicName": "TimeIn",
        "description": "Time In"
      },
      {
        "value": "3",
        "symbolicName": "TimeOut",
        "description": "Time Out"
      },
      {
        "value": "4",
        "symbolicName": "BrokerReceipt",
        "description": "Broker Receipt"
      },
      {
        "value": "5",
        "symbolicName": "BrokerExecution",
        "description": "Broker Execution"
      },
      {
        "value": "6",
        "symbolicName": "DeskReceipt",
        "description": "Desk Receipt"
      },
      {
        "value": "7",
        "symbolicName": "SubmissionToClearing",
        "description": "Submission to Clearing"
      }
    ]
  },
  {
    "tag": "771",
    "name": "TrdRegTimestampOrigin",
    "type": "String",
    "description": "Text which identifies the \"origin\" (i.e. system which was used to generate the time stamp) for the Traded / Regulatory timestamp value."
  },
  {
    "tag": "772",
    "name": "ConfirmRefID",
    "type": "String",
    "description": "Reference identifier to be used with ConfirmTransType (666) = Replace or Cancel"
  },
  {
    "tag": "773",
    "name": "ConfirmType",
    "type": "int",
    "description": "Identifies the type of Confirmation message being sent.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Status",
        "description": "Status"
      },
      {
        "value": "2",
        "symbolicName": "Confirmation",
        "description": "Confirmation"
      },
      {
        "value": "3",
        "symbolicName": "ConfirmationRequestRejected",
        "description": "Confirmation Request Rejected (reason can be stated in Text (58) field)"
      }
    ]
  },
  {
    "tag": "774",
    "name": "ConfirmRejReason",
    "type": "int",
    "description": "Identifies the reason for rejecting a Confirmation.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "MismatchedAccount",
        "description": "Mismatched account"
      },
      {
        "value": "2",
        "symbolicName": "MissingSettlementInstructions",
        "description": "Missing settlement instructions"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "775",
    "name": "BookingType",
    "type": "int",
    "description": "Method for booking out this order. Used when notifying a broker that an order to be settled by that broker is to be booked out as an OTC derivative (e.g. CFD or similar).",
    "enum": [
      {
        "value": "0",
        "symbolicName": "RegularBooking",
        "description": "Regular booking"
      },
      {
        "value": "1",
        "symbolicName": "CFD",
        "description": "CFD (Contract for difference)"
      },
      {
        "value": "2",
        "symbolicName": "TotalReturnSwap",
        "description": "Total Return Swap"
      }
    ]
  },
  {
    "tag": "776",
    "name": "IndividualAllocRejCode",
    "type": "int",
    "description": "Identified reason for rejecting an individual AllocAccount (79) detail.\nSame values as AllocRejCode (88)"
  },
  {
    "tag": "777",
    "name": "SettlInstMsgID",
    "type": "String",
    "description": "Unique identifier for Settlement Instruction message."
  },
  {
    "tag": "778",
    "name": "NoSettlInst",
    "type": "NumInGroup",
    "description": "Number of settlement instructions within repeating group."
  },
  {
    "tag": "779",
    "name": "LastUpdateTime",
    "type": "UTCTimestamp",
    "description": "Timestamp of last update to data item (or creation if no updates made since creation)."
  },
  {
    "tag": "780",
    "name": "AllocSettlInstType",
    "type": "int",
    "description": "Used to indicate whether settlement instructions are provided on an allocation instruction message, and if not, how they are to be derived.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UseDefaultInstructions",
        "description": "Use default instructions"
      },
      {
        "value": "1",
        "symbolicName": "DeriveFromParametersProvided",
        "description": "Derive from parameters provided"
      },
      {
        "value": "2",
        "symbolicName": "FullDetailsProvided",
        "description": "Full details provided"
      },
      {
        "value": "3",
        "symbolicName": "SSIDBIDsProvided",
        "description": "SSI DB IDs provided"
      },
      {
        "value": "4",
        "symbolicName": "PhoneForInstructions",
        "description": "Phone for instructions"
      }
    ]
  },
  {
    "tag": "781",
    "name": "NoSettlPartyIDs",
    "type": "NumInGroup",
    "description": "Number of SettlPartyID (782), SettlPartyIDSource (783), and SettlPartyRole (784) entries"
  },
  {
    "tag": "782",
    "name": "SettlPartyID",
    "type": "String",
    "description": "PartyID value within a settlement parties component. Nested repeating group.\nSame values as PartyID (448)"
  },
  {
    "tag": "783",
    "name": "SettlPartyIDSource",
    "type": "char",
    "description": "PartyIDSource value within a settlement parties component.\nSame values as PartyIDSource (447)"
  },
  {
    "tag": "784",
    "name": "SettlPartyRole",
    "type": "int",
    "description": "PartyRole value within a settlement parties component.\nSame values as PartyRole (452)"
  },
  {
    "tag": "785",
    "name": "SettlPartySubID",
    "type": "String",
    "description": "PartySubID value within a settlement parties component.\nSame values as PartySubID (523)"
  },
  {
    "tag": "786",
    "name": "SettlPartySubIDType",
    "type": "int",
    "description": "Type of SettlPartySubID (785) value.\nSame values as PartySubIDType (803)"
  },
  {
    "tag": "787",
    "name": "DlvyInstType",
    "type": "char",
    "description": "Used to indicate whether a delivery instruction is used for securities or cash settlement.",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cash",
        "description": "Cash"
      },
      {
        "value": "S",
        "symbolicName": "Securities",
        "description": "Securities"
      }
    ]
  },
  {
    "tag": "788",
    "name": "TerminationType",
    "type": "int",
    "description": "Type of financing termination.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Overnight",
        "description": "Overnight"
      },
      {
        "value": "2",
        "symbolicName": "Term",
        "description": "Term"
      },
      {
        "value": "3",
        "symbolicName": "Flexible",
        "description": "Flexible"
      },
      {
        "value": "4",
        "symbolicName": "Open",
        "description": "Open"
      }
    ]
  },
  {
    "tag": "789",
    "name": "NextExpectedMsgSeqNum",
    "type": "SeqNum",
    "description": "Next expected MsgSeqNum value to be received."
  },
  {
    "tag": "790",
    "name": "OrdStatusReqID",
    "type": "String",
    "description": "Can be used to uniquely identify a specific Order Status Request message."
  },
  {
    "tag": "791",
    "name": "SettlInstReqID",
    "type": "String",
    "description": "Unique ID of settlement instruction request message"
  },
  {
    "tag": "792",
    "name": "SettlInstReqRejCode",
    "type": "int",
    "description": "Identifies reason for rejection (of a settlement instruction request message).",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnableToProcessRequest",
        "description": "Unable to process request"
      },
      {
        "value": "1",
        "symbolicName": "UnknownAccount",
        "description": "Unknown account"
      },
      {
        "value": "2",
        "symbolicName": "NoMatchingSettlementInstructionsFound",
        "description": "No matching settlement instructions found"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "793",
    "name": "SecondaryAllocID",
    "type": "String",
    "description": "Secondary allocation identifier. Unlike the AllocID (70), this can be shared across a number of allocation instruction or allocation report messages, thereby making it possible to pass an identifier for an original allocation message on multiple messages (e.g. from one party to a second to a third, across cancel and replace messages etc.)."
  },
  {
    "tag": "794",
    "name": "AllocReportType",
    "type": "int",
    "description": "Describes the specific type or purpose of an Allocation Report message",
    "enum": [
      {
        "value": "2",
        "symbolicName": "PreliminaryRequestToIntermediary",
        "description": "Preliminary Request to Intermediary"
      },
      {
        "value": "3",
        "symbolicName": "SellsideCalculatedUsingPreliminary",
        "description": "Sellside Calculated Using Preliminary (includes MiscFees and NetMoney)"
      },
      {
        "value": "4",
        "symbolicName": "SellsideCalculatedWithoutPreliminary",
        "description": "Sellside Calculated Without Preliminary (sent unsolicited by sellside, includes MiscFees and NetMoney)"
      },
      {
        "value": "5",
        "symbolicName": "WarehouseRecap",
        "description": "Warehouse Recap"
      },
      {
        "value": "8",
        "symbolicName": "RequestToIntermediary",
        "description": "Request to Intermediary"
      },
      {
        "value": "9",
        "symbolicName": "Accept",
        "description": "Accept"
      },
      {
        "value": "10",
        "symbolicName": "Reject",
        "description": "Reject"
      },
      {
        "value": "11",
        "symbolicName": "AcceptPending",
        "description": "Accept Pending"
      },
      {
        "value": "12",
        "symbolicName": "Complete",
        "description": "Complete"
      },
      {
        "value": "14",
        "symbolicName": "ReversePending",
        "description": "Reverse Pending"
      }
    ]
  },
  {
    "tag": "795",
    "name": "AllocReportRefID",
    "type": "String",
    "description": "Reference identifier to be used with AllocTransType (7) = Replace or Cancel"
  },
  {
    "tag": "796",
    "name": "AllocCancReplaceReason",
    "type": "int",
    "description": "Reason for cancelling or replacing an Allocation Instruction or Allocation Report message",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OriginalDetailsIncomplete",
        "description": "Original details incomplete/incorrect"
      },
      {
        "value": "2",
        "symbolicName": "ChangeInUnderlyingOrderDetails",
        "description": "Change in underlying order details"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "797",
    "name": "CopyMsgIndicator",
    "type": "Boolean",
    "description": "Indicates whether or not this message is a drop copy of another message."
  },
  {
    "tag": "798",
    "name": "AllocAccountType",
    "type": "int",
    "description": "Type of account associated with a confirmation or other trade-level message",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CarriedCustomerSide",
        "description": "Account is carried pn customer side of books"
      },
      {
        "value": "2",
        "symbolicName": "CarriedNonCustomerSide",
        "description": "Account is carried on non-customer side of books"
      },
      {
        "value": "3",
        "symbolicName": "HouseTrader",
        "description": "House trader"
      },
      {
        "value": "4",
        "symbolicName": "FloorTrader",
        "description": "Floor trader"
      },
      {
        "value": "6",
        "symbolicName": "CarriedNonCustomerSideCrossMargined",
        "description": "Account is carried on non-customer side of books and is cross margined"
      },
      {
        "value": "7",
        "symbolicName": "HouseTraderCrossMargined",
        "description": "Account is house trader and is cross margined"
      },
      {
        "value": "8",
        "symbolicName": "JointBackOfficeAccount",
        "description": "Joint back office account (JBO)"
      }
    ]
  },
  {
    "tag": "799",
    "name": "OrderAvgPx",
    "type": "Price",
    "description": "Average price for a specific order"
  },
  {
    "tag": "800",
    "name": "OrderBookingQty",
    "type": "Qty",
    "description": "Quantity of the order that is being booked out as part of an Allocation Instruction or Allocation Report message"
  },
  {
    "tag": "801",
    "name": "NoSettlPartySubIDs",
    "type": "NumInGroup",
    "description": "Number of SettlPartySubID (785) and SettlPartySubIDType (786) entries"
  },
  {
    "tag": "802",
    "name": "NoPartySubIDs",
    "type": "NumInGroup",
    "description": "Number of PartySubID (523)and PartySubIDType (803) entries"
  },
  {
    "tag": "803",
    "name": "PartySubIDType",
    "type": "int",
    "description": "Type of PartySubID (523) value\n4000+ = Reserved and available for bi-laterally agreed upon user defined values",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Firm",
        "description": "Firm"
      },
      {
        "value": "2",
        "symbolicName": "Person",
        "description": "Person"
      },
      {
        "value": "3",
        "symbolicName": "System",
        "description": "System"
      },
      {
        "value": "4",
        "symbolicName": "Application",
        "description": "Application"
      },
      {
        "value": "5",
        "symbolicName": "FullLegalNameOfFirm",
        "description": "Full legal name of firm"
      },
      {
        "value": "6",
        "symbolicName": "PostalAddress",
        "description": "Postal address"
      },
      {
        "value": "7",
        "symbolicName": "PhoneNumber",
        "description": "Phone number"
      },
      {
        "value": "8",
        "symbolicName": "EmailAddress",
        "description": "Email address"
      },
      {
        "value": "9",
        "symbolicName": "ContactName",
        "description": "Contact name"
      },
      {
        "value": "10",
        "symbolicName": "SecuritiesAccountNumber",
        "description": "Securities account number (for settlement instructions)"
      },
      {
        "value": "11",
        "symbolicName": "RegistrationNumber",
        "description": "Registration number (for settlement instructions and confirmations)"
      },
      {
        "value": "12",
        "symbolicName": "RegisteredAddressForConfirmation",
        "description": "Registered address (for confirmation purposes)"
      },
      {
        "value": "13",
        "symbolicName": "RegulatoryStatus",
        "description": "Regulatory status (for confirmation purposes)"
      },
      {
        "value": "14",
        "symbolicName": "RegistrationName",
        "description": "Registration name (for settlement instructions)"
      },
      {
        "value": "15",
        "symbolicName": "CashAccountNumber",
        "description": "Cash account number (for settlement instructions)"
      },
      {
        "value": "16",
        "symbolicName": "BIC",
        "description": "BIC"
      },
      {
        "value": "17",
        "symbolicName": "CSDParticipantMemberCode",
        "description": "CSD participant member code"
      },
      {
        "value": "18",
        "symbolicName": "RegisteredAddress",
        "description": "Registered address"
      },
      {
        "value": "19",
        "symbolicName": "FundAccountName",
        "description": "Fund account name"
      },
      {
        "value": "20",
        "symbolicName": "TelexNumber",
        "description": "Telex number"
      },
      {
        "value": "21",
        "symbolicName": "FaxNumber",
        "description": "Fax number"
      },
      {
        "value": "22",
        "symbolicName": "SecuritiesAccountName",
        "description": "Securities account name"
      },
      {
        "value": "23",
        "symbolicName": "CashAccountName",
        "description": "Cash account name"
      },
      {
        "value": "24",
        "symbolicName": "Department",
        "description": "Department"
      },
      {
        "value": "25",
        "symbolicName": "LocationDesk",
        "description": "Location desk"
      },
      {
        "value": "26",
        "symbolicName": "PositionAccountType",
        "description": "Position account type"
      },
      {
        "value": "27",
        "symbolicName": "SecurityLocateID",
        "description": "Security locate ID"
      },
      {
        "value": "28",
        "symbolicName": "MarketMaker",
        "description": "Market maker"
      },
      {
        "value": "29",
        "symbolicName": "EligibleCounterparty",
        "description": "Eligible counterparty"
      },
      {
        "value": "30",
        "symbolicName": "ProfessionalClient",
        "description": "Professional client"
      },
      {
        "value": "31",
        "symbolicName": "Location",
        "description": "Location"
      },
      {
        "value": "32",
        "symbolicName": "ExecutionVenue",
        "description": "Execution venue"
      },
      {
        "value": "33",
        "symbolicName": "CurrencyDeliveryIdentifier",
        "description": "Currency delivery identifier"
      }
    ]
  },
  {
    "tag": "804",
    "name": "NoNestedPartySubIDs",
    "type": "NumInGroup",
    "description": "Number of NestedPartySubID (545) and NestedPartySubIDType (805) entries"
  },
  {
    "tag": "805",
    "name": "NestedPartySubIDType",
    "type": "int",
    "description": "Type of NestedPartySubID (545) value.\nSame values as PartySubIDType (803)"
  },
  {
    "tag": "806",
    "name": "NoNested2PartySubIDs",
    "type": "NumInGroup",
    "description": "Number of Nested2PartySubID (760) and Nested2PartySubIDType (807) entries. Second instance of <NestedParties>."
  },
  {
    "tag": "807",
    "name": "Nested2PartySubIDType",
    "type": "int",
    "description": "Type of Nested2PartySubID (760) value. Second instance of <NestedParties>.\nSame values as PartySubIDType (803)"
  },
  {
    "tag": "808",
    "name": "AllocIntermedReqType",
    "type": "int",
    "description": "Response to allocation to be communicated to a counterparty through an intermediary, i.e. clearing house. Used in conjunction with AllocType = \"Request to Intermediary\" and AllocReportType = \"Request to Intermediary\"",
    "enum": [
      {
        "value": "1",
        "symbolicName": "PendingAccept",
        "description": "Pending Accept"
      },
      {
        "value": "2",
        "symbolicName": "PendingRelease",
        "description": "Pending Release"
      },
      {
        "value": "3",
        "symbolicName": "PendingReversal",
        "description": "Pending Reversal"
      },
      {
        "value": "4",
        "symbolicName": "Accept",
        "description": "Accept"
      },
      {
        "value": "5",
        "symbolicName": "BlockLevelReject",
        "description": "Block Level Reject"
      },
      {
        "value": "6",
        "symbolicName": "AccountLevelReject",
        "description": "Account Level Reject"
      }
    ]
  },
  {
    "tag": "810",
    "name": "UnderlyingPx",
    "type": "Price",
    "description": "Underlying price associate with a derivative instrument."
  },
  {
    "tag": "811",
    "name": "PriceDelta",
    "type": "float",
    "description": "The rate of change in the price of a derivative with respect to the movement in the price of the underlying instrument(s) upon which the derivative instrument price is based.\nThis value is normally between -1.0 and 1.0."
  },
  {
    "tag": "812",
    "name": "ApplQueueMax",
    "type": "int",
    "description": "Used to specify the maximum number of application messages that can be queued bedore a corrective action needs to take place to resolve the queuing issue."
  },
  {
    "tag": "813",
    "name": "ApplQueueDepth",
    "type": "int",
    "description": "Current number of application messages that were queued at the time that the message was created by the counterparty."
  },
  {
    "tag": "814",
    "name": "ApplQueueResolution",
    "type": "int",
    "description": "Resolution taken when ApplQueueDepth (813) exceeds ApplQueueMax (812) or system specified maximum queue size.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NoActionTaken",
        "description": "No Action Taken"
      },
      {
        "value": "1",
        "symbolicName": "QueueFlushed",
        "description": "Queue Flushed"
      },
      {
        "value": "2",
        "symbolicName": "OverlayLast",
        "description": "Overlay Last"
      },
      {
        "value": "3",
        "symbolicName": "EndSession",
        "description": "End Session"
      }
    ]
  },
  {
    "tag": "815",
    "name": "ApplQueueAction",
    "type": "int",
    "description": "Action to take to resolve an application message queue (backlog).",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NoActionTaken",
        "description": "No Action Taken"
      },
      {
        "value": "1",
        "symbolicName": "QueueFlushed",
        "description": "Queue Flushed"
      },
      {
        "value": "2",
        "symbolicName": "OverlayLast",
        "description": "Overlay Last"
      },
      {
        "value": "3",
        "symbolicName": "EndSession",
        "description": "End Session"
      }
    ]
  },
  {
    "tag": "816",
    "name": "NoAltMDSource",
    "type": "NumInGroup",
    "description": "Number of alternative market data sources"
  },
  {
    "tag": "817",
    "name": "AltMDSourceID",
    "type": "String",
    "description": "Session layer source for market data\n(For the standard FIX session layer, this would be the TargetCompID (56) where market data can be obtained)."
  },
  {
    "tag": "818",
    "name": "SecondaryTradeReportID",
    "type": "String",
    "description": "Secondary trade report identifier - can be used to associate an additional identifier with a trade."
  },
  {
    "tag": "819",
    "name": "AvgPxIndicator",
    "type": "int",
    "description": "Average Pricing Indicator",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NoAveragePricing",
        "description": "No Average Pricing"
      },
      {
        "value": "1",
        "symbolicName": "Trade",
        "description": "Trade is part of an average price group identified by the TradeLinkID (820)"
      },
      {
        "value": "2",
        "symbolicName": "LastTrade",
        "description": "Last trade is the average price group identified by the TradeLinkID (820)"
      }
    ]
  },
  {
    "tag": "820",
    "name": "TradeLinkID",
    "type": "String",
    "description": "Used to link a group of trades together. Useful for linking a group of trades together for average price calculations."
  },
  {
    "tag": "821",
    "name": "OrderInputDevice",
    "type": "String",
    "description": "Specific device number, terminal number or station where order was entered"
  },
  {
    "tag": "822",
    "name": "UnderlyingTradingSessionID",
    "type": "String",
    "description": "Trading Session in which the underlying instrument trades"
  },
  {
    "tag": "823",
    "name": "UnderlyingTradingSessionSubID",
    "type": "String",
    "description": "Trading Session sub identifier in which the underlying instrument trades"
  },
  {
    "tag": "824",
    "name": "TradeLegRefID",
    "type": "String",
    "description": "Reference to the leg of a multileg instrument to which this trade refers"
  },
  {
    "tag": "825",
    "name": "ExchangeRule",
    "type": "String",
    "description": "Used to report any exchange rules that apply to this trade.\nPrimarily intended for US futures markets. Certain trading practices are permitted by the CFTC, such as large lot trading, block trading, all or none trades. If the rules are used, the exchanges are required to indicate these rules on the trade."
  },
  {
    "tag": "826",
    "name": "TradeAllocIndicator",
    "type": "int",
    "description": "Identifies how the trade is to be allocated",
    "enum": [
      {
        "value": "0",
        "symbolicName": "AllocationNotRequired",
        "description": "Allocation not required"
      },
      {
        "value": "1",
        "symbolicName": "AllocationRequired",
        "description": "Allocation required (give-up trade) allocation information not provided (incomplete)"
      },
      {
        "value": "2",
        "symbolicName": "UseAllocationProvidedWithTheTrade",
        "description": "Use allocation provided with the trade"
      },
      {
        "value": "3",
        "symbolicName": "AllocationGiveUpExecutor",
        "description": "Allocation give-up executor"
      },
      {
        "value": "4",
        "symbolicName": "AllocationFromExecutor",
        "description": "Allocation from executor"
      },
      {
        "value": "5",
        "symbolicName": "AllocationToClaimAccount",
        "description": "Allocation to claim account"
      }
    ]
  },
  {
    "tag": "827",
    "name": "ExpirationCycle",
    "type": "int",
    "description": "Part of trading cycle when an instrument expires. Field is applicable for derivatives.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ExpireOnTradingSessionClose",
        "description": "Expire on trading session close (default)"
      },
      {
        "value": "1",
        "symbolicName": "ExpireOnTradingSessionOpen",
        "description": "Expire on trading session open"
      },
      {
        "value": "2",
        "symbolicName": "SpecifiedExpiration",
        "description": "Trading eligibility expiration specified in the date and time fields [EventDate(866) and EventTime(1145)] associated with EventType(865)=7(Last Eligible Trade Date)"
      }
    ]
  },
  {
    "tag": "828",
    "name": "TrdType",
    "type": "int",
    "description": "Type of Trade:",
    "enum": [
      {
        "value": "0",
        "symbolicName": "RegularTrade",
        "description": "Regular Trade"
      },
      {
        "value": "1",
        "symbolicName": "BlockTrade",
        "description": "Block Trade"
      },
      {
        "value": "2",
        "symbolicName": "EFP",
        "description": "EFP (Exchange for physical)"
      },
      {
        "value": "3",
        "symbolicName": "Transfer",
        "description": "Transfer"
      },
      {
        "value": "4",
        "symbolicName": "LateTrade",
        "description": "Late Trade"
      },
      {
        "value": "5",
        "symbolicName": "TTrade",
        "description": "T Trade"
      },
      {
        "value": "6",
        "symbolicName": "WeightedAveragePriceTrade",
        "description": "Weighted Average Price Trade"
      },
      {
        "value": "7",
        "symbolicName": "BunchedTrade",
        "description": "Bunched Trade"
      },
      {
        "value": "8",
        "symbolicName": "LateBunchedTrade",
        "description": "Late Bunched Trade"
      },
      {
        "value": "9",
        "symbolicName": "PriorReferencePriceTrade",
        "description": "Prior Reference Price Trade"
      },
      {
        "value": "10",
        "symbolicName": "AfterHoursTrade",
        "description": "After Hours Trade"
      },
      {
        "value": "11",
        "symbolicName": "ExchangeForRisk",
        "description": "Exchange for Risk (EFR)"
      },
      {
        "value": "12",
        "symbolicName": "ExchangeForSwap",
        "description": "Exchange for Swap (EFS )"
      },
      {
        "value": "13",
        "symbolicName": "ExchangeOfFuturesFor",
        "description": "Exchange of Futures for (in Market) Futures (EFM ) (e,g, full sized for mini)"
      },
      {
        "value": "14",
        "symbolicName": "ExchangeOfOptionsForOptions",
        "description": "Exchange of Options for Options (EOO)"
      },
      {
        "value": "15",
        "symbolicName": "TradingAtSettlement",
        "description": "Trading at Settlement"
      },
      {
        "value": "16",
        "symbolicName": "AllOrNone",
        "description": "All or None"
      },
      {
        "value": "17",
        "symbolicName": "FuturesLargeOrderExecution",
        "description": "Futures Large Order Execution"
      },
      {
        "value": "18",
        "symbolicName": "ExchangeOfFuturesForFutures",
        "description": "Exchange of Futures for Futures (external market) (EFF)"
      },
      {
        "value": "19",
        "symbolicName": "OptionInterimTrade",
        "description": "Option Interim Trade"
      },
      {
        "value": "20",
        "symbolicName": "OptionCabinetTrade",
        "description": "Option Cabinet Trade"
      },
      {
        "value": "22",
        "symbolicName": "PrivatelyNegotiatedTrades",
        "description": "Privately Negotiated Trades"
      },
      {
        "value": "23",
        "symbolicName": "SubstitutionOfFuturesForForwards",
        "description": "Substitution of Futures for Forwards"
      },
      {
        "value": "48",
        "symbolicName": "NonStandardSettlement",
        "description": "Non-standard settlement"
      },
      {
        "value": "49",
        "symbolicName": "DerivativeRelatedTransaction",
        "description": "Derivative Related Transaction"
      },
      {
        "value": "50",
        "symbolicName": "PortfolioTrade",
        "description": "Portfolio Trade"
      },
      {
        "value": "51",
        "symbolicName": "VolumeWeightedAverageTrade",
        "description": "Volume Weighted Average Trade"
      },
      {
        "value": "52",
        "symbolicName": "ExchangeGrantedTrade",
        "description": "Exchange Granted Trade"
      },
      {
        "value": "53",
        "symbolicName": "RepurchaseAgreement",
        "description": "Repurchase Agreement"
      },
      {
        "value": "54",
        "symbolicName": "OTC",
        "description": "OTC"
      },
      {
        "value": "55",
        "symbolicName": "ExchangeBasisFacility",
        "description": "Exchange Basis Facility (EBF)"
      },
      {
        "value": "24",
        "symbolicName": "ErrorTrade",
        "description": "Error trade"
      },
      {
        "value": "25",
        "symbolicName": "SpecialCumDividend",
        "description": "Special cum dividend (CD)"
      },
      {
        "value": "26",
        "symbolicName": "SpecialExDividend",
        "description": "Special ex dividend (XD)"
      },
      {
        "value": "27",
        "symbolicName": "SpecialCumCoupon",
        "description": "Special cum coupon (CC)"
      },
      {
        "value": "28",
        "symbolicName": "SpecialExCoupon",
        "description": "Special ex coupon (XC)"
      },
      {
        "value": "29",
        "symbolicName": "CashSettlement",
        "description": "Cash settlement (CS)"
      },
      {
        "value": "30",
        "symbolicName": "SpecialPrice",
        "description": "Special price (usually net- or all-in price) (SP)"
      },
      {
        "value": "31",
        "symbolicName": "GuaranteedDelivery",
        "description": "Guaranteed delivery (GD)"
      },
      {
        "value": "32",
        "symbolicName": "SpecialCumRights",
        "description": "Special cum rights (CR)"
      },
      {
        "value": "33",
        "symbolicName": "SpecialExRights",
        "description": "Special ex rights (XR)"
      },
      {
        "value": "34",
        "symbolicName": "SpecialCumCapitalRepayments",
        "description": "Special cum capital repayments (CP)"
      },
      {
        "value": "35",
        "symbolicName": "SpecialExCapitalRepayments",
        "description": "Special ex capital repayments (XP)"
      },
      {
        "value": "36",
        "symbolicName": "SpecialCumBonus",
        "description": "Special cum bonus (CB)"
      },
      {
        "value": "37",
        "symbolicName": "SpecialExBonus",
        "description": "Special ex bonus (XB)"
      },
      {
        "value": "38",
        "symbolicName": "LargeTrade",
        "description": "Block trade (same as large trade)"
      },
      {
        "value": "39",
        "symbolicName": "WorkedPrincipalTrade",
        "description": "Worked principal trade (UK-specific)"
      },
      {
        "value": "40",
        "symbolicName": "BlockTrades",
        "description": "Block Trades - after market"
      },
      {
        "value": "41",
        "symbolicName": "NameChange",
        "description": "Name change"
      },
      {
        "value": "42",
        "symbolicName": "PortfolioTransfer",
        "description": "Portfolio transfer"
      },
      {
        "value": "43",
        "symbolicName": "ProrogationBuy",
        "description": "Prorogation buy - Euronext Paris only. Is used to defer settlement under French SRD (deferred settlement system) . Trades must be reported as crosses at zero price"
      },
      {
        "value": "44",
        "symbolicName": "ProrogationSell",
        "description": "Prorogation sell - see prorogation buy"
      },
      {
        "value": "45",
        "symbolicName": "OptionExercise",
        "description": "Option exercise"
      },
      {
        "value": "46",
        "symbolicName": "DeltaNeutralTransaction",
        "description": "Delta neutral transaction"
      },
      {
        "value": "47",
        "symbolicName": "FinancingTransaction",
        "description": "Financing transaction (includes repo and stock lending)"
      }
    ]
  },
  {
    "tag": "829",
    "name": "TrdSubType",
    "type": "int",
    "description": "Further qualification to the trade type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "CMTA",
        "description": "CMTA"
      },
      {
        "value": "1",
        "symbolicName": "InternalTransferOrAdjustment",
        "description": "Internal transfer or adjustment"
      },
      {
        "value": "2",
        "symbolicName": "ExternalTransferOrTransferOfAccount",
        "description": "External transfer or transfer of account"
      },
      {
        "value": "3",
        "symbolicName": "RejectForSubmittingSide",
        "description": "Reject for submitting side"
      },
      {
        "value": "4",
        "symbolicName": "AdvisoryForContraSide",
        "description": "Advisory for contra side"
      },
      {
        "value": "5",
        "symbolicName": "OffsetDueToAnAllocation",
        "description": "Offset due to an allocation"
      },
      {
        "value": "6",
        "symbolicName": "OnsetDueToAnAllocation",
        "description": "Onset due to an allocation"
      },
      {
        "value": "7",
        "symbolicName": "DifferentialSpread",
        "description": "Differential spread"
      },
      {
        "value": "8",
        "symbolicName": "ImpliedSpreadLegExecutedAgainstAnOutright",
        "description": "Implied spread leg executed against an outright"
      },
      {
        "value": "9",
        "symbolicName": "TransactionFromExercise",
        "description": "Transaction from exercise"
      },
      {
        "value": "10",
        "symbolicName": "TransactionFromAssignment",
        "description": "Transaction from assignment"
      },
      {
        "value": "11",
        "symbolicName": "ACATS",
        "description": "ACATS"
      },
      {
        "value": "33",
        "symbolicName": "OffHoursTrade",
        "description": "Off Hours Trade"
      },
      {
        "value": "34",
        "symbolicName": "OnHoursTrade",
        "description": "On Hours Trade"
      },
      {
        "value": "35",
        "symbolicName": "OTCQuote",
        "description": "OTC Quote"
      },
      {
        "value": "36",
        "symbolicName": "ConvertedSWAP",
        "description": "Converted SWAP"
      },
      {
        "value": "14",
        "symbolicName": "AI",
        "description": "AI (Automated input facility disabled in response to an exchange request.)"
      },
      {
        "value": "15",
        "symbolicName": "B",
        "description": "B (Transaction between two member firms where neither member firm is registered as a market maker in the security in question and neither is a designated fund manager. Also used by broker dealers when dealing with another broker which is not a member firm. Non-order book securities only.)"
      },
      {
        "value": "16",
        "symbolicName": "K",
        "description": "K (Transaction using block trade facility.)"
      },
      {
        "value": "17",
        "symbolicName": "LC",
        "description": "LC (Correction submitted more than three days after publication of the original trade report.)"
      },
      {
        "value": "18",
        "symbolicName": "M",
        "description": "M (Transaction, other than a transaction resulting from a stock swap or stock switch, between two market makers registered in that security including IDB or a public display system trades. Non-order book securities only.)"
      },
      {
        "value": "19",
        "symbolicName": "N",
        "description": "N (Non-protected portfolio transaction or a fully disclosed portfolio transaction)"
      },
      {
        "value": "20",
        "symbolicName": "NM",
        "description": "NM ( i) transaction where Exchange has granted permission for non-publication\nii)IDB is reporting as seller\niii) submitting a transaction report to the Exchange, where the transaction report is not also a trade report.)"
      },
      {
        "value": "21",
        "symbolicName": "NR",
        "description": "NR (Non-risk transaction in a SEATS security other than an AIM security)"
      },
      {
        "value": "22",
        "symbolicName": "P",
        "description": "P (Protected portfolio transaction or a worked principal agreement to effect a portfolio transaction which includes order book securities)"
      },
      {
        "value": "23",
        "symbolicName": "PA",
        "description": "PA (Protected transaction notification)"
      },
      {
        "value": "24",
        "symbolicName": "PC",
        "description": "PC (Contra trade for transaction which took place on a previous day and which was automatically executed on the Exchange trading system)"
      },
      {
        "value": "25",
        "symbolicName": "PN",
        "description": "PN (Worked principal notification for a portfolio transaction which includes order book securities)"
      },
      {
        "value": "26",
        "symbolicName": "R",
        "description": "R ( (i) riskless principal transaction between non-members where the buying and selling transactions are executed at different prices or on different terms (requires a trade report with trade type indicator R for each transaction)\n(ii) market maker is reporting all the legs of a riskless principal transaction where the buying and selling transactions are executed at different prices (requires a trade report with trade type indicator R for each transaction)or\n(iii) market maker is reporting the onward leg of a riskless principal transaction where the legs are executed at different prices, and another market maker has submitted a trade report using trade type indicator M for the first leg (this requires a single trade report with trade type indicator R).)"
      },
      {
        "value": "27",
        "symbolicName": "RO",
        "description": "RO (Transaction which resulted from the exercise of a traditional option or a stock-settled covered warrant)"
      },
      {
        "value": "28",
        "symbolicName": "RT",
        "description": "RT (Risk transaction in a SEATS security, (excluding AIM security) reported by a market maker registered in that security)"
      },
      {
        "value": "29",
        "symbolicName": "SW",
        "description": "SW (Transactions resulting from stock swap or a stock switch (one report is required for each line of stock))"
      },
      {
        "value": "30",
        "symbolicName": "T",
        "description": "T (If reporting a single protected transaction)"
      },
      {
        "value": "31",
        "symbolicName": "WN",
        "description": "WN (Worked principal notification for a single order book security)"
      },
      {
        "value": "32",
        "symbolicName": "WT",
        "description": "WT (Worked principal transaction (other than a portfolio transaction))"
      },
      {
        "value": "37",
        "symbolicName": "CrossedTrade",
        "description": "Crossed Trade (X)"
      },
      {
        "value": "38",
        "symbolicName": "InterimProtectedTrade",
        "description": "Interim Protected Trade (I)"
      },
      {
        "value": "39",
        "symbolicName": "LargeInScale",
        "description": "Large in Scale (L)"
      }
    ]
  },
  {
    "tag": "830",
    "name": "TransferReason",
    "type": "String",
    "description": "Reason trade is being transferred"
  },
  {
    "tag": "832",
    "name": "TotNumAssignmentReports",
    "type": "int",
    "description": "Total Number of Assignment Reports being returned to a firm"
  },
  {
    "tag": "833",
    "name": "AsgnRptID",
    "type": "String",
    "description": "Unique identifier for the Assignment Report"
  },
  {
    "tag": "834",
    "name": "ThresholdAmount",
    "type": "PriceOffset",
    "description": "Amount that a position has to be in the money before it is exercised."
  },
  {
    "tag": "835",
    "name": "PegMoveType",
    "type": "int",
    "description": "Describes whether peg is static or floats",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Floating",
        "description": "Floating (default)"
      },
      {
        "value": "1",
        "symbolicName": "Fixed",
        "description": "Fixed"
      }
    ]
  },
  {
    "tag": "836",
    "name": "PegOffsetType",
    "type": "int",
    "description": "Type of Peg Offset value",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Price",
        "description": "Price (default)"
      },
      {
        "value": "1",
        "symbolicName": "BasisPoints",
        "description": "Basis Points"
      },
      {
        "value": "2",
        "symbolicName": "Ticks",
        "description": "Ticks"
      },
      {
        "value": "3",
        "symbolicName": "PriceTier",
        "description": "Price Tier / Level"
      }
    ]
  },
  {
    "tag": "837",
    "name": "PegLimitType",
    "type": "int",
    "description": "Type of Peg Limit",
    "enum": [
      {
        "value": "0",
        "symbolicName": "OrBetter",
        "description": "Or better (default) - price improvement allowed"
      },
      {
        "value": "1",
        "symbolicName": "Strict",
        "description": "Strict - limit is a strict limit"
      },
      {
        "value": "2",
        "symbolicName": "OrWorse",
        "description": "Or worse - for a buy the peg limit is a minimum and for a sell the peg limit is a maximum (for use for orders which have a price range)"
      }
    ]
  },
  {
    "tag": "838",
    "name": "PegRoundDirection",
    "type": "int",
    "description": "If the calculated peg price is not a valid tick price, specifies whether to round the price to be more or less aggressive",
    "enum": [
      {
        "value": "1",
        "symbolicName": "MoreAggressive",
        "description": "More aggressive - on a buy order round the price up to the nearest tick; on a sell order round down to the nearest tick"
      },
      {
        "value": "2",
        "symbolicName": "MorePassive",
        "description": "More passive - on a buy order round down to the nearest tick; on a sell order round up to the nearest tick"
      }
    ]
  },
  {
    "tag": "839",
    "name": "PeggedPrice",
    "type": "Price",
    "description": "The price the order is currently pegged at"
  },
  {
    "tag": "840",
    "name": "PegScope",
    "type": "int",
    "description": "The scope of the peg",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Local",
        "description": "Local (Exchange, ECN, ATS)"
      },
      {
        "value": "2",
        "symbolicName": "National",
        "description": "National"
      },
      {
        "value": "3",
        "symbolicName": "Global",
        "description": "Global"
      },
      {
        "value": "4",
        "symbolicName": "NationalExcludingLocal",
        "description": "National excluding local"
      }
    ]
  },
  {
    "tag": "841",
    "name": "DiscretionMoveType",
    "type": "int",
    "description": "Describes whether discretionay price is static or floats",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Floating",
        "description": "Floating (default)"
      },
      {
        "value": "1",
        "symbolicName": "Fixed",
        "description": "Fixed"
      }
    ]
  },
  {
    "tag": "842",
    "name": "DiscretionOffsetType",
    "type": "int",
    "description": "Type of Discretion Offset value",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Price",
        "description": "Price (default)"
      },
      {
        "value": "1",
        "symbolicName": "BasisPoints",
        "description": "Basis Points"
      },
      {
        "value": "2",
        "symbolicName": "Ticks",
        "description": "Ticks"
      },
      {
        "value": "3",
        "symbolicName": "PriceTier",
        "description": "Price Tier / Level"
      }
    ]
  },
  {
    "tag": "843",
    "name": "DiscretionLimitType",
    "type": "int",
    "description": "Type of Discretion Limit",
    "enum": [
      {
        "value": "0",
        "symbolicName": "OrBetter",
        "description": "Or better (default) - price improvement allowed"
      },
      {
        "value": "1",
        "symbolicName": "Strict",
        "description": "Strict - limit is a strict limit"
      },
      {
        "value": "2",
        "symbolicName": "OrWorse",
        "description": "Or worse - for a buy the discretion price is a minimum and for a sell the discretion price is a maximum (for use for orders which have a price range)"
      }
    ]
  },
  {
    "tag": "844",
    "name": "DiscretionRoundDirection",
    "type": "int",
    "description": "If the calculated discretionary price is not a valid tick price, specifies whether to round the price to be more or less aggressive",
    "enum": [
      {
        "value": "1",
        "symbolicName": "MoreAggressive",
        "description": "More aggressive - on a buy order round the price up to the nearest tick; on a sell round down to the nearest tick"
      },
      {
        "value": "2",
        "symbolicName": "MorePassive",
        "description": "More passive - on a buy order round down to the nearest tick; on a sell order round up to the nearest tick"
      }
    ]
  },
  {
    "tag": "845",
    "name": "DiscretionPrice",
    "type": "Price",
    "description": "The current discretionary price of the order"
  },
  {
    "tag": "846",
    "name": "DiscretionScope",
    "type": "int",
    "description": "The scope of the discretion",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Local",
        "description": "Local (Exchange, ECN, ATS)"
      },
      {
        "value": "2",
        "symbolicName": "National",
        "description": "National"
      },
      {
        "value": "3",
        "symbolicName": "Global",
        "description": "Global"
      },
      {
        "value": "4",
        "symbolicName": "NationalExcludingLocal",
        "description": "National excluding local"
      }
    ]
  },
  {
    "tag": "847",
    "name": "TargetStrategy",
    "type": "int",
    "description": "The target strategy of the order\n1000+ = Reserved and available for bi-laterally agreed upon user defined values",
    "enum": [
      {
        "value": "1",
        "symbolicName": "VWAP",
        "description": "VWAP"
      },
      {
        "value": "2",
        "symbolicName": "Participate",
        "description": "Participate (i.e. aim to be x percent of the market volume)"
      },
      {
        "value": "3",
        "symbolicName": "MininizeMarketImpact",
        "description": "Mininize market impact"
      }
    ]
  },
  {
    "tag": "848",
    "name": "TargetStrategyParameters",
    "type": "String",
    "description": "Field to allow further specification of the TargetStrategy - usage to be agreed between counterparties"
  },
  {
    "tag": "849",
    "name": "ParticipationRate",
    "type": "Percentage",
    "description": "For a TargetStrategy=Participate order specifies the target particpation rate. For other order types this is a volume limit (i.e. do not be more than this percent of the market volume)"
  },
  {
    "tag": "850",
    "name": "TargetStrategyPerformance",
    "type": "float",
    "description": "For communication of the performance of the order versus the target strategy"
  },
  {
    "tag": "851",
    "name": "LastLiquidityInd",
    "type": "int",
    "description": "Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AddedLiquidity",
        "description": "Added Liquidity"
      },
      {
        "value": "2",
        "symbolicName": "RemovedLiquidity",
        "description": "Removed Liquidity"
      },
      {
        "value": "3",
        "symbolicName": "LiquidityRoutedOut",
        "description": "Liquidity Routed Out"
      },
      {
        "value": "4",
        "symbolicName": "Auction",
        "description": "Auction"
      }
    ]
  },
  {
    "tag": "852",
    "name": "PublishTrdIndicator",
    "type": "Boolean",
    "description": "Indicates if a trade should be reported via a market reporting service.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DoNotReportTrade",
        "description": "Do Not Report Trade"
      },
      {
        "value": "Y",
        "symbolicName": "ReportTrade",
        "description": "Report Trade"
      }
    ]
  },
  {
    "tag": "853",
    "name": "ShortSaleReason",
    "type": "int",
    "description": "Reason for short sale.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "DealerSoldShort",
        "description": "Dealer Sold Short"
      },
      {
        "value": "1",
        "symbolicName": "DealerSoldShortExempt",
        "description": "Dealer Sold Short Exempt"
      },
      {
        "value": "2",
        "symbolicName": "SellingCustomerSoldShort",
        "description": "Selling Customer Sold Short"
      },
      {
        "value": "3",
        "symbolicName": "SellingCustomerSoldShortExempt",
        "description": "Selling Customer Sold Short Exempt"
      },
      {
        "value": "4",
        "symbolicName": "QualifiedServiceRepresentative",
        "description": "Qualified Service Representative (QSR) or Automatic Give-up (AGU) Contra Side Sold Short"
      },
      {
        "value": "5",
        "symbolicName": "QSROrAGUContraSideSoldShortExempt",
        "description": "QSR or AGU Contra Side Sold Short Exempt"
      }
    ]
  },
  {
    "tag": "854",
    "name": "QtyType",
    "type": "int",
    "description": "Type of quantity specified in a quantity field:",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Units",
        "description": "Units (shares, par, currency)"
      },
      {
        "value": "1",
        "symbolicName": "Contracts",
        "description": "Contracts (if used - must specify ContractMultiplier (tag 231))"
      },
      {
        "value": "2",
        "symbolicName": "UnitsOfMeasurePerTimeUnit",
        "description": "Units of Measure per Time Unit (if used - must specify UnitofMeasure (tag 996) and TimeUnit (tag 997))"
      }
    ]
  },
  {
    "tag": "855",
    "name": "SecondaryTrdType",
    "type": "int",
    "description": "Additional TrdType(828) assigned to a trade by trade match system."
  },
  {
    "tag": "856",
    "name": "TradeReportType",
    "type": "int",
    "description": "Type of Trade Report",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Submit",
        "description": "Submit"
      },
      {
        "value": "1",
        "symbolicName": "Alleged",
        "description": "Alleged"
      },
      {
        "value": "2",
        "symbolicName": "Accept",
        "description": "Accept"
      },
      {
        "value": "3",
        "symbolicName": "Decline",
        "description": "Decline"
      },
      {
        "value": "4",
        "symbolicName": "Addendum",
        "description": "Addendum"
      },
      {
        "value": "5",
        "symbolicName": "No",
        "description": "No/Was"
      },
      {
        "value": "6",
        "symbolicName": "TradeReportCancel",
        "description": "Trade Report Cancel"
      },
      {
        "value": "7",
        "symbolicName": "LockedIn",
        "description": "(Locked-In) Trade Break"
      },
      {
        "value": "8",
        "symbolicName": "Defaulted",
        "description": "Defaulted"
      },
      {
        "value": "9",
        "symbolicName": "InvalidCMTA",
        "description": "Invalid CMTA"
      },
      {
        "value": "10",
        "symbolicName": "Pended",
        "description": "Pended"
      },
      {
        "value": "11",
        "symbolicName": "AllegedNew",
        "description": "Alleged New"
      },
      {
        "value": "12",
        "symbolicName": "AllegedAddendum",
        "description": "Alleged Addendum"
      },
      {
        "value": "13",
        "symbolicName": "AllegedNo",
        "description": "Alleged No/Was"
      },
      {
        "value": "14",
        "symbolicName": "AllegedTradeReportCancel",
        "description": "Alleged Trade Report Cancel"
      },
      {
        "value": "15",
        "symbolicName": "AllegedTradeBreak",
        "description": "Alleged (Locked-In) Trade Break"
      }
    ]
  },
  {
    "tag": "857",
    "name": "AllocNoOrdersType",
    "type": "int",
    "description": "Indicates how the orders being booked and allocated by an Allocation Instruction or Allocation Report message are identified, i.e. by explicit definition in the NoOrders group or not.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NotSpecified",
        "description": "Not Specified"
      },
      {
        "value": "1",
        "symbolicName": "ExplicitListProvided",
        "description": "Explicit List Provided"
      }
    ]
  },
  {
    "tag": "858",
    "name": "SharedCommission",
    "type": "Amt",
    "description": "Commission to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement."
  },
  {
    "tag": "859",
    "name": "ConfirmReqID",
    "type": "String",
    "description": "Unique identifier for a Confirmation Request message"
  },
  {
    "tag": "860",
    "name": "AvgParPx",
    "type": "Price",
    "description": "Used to express average price as percent of par (used where AvgPx field is expressed in some other way)"
  },
  {
    "tag": "861",
    "name": "ReportedPx",
    "type": "Price",
    "description": "Reported price (used to differentiate from AvgPx on a confirmation of a marked-up or marked-down principal trade)"
  },
  {
    "tag": "862",
    "name": "NoCapacities",
    "type": "NumInGroup",
    "description": "Number of repeating OrderCapacity entries."
  },
  {
    "tag": "863",
    "name": "OrderCapacityQty",
    "type": "Qty",
    "description": "Quantity executed under a specific OrderCapacity (e.g. quantity executed as agent, quantity executed as principal)"
  },
  {
    "tag": "864",
    "name": "NoEvents",
    "type": "NumInGroup",
    "description": "Number of repeating EventType entries."
  },
  {
    "tag": "865",
    "name": "EventType",
    "type": "int",
    "description": "Code to represent the type of event",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Put",
        "description": "Put"
      },
      {
        "value": "2",
        "symbolicName": "Call",
        "description": "Call"
      },
      {
        "value": "3",
        "symbolicName": "Tender",
        "description": "Tender"
      },
      {
        "value": "4",
        "symbolicName": "SinkingFundCall",
        "description": "Sinking Fund Call"
      },
      {
        "value": "5",
        "symbolicName": "Activation",
        "description": "Activation"
      },
      {
        "value": "6",
        "symbolicName": "Inactiviation",
        "description": "Inactiviation"
      },
      {
        "value": "7",
        "symbolicName": "LastEligibleTradeDate",
        "description": "Last Eligible Trade Date"
      },
      {
        "value": "8",
        "symbolicName": "SwapStartDate",
        "description": "Swap Start Date"
      },
      {
        "value": "9",
        "symbolicName": "SwapEndDate",
        "description": "Swap End Date"
      },
      {
        "value": "10",
        "symbolicName": "SwapRollDate",
        "description": "Swap Roll Date"
      },
      {
        "value": "11",
        "symbolicName": "SwapNextStartDate",
        "description": "Swap Next Start Date"
      },
      {
        "value": "12",
        "symbolicName": "SwapNextRollDate",
        "description": "Swap Next Roll Date"
      },
      {
        "value": "13",
        "symbolicName": "FirstDeliveryDate",
        "description": "First Delivery Date"
      },
      {
        "value": "14",
        "symbolicName": "LastDeliveryDate",
        "description": "Last Delivery Date"
      },
      {
        "value": "15",
        "symbolicName": "InitialInventoryDueDate",
        "description": "Initial Inventory Due Date"
      },
      {
        "value": "16",
        "symbolicName": "FinalInventoryDueDate",
        "description": "Final Inventory Due Date"
      },
      {
        "value": "17",
        "symbolicName": "FirstIntentDate",
        "description": "First Intent Date"
      },
      {
        "value": "18",
        "symbolicName": "LastIntentDate",
        "description": "Last Intent Date"
      },
      {
        "value": "19",
        "symbolicName": "PositionRemovalDate",
        "description": "Position Removal Date"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "866",
    "name": "EventDate",
    "type": "LocalMktDate",
    "description": "Date of event"
  },
  {
    "tag": "867",
    "name": "EventPx",
    "type": "Price",
    "description": "Predetermined price of issue at event, if applicable"
  },
  {
    "tag": "868",
    "name": "EventText",
    "type": "String",
    "description": "Comments related to the event."
  },
  {
    "tag": "869",
    "name": "PctAtRisk",
    "type": "Percentage",
    "description": "Percent at risk due to lowest possible call."
  },
  {
    "tag": "870",
    "name": "NoInstrAttrib",
    "type": "NumInGroup",
    "description": "Number of repeating InstrAttribType entries."
  },
  {
    "tag": "871",
    "name": "InstrAttribType",
    "type": "int",
    "description": "Code to represent the type of instrument attribute",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Flat",
        "description": "Flat (securities pay interest on a current basis but are traded without interest)"
      },
      {
        "value": "2",
        "symbolicName": "ZeroCoupon",
        "description": "Zero coupon"
      },
      {
        "value": "3",
        "symbolicName": "InterestBearing",
        "description": "Interest bearing (for Euro commercial paper when not issued at discount)"
      },
      {
        "value": "4",
        "symbolicName": "NoPeriodicPayments",
        "description": "No periodic payments"
      },
      {
        "value": "5",
        "symbolicName": "VariableRate",
        "description": "Variable rate"
      },
      {
        "value": "6",
        "symbolicName": "LessFeeForPut",
        "description": "Less fee for put"
      },
      {
        "value": "7",
        "symbolicName": "SteppedCoupon",
        "description": "Stepped coupon"
      },
      {
        "value": "8",
        "symbolicName": "CouponPeriod",
        "description": "Coupon period (if not semi-annual). Supply redemption date in the InstrAttribValue (872) field."
      },
      {
        "value": "9",
        "symbolicName": "When",
        "description": "When [and if] issued"
      },
      {
        "value": "10",
        "symbolicName": "OriginalIssueDiscount",
        "description": "Original issue discount"
      },
      {
        "value": "11",
        "symbolicName": "Callable",
        "description": "Callable, puttable"
      },
      {
        "value": "12",
        "symbolicName": "EscrowedToMaturity",
        "description": "Escrowed to Maturity"
      },
      {
        "value": "13",
        "symbolicName": "EscrowedToRedemptionDate",
        "description": "Escrowed to redemption date - callable. Supply redemption date in the InstrAttribValue (872) field"
      },
      {
        "value": "14",
        "symbolicName": "PreRefunded",
        "description": "Pre-refunded"
      },
      {
        "value": "15",
        "symbolicName": "InDefault",
        "description": "In default"
      },
      {
        "value": "16",
        "symbolicName": "Unrated",
        "description": "Unrated"
      },
      {
        "value": "17",
        "symbolicName": "Taxable",
        "description": "Taxable"
      },
      {
        "value": "18",
        "symbolicName": "Indexed",
        "description": "Indexed"
      },
      {
        "value": "19",
        "symbolicName": "SubjectToAlternativeMinimumTax",
        "description": "Subject To Alternative Minimum Tax"
      },
      {
        "value": "20",
        "symbolicName": "OriginalIssueDiscountPrice",
        "description": "Original issue discount price. Supply price in the InstrAttribValue (872) field"
      },
      {
        "value": "21",
        "symbolicName": "CallableBelowMaturityValue",
        "description": "Callable below maturity value"
      },
      {
        "value": "22",
        "symbolicName": "CallableWithoutNotice",
        "description": "Callable without notice by mail to holder unless registered"
      },
      {
        "value": "23",
        "symbolicName": "PriceTickRulesForSecurity",
        "description": "Price tick rules for security."
      },
      {
        "value": "24",
        "symbolicName": "TradeTypeEligibilityDetailsForSecurity",
        "description": "Trade type eligibility details for security."
      },
      {
        "value": "25",
        "symbolicName": "InstrumentDenominator",
        "description": "Instrument Denominator"
      },
      {
        "value": "26",
        "symbolicName": "InstrumentNumerator",
        "description": "Instrument Numerator"
      },
      {
        "value": "27",
        "symbolicName": "InstrumentPricePrecision",
        "description": "Instrument Price Precision"
      },
      {
        "value": "28",
        "symbolicName": "InstrumentStrikePrice",
        "description": "Instrument Strike Price"
      },
      {
        "value": "29",
        "symbolicName": "TradeableIndicator",
        "description": "Tradeable Indicator"
      },
      {
        "value": "99",
        "symbolicName": "Text",
        "description": "Text. Supply the text of the attribute or disclaimer in the InstrAttribValue (872) field."
      }
    ]
  },
  {
    "tag": "872",
    "name": "InstrAttribValue",
    "type": "String",
    "description": "Attribute value appropriate to the InstrAttribType (87) field."
  },
  {
    "tag": "873",
    "name": "DatedDate",
    "type": "LocalMktDate",
    "description": "The effective date of a new securities issue determined by its underwriters. Often but not always the same as the Issue Date and the Interest Accrual Date"
  },
  {
    "tag": "874",
    "name": "InterestAccrualDate",
    "type": "LocalMktDate",
    "description": "The start date used for calculating accrued interest on debt instruments which are being sold between interest payment dates. Often but not always the same as the Issue Date and the Dated Date"
  },
  {
    "tag": "875",
    "name": "CPProgram",
    "type": "int",
    "description": "The program under which a commercial paper is issued",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Program3a3",
        "description": "3(a)(3)"
      },
      {
        "value": "2",
        "symbolicName": "Program42",
        "description": "4(2)"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "876",
    "name": "CPRegType",
    "type": "String",
    "description": "The registration type of a commercial paper issuance"
  },
  {
    "tag": "877",
    "name": "UnderlyingCPProgram",
    "type": "String",
    "description": "The program under which the underlying commercial paper is issued"
  },
  {
    "tag": "878",
    "name": "UnderlyingCPRegType",
    "type": "String",
    "description": "The registration type of the underlying commercial paper issuance"
  },
  {
    "tag": "879",
    "name": "UnderlyingQty",
    "type": "Qty",
    "description": "Unit amount of the underlying security (par, shares, currency, etc.)"
  },
  {
    "tag": "880",
    "name": "TrdMatchID",
    "type": "String",
    "description": "Identifier assigned to a trade by a matching system."
  },
  {
    "tag": "881",
    "name": "SecondaryTradeReportRefID",
    "type": "String",
    "description": "Used to refer to a previous SecondaryTradeReportRefID when amending the transaction (cancel, replace, release, or reversal)."
  },
  {
    "tag": "882",
    "name": "UnderlyingDirtyPrice",
    "type": "Price",
    "description": "Price (percent-of-par or per unit) of the underlying security or basket. \"Dirty\" means it includes accrued interest"
  },
  {
    "tag": "883",
    "name": "UnderlyingEndPrice",
    "type": "Price",
    "description": "Price (percent-of-par or per unit) of the underlying security or basket at the end of the agreement."
  },
  {
    "tag": "884",
    "name": "UnderlyingStartValue",
    "type": "Amt",
    "description": "Currency value attributed to this collateral at the start of the agreement"
  },
  {
    "tag": "885",
    "name": "UnderlyingCurrentValue",
    "type": "Amt",
    "description": "Currency value currently attributed to this collateral"
  },
  {
    "tag": "886",
    "name": "UnderlyingEndValue",
    "type": "Amt",
    "description": "Currency value attributed to this collateral at the end of the agreement"
  },
  {
    "tag": "887",
    "name": "NoUnderlyingStips",
    "type": "NumInGroup",
    "description": "Number of underlying stipulation entries"
  },
  {
    "tag": "888",
    "name": "UnderlyingStipType",
    "type": "String",
    "description": "Type of stipulation.\nSame values as StipulationType (233)"
  },
  {
    "tag": "889",
    "name": "UnderlyingStipValue",
    "type": "String",
    "description": "Value of stipulation.\nSame values as StipulationValue (234)"
  },
  {
    "tag": "890",
    "name": "MaturityNetMoney",
    "type": "Amt",
    "description": "Net Money at maturity if Zero Coupon and maturity value is different from par value"
  },
  {
    "tag": "891",
    "name": "MiscFeeBasis",
    "type": "int",
    "description": "Defines the unit for a miscellaneous fee.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Absolute",
        "description": "Absolute"
      },
      {
        "value": "1",
        "symbolicName": "PerUnit",
        "description": "Per Unit"
      },
      {
        "value": "2",
        "symbolicName": "Percentage",
        "description": "Percentage"
      }
    ]
  },
  {
    "tag": "892",
    "name": "TotNoAllocs",
    "type": "int",
    "description": "Total number of NoAlloc entries across all messages. Should be the sum of all NoAllocs in each message that has repeating NoAlloc entries related to the same AllocID or AllocReportID. Used to support fragmentation."
  },
  {
    "tag": "893",
    "name": "LastFragment",
    "type": "Boolean",
    "description": "Indicates whether this message is the last in a sequence of messages for those messages that support fragmentation, such as Allocation Instruction, Mass Quote, Security List, Derivative Security List",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotLastMessage",
        "description": "Not Last Message"
      },
      {
        "value": "Y",
        "symbolicName": "LastMessage",
        "description": "Last Message"
      }
    ]
  },
  {
    "tag": "894",
    "name": "CollReqID",
    "type": "String",
    "description": "Collateral Request Identifier"
  },
  {
    "tag": "895",
    "name": "CollAsgnReason",
    "type": "int",
    "description": "Reason for Collateral Assignment",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Initial",
        "description": "Initial"
      },
      {
        "value": "1",
        "symbolicName": "Scheduled",
        "description": "Scheduled"
      },
      {
        "value": "2",
        "symbolicName": "TimeWarning",
        "description": "Time Warning"
      },
      {
        "value": "3",
        "symbolicName": "MarginDeficiency",
        "description": "Margin Deficiency"
      },
      {
        "value": "4",
        "symbolicName": "MarginExcess",
        "description": "Margin Excess"
      },
      {
        "value": "5",
        "symbolicName": "ForwardCollateralDemand",
        "description": "Forward Collateral Demand"
      },
      {
        "value": "6",
        "symbolicName": "EventOfDefault",
        "description": "Event of default"
      },
      {
        "value": "7",
        "symbolicName": "AdverseTaxEvent",
        "description": "Adverse tax event"
      }
    ]
  },
  {
    "tag": "896",
    "name": "CollInquiryQualifier",
    "type": "int",
    "description": "Collateral inquiry qualifiers:",
    "enum": [
      {
        "value": "0",
        "symbolicName": "TradeDate",
        "description": "Trade Date"
      },
      {
        "value": "1",
        "symbolicName": "GCInstrument",
        "description": "GC Instrument"
      },
      {
        "value": "2",
        "symbolicName": "CollateralInstrument",
        "description": "Collateral Instrument"
      },
      {
        "value": "3",
        "symbolicName": "SubstitutionEligible",
        "description": "Substitution Eligible"
      },
      {
        "value": "4",
        "symbolicName": "NotAssigned",
        "description": "Not Assigned"
      },
      {
        "value": "5",
        "symbolicName": "PartiallyAssigned",
        "description": "Partially Assigned"
      },
      {
        "value": "6",
        "symbolicName": "FullyAssigned",
        "description": "Fully Assigned"
      },
      {
        "value": "7",
        "symbolicName": "OutstandingTrades",
        "description": "Outstanding Trades (Today < end date)"
      }
    ]
  },
  {
    "tag": "897",
    "name": "NoTrades",
    "type": "NumInGroup",
    "description": "Number of trades in repeating group."
  },
  {
    "tag": "898",
    "name": "MarginRatio",
    "type": "Percentage",
    "description": "The fraction of the cash consideration that must be collateralized, expressed as a percent. A MarginRatio of 02% indicates that the value of the collateral (after deducting for \"haircut\") must exceed the cash consideration by 2%."
  },
  {
    "tag": "899",
    "name": "MarginExcess",
    "type": "Amt",
    "description": "Excess margin amount (deficit if value is negative)"
  },
  {
    "tag": "900",
    "name": "TotalNetValue",
    "type": "Amt",
    "description": "TotalNetValue is determined as follows:\nAt the initial collateral assignment TotalNetValue is the sum of (UnderlyingStartValue * (1-haircut)).\nIn a collateral substitution TotalNetValue is the sum of (UnderlyingCurrentValue * (1-haircut)).\nFor listed derivatives clearing margin management, this is the collateral value which equals (Market value * haircut)"
  },
  {
    "tag": "901",
    "name": "CashOutstanding",
    "type": "Amt",
    "description": "Starting consideration less repayments"
  },
  {
    "tag": "902",
    "name": "CollAsgnID",
    "type": "String",
    "description": "Collateral Assignment Identifier"
  },
  {
    "tag": "903",
    "name": "CollAsgnTransType",
    "type": "int",
    "description": "Collateral Assignment Transaction Type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "2",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "3",
        "symbolicName": "Release",
        "description": "Release"
      },
      {
        "value": "4",
        "symbolicName": "Reverse",
        "description": "Reverse"
      }
    ]
  },
  {
    "tag": "904",
    "name": "CollRespID",
    "type": "String",
    "description": "Collateral Response Identifier"
  },
  {
    "tag": "905",
    "name": "CollAsgnRespType",
    "type": "int",
    "description": "Collateral Assignment Response Type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Received",
        "description": "Received"
      },
      {
        "value": "1",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "2",
        "symbolicName": "Declined",
        "description": "Declined"
      },
      {
        "value": "3",
        "symbolicName": "Rejected",
        "description": "Rejected"
      }
    ]
  },
  {
    "tag": "906",
    "name": "CollAsgnRejectReason",
    "type": "int",
    "description": "Collateral Assignment Reject Reason",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnknownDeal",
        "description": "Unknown deal (order / trade)"
      },
      {
        "value": "1",
        "symbolicName": "UnknownOrInvalidInstrument",
        "description": "Unknown or invalid instrument"
      },
      {
        "value": "2",
        "symbolicName": "UnauthorizedTransaction",
        "description": "Unauthorized transaction"
      },
      {
        "value": "3",
        "symbolicName": "InsufficientCollateral",
        "description": "Insufficient collateral"
      },
      {
        "value": "4",
        "symbolicName": "InvalidTypeOfCollateral",
        "description": "Invalid type of collateral"
      },
      {
        "value": "5",
        "symbolicName": "ExcessiveSubstitution",
        "description": "Excessive substitution"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "907",
    "name": "CollAsgnRefID",
    "type": "String",
    "description": "Collateral Assignment Identifier to which a transaction refers"
  },
  {
    "tag": "908",
    "name": "CollRptID",
    "type": "String",
    "description": "Collateral Report Identifier"
  },
  {
    "tag": "909",
    "name": "CollInquiryID",
    "type": "String",
    "description": "Collateral Inquiry Identifier"
  },
  {
    "tag": "910",
    "name": "CollStatus",
    "type": "int",
    "description": "Collateral Status",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Unassigned",
        "description": "Unassigned"
      },
      {
        "value": "1",
        "symbolicName": "PartiallyAssigned",
        "description": "Partially Assigned"
      },
      {
        "value": "2",
        "symbolicName": "AssignmentProposed",
        "description": "Assignment Proposed"
      },
      {
        "value": "3",
        "symbolicName": "Assigned",
        "description": "Assigned (Accepted)"
      },
      {
        "value": "4",
        "symbolicName": "Challenged",
        "description": "Challenged"
      }
    ]
  },
  {
    "tag": "911",
    "name": "TotNumReports",
    "type": "int",
    "description": "Total number of reports returned in response to a request."
  },
  {
    "tag": "912",
    "name": "LastRptRequested",
    "type": "Boolean",
    "description": "Indicates whether this message is that last report message in response to a request, such as Order Mass Status Request.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotLastMessage",
        "description": "Not last message"
      },
      {
        "value": "Y",
        "symbolicName": "LastMessage",
        "description": "Last message"
      }
    ]
  },
  {
    "tag": "913",
    "name": "AgreementDesc",
    "type": "String",
    "description": "The full name of the base standard agreement, annexes and amendments in place between the principals applicable to a financing transaction."
  },
  {
    "tag": "914",
    "name": "AgreementID",
    "type": "String",
    "description": "A common reference to the applicable standing agreement between the counterparties to a financing transaction."
  },
  {
    "tag": "915",
    "name": "AgreementDate",
    "type": "LocalMktDate",
    "description": "A reference to the date the underlying agreement specified by AgreementID and AgreementDesc was executed."
  },
  {
    "tag": "916",
    "name": "StartDate",
    "type": "LocalMktDate",
    "description": "Start date of a financing deal, i.e. the date the buyer pays the seller cash and takes control of the collateral"
  },
  {
    "tag": "917",
    "name": "EndDate",
    "type": "LocalMktDate",
    "description": "End date of a financing deal, i.e. the date the seller reimburses the buyer and takes back control of the collateral"
  },
  {
    "tag": "918",
    "name": "AgreementCurrency",
    "type": "Currency",
    "description": "Contractual currency forming the basis of a financing agreement and associated transactions. Usually, but not always, the same as the trade currency."
  },
  {
    "tag": "919",
    "name": "DeliveryType",
    "type": "int",
    "description": "Identifies type of settlement",
    "enum": [
      {
        "value": "0",
        "symbolicName": "VersusPayment",
        "description": "\"Versus Payment\": Deliver (if sell) or Receive (if buy) vs. (against) Payment"
      },
      {
        "value": "1",
        "symbolicName": "Free",
        "description": "\"Free\": Deliver (if sell) or Receive (if buy) Free"
      },
      {
        "value": "2",
        "symbolicName": "TriParty",
        "description": "Tri-Party"
      },
      {
        "value": "3",
        "symbolicName": "HoldInCustody",
        "description": "Hold In Custody"
      }
    ]
  },
  {
    "tag": "920",
    "name": "EndAccruedInterestAmt",
    "type": "Amt",
    "description": "Accrued Interest Amount applicable to a financing transaction on the End Date."
  },
  {
    "tag": "921",
    "name": "StartCash",
    "type": "Amt",
    "description": "Starting dirty cash consideration of a financing deal, i.e. paid to the seller on the Start Date."
  },
  {
    "tag": "922",
    "name": "EndCash",
    "type": "Amt",
    "description": "Ending dirty cash consideration of a financing deal. i.e. reimbursed to the buyer on the End Date."
  },
  {
    "tag": "923",
    "name": "UserRequestID",
    "type": "String",
    "description": "Unique identifier for a User Request."
  },
  {
    "tag": "924",
    "name": "UserRequestType",
    "type": "int",
    "description": "Indicates the action required by a User Request Message",
    "enum": [
      {
        "value": "1",
        "symbolicName": "LogOnUser",
        "description": "Log On User"
      },
      {
        "value": "2",
        "symbolicName": "LogOffUser",
        "description": "Log Off User"
      },
      {
        "value": "3",
        "symbolicName": "ChangePasswordForUser",
        "description": "Change Password For User"
      },
      {
        "value": "4",
        "symbolicName": "RequestIndividualUserStatus",
        "description": "Request Individual User Status"
      }
    ]
  },
  {
    "tag": "925",
    "name": "NewPassword",
    "type": "String",
    "description": "New Password or passphrase"
  },
  {
    "tag": "926",
    "name": "UserStatus",
    "type": "int",
    "description": "Indicates the status of a user",
    "enum": [
      {
        "value": "1",
        "symbolicName": "LoggedIn",
        "description": "Logged In"
      },
      {
        "value": "2",
        "symbolicName": "NotLoggedIn",
        "description": "Not Logged In"
      },
      {
        "value": "3",
        "symbolicName": "UserNotRecognised",
        "description": "User Not Recognised"
      },
      {
        "value": "4",
        "symbolicName": "PasswordIncorrect",
        "description": "Password Incorrect"
      },
      {
        "value": "5",
        "symbolicName": "PasswordChanged",
        "description": "Password Changed"
      },
      {
        "value": "6",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "7",
        "symbolicName": "ForcedUserLogoutByExchange",
        "description": "Forced user logout by Exchange"
      },
      {
        "value": "8",
        "symbolicName": "SessionShutdownWarning",
        "description": "Session shutdown warning"
      }
    ]
  },
  {
    "tag": "927",
    "name": "UserStatusText",
    "type": "String",
    "description": "A text description associated with a user status."
  },
  {
    "tag": "928",
    "name": "StatusValue",
    "type": "int",
    "description": "Indicates the status of a network connection",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Connected",
        "description": "Connected"
      },
      {
        "value": "2",
        "symbolicName": "NotConnectedUnexpected",
        "description": "Not Connected - down expected up"
      },
      {
        "value": "3",
        "symbolicName": "NotConnectedExpected",
        "description": "Not Connected - down expected down"
      },
      {
        "value": "4",
        "symbolicName": "InProcess",
        "description": "In Process"
      }
    ]
  },
  {
    "tag": "929",
    "name": "StatusText",
    "type": "String",
    "description": "A text description associated with a network status."
  },
  {
    "tag": "930",
    "name": "RefCompID",
    "type": "String",
    "description": "Assigned value used to identify a firm."
  },
  {
    "tag": "931",
    "name": "RefSubID",
    "type": "String",
    "description": "Assigned value used to identify specific elements within a firm."
  },
  {
    "tag": "932",
    "name": "NetworkResponseID",
    "type": "String",
    "description": "Unique identifier for a network response."
  },
  {
    "tag": "933",
    "name": "NetworkRequestID",
    "type": "String",
    "description": "Unique identifier for a network resquest."
  },
  {
    "tag": "934",
    "name": "LastNetworkResponseID",
    "type": "String",
    "description": "Identifier of the previous Network Response message sent to a counterparty, used to allow incremental updates."
  },
  {
    "tag": "935",
    "name": "NetworkRequestType",
    "type": "int",
    "description": "Indicates the type and level of details required for a Network Status Request Message\nBoolean logic applies EG If you want to subscribe for changes to certain id's then UserRequestType =0 (8+2), Snapshot for certain ID's = 9 (8+1)",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Snapshot",
        "description": "Snapshot"
      },
      {
        "value": "2",
        "symbolicName": "Subscribe",
        "description": "Subscribe"
      },
      {
        "value": "4",
        "symbolicName": "StopSubscribing",
        "description": "Stop Subscribing"
      },
      {
        "value": "8",
        "symbolicName": "LevelOfDetail",
        "description": "Level of Detail, then NoCompID's becomes required"
      }
    ]
  },
  {
    "tag": "936",
    "name": "NoCompIDs",
    "type": "NumInGroup",
    "description": "Number of CompID entries in a repeating group."
  },
  {
    "tag": "937",
    "name": "NetworkStatusResponseType",
    "type": "int",
    "description": "Indicates the type of Network Response Message.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Full",
        "description": "Full"
      },
      {
        "value": "2",
        "symbolicName": "IncrementalUpdate",
        "description": "Incremental Update"
      }
    ]
  },
  {
    "tag": "938",
    "name": "NoCollInquiryQualifier",
    "type": "NumInGroup",
    "description": "Number of CollInquiryQualifier entries in a repeating group."
  },
  {
    "tag": "939",
    "name": "TrdRptStatus",
    "type": "int",
    "description": "Trade Report Status",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "1",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "3",
        "symbolicName": "AcceptedWithErrors",
        "description": "Accepted with errors"
      }
    ]
  },
  {
    "tag": "940",
    "name": "AffirmStatus",
    "type": "int",
    "description": "Identifies the status of the ConfirmationAck.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Received",
        "description": "Received"
      },
      {
        "value": "2",
        "symbolicName": "ConfirmRejected",
        "description": "Confirm rejected, i.e. not affirmed"
      },
      {
        "value": "3",
        "symbolicName": "Affirmed",
        "description": "Affirmed"
      }
    ]
  },
  {
    "tag": "941",
    "name": "UnderlyingStrikeCurrency",
    "type": "Currency",
    "description": "Currency in which the strike price of an underlying instrument is denominated"
  },
  {
    "tag": "942",
    "name": "LegStrikeCurrency",
    "type": "Currency",
    "description": "Currency in which the strike price of a instrument leg of a multileg instrument is denominated"
  },
  {
    "tag": "943",
    "name": "TimeBracket",
    "type": "String",
    "description": "A code that represents a time interval in which a fill or trade occurred.\nRequired for US futures markets."
  },
  {
    "tag": "944",
    "name": "CollAction",
    "type": "int",
    "description": "Action proposed for an Underlying Instrument instance.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Retain",
        "description": "Retain"
      },
      {
        "value": "1",
        "symbolicName": "Add",
        "description": "Add"
      },
      {
        "value": "2",
        "symbolicName": "Remove",
        "description": "Remove"
      }
    ]
  },
  {
    "tag": "945",
    "name": "CollInquiryStatus",
    "type": "int",
    "description": "Status of Collateral Inquiry",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "1",
        "symbolicName": "AcceptedWithWarnings",
        "description": "Accepted With Warnings"
      },
      {
        "value": "2",
        "symbolicName": "Completed",
        "description": "Completed"
      },
      {
        "value": "3",
        "symbolicName": "CompletedWithWarnings",
        "description": "Completed With Warnings"
      },
      {
        "value": "4",
        "symbolicName": "Rejected",
        "description": "Rejected"
      }
    ]
  },
  {
    "tag": "946",
    "name": "CollInquiryResult",
    "type": "int",
    "description": "Result returned in response to Collateral Inquiry\n4000+ Reserved and available for bi-laterally agreed upon user-defined values",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Successful",
        "description": "Successful (default)"
      },
      {
        "value": "1",
        "symbolicName": "InvalidOrUnknownInstrument",
        "description": "Invalid or unknown instrument"
      },
      {
        "value": "2",
        "symbolicName": "InvalidOrUnknownCollateralType",
        "description": "Invalid or unknown collateral type"
      },
      {
        "value": "3",
        "symbolicName": "InvalidParties",
        "description": "Invalid Parties"
      },
      {
        "value": "4",
        "symbolicName": "InvalidTransportTypeRequested",
        "description": "Invalid Transport Type requested"
      },
      {
        "value": "5",
        "symbolicName": "InvalidDestinationRequested",
        "description": "Invalid Destination requested"
      },
      {
        "value": "6",
        "symbolicName": "NoCollateralFoundForTheTradeSpecified",
        "description": "No collateral found for the trade specified"
      },
      {
        "value": "7",
        "symbolicName": "NoCollateralFoundForTheOrderSpecified",
        "description": "No collateral found for the order specified"
      },
      {
        "value": "8",
        "symbolicName": "CollateralInquiryTypeNotSupported",
        "description": "Collateral inquiry type not supported"
      },
      {
        "value": "9",
        "symbolicName": "UnauthorizedForCollateralInquiry",
        "description": "Unauthorized for collateral inquiry"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other (further information in Text (58) field)"
      }
    ]
  },
  {
    "tag": "947",
    "name": "StrikeCurrency",
    "type": "Currency",
    "description": "Currency in which the StrikePrice is denominated."
  },
  {
    "tag": "948",
    "name": "NoNested3PartyIDs",
    "type": "NumInGroup",
    "description": "Number of Nested3PartyID (949), Nested3PartyIDSource (950), and Nested3PartyRole (95) entries"
  },
  {
    "tag": "949",
    "name": "Nested3PartyID",
    "type": "String",
    "description": "PartyID value within a \"third instance\" Nested repeating group.\nSame values as PartyID (448)"
  },
  {
    "tag": "950",
    "name": "Nested3PartyIDSource",
    "type": "char",
    "description": "PartyIDSource value within a \"third instance\" Nested repeating group.\nSame values as PartyIDSource (447)"
  },
  {
    "tag": "951",
    "name": "Nested3PartyRole",
    "type": "int",
    "description": "PartyRole value within a \"third instance\" Nested repeating group.\nSame values as PartyRole (452)"
  },
  {
    "tag": "952",
    "name": "NoNested3PartySubIDs",
    "type": "NumInGroup",
    "description": "Number of Nested3PartySubIDs (953) entries"
  },
  {
    "tag": "953",
    "name": "Nested3PartySubID",
    "type": "String",
    "description": "PartySubID value within a \"third instance\" Nested repeating group.\nSame values as PartySubID (523)"
  },
  {
    "tag": "954",
    "name": "Nested3PartySubIDType",
    "type": "int",
    "description": "PartySubIDType value within a \"third instance\" Nested repeating group.\nSame values as PartySubIDType (803)"
  },
  {
    "tag": "955",
    "name": "LegContractSettlMonth",
    "type": "MonthYear",
    "description": "Specifies when the contract (i.e. MBS/TBA) will settle."
  },
  {
    "tag": "956",
    "name": "LegInterestAccrualDate",
    "type": "LocalMktDate",
    "description": "The start date used for calculating accrued interest on debt instruments which are being sold between interest payment dates. Often but not always the same as the Issue Date and the Dated Date"
  },
  {
    "tag": "957",
    "name": "NoStrategyParameters",
    "type": "NumInGroup",
    "description": "Indicates number of strategy parameters"
  },
  {
    "tag": "958",
    "name": "StrategyParameterName",
    "type": "String",
    "description": "Name of parameter"
  },
  {
    "tag": "959",
    "name": "StrategyParameterType",
    "type": "int",
    "description": "Datatype of the parameter",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Int",
        "description": "Int"
      },
      {
        "value": "2",
        "symbolicName": "Length",
        "description": "Length"
      },
      {
        "value": "3",
        "symbolicName": "NumInGroup",
        "description": "NumInGroup"
      },
      {
        "value": "4",
        "symbolicName": "SeqNum",
        "description": "SeqNum"
      },
      {
        "value": "5",
        "symbolicName": "TagNum",
        "description": "TagNum"
      },
      {
        "value": "6",
        "symbolicName": "Float",
        "description": "float"
      },
      {
        "value": "7",
        "symbolicName": "Qty",
        "description": "Qty"
      },
      {
        "value": "8",
        "symbolicName": "Price",
        "description": "Price"
      },
      {
        "value": "9",
        "symbolicName": "PriceOffset",
        "description": "PriceOffset"
      },
      {
        "value": "10",
        "symbolicName": "Amt",
        "description": "Amt"
      },
      {
        "value": "11",
        "symbolicName": "Percentage",
        "description": "Percentage"
      },
      {
        "value": "12",
        "symbolicName": "Char",
        "description": "Char"
      },
      {
        "value": "13",
        "symbolicName": "Boolean",
        "description": "Boolean"
      },
      {
        "value": "14",
        "symbolicName": "String",
        "description": "String"
      },
      {
        "value": "15",
        "symbolicName": "MultipleCharValue",
        "description": "MultipleCharValue"
      },
      {
        "value": "16",
        "symbolicName": "Currency",
        "description": "Currency"
      },
      {
        "value": "17",
        "symbolicName": "Exchange",
        "description": "Exchange"
      },
      {
        "value": "18",
        "symbolicName": "MonthYear",
        "description": "MonthYear"
      },
      {
        "value": "19",
        "symbolicName": "UTCTimestamp",
        "description": "UTCTimestamp"
      },
      {
        "value": "20",
        "symbolicName": "UTCTimeOnly",
        "description": "UTCTimeOnly"
      },
      {
        "value": "21",
        "symbolicName": "LocalMktDate",
        "description": "LocalMktDate"
      },
      {
        "value": "22",
        "symbolicName": "UTCDateOnly",
        "description": "UTCDateOnly"
      },
      {
        "value": "23",
        "symbolicName": "Data",
        "description": "data"
      },
      {
        "value": "24",
        "symbolicName": "MultipleStringValue",
        "description": "MultipleStringValue"
      },
      {
        "value": "25",
        "symbolicName": "Country",
        "description": "Country"
      },
      {
        "value": "26",
        "symbolicName": "Language",
        "description": "Language"
      },
      {
        "value": "27",
        "symbolicName": "TZTimeOnly",
        "description": "TZTimeOnly"
      },
      {
        "value": "28",
        "symbolicName": "TZTimestamp",
        "description": "TZTimestamp"
      },
      {
        "value": "29",
        "symbolicName": "Tenor",
        "description": "Tenor"
      }
    ]
  },
  {
    "tag": "960",
    "name": "StrategyParameterValue",
    "type": "String",
    "description": "Value of the parameter"
  },
  {
    "tag": "961",
    "name": "HostCrossID",
    "type": "String",
    "description": "Host assigned entity ID that can be used to reference all components of a cross; sides + strategy + legs. Used as the primary key with which to refer to the Cross Order for cancellation and replace. The HostCrossID will also be used to link together components of the Cross Order. For example, each individual Execution Report associated with the order will carry HostCrossID in order to tie back to the original cross order."
  },
  {
    "tag": "962",
    "name": "SideTimeInForce",
    "type": "UTCTimestamp",
    "description": "Indicates how long the order as specified in the side stays in effect. SideTimeInForce allows a two-sided cross order to specify order behavior separately for each side. Absence of this field indicates that TimeInForce should be referenced. SideTimeInForce will override TimeInForce if both are provided."
  },
  {
    "tag": "963",
    "name": "MDReportID",
    "type": "int",
    "description": "Unique identifier for the Market Data Report."
  },
  {
    "tag": "964",
    "name": "SecurityReportID",
    "type": "int",
    "description": "Identifies a Security List message."
  },
  {
    "tag": "965",
    "name": "SecurityStatus",
    "type": "String",
    "description": "Used for derivatives. Denotes the current state of the Instrument.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Active",
        "description": "Active"
      },
      {
        "value": "2",
        "symbolicName": "Inactive",
        "description": "Inactive"
      }
    ]
  },
  {
    "tag": "966",
    "name": "SettleOnOpenFlag",
    "type": "String",
    "description": "Indicator to determine if instrument is settle on open"
  },
  {
    "tag": "967",
    "name": "StrikeMultiplier",
    "type": "float",
    "description": "Used for derivatives. Multiplier applied to the strike price for the purpose of calculating the settlement value."
  },
  {
    "tag": "968",
    "name": "StrikeValue",
    "type": "float",
    "description": "Used for derivatives. The number of shares/units for the financial instrument involved in the option trade."
  },
  {
    "tag": "969",
    "name": "MinPriceIncrement",
    "type": "float",
    "description": "Minimum price increase for a given exchange-traded Instrument"
  },
  {
    "tag": "970",
    "name": "PositionLimit",
    "type": "int",
    "description": "Position Limit for a given exchange-traded product."
  },
  {
    "tag": "971",
    "name": "NTPositionLimit",
    "type": "int",
    "description": "Position Limit in the near-term contract for a given exchange-traded product."
  },
  {
    "tag": "972",
    "name": "UnderlyingAllocationPercent",
    "type": "Percentage",
    "description": "Percent of the Strike Price that this underlying represents."
  },
  {
    "tag": "973",
    "name": "UnderlyingCashAmount",
    "type": "Amt",
    "description": "Cash amount associated with the underlying component."
  },
  {
    "tag": "974",
    "name": "UnderlyingCashType",
    "type": "String",
    "description": "Used for derivatives that deliver into cash underlying.",
    "enum": [
      {
        "value": "FIXED",
        "symbolicName": "FIXED",
        "description": "FIXED"
      },
      {
        "value": "DIFF",
        "symbolicName": "DIFF",
        "description": "DIFF"
      }
    ]
  },
  {
    "tag": "975",
    "name": "UnderlyingSettlementType",
    "type": "int",
    "description": "Indicates order settlement period for the underlying instrument.",
    "enum": [
      {
        "value": "2",
        "symbolicName": "TPlus1",
        "description": "T+1"
      },
      {
        "value": "4",
        "symbolicName": "TPlus3",
        "description": "T+3"
      },
      {
        "value": "5",
        "symbolicName": "TPlus4",
        "description": "T+4"
      }
    ]
  },
  {
    "tag": "976",
    "name": "QuantityDate",
    "type": "LocalMktDate",
    "description": "Date associated to the quantity that is being reported for the position."
  },
  {
    "tag": "977",
    "name": "ContIntRptID",
    "type": "String",
    "description": "Unique identifier for the Contrary Intention report"
  },
  {
    "tag": "978",
    "name": "LateIndicator",
    "type": "Boolean",
    "description": "Indicates if the contrary intention was received after the exchange imposed cutoff time"
  },
  {
    "tag": "979",
    "name": "InputSource",
    "type": "String",
    "description": "Source of the contrary intention"
  },
  {
    "tag": "980",
    "name": "SecurityUpdateAction",
    "type": "char",
    "description": "",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Add",
        "description": "Add"
      },
      {
        "value": "D",
        "symbolicName": "Delete",
        "description": "Delete"
      },
      {
        "value": "M",
        "symbolicName": "Modify",
        "description": "Modify"
      }
    ]
  },
  {
    "tag": "981",
    "name": "NoExpiration",
    "type": "NumInGroup",
    "description": "Number of Expiration Qty entries"
  },
  {
    "tag": "982",
    "name": "ExpirationQtyType",
    "type": "int",
    "description": "Expiration Quantity type",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AutoExercise",
        "description": "Auto Exercise"
      },
      {
        "value": "2",
        "symbolicName": "NonAutoExercise",
        "description": "Non Auto Exercise"
      },
      {
        "value": "3",
        "symbolicName": "FinalWillBeExercised",
        "description": "Final Will Be Exercised"
      },
      {
        "value": "4",
        "symbolicName": "ContraryIntention",
        "description": "Contrary Intention"
      },
      {
        "value": "5",
        "symbolicName": "Difference",
        "description": "Difference"
      }
    ]
  },
  {
    "tag": "983",
    "name": "ExpQty",
    "type": "Qty",
    "description": "Expiration Quantity associated with the Expiration Type"
  },
  {
    "tag": "984",
    "name": "NoUnderlyingAmounts",
    "type": "NumInGroup",
    "description": "Total number of occurrences of Amount to pay in order to receive the underlying instrument"
  },
  {
    "tag": "985",
    "name": "UnderlyingPayAmount",
    "type": "Amt",
    "description": "Amount to pay in order to receive the underlying instrument"
  },
  {
    "tag": "986",
    "name": "UnderlyingCollectAmount",
    "type": "Amt",
    "description": "Amount to collect in order to deliver the underlying instrument"
  },
  {
    "tag": "987",
    "name": "UnderlyingSettlementDate",
    "type": "LocalMktDate",
    "description": "Date the underlying instrument will settle. Used for derivatives that deliver into more than one underlying instrument. Settlement dates can vary across underlying instruments."
  },
  {
    "tag": "988",
    "name": "UnderlyingSettlementStatus",
    "type": "String",
    "description": "Settlement status of the underlying instrument. Used for derivatives that deliver into more than one underlying instrument. Settlement can be delayed for an underlying instrument."
  },
  {
    "tag": "989",
    "name": "SecondaryIndividualAllocID",
    "type": "String",
    "description": "Will allow the intermediary to specify an allocation ID generated by their system."
  },
  {
    "tag": "990",
    "name": "LegReportID",
    "type": "String",
    "description": "Additional attribute to store the Trade ID of the Leg."
  },
  {
    "tag": "991",
    "name": "RndPx",
    "type": "Price",
    "description": "Specifies average price rounded to quoted precision."
  },
  {
    "tag": "992",
    "name": "IndividualAllocType",
    "type": "int",
    "description": "Identifies whether the allocation is to be sub-allocated or allocated to a third party",
    "enum": [
      {
        "value": "1",
        "symbolicName": "SubAllocate",
        "description": "Sub Allocate"
      },
      {
        "value": "2",
        "symbolicName": "ThirdPartyAllocation",
        "description": "Third Party Allocation"
      }
    ]
  },
  {
    "tag": "993",
    "name": "AllocCustomerCapacity",
    "type": "String",
    "description": "Capacity of customer in the allocation block."
  },
  {
    "tag": "994",
    "name": "TierCode",
    "type": "String",
    "description": "The Tier the trade was matched by the clearing system."
  },
  {
    "tag": "996",
    "name": "UnitOfMeasure",
    "type": "String",
    "description": "The unit of measure of the underlying commodity upon which the contract is based. Two groups of units of measure enumerations are supported.\nFixed Magnitude UOMs are primarily used in energy derivatives and specify a magnitude (such as, MM, Kilo, M, etc.) and the dimension (such as, watt hours, BTU's) to produce standard fixed measures (such as MWh - Megawatt-hours, MMBtu - One million BTUs).\nThe second group, Variable Quantity UOMs, specifies the dimension as a single unit without a magnitude (or more accurately a magnitude of one) and uses the UnitOfMeasureQty(1147) field to define the quantity of units per contract. Variable Quantity UOMs are used for both commodities (such as lbs of lean cattle, bushels of corn, ounces of gold) and financial futures.\nExamples:\nFor lean cattle futures contracts, a UnitOfMeasure of 'lbs' with a UnitOfMeasureQty(1147) of 40,000, means each lean cattle futures contract represents 40,000 lbs of lean cattle.\nFor Eurodollars futures contracts, a UnitOfMeasure of USD with a UnitOfMeasureQty(1147) of 1,000,000, means a Eurodollar futures contract represents 1,000,000 USD.\nFor gold futures contracts, a UnitOfMeasure is oz_tr (Troy ounce) with a UnitOfMeasureQty(1147) of 1,000, means each gold futures contract represents 1,000 troy ounces of gold.",
    "enum": [
      {
        "value": "Bcf",
        "symbolicName": "BillionCubicFeet",
        "description": "Billion cubic feet"
      },
      {
        "value": "MMbbl",
        "symbolicName": "MillionBarrels",
        "description": "Million Barrels"
      },
      {
        "value": "MMBtu",
        "symbolicName": "OneMillionBTU",
        "description": "One Million BTU"
      },
      {
        "value": "MWh",
        "symbolicName": "MegawattHours",
        "description": "Megawatt hours"
      },
      {
        "value": "Bbl",
        "symbolicName": "Barrels",
        "description": "Barrels"
      },
      {
        "value": "Bu",
        "symbolicName": "Bushels",
        "description": "Bushels"
      },
      {
        "value": "lbs",
        "symbolicName": "Pounds",
        "description": "pounds"
      },
      {
        "value": "Gal",
        "symbolicName": "Gallons",
        "description": "Gallons"
      },
      {
        "value": "oz_tr",
        "symbolicName": "TroyOunces",
        "description": "Troy Ounces"
      },
      {
        "value": "t",
        "symbolicName": "MetricTons",
        "description": "Metric Tons (aka Tonne)"
      },
      {
        "value": "tn",
        "symbolicName": "Tons",
        "description": "Tons (US)"
      },
      {
        "value": "USD",
        "symbolicName": "USDollars",
        "description": "US Dollars"
      },
      {
        "value": "Alw",
        "symbolicName": "Allowances",
        "description": "Allowances"
      }
    ]
  },
  {
    "tag": "997",
    "name": "TimeUnit",
    "type": "String",
    "description": "Unit of time associated with the contract.\nNOTE: Additional values may be used by mutual agreement of the counterparties",
    "enum": [
      {
        "value": "H",
        "symbolicName": "Hour",
        "description": "Hour"
      },
      {
        "value": "Min",
        "symbolicName": "Minute",
        "description": "Minute"
      },
      {
        "value": "S",
        "symbolicName": "Second",
        "description": "Second"
      },
      {
        "value": "D",
        "symbolicName": "Day",
        "description": "Day"
      },
      {
        "value": "Wk",
        "symbolicName": "Week",
        "description": "Week"
      },
      {
        "value": "Mo",
        "symbolicName": "Month",
        "description": "Month"
      },
      {
        "value": "Yr",
        "symbolicName": "Year",
        "description": "Year"
      }
    ]
  },
  {
    "tag": "998",
    "name": "UnderlyingUnitOfMeasure",
    "type": "String",
    "description": "Refer to defintion of UnitOfMeasure(996)"
  },
  {
    "tag": "999",
    "name": "LegUnitOfMeasure",
    "type": "String",
    "description": "Refer to defintion of UnitOfMeasure(996)"
  },
  {
    "tag": "1000",
    "name": "UnderlyingTimeUnit",
    "type": "String",
    "description": "Same as TimeUnit."
  },
  {
    "tag": "1001",
    "name": "LegTimeUnit",
    "type": "String",
    "description": "Same as TimeUnit."
  },
  {
    "tag": "1002",
    "name": "AllocMethod",
    "type": "int",
    "description": "Specifies the method under which a trade quantity was allocated.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Automatic",
        "description": "Automatic"
      },
      {
        "value": "2",
        "symbolicName": "Guarantor",
        "description": "Guarantor"
      },
      {
        "value": "3",
        "symbolicName": "Manual",
        "description": "Manual"
      }
    ]
  },
  {
    "tag": "1003",
    "name": "TradeID",
    "type": "String",
    "description": "The unique ID assigned to the trade entity once it is received or matched by the exchange or central counterparty."
  },
  {
    "tag": "1005",
    "name": "SideTradeReportID",
    "type": "String",
    "description": "Used on a multi-sided trade to designate the ReportID"
  },
  {
    "tag": "1006",
    "name": "SideFillStationCd",
    "type": "String",
    "description": "Used on a multi-sided trade to convey order routing information"
  },
  {
    "tag": "1007",
    "name": "SideReasonCd",
    "type": "String",
    "description": "Used on a multi-sided trade to convey reason for execution"
  },
  {
    "tag": "1008",
    "name": "SideTrdSubTyp",
    "type": "int",
    "description": "Used on a multi-sided trade to specify the type of trade for a given side. Same values as TrdSubType (829)."
  },
  {
    "tag": "1009",
    "name": "SideLastQty",
    "type": "int",
    "description": "Used to indicate the quantity on one of a multi-sided Trade Capture Report"
  },
  {
    "tag": "1011",
    "name": "MessageEventSource",
    "type": "String",
    "description": "Used to identify the event or source which gave rise to a message.\nValid values will be based on an exchange's implementation.\nExample values are:\n\"MQM\" (originated at Firm Back Office)\n\"Clear\" (originated in Clearing System)\n\"Reg\" (static data generated via Register request)"
  },
  {
    "tag": "1012",
    "name": "SideTrdRegTimestamp",
    "type": "UTCTimestamp",
    "description": "Will be used in a multi-sided message.\nTraded Regulatory timestamp value Use to store time information required by government regulators or self regulatory organizations such as an exchange or clearing house"
  },
  {
    "tag": "1013",
    "name": "SideTrdRegTimestampType",
    "type": "int",
    "description": "Same as TrdRegTimeStampType"
  },
  {
    "tag": "1014",
    "name": "SideTrdRegTimestampSrc",
    "type": "String",
    "description": "Same as TrdRegTimestampOrigin\nText which identifies the origin i.e. system which was used to generate the time stamp for the Traded Regulatory timestamp value"
  },
  {
    "tag": "1015",
    "name": "AsOfIndicator",
    "type": "char",
    "description": "Used to indicate that a floor-trade was originally submitted \"as of\" a specific trade date which is earlier than its clearing date.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "False",
        "description": "false - trade is not an AsOf trade"
      },
      {
        "value": "1",
        "symbolicName": "True",
        "description": "true - trade is an AsOf trade"
      }
    ]
  },
  {
    "tag": "1016",
    "name": "NoSideTrdRegTS",
    "type": "NumInGroup",
    "description": "Indicates number of SideTimestamps contained in group"
  },
  {
    "tag": "1017",
    "name": "LegOptionRatio",
    "type": "float",
    "description": "Expresses the risk of an option leg\nValue must be between -1 and 1.\nA Call Option will require a ratio value between 0 and 1\nA Put Option will require a ratio value between -1 and 0"
  },
  {
    "tag": "1018",
    "name": "NoInstrumentParties",
    "type": "NumInGroup",
    "description": "Identifies the number of parties identified with an instrument"
  },
  {
    "tag": "1019",
    "name": "InstrumentPartyID",
    "type": "String",
    "description": "PartyID value within an instrument party repeating group. Same values as PartyID (448)"
  },
  {
    "tag": "1020",
    "name": "TradeVolume",
    "type": "Qty",
    "description": "Used to report volume with a trade"
  },
  {
    "tag": "1021",
    "name": "MDBookType",
    "type": "int",
    "description": "Describes the type of book for which the feed is intended. Used when multiple feeds are provided over the same connection",
    "enum": [
      {
        "value": "1",
        "symbolicName": "TopOfBook",
        "description": "Top of Book"
      },
      {
        "value": "2",
        "symbolicName": "PriceDepth",
        "description": "Price Depth"
      },
      {
        "value": "3",
        "symbolicName": "OrderDepth",
        "description": "Order Depth"
      }
    ]
  },
  {
    "tag": "1022",
    "name": "MDFeedType",
    "type": "String",
    "description": "Describes a class of service for a given data feed, ie Regular and Market Maker, Bandwidth Intensive or Bandwidth Conservative"
  },
  {
    "tag": "1023",
    "name": "MDPriceLevel",
    "type": "int",
    "description": "Integer to convey the level of a bid or offer at a given price level. This is in contrast to MDEntryPositionNo which is used to convey the position of an order within a Price level"
  },
  {
    "tag": "1024",
    "name": "MDOriginType",
    "type": "int",
    "description": "Used to describe the origin of an entry in the book",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Book",
        "description": "Book"
      },
      {
        "value": "1",
        "symbolicName": "OffBook",
        "description": "Off-Book"
      },
      {
        "value": "2",
        "symbolicName": "Cross",
        "description": "Cross"
      }
    ]
  },
  {
    "tag": "1025",
    "name": "FirstPx",
    "type": "Price",
    "description": "Indicates the first trade price of the day/session"
  },
  {
    "tag": "1026",
    "name": "MDEntrySpotRate",
    "type": "float",
    "description": "The spot rate for an FX entry"
  },
  {
    "tag": "1027",
    "name": "MDEntryForwardPoints",
    "type": "PriceOffset",
    "description": "Used for an F/X entry. The forward points to be added to or subtracted from the spot rate to get the \"all-in\" rate in MDEntryPx. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "1028",
    "name": "ManualOrderIndicator",
    "type": "Boolean",
    "description": "Indicates if the order was initially received manually (as opposed to electronically)"
  },
  {
    "tag": "1029",
    "name": "CustDirectedOrder",
    "type": "Boolean",
    "description": "Indicates if the customer directed this order to a specific execution venue \"Y\" or not \"N\".\nA default of \"N\" customer did not direct this order should be used in the case where the information is both missing and essential."
  },
  {
    "tag": "1030",
    "name": "ReceivedDeptID",
    "type": "String",
    "description": "Identifies the Broker / Dealer Department that first took the order."
  },
  {
    "tag": "1031",
    "name": "CustOrderHandlingInst",
    "type": "MultipleStringValue",
    "description": "Codes that apply special information that the Broker / Dealer needs to report, as specified by the customer.\nNOTE: This field and its values have no bearing on the ExecInst and TimeInForce fields. These values should not be used instead of ExecInst or TimeInForce. This field and its values are intended for compliance reporting only.\nValid values are grouped by OrderHandlingInstSource(1032).",
    "enum": [
      {
        "value": "ADD",
        "symbolicName": "AddOnOrder",
        "description": "Add-on Order"
      },
      {
        "value": "AON",
        "symbolicName": "AllOrNone",
        "description": "All or None"
      },
      {
        "value": "CNH",
        "symbolicName": "CashNotHeld",
        "description": "Cash Not Held"
      },
      {
        "value": "DIR",
        "symbolicName": "DirectedOrder",
        "description": "Directed Order"
      },
      {
        "value": "E.W",
        "symbolicName": "ExchangeForPhysicalTransaction",
        "description": "Exchange for Physical Transaction"
      },
      {
        "value": "FOK",
        "symbolicName": "FillOrKill",
        "description": "Fill or Kill"
      },
      {
        "value": "IO",
        "symbolicName": "ImbalanceOnly",
        "description": "Imbalance Only"
      },
      {
        "value": "IOC",
        "symbolicName": "ImmediateOrCancel",
        "description": "Immediate or Cancel"
      },
      {
        "value": "LOO",
        "symbolicName": "LimitOnOpen",
        "description": "Limit On Open"
      },
      {
        "value": "LOC",
        "symbolicName": "LimitOnClose",
        "description": "Limit on Close"
      },
      {
        "value": "MAO",
        "symbolicName": "MarketAtOpen",
        "description": "Market at Open"
      },
      {
        "value": "MAC",
        "symbolicName": "MarketAtClose",
        "description": "Market at Close"
      },
      {
        "value": "MOO",
        "symbolicName": "MarketOnOpen",
        "description": "Market on Open"
      },
      {
        "value": "MOC",
        "symbolicName": "MarketOnClose",
        "description": "Market On Close"
      },
      {
        "value": "MQT",
        "symbolicName": "MinimumQuantity",
        "description": "Minimum Quantity"
      },
      {
        "value": "NH",
        "symbolicName": "NotHeld",
        "description": "Not Held"
      },
      {
        "value": "OVD",
        "symbolicName": "OverTheDay",
        "description": "Over the Day"
      },
      {
        "value": "PEG",
        "symbolicName": "Pegged",
        "description": "Pegged"
      },
      {
        "value": "RSV",
        "symbolicName": "ReserveSizeOrder",
        "description": "Reserve Size Order"
      },
      {
        "value": "S.W",
        "symbolicName": "StopStockTransaction",
        "description": "Stop Stock Transaction"
      },
      {
        "value": "SCL",
        "symbolicName": "Scale",
        "description": "Scale"
      },
      {
        "value": "TMO",
        "symbolicName": "TimeOrder",
        "description": "Time Order"
      },
      {
        "value": "TS",
        "symbolicName": "TrailingStop",
        "description": "Trailing Stop"
      },
      {
        "value": "WRK",
        "symbolicName": "Work",
        "description": "Work"
      }
    ]
  },
  {
    "tag": "1032",
    "name": "OrderHandlingInstSource",
    "type": "int",
    "description": "Identifies the class or source of the \"OrderHandlingInst\" values. Scope of this will apply to both CustOrderHandlingInst and DeskOrderHandlingInst fields.\nRequired if CustOrderHandlingInst and/or DeskOrderHandlingInst is specified.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "NASDOATS",
        "description": "NASD OATS"
      }
    ]
  },
  {
    "tag": "1033",
    "name": "DeskType",
    "type": "String",
    "description": "Type of trading desk.  Valid values are grouped by DeskTypeSource(1034).",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Agency",
        "description": "Agency"
      },
      {
        "value": "AR",
        "symbolicName": "Arbitrage",
        "description": "Arbitrage"
      },
      {
        "value": "D",
        "symbolicName": "Derivatives",
        "description": "Derivatives"
      },
      {
        "value": "IN",
        "symbolicName": "International",
        "description": "International"
      },
      {
        "value": "IS",
        "symbolicName": "Institutional",
        "description": "Institutional"
      },
      {
        "value": "O",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "PF",
        "symbolicName": "PreferredTrading",
        "description": "Preferred Trading"
      },
      {
        "value": "PR",
        "symbolicName": "Proprietary",
        "description": "Proprietary"
      },
      {
        "value": "PT",
        "symbolicName": "ProgramTrading",
        "description": "Program Trading"
      },
      {
        "value": "S",
        "symbolicName": "Sales",
        "description": "Sales"
      },
      {
        "value": "T",
        "symbolicName": "Trading",
        "description": "Trading"
      }
    ]
  },
  {
    "tag": "1034",
    "name": "DeskTypeSource",
    "type": "int",
    "description": "Identifies the class or source of DeskType(1033) values. Required if DeskType(1033) is specified.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "NASDOATS",
        "description": "NASD OATS"
      }
    ]
  },
  {
    "tag": "1035",
    "name": "DeskOrderHandlingInst",
    "type": "MultipleStringValue",
    "description": "Codes that apply special information that the Broker / Dealer needs to report.\nNOTE: This field and its values have no bearing on the ExecInst and TimeInForce fields. These values should not be used instead of ExecInst or TimeInForce. This field and its values are intended for compliance reporting only.\nValid values are grouped by OrderHandlingInstSource(1032).",
    "enum": [
      {
        "value": "ADD",
        "symbolicName": "AddOnOrder",
        "description": "Add-on Order"
      },
      {
        "value": "AON",
        "symbolicName": "AllOrNone",
        "description": "All or None"
      },
      {
        "value": "CNH",
        "symbolicName": "CashNotHeld",
        "description": "Cash Not Held"
      },
      {
        "value": "DIR",
        "symbolicName": "DirectedOrder",
        "description": "Directed Order"
      },
      {
        "value": "E.W",
        "symbolicName": "ExchangeForPhysicalTransaction",
        "description": "Exchange for Physical Transaction"
      },
      {
        "value": "FOK",
        "symbolicName": "FillOrKill",
        "description": "Fill or Kill"
      },
      {
        "value": "IO",
        "symbolicName": "ImbalanceOnly",
        "description": "Imbalance Only"
      },
      {
        "value": "IOC",
        "symbolicName": "ImmediateOrCancel",
        "description": "Immediate or Cancel"
      },
      {
        "value": "LOO",
        "symbolicName": "LimitOnOpen",
        "description": "Limit On Open"
      },
      {
        "value": "LOC",
        "symbolicName": "LimitOnClose",
        "description": "Limit on Close"
      },
      {
        "value": "MAO",
        "symbolicName": "MarketAtOpen",
        "description": "Market at Open"
      },
      {
        "value": "MAC",
        "symbolicName": "MarketAtClose",
        "description": "Market at Close"
      },
      {
        "value": "MOO",
        "symbolicName": "MarketOnOpen",
        "description": "Market on Open"
      },
      {
        "value": "MOC",
        "symbolicName": "MarketOnClose",
        "description": "Market On Close"
      },
      {
        "value": "MQT",
        "symbolicName": "MinimumQuantity",
        "description": "Minimum Quantity"
      },
      {
        "value": "NH",
        "symbolicName": "NotHeld",
        "description": "Not Held"
      },
      {
        "value": "OVD",
        "symbolicName": "OverTheDay",
        "description": "Over the Day"
      },
      {
        "value": "PEG",
        "symbolicName": "Pegged",
        "description": "Pegged"
      },
      {
        "value": "RSV",
        "symbolicName": "ReserveSizeOrder",
        "description": "Reserve Size Order"
      },
      {
        "value": "S.W",
        "symbolicName": "StopStockTransaction",
        "description": "Stop Stock Transaction"
      },
      {
        "value": "SCL",
        "symbolicName": "Scale",
        "description": "Scale"
      },
      {
        "value": "TMO",
        "symbolicName": "TimeOrder",
        "description": "Time Order"
      },
      {
        "value": "TS",
        "symbolicName": "TrailingStop",
        "description": "Trailing Stop"
      },
      {
        "value": "WRK",
        "symbolicName": "Work",
        "description": "Work"
      }
    ]
  },
  {
    "tag": "1036",
    "name": "ExecAckStatus",
    "type": "char",
    "description": "The status of this execution acknowledgement message.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Received",
        "description": "Received, not yet processed"
      },
      {
        "value": "1",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "2",
        "symbolicName": "Don",
        "description": "Don't know / Rejected"
      }
    ]
  },
  {
    "tag": "1037",
    "name": "UnderlyingDeliveryAmount",
    "type": "Amt",
    "description": "Indicates the underlying position amount to be delivered"
  },
  {
    "tag": "1038",
    "name": "UnderlyingCapValue",
    "type": "Amt",
    "description": "Maximum notional value for a capped financial instrument"
  },
  {
    "tag": "1039",
    "name": "UnderlyingSettlMethod",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1040",
    "name": "SecondaryTradeID",
    "type": "String",
    "description": "Used to carry an internal trade entity ID which may or may not be reported to the firm"
  },
  {
    "tag": "1041",
    "name": "FirmTradeID",
    "type": "String",
    "description": "The ID assigned to a trade by the Firm to track a trade within the Firm system. This ID can be assigned either before or after submission to the exchange or central counterpary"
  },
  {
    "tag": "1042",
    "name": "SecondaryFirmTradeID",
    "type": "String",
    "description": "Used to carry an internal firm assigned ID which may or may not be reported to the exchange or central counterpary"
  },
  {
    "tag": "1043",
    "name": "CollApplType",
    "type": "int",
    "description": "conveys how the collateral should be/has been applied",
    "enum": [
      {
        "value": "0",
        "symbolicName": "SpecificDeposit",
        "description": "Specific Deposit"
      },
      {
        "value": "1",
        "symbolicName": "General",
        "description": "General"
      }
    ]
  },
  {
    "tag": "1044",
    "name": "UnderlyingAdjustedQuantity",
    "type": "Qty",
    "description": "Unit amount of the underlying security (shares) adjusted for pending corporate action not yet allocated."
  },
  {
    "tag": "1045",
    "name": "UnderlyingFXRate",
    "type": "float",
    "description": "Foreign exchange rate used to compute UnderlyingCurrentValue(885) (or market value) from UnderlyingCurrency(318) to Currency(15)."
  },
  {
    "tag": "1046",
    "name": "UnderlyingFXRateCalc",
    "type": "char",
    "description": "Specifies whether the UnderlyingFxRate(1045) should be multiplied or divided.",
    "enum": [
      {
        "value": "D",
        "symbolicName": "Divide",
        "description": "Divide"
      },
      {
        "value": "M",
        "symbolicName": "Multiply",
        "description": "Multiply"
      }
    ]
  },
  {
    "tag": "1047",
    "name": "AllocPositionEffect",
    "type": "char",
    "description": "Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.",
    "enum": [
      {
        "value": "O",
        "symbolicName": "Open",
        "description": "Open"
      },
      {
        "value": "C",
        "symbolicName": "Close",
        "description": "Close"
      },
      {
        "value": "R",
        "symbolicName": "Rolled",
        "description": "Rolled"
      },
      {
        "value": "F",
        "symbolicName": "FIFO",
        "description": "FIFO"
      }
    ]
  },
  {
    "tag": "1048",
    "name": "DealingCapacity",
    "type": "char",
    "description": "Identifies role of dealer; Agent, Principal, RisklessPrincipal",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Agent",
        "description": "Agent"
      },
      {
        "value": "P",
        "symbolicName": "Principal",
        "description": "Principal"
      },
      {
        "value": "R",
        "symbolicName": "RisklessPrincipal",
        "description": "Riskless Principal"
      }
    ]
  },
  {
    "tag": "1049",
    "name": "InstrmtAssignmentMethod",
    "type": "char",
    "description": "Method under which assignment was conducted",
    "enum": [
      {
        "value": "P",
        "symbolicName": "ProRata",
        "description": "Pro rata"
      },
      {
        "value": "R",
        "symbolicName": "Random",
        "description": "Random"
      }
    ]
  },
  {
    "tag": "1050",
    "name": "InstrumentPartyIDSource",
    "type": "char",
    "description": "PartyIDSource value within an instrument partyrepeating group.\nSame values as PartyIDSource (447)"
  },
  {
    "tag": "1051",
    "name": "InstrumentPartyRole",
    "type": "int",
    "description": "PartyRole value within an instrument partyepeating group.\nSame values as PartyRole (452)"
  },
  {
    "tag": "1052",
    "name": "NoInstrumentPartySubIDs",
    "type": "NumInGroup",
    "description": "Number of InstrumentPartySubID (1053) and InstrumentPartySubIDType (1054) entries"
  },
  {
    "tag": "1053",
    "name": "InstrumentPartySubID",
    "type": "String",
    "description": "PartySubID value within an instrument party repeating group.\nSame values as PartySubID (523)"
  },
  {
    "tag": "1054",
    "name": "InstrumentPartySubIDType",
    "type": "int",
    "description": "Type of InstrumentPartySubID (1053) value.\nSame values as PartySubIDType (803)"
  },
  {
    "tag": "1055",
    "name": "PositionCurrency",
    "type": "String",
    "description": "The Currency in which the position Amount is denominated"
  },
  {
    "tag": "1056",
    "name": "CalculatedCcyLastQty",
    "type": "Qty",
    "description": "Used for the calculated quantity of the other side of the currency trade. Can be derived from LastQty and LastPx."
  },
  {
    "tag": "1057",
    "name": "AggressorIndicator",
    "type": "Boolean",
    "description": "Used to identify whether the order initiator is an aggressor or not in the trade.",
    "enum": [
      {
        "value": "Y",
        "symbolicName": "OrderInitiatorIsAggressor",
        "description": "Order initiator is aggressor"
      },
      {
        "value": "N",
        "symbolicName": "OrderInitiatorIsPassive",
        "description": "Order initiator is passive"
      }
    ]
  },
  {
    "tag": "1058",
    "name": "NoUndlyInstrumentParties",
    "type": "NumInGroup",
    "description": "Identifies the number of parties identified with an underlying instrument"
  },
  {
    "tag": "1059",
    "name": "UnderlyingInstrumentPartyID",
    "type": "String",
    "description": "PartyID value within an underlying instrument party repeating group.\nSame values as PartyID (448)"
  },
  {
    "tag": "1060",
    "name": "UnderlyingInstrumentPartyIDSource",
    "type": "char",
    "description": "PartyIDSource value within an underlying instrument partyrepeating group.\nSame values as PartyIDSource (447)"
  },
  {
    "tag": "1061",
    "name": "UnderlyingInstrumentPartyRole",
    "type": "int",
    "description": "PartyRole value within an underlying instrument partyepeating group.\nSame values as PartyRole (452)"
  },
  {
    "tag": "1062",
    "name": "NoUndlyInstrumentPartySubIDs",
    "type": "NumInGroup",
    "description": "Number of Underlying InstrumentPartySubID (1053) and InstrumentPartySubIDType (1054) entries"
  },
  {
    "tag": "1063",
    "name": "UnderlyingInstrumentPartySubID",
    "type": "String",
    "description": "PartySubID value within an underlying instrument party repeating group.\nSame values as PartySubID (523)"
  },
  {
    "tag": "1064",
    "name": "UnderlyingInstrumentPartySubIDType",
    "type": "int",
    "description": "Type of underlying InstrumentPartySubID (1053) value.\nSame values as PartySubIDType (803)"
  },
  {
    "tag": "1065",
    "name": "BidSwapPoints",
    "type": "PriceOffset",
    "description": "The bid FX Swap points for an FX Swap. It is the \"far bid forward points - near offer forward point\". Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "1066",
    "name": "OfferSwapPoints",
    "type": "PriceOffset",
    "description": "The offer FX Swap points for an FX Swap. It is the \"far offer forward points - near bid forward points\". Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "1067",
    "name": "LegBidForwardPoints",
    "type": "PriceOffset",
    "description": "The bid FX forward points for the leg of an FX Swap. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "1068",
    "name": "LegOfferForwardPoints",
    "type": "PriceOffset",
    "description": "The offer FX forward points for the leg of an FX Swap. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "1069",
    "name": "SwapPoints",
    "type": "PriceOffset",
    "description": "For FX Swap, this is used to express the differential between the far leg's bid/offer and the near leg's bid/offer. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "1070",
    "name": "MDQuoteType",
    "type": "int",
    "description": "Identifies market data quote type.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Indicative",
        "description": "Indicative"
      },
      {
        "value": "1",
        "symbolicName": "Tradeable",
        "description": "Tradeable"
      },
      {
        "value": "2",
        "symbolicName": "RestrictedTradeable",
        "description": "Restricted Tradeable"
      },
      {
        "value": "3",
        "symbolicName": "Counter",
        "description": "Counter"
      },
      {
        "value": "4",
        "symbolicName": "IndicativeAndTradeable",
        "description": "Indicative and Tradeable"
      }
    ]
  },
  {
    "tag": "1071",
    "name": "LastSwapPoints",
    "type": "PriceOffset",
    "description": "For FX Swap, this is used to express the last market event for the differential between the far leg's bid/offer and the near leg's bid/offer in a fill or partial fill. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "1072",
    "name": "SideGrossTradeAmt",
    "type": "Amt",
    "description": "The gross trade amount for this side of the trade. See also GrossTradeAmt (381) for additional definition."
  },
  {
    "tag": "1073",
    "name": "LegLastForwardPoints",
    "type": "PriceOffset",
    "description": "The forward points for this leg's fill event. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199"
  },
  {
    "tag": "1074",
    "name": "LegCalculatedCcyLastQty",
    "type": "Qty",
    "description": "Used for the calculated quantity of the other side of the currency for this leg. Can be derived from LegQty and LegLastPx."
  },
  {
    "tag": "1075",
    "name": "LegGrossTradeAmt",
    "type": "Amt",
    "description": "The gross trade amount of the leg. For FX Futures this is used to express the notional value of a fill when LegLastQty and other quantity fields are express in terms of contract size."
  },
  {
    "tag": "1079",
    "name": "MaturityTime",
    "type": "TZTimeOnly",
    "description": "Time of security's maturity expressed in local time with offset to UTC specified"
  },
  {
    "tag": "1080",
    "name": "RefOrderID",
    "type": "String",
    "description": "The ID reference to the order being hit or taken"
  },
  {
    "tag": "1081",
    "name": "RefOrderIDSource",
    "type": "char",
    "description": "Used to specify what identifier, provided in order depth market data, to use when hitting (taking) a specific order.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "SecondaryOrderID",
        "description": "SecondaryOrderID(198)"
      },
      {
        "value": "1",
        "symbolicName": "OrderID",
        "description": "OrderID(37)"
      },
      {
        "value": "2",
        "symbolicName": "MDEntryID",
        "description": "MDEntryID(278)"
      },
      {
        "value": "3",
        "symbolicName": "QuoteEntryID",
        "description": "QuoteEntryID(299)"
      },
      {
        "value": "4",
        "symbolicName": "OriginalOrderID",
        "description": "Original order ID"
      }
    ]
  },
  {
    "tag": "1082",
    "name": "SecondaryDisplayQty",
    "type": "Qty",
    "description": "Used for reserve orders when DisplayQty applies to the primary execution market (e.g.an ECN) and another quantity is to be shown at other markets (e.g. the exchange). On orders specifies the qty to be displayed, on execution reports the currently displayed quantity."
  },
  {
    "tag": "1083",
    "name": "DisplayWhen",
    "type": "char",
    "description": "Instructs when to refresh DisplayQty (1138).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Immediate",
        "description": "Immediate (after each fill)"
      },
      {
        "value": "2",
        "symbolicName": "Exhaust",
        "description": "Exhaust (when DisplayQty = 0)"
      }
    ]
  },
  {
    "tag": "1084",
    "name": "DisplayMethod",
    "type": "char",
    "description": "Defines what value to use in DisplayQty (1138). If not specified the default DisplayMethod is \"1\"",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Initial",
        "description": "Initial (use original DisplayQty)"
      },
      {
        "value": "2",
        "symbolicName": "New",
        "description": "New (use RefreshQty)"
      },
      {
        "value": "3",
        "symbolicName": "Random",
        "description": "Random (randomize value)"
      },
      {
        "value": "4",
        "symbolicName": "Undisclosed",
        "description": "Undisclosed (invisible order)"
      }
    ]
  },
  {
    "tag": "1085",
    "name": "DisplayLowQty",
    "type": "Qty",
    "description": "Defines the lower quantity limit to a randomized refresh of DisplayQty."
  },
  {
    "tag": "1086",
    "name": "DisplayHighQty",
    "type": "Qty",
    "description": "Defines the upper quantity limit to a randomized refresh of DisplayQty."
  },
  {
    "tag": "1087",
    "name": "DisplayMinIncr",
    "type": "Qty",
    "description": "Defines the minimum increment to be used when calculating a random refresh of DisplayQty. A user specifies this when he wants a larger increment than the standard provided by the market (e.g. the round lot size)."
  },
  {
    "tag": "1088",
    "name": "RefreshQty",
    "type": "Qty",
    "description": "Defines the quantity used to refresh DisplayQty."
  },
  {
    "tag": "1089",
    "name": "MatchIncrement",
    "type": "Qty",
    "description": "Allows orders to specify a minimum quantity that applies to every execution (one execution could be for multiple counter-orders). The order may still fill against smaller orders, but the cumulative quantity of the execution must be in multiples of the MatchIncrement."
  },
  {
    "tag": "1090",
    "name": "MaxPriceLevels",
    "type": "int",
    "description": "Allows an order to specify a maximum number of price levels to trade through. Only valid for aggressive orders and during continuous (autoexecution) trading sessions. Property lost when order is put on book. A partially filled order is assigned last trade price as limit price. Non-filled order behaves as ordinary Market or Limit."
  },
  {
    "tag": "1091",
    "name": "PreTradeAnonymity",
    "type": "Boolean",
    "description": "Allows trader to explicitly request anonymity or disclosure in pre-trade market data feeds. Anonymity is relevant in markets where counterparties are regularly disclosed in order depth feeds. Disclosure is relevant when counterparties are not normally visible."
  },
  {
    "tag": "1092",
    "name": "PriceProtectionScope",
    "type": "char",
    "description": "Defines the type of price protection the customer requires on their order.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "None"
      },
      {
        "value": "1",
        "symbolicName": "Local",
        "description": "Local (Exchange, ECN, ATS)"
      },
      {
        "value": "2",
        "symbolicName": "National",
        "description": "National (Across all national markets)"
      },
      {
        "value": "3",
        "symbolicName": "Global",
        "description": "Global (Across all markets)"
      }
    ]
  },
  {
    "tag": "1093",
    "name": "LotType",
    "type": "char",
    "description": "Defines the lot type assigned to the order.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OddLot",
        "description": "Odd Lot"
      },
      {
        "value": "2",
        "symbolicName": "RoundLot",
        "description": "Round Lot"
      },
      {
        "value": "3",
        "symbolicName": "BlockLot",
        "description": "Block Lot"
      },
      {
        "value": "4",
        "symbolicName": "RoundLotBasedUpon",
        "description": "Round lot based upon UnitOfMeasure(996)"
      }
    ]
  },
  {
    "tag": "1094",
    "name": "PegPriceType",
    "type": "int",
    "description": "Defines the type of peg.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "LastPeg",
        "description": "Last peg (last sale)"
      },
      {
        "value": "2",
        "symbolicName": "MidPricePeg",
        "description": "Mid-price peg (midprice of inside quote)"
      },
      {
        "value": "3",
        "symbolicName": "OpeningPeg",
        "description": "Opening peg"
      },
      {
        "value": "4",
        "symbolicName": "MarketPeg",
        "description": "Market peg"
      },
      {
        "value": "5",
        "symbolicName": "PrimaryPeg",
        "description": "Primary peg (primary market - buy at bid or sell at offer)"
      },
      {
        "value": "7",
        "symbolicName": "PegToVWAP",
        "description": "Peg to VWAP"
      },
      {
        "value": "8",
        "symbolicName": "TrailingStopPeg",
        "description": "Trailing Stop Peg"
      },
      {
        "value": "9",
        "symbolicName": "PegToLimitPrice",
        "description": "Peg to Limit Price"
      }
    ]
  },
  {
    "tag": "1095",
    "name": "PeggedRefPrice",
    "type": "Price",
    "description": "The value of the reference price that the order is pegged to. PeggedRefPrice + PegOffsetValue (211) = PeggedPrice (839) unless the limit price (44, Price) is breached. The values may not be exact due to rounding."
  },
  {
    "tag": "1096",
    "name": "PegSecurityIDSource",
    "type": "String",
    "description": "Defines the identity of the security off whose prices the order will peg. Same values as SecurityIDSource (22)"
  },
  {
    "tag": "1097",
    "name": "PegSecurityID",
    "type": "String",
    "description": "Defines the identity of the security off whose prices the order will peg."
  },
  {
    "tag": "1098",
    "name": "PegSymbol",
    "type": "String",
    "description": "Defines the common, 'human understood' representation of the security off whose prices the order will Peg."
  },
  {
    "tag": "1099",
    "name": "PegSecurityDesc",
    "type": "String",
    "description": "Security description of the security off whose prices the order will Peg."
  },
  {
    "tag": "1100",
    "name": "TriggerType",
    "type": "char",
    "description": "Defines when the trigger will hit, i.e. the action specified by the trigger instructions will come into effect.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "PartialExecution",
        "description": "Partial Execution"
      },
      {
        "value": "2",
        "symbolicName": "SpecifiedTradingSession",
        "description": "Specified Trading Session"
      },
      {
        "value": "3",
        "symbolicName": "NextAuction",
        "description": "Next Auction"
      },
      {
        "value": "4",
        "symbolicName": "PriceMovement",
        "description": "Price Movement"
      }
    ]
  },
  {
    "tag": "1101",
    "name": "TriggerAction",
    "type": "char",
    "description": "Defines the type of action to take when the trigger hits.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Activate",
        "description": "Activate"
      },
      {
        "value": "2",
        "symbolicName": "Modify",
        "description": "Modify"
      },
      {
        "value": "3",
        "symbolicName": "Cancel",
        "description": "Cancel"
      }
    ]
  },
  {
    "tag": "1102",
    "name": "TriggerPrice",
    "type": "Price",
    "description": "The price at which the trigger should hit."
  },
  {
    "tag": "1103",
    "name": "TriggerSymbol",
    "type": "String",
    "description": "Defines the common, 'human understood' representation of the security whose prices will be tracked by the trigger logic."
  },
  {
    "tag": "1104",
    "name": "TriggerSecurityID",
    "type": "String",
    "description": "Defines the identity of the security whose prices will be tracked by the trigger logic."
  },
  {
    "tag": "1105",
    "name": "TriggerSecurityIDSource",
    "type": "String",
    "description": "Defines the identity of the security whose prices will be tracked by the trigger logic. Same values as SecurityIDSource (22)."
  },
  {
    "tag": "1106",
    "name": "TriggerSecurityDesc",
    "type": "String",
    "description": "Defines the security description of the security whose prices will be tracked by the trigger logic."
  },
  {
    "tag": "1107",
    "name": "TriggerPriceType",
    "type": "char",
    "description": "The type of price that the trigger is compared to.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "BestOffer",
        "description": "Best Offer"
      },
      {
        "value": "2",
        "symbolicName": "LastTrade",
        "description": "Last Trade"
      },
      {
        "value": "3",
        "symbolicName": "BestBid",
        "description": "Best Bid"
      },
      {
        "value": "4",
        "symbolicName": "BestBidOrLastTrade",
        "description": "Best Bid or Last Trade"
      },
      {
        "value": "5",
        "symbolicName": "BestOfferOrLastTrade",
        "description": "Best Offer or Last Trade"
      },
      {
        "value": "6",
        "symbolicName": "BestMid",
        "description": "Best Mid"
      }
    ]
  },
  {
    "tag": "1108",
    "name": "TriggerPriceTypeScope",
    "type": "char",
    "description": "Defines the type of price protection the customer requires on their order.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "None"
      },
      {
        "value": "1",
        "symbolicName": "Local",
        "description": "Local (Exchange, ECN, ATS)"
      },
      {
        "value": "2",
        "symbolicName": "National",
        "description": "National (Across all national markets)"
      },
      {
        "value": "3",
        "symbolicName": "Global",
        "description": "Global (Across all markets)"
      }
    ]
  },
  {
    "tag": "1109",
    "name": "TriggerPriceDirection",
    "type": "char",
    "description": "The side from which the trigger price is reached.",
    "enum": [
      {
        "value": "U",
        "symbolicName": "Up",
        "description": "Trigger if the price of the specified type goes UP to or through the specified Trigger Price."
      },
      {
        "value": "D",
        "symbolicName": "Down",
        "description": "Trigger if the price of the specified type goes DOWN to or through the specified Trigger Price."
      }
    ]
  },
  {
    "tag": "1110",
    "name": "TriggerNewPrice",
    "type": "Price",
    "description": "The Price that the order should have after the trigger has hit. Could be applicable for any trigger type, but must be specified for Trigger Type 1."
  },
  {
    "tag": "1111",
    "name": "TriggerOrderType",
    "type": "char",
    "description": "The OrdType the order should have after the trigger has hit. Required to express orders that change from Limit to Market. Other values from OrdType (40) may be used if appropriate and bilaterally agreed upon.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Market",
        "description": "Market"
      },
      {
        "value": "2",
        "symbolicName": "Limit",
        "description": "Limit"
      }
    ]
  },
  {
    "tag": "1112",
    "name": "TriggerNewQty",
    "type": "Qty",
    "description": "The Quantity the order should have after the trigger has hit."
  },
  {
    "tag": "1113",
    "name": "TriggerTradingSessionID",
    "type": "String",
    "description": "Defines the trading session at which the order will be activated."
  },
  {
    "tag": "1114",
    "name": "TriggerTradingSessionSubID",
    "type": "String",
    "description": "Defines the subordinate trading session at which the order will be activated."
  },
  {
    "tag": "1115",
    "name": "OrderCategory",
    "type": "char",
    "description": "Defines the type of interest behind a trade (fill or partial fill).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Order",
        "description": "Order"
      },
      {
        "value": "2",
        "symbolicName": "Quote",
        "description": "Quote"
      },
      {
        "value": "3",
        "symbolicName": "PrivatelyNegotiatedTrade",
        "description": "Privately Negotiated Trade"
      },
      {
        "value": "4",
        "symbolicName": "MultilegOrder",
        "description": "Multileg order"
      },
      {
        "value": "5",
        "symbolicName": "LinkedOrder",
        "description": "Linked order"
      },
      {
        "value": "6",
        "symbolicName": "QuoteRequest",
        "description": "Quote Request"
      },
      {
        "value": "7",
        "symbolicName": "ImpliedOrder",
        "description": "Implied Order"
      },
      {
        "value": "8",
        "symbolicName": "CrossOrder",
        "description": "Cross Order"
      },
      {
        "value": "9",
        "symbolicName": "StreamingPrice",
        "description": "Streaming price (quote)"
      }
    ]
  },
  {
    "tag": "1116",
    "name": "NoRootPartyIDs",
    "type": "NumInGroup",
    "description": "Number of RootPartyID (1117), RootPartyIDSource (1118), and RootPartyRole (1119) entries"
  },
  {
    "tag": "1117",
    "name": "RootPartyID",
    "type": "String",
    "description": "PartyID value within a root parties component. Same values as PartyID (448)"
  },
  {
    "tag": "1118",
    "name": "RootPartyIDSource",
    "type": "char",
    "description": "PartyIDSource value within a root parties component. Same values as PartyIDSource (447)"
  },
  {
    "tag": "1119",
    "name": "RootPartyRole",
    "type": "int",
    "description": "PartyRole value within a root parties component. Same values as PartyRole (452)"
  },
  {
    "tag": "1120",
    "name": "NoRootPartySubIDs",
    "type": "NumInGroup",
    "description": "Number of RootPartySubID (1121) and RootPartySubIDType (1122) entries"
  },
  {
    "tag": "1121",
    "name": "RootPartySubID",
    "type": "String",
    "description": "PartySubID value within a root parties component. Same values as PartySubID (523)"
  },
  {
    "tag": "1122",
    "name": "RootPartySubIDType",
    "type": "int",
    "description": "Type of RootPartySubID (1121) value. Same values as PartySubIDType (803)"
  },
  {
    "tag": "1123",
    "name": "TradeHandlingInstr",
    "type": "char",
    "description": "Specified how the Trade Capture Report should be handled by the Respondent.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "TradeConfirmation",
        "description": "Trade Confirmation"
      },
      {
        "value": "1",
        "symbolicName": "TwoPartyReport",
        "description": "Two-Party Report"
      },
      {
        "value": "2",
        "symbolicName": "OnePartyReportForMatching",
        "description": "One-Party Report for Matching"
      },
      {
        "value": "3",
        "symbolicName": "OnePartyReportForPassThrough",
        "description": "One-Party Report for Pass Through"
      },
      {
        "value": "4",
        "symbolicName": "AutomatedFloorOrderRouting",
        "description": "Automated Floor Order Routing"
      },
      {
        "value": "5",
        "symbolicName": "TwoPartyReportForClaim",
        "description": "Two Party Report for Claim"
      }
    ]
  },
  {
    "tag": "1124",
    "name": "OrigTradeHandlingInstr",
    "type": "char",
    "description": "Optionally used with TradeHandlingInstr = 0 to relay the trade handling instruction used when reporting the trade to the marketplace. Same values as TradeHandlingInstr (1123)"
  },
  {
    "tag": "1125",
    "name": "OrigTradeDate",
    "type": "LocalMktDate",
    "description": "Used to preserve original trade date when original trade is being referenced in a subsequent trade transaction such as a transfer"
  },
  {
    "tag": "1126",
    "name": "OrigTradeID",
    "type": "String",
    "description": "Used to preserve original trade id when original trade is being referenced in a subsequent trade transaction such as a transfer"
  },
  {
    "tag": "1127",
    "name": "OrigSecondaryTradeID",
    "type": "String",
    "description": "Used to preserve original secondary trade id when original trade is being referenced in a subsequent trade transaction such as a transfer"
  },
  {
    "tag": "1128",
    "name": "ApplVerID",
    "type": "String",
    "description": "Specifies the service pack release being applied at message level. Enumerated field with values assigned at time of service pack release",
    "enum": [
      {
        "value": "0",
        "symbolicName": "FIX27",
        "description": "FIX27"
      },
      {
        "value": "1",
        "symbolicName": "FIX30",
        "description": "FIX30"
      },
      {
        "value": "2",
        "symbolicName": "FIX40",
        "description": "FIX40"
      },
      {
        "value": "3",
        "symbolicName": "FIX41",
        "description": "FIX41"
      },
      {
        "value": "4",
        "symbolicName": "FIX42",
        "description": "FIX42"
      },
      {
        "value": "5",
        "symbolicName": "FIX43",
        "description": "FIX43"
      },
      {
        "value": "6",
        "symbolicName": "FIX44",
        "description": "FIX44"
      },
      {
        "value": "7",
        "symbolicName": "FIX50",
        "description": "FIX50"
      },
      {
        "value": "8",
        "symbolicName": "FIX50SP1",
        "description": "FIX50SP1"
      },
      {
        "value": "9",
        "symbolicName": "FIX50SP2",
        "description": "FIX50SP2"
      }
    ]
  },
  {
    "tag": "1129",
    "name": "CstmApplVerID",
    "type": "String",
    "description": "Specifies a custom extension to a message being applied at the message level. Enumerated field"
  },
  {
    "tag": "1130",
    "name": "RefApplVerID",
    "type": "String",
    "description": "Specifies the service pack release being applied to a message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID"
  },
  {
    "tag": "1131",
    "name": "RefCstmApplVerID",
    "type": "String",
    "description": "Specifies a custom extension to a message being applied at the session level."
  },
  {
    "tag": "1132",
    "name": "TZTransactTime",
    "type": "TZTimestamp",
    "description": "Transact time in the local date-time stamp with a TZ offset to UTC identified"
  },
  {
    "tag": "1133",
    "name": "ExDestinationIDSource",
    "type": "char",
    "description": "The ID source of ExDestination",
    "enum": [
      {
        "value": "B",
        "symbolicName": "BIC",
        "description": "BIC (Bank Identification Code) (ISO 9362)"
      },
      {
        "value": "C",
        "symbolicName": "GeneralIdentifier",
        "description": "Generally accepted market participant identifier (e.g. NASD mnemonic)"
      },
      {
        "value": "D",
        "symbolicName": "Proprietary",
        "description": "Proprietary / Custom code"
      },
      {
        "value": "E",
        "symbolicName": "ISOCountryCode",
        "description": "ISO Country Code"
      },
      {
        "value": "G",
        "symbolicName": "MIC",
        "description": "MIC (ISO 10383 - Market Identifier Code)"
      }
    ]
  },
  {
    "tag": "1134",
    "name": "ReportedPxDiff",
    "type": "Boolean",
    "description": "Indicates that the reported price that is different from the market price. The price difference should be stated by using field 828 TrdType and, if required, field 829 TrdSubType"
  },
  {
    "tag": "1135",
    "name": "RptSys",
    "type": "String",
    "description": "Indicates the system or medium on which the report has been published"
  },
  {
    "tag": "1136",
    "name": "AllocClearingFeeIndicator",
    "type": "String",
    "description": "ClearingFeeIndicator(635) for Allocation, see ClearingFeeIndicator(635) for permitted values."
  },
  {
    "tag": "1137",
    "name": "DefaultApplVerID",
    "type": "String",
    "description": "Specifies the service pack release being applied, by default, to message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID"
  },
  {
    "tag": "1138",
    "name": "DisplayQty",
    "type": "Qty",
    "description": "The quantity to be displayed . Required for reserve orders. On orders specifies the qty to be displayed, on execution reports the currently displayed quantity."
  },
  {
    "tag": "1139",
    "name": "ExchangeSpecialInstructions",
    "type": "String",
    "description": "Free format text string related to exchange."
  },
  {
    "tag": "1213",
    "name": "UnderlyingMaturityTime",
    "type": "TZTimeOnly",
    "description": "Time of security's maturity expressed in local time with offset to UTC specified"
  },
  {
    "tag": "1212",
    "name": "LegMaturityTime",
    "type": "TZTimeOnly",
    "description": "Time of security's maturity expressed in local time with offset to UTC specified"
  },
  {
    "tag": "1140",
    "name": "MaxTradeVol",
    "type": "Qty",
    "description": "The maximum order quantity that can be submitted for a security."
  },
  {
    "tag": "1141",
    "name": "NoMDFeedTypes",
    "type": "NumInGroup",
    "description": "The number of feed types and corresponding book depths associated with a security"
  },
  {
    "tag": "1142",
    "name": "MatchAlgorithm",
    "type": "String",
    "description": "The types of algorithm used to match orders in a specific security. Possilbe value types are FIFO, Allocation, Pro-rata, Lead Market Maker, Currency Calender."
  },
  {
    "tag": "1143",
    "name": "MaxPriceVariation",
    "type": "float",
    "description": "The maximum price variation of an execution from one event to the next for a given security."
  },
  {
    "tag": "1144",
    "name": "ImpliedMarketIndicator",
    "type": "int",
    "description": "Indicates that an implied market should be created for either the legs of a multi-leg instrument (Implied-in) or for the multi-leg instrument based on the existence of the legs (Implied-out). Determination as to whether implied markets should be created is generally done at the level of the multi-leg instrument. Commonly used in listed derivatives.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NotImplied",
        "description": "Not implied"
      },
      {
        "value": "1",
        "symbolicName": "ImpliedIn",
        "description": "Implied-in - The existence of a multi-leg instrument is implied by the legs of that instrument"
      },
      {
        "value": "2",
        "symbolicName": "ImpliedOut",
        "description": "Implied-out - The existence of the underlying legs are implied by the multi-leg instrument"
      },
      {
        "value": "3",
        "symbolicName": "BothImpliedInAndImpliedOut",
        "description": "Both Implied-in and Implied-out"
      }
    ]
  },
  {
    "tag": "1145",
    "name": "EventTime",
    "type": "UTCTimestamp",
    "description": "Specific time of event. To be used in combination with EventDate [866]"
  },
  {
    "tag": "1146",
    "name": "MinPriceIncrementAmount",
    "type": "Amt",
    "description": "Minimum price increment amount associated with the MinPriceIncrement ( tag 969). For listed derivatives, the value can be calculated by multiplying MinPriceIncrement by ContractValueFactor(231)."
  },
  {
    "tag": "1147",
    "name": "UnitOfMeasureQty",
    "type": "Qty",
    "description": "Used to indicate the quantity of the underlying commodity unit of measure on which the contract is based, such as, 2500 lbs of lean cattle, 1000 barrels of crude oil, 1000 bushels of corn, etc. UnitOfMeasureQty is required for UnitOfMeasure(996) Variable Quantity UOMs enumerations. Refer to the definition of UnitOfMeasure(996) for more information on the use of UnitOfMeasureQty."
  },
  {
    "tag": "1148",
    "name": "LowLimitPrice",
    "type": "Price",
    "description": "Allowable low limit price for the trading day. A key parameter in validating order price. Used as the lower band for validating order prices. Orders submitted with prices below the lower limit will be rejected"
  },
  {
    "tag": "1149",
    "name": "HighLimitPrice",
    "type": "Price",
    "description": "Allowable high limit price for the trading day. A key parameter in validating order price. Used as the upper band for validating order prices. Orders submitted with prices above the upper limit will be rejected"
  },
  {
    "tag": "1150",
    "name": "TradingReferencePrice",
    "type": "Price",
    "description": "Reference price for the current trading price range usually representing the mid price between the HighLimitPrice and LowLimitPrice. The value may be the settlement price or closing price of the prior trading day."
  },
  {
    "tag": "1151",
    "name": "SecurityGroup",
    "type": "String",
    "description": "An exchange specific name assigned to a group of related securities which may be concurrently affected by market events and actions."
  },
  {
    "tag": "1152",
    "name": "LegNumber",
    "type": "int",
    "description": "Allow sequencing of Legs for a Strategy to be captured"
  },
  {
    "tag": "1153",
    "name": "SettlementCycleNo",
    "type": "int",
    "description": "Settlement cycle in which the settlement obligation was generated"
  },
  {
    "tag": "1154",
    "name": "SideCurrency",
    "type": "Currency",
    "description": "Used to identify the trading currency on the Trade Capture Report Side"
  },
  {
    "tag": "1155",
    "name": "SideSettlCurrency",
    "type": "Currency",
    "description": "Used to identify the settlement currency on the Trade Capture Report Side"
  },
  {
    "tag": "1157",
    "name": "CcyAmt",
    "type": "Amt",
    "description": "Net flow of Currency 1"
  },
  {
    "tag": "1158",
    "name": "NoSettlDetails",
    "type": "NumInGroup",
    "description": "Used to group Each Settlement Party"
  },
  {
    "tag": "1159",
    "name": "SettlObligMode",
    "type": "int",
    "description": "Used to identify the reporting mode of the settlement obligation which is either preliminary or final",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Preliminary",
        "description": "Preliminary"
      },
      {
        "value": "2",
        "symbolicName": "Final",
        "description": "Final"
      }
    ]
  },
  {
    "tag": "1160",
    "name": "SettlObligMsgID",
    "type": "String",
    "description": "Message identifier for Settlement Obligation Report"
  },
  {
    "tag": "1161",
    "name": "SettlObligID",
    "type": "String",
    "description": "Unique ID for this settlement instruction."
  },
  {
    "tag": "1162",
    "name": "SettlObligTransType",
    "type": "char",
    "description": "Transaction Type - required except where SettlInstMode is 5=Reject SSI request",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "T",
        "symbolicName": "Restate",
        "description": "Restate"
      }
    ]
  },
  {
    "tag": "1163",
    "name": "SettlObligRefID",
    "type": "String",
    "description": "Required where SettlInstTransType is Cancel or Replace"
  },
  {
    "tag": "1164",
    "name": "SettlObligSource",
    "type": "char",
    "description": "Used to identify whether these delivery instructions are for the buyside or the sellside.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "InstructionsOfBroker",
        "description": "Instructions of Broker"
      },
      {
        "value": "2",
        "symbolicName": "InstructionsForInstitution",
        "description": "Instructions for Institution"
      },
      {
        "value": "3",
        "symbolicName": "Investor",
        "description": "Investor"
      }
    ]
  },
  {
    "tag": "1165",
    "name": "NoSettlOblig",
    "type": "NumInGroup",
    "description": "Number of settlement obligations"
  },
  {
    "tag": "1166",
    "name": "QuoteMsgID",
    "type": "String",
    "description": "Unique identifier for a quote message."
  },
  {
    "tag": "1167",
    "name": "QuoteEntryStatus",
    "type": "int",
    "description": "Identifies the status of an individual quote. See also QuoteStatus(297) which is used for single Quotes.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "Accepted"
      },
      {
        "value": "5",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "6",
        "symbolicName": "RemovedFromMarket",
        "description": "Removed from Market"
      },
      {
        "value": "7",
        "symbolicName": "Expired",
        "description": "Expired"
      },
      {
        "value": "12",
        "symbolicName": "LockedMarketWarning",
        "description": "Locked Market Warning"
      },
      {
        "value": "13",
        "symbolicName": "CrossMarketWarning",
        "description": "Cross Market Warning"
      },
      {
        "value": "14",
        "symbolicName": "CanceledDueToLockMarket",
        "description": "Canceled due to Lock Market"
      },
      {
        "value": "15",
        "symbolicName": "CanceledDueToCrossMarket",
        "description": "Canceled due to Cross Market"
      },
      {
        "value": "16",
        "symbolicName": "Active",
        "description": "Active"
      }
    ]
  },
  {
    "tag": "1168",
    "name": "TotNoCxldQuotes",
    "type": "int",
    "description": "Specifies the number of canceled quotes"
  },
  {
    "tag": "1169",
    "name": "TotNoAccQuotes",
    "type": "int",
    "description": "Specifies the number of accepted quotes"
  },
  {
    "tag": "1170",
    "name": "TotNoRejQuotes",
    "type": "int",
    "description": "Specifies the number of rejected quotes"
  },
  {
    "tag": "1171",
    "name": "PrivateQuote",
    "type": "Boolean",
    "description": "Specifies whether a quote is public, i.e. available to the market, or private, i.e. available to a specified counterparty only.",
    "enum": [
      {
        "value": "Y",
        "symbolicName": "PrivateQuote",
        "description": "Private Quote"
      },
      {
        "value": "N",
        "symbolicName": "PublicQuote",
        "description": "Public Quote"
      }
    ]
  },
  {
    "tag": "1172",
    "name": "RespondentType",
    "type": "int",
    "description": "Specifies the type of respondents requested.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AllMarketParticipants",
        "description": "All market participants"
      },
      {
        "value": "2",
        "symbolicName": "SpecifiedMarketParticipants",
        "description": "Specified market participants"
      },
      {
        "value": "3",
        "symbolicName": "AllMarketMakers",
        "description": "All Market Makers"
      },
      {
        "value": "4",
        "symbolicName": "PrimaryMarketMaker",
        "description": "Primary Market Maker(s)"
      }
    ]
  },
  {
    "tag": "1173",
    "name": "MDSubBookType",
    "type": "int",
    "description": "Describes a class of sub book, e.g. for the separation of various lot types. The Sub Book Type indicates that the following Market Data Entries belong to a non-integrated Sub Book. Whenever provided the Sub Book must be used together with MDPriceLevel and MDEntryPositionNo in order to sort the order properly.\nValues are bilaterally agreed."
  },
  {
    "tag": "1174",
    "name": "SecurityTradingEvent",
    "type": "int",
    "description": "Identifies an event related to a SecurityTradingStatus(326). An event occurs and is gone, it is not a state that applies for a period of time.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OrderImbalance",
        "description": "Order imbalance, auction is extended"
      },
      {
        "value": "2",
        "symbolicName": "TradingResumes",
        "description": "Trading resumes (after Halt)"
      },
      {
        "value": "3",
        "symbolicName": "PriceVolatilityInterruption",
        "description": "Price Volatility Interruption"
      },
      {
        "value": "4",
        "symbolicName": "ChangeOfTradingSession",
        "description": "Change of Trading Session"
      },
      {
        "value": "5",
        "symbolicName": "ChangeOfTradingSubsession",
        "description": "Change of Trading Subsession"
      },
      {
        "value": "6",
        "symbolicName": "ChangeOfSecurityTradingStatus",
        "description": "Change of Security Trading Status"
      },
      {
        "value": "7",
        "symbolicName": "ChangeOfBookType",
        "description": "Change of Book Type"
      },
      {
        "value": "8",
        "symbolicName": "ChangeOfMarketDepth",
        "description": "Change of Market Depth"
      }
    ]
  },
  {
    "tag": "1175",
    "name": "NoStatsIndicators",
    "type": "NumInGroup",
    "description": "Number of statistics indicator repeating group entries"
  },
  {
    "tag": "1176",
    "name": "StatsType",
    "type": "int",
    "description": "Type of statistics",
    "enum": [
      {
        "value": "1",
        "symbolicName": "ExchangeLast",
        "description": "Exchange Last"
      },
      {
        "value": "2",
        "symbolicName": "High",
        "description": "High / Low Price"
      },
      {
        "value": "3",
        "symbolicName": "AveragePrice",
        "description": "Average Price (VWAP, TWAP ... )"
      },
      {
        "value": "4",
        "symbolicName": "Turnover",
        "description": "Turnover (Price * Qty)"
      }
    ]
  },
  {
    "tag": "1177",
    "name": "NoOfSecSizes",
    "type": "NumInGroup",
    "description": "The number of secondary sizes specifies in this entry"
  },
  {
    "tag": "1178",
    "name": "MDSecSizeType",
    "type": "int",
    "description": "Specifies the type of secondary size.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Customer",
        "description": "Customer"
      }
    ]
  },
  {
    "tag": "1179",
    "name": "MDSecSize",
    "type": "Qty",
    "description": "A part of the MDEntrySize(271) that represents secondary interest as specified by MDSecSizeType(1178)."
  },
  {
    "tag": "1180",
    "name": "ApplID",
    "type": "String",
    "description": "Identifies the application with which a message is associated. Used only if application sequencing is in effect."
  },
  {
    "tag": "1181",
    "name": "ApplSeqNum",
    "type": "SeqNum",
    "description": "Data sequence number to be used when FIX session is not in effect"
  },
  {
    "tag": "1182",
    "name": "ApplBegSeqNum",
    "type": "SeqNum",
    "description": "Beginning range of application sequence numbers"
  },
  {
    "tag": "1183",
    "name": "ApplEndSeqNum",
    "type": "SeqNum",
    "description": "Ending range of application sequence numbers"
  },
  {
    "tag": "1184",
    "name": "SecurityXMLLen",
    "type": "Length",
    "description": "Lenght of the SecurityXML data block."
  },
  {
    "tag": "1185",
    "name": "SecurityXML",
    "type": "XMLData",
    "description": "Actual XML data stream describing a security, normally FpML."
  },
  {
    "tag": "1186",
    "name": "SecurityXMLSchema",
    "type": "String",
    "description": "The schema used to validate the contents of SecurityXML"
  },
  {
    "tag": "1187",
    "name": "RefreshIndicator",
    "type": "Boolean",
    "description": "Set by the sender to tell the receiver to perform an immediate refresh of the book due to disruptions in the accompanying real-time feed\n'Y' - Mandatory refresh by all participants\n'N' - Process as required"
  },
  {
    "tag": "1188",
    "name": "Volatility",
    "type": "float",
    "description": "Annualized volatility for option model calculations"
  },
  {
    "tag": "1189",
    "name": "TimeToExpiration",
    "type": "float",
    "description": "Time to expiration in years calculated as the number of days remaining to expiration divided by 365 days per year."
  },
  {
    "tag": "1190",
    "name": "RiskFreeRate",
    "type": "float",
    "description": "Interest rate. Usually some form of short term rate."
  },
  {
    "tag": "1191",
    "name": "PriceUnitOfMeasure",
    "type": "String",
    "description": "Used to express the UOM of the price if different from the contract. In futures, this can be different for cross-rate products in which the price is quoted in units differently from the contract"
  },
  {
    "tag": "1192",
    "name": "PriceUnitOfMeasureQty",
    "type": "Qty",
    "description": "Used to express the UOM Quantity of the price if different from the contract. In futures, this can be different for physically delivered products in which price is quoted in a unit size different from the contract, i.e. a Cattle Future contract has a UOMQty of 40,000 and a PriceUOMQty of 100."
  },
  {
    "tag": "1193",
    "name": "SettlMethod",
    "type": "char",
    "description": "Settlement method for a contract. Can be used as an alternative to CFI Code value",
    "enum": [
      {
        "value": "C",
        "symbolicName": "CashSettlementRequired",
        "description": "Cash settlement required"
      },
      {
        "value": "P",
        "symbolicName": "PhysicalSettlementRequired",
        "description": "Physical settlement required"
      }
    ]
  },
  {
    "tag": "1194",
    "name": "ExerciseStyle",
    "type": "int",
    "description": "Type of exercise of a derivatives security",
    "enum": [
      {
        "value": "0",
        "symbolicName": "European",
        "description": "European"
      },
      {
        "value": "1",
        "symbolicName": "American",
        "description": "American"
      },
      {
        "value": "2",
        "symbolicName": "Bermuda",
        "description": "Bermuda"
      }
    ]
  },
  {
    "tag": "1419",
    "name": "UnderlyingExerciseStyle",
    "type": "int",
    "description": "Type of exercise of a derivatives security"
  },
  {
    "tag": "1420",
    "name": "LegExerciseStyle",
    "type": "int",
    "description": "Type of exercise of a derivatives security"
  },
  {
    "tag": "1195",
    "name": "OptPayoutAmount",
    "type": "Amt",
    "description": "Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount. \nConditionally required if OptPayoutType(1482) is set to binary."
  },
  {
    "tag": "1196",
    "name": "PriceQuoteMethod",
    "type": "String",
    "description": "Method for price quotation",
    "enum": [
      {
        "value": "STD",
        "symbolicName": "Standard",
        "description": "Standard, money per unit of a physical"
      },
      {
        "value": "INX",
        "symbolicName": "Index",
        "description": "Index"
      },
      {
        "value": "INT",
        "symbolicName": "InterestRateIndex",
        "description": "Interest rate Index"
      },
      {
        "value": "PCTPAR",
        "symbolicName": "PercentOfPar",
        "description": "Percent of Par"
      }
    ]
  },
  {
    "tag": "1197",
    "name": "ValuationMethod",
    "type": "String",
    "description": "Specifies the type of valuation method applied.",
    "enum": [
      {
        "value": "EQTY",
        "symbolicName": "PremiumStyle",
        "description": "premium style"
      },
      {
        "value": "FUT",
        "symbolicName": "FuturesStyleMarkToMarket",
        "description": "futures style mark-to-market"
      },
      {
        "value": "FUTDA",
        "symbolicName": "FuturesStyleWithAnAttachedCashAdjustment",
        "description": "futures style with an attached cash adjustment"
      },
      {
        "value": "CDS",
        "symbolicName": "CDSStyleCollateralization",
        "description": "CDS style collateralization of market to market and coupon"
      },
      {
        "value": "CDSD",
        "symbolicName": "CDSInDeliveryUseRecoveryRateToCalculate",
        "description": "CDS in delivery - use recovery rate to calculate obligation"
      }
    ]
  },
  {
    "tag": "1198",
    "name": "ListMethod",
    "type": "int",
    "description": "Indicates whether instruments are pre-listed only or can also be defined via user request",
    "enum": [
      {
        "value": "0",
        "symbolicName": "PreListedOnly",
        "description": "pre-listed only"
      },
      {
        "value": "1",
        "symbolicName": "UserRequested",
        "description": "user requested"
      }
    ]
  },
  {
    "tag": "1199",
    "name": "CapPrice",
    "type": "Price",
    "description": "Used to express the ceiling price of a capped call"
  },
  {
    "tag": "1200",
    "name": "FloorPrice",
    "type": "Price",
    "description": "Used to express the floor price of a capped put"
  },
  {
    "tag": "1201",
    "name": "NoStrikeRules",
    "type": "NumInGroup",
    "description": "Number of strike rule entries. This block specifies the rules for determining how new strikes should be listed within the stated price range of the underlying instrument"
  },
  {
    "tag": "1202",
    "name": "StartStrikePxRange",
    "type": "Price",
    "description": "Starting price for the range to which the StrikeIncrement applies. Price refers to the price of the underlying"
  },
  {
    "tag": "1203",
    "name": "EndStrikePxRange",
    "type": "Price",
    "description": "Ending price of the range to which the StrikeIncrement applies. Price refers to the price of the underlying"
  },
  {
    "tag": "1204",
    "name": "StrikeIncrement",
    "type": "float",
    "description": "Value by which strike price should be incremented within the specified price range."
  },
  {
    "tag": "1205",
    "name": "NoTickRules",
    "type": "NumInGroup",
    "description": "Number of tick rules. This block specifies the rules for determining how a security ticks, i.e. the price increments at which it can be quoted and traded, depending on the current price of the security"
  },
  {
    "tag": "1206",
    "name": "StartTickPriceRange",
    "type": "Price",
    "description": "Starting price range for specified tick increment"
  },
  {
    "tag": "1207",
    "name": "EndTickPriceRange",
    "type": "Price",
    "description": "Ending price range for the specified tick increment"
  },
  {
    "tag": "1208",
    "name": "TickIncrement",
    "type": "Price",
    "description": "Tick increment for stated price range. Specifies the valid price increments at which a security can be quoted and traded"
  },
  {
    "tag": "1209",
    "name": "TickRuleType",
    "type": "int",
    "description": "Specifies the type of tick rule which is being described",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "Regular"
      },
      {
        "value": "1",
        "symbolicName": "Variable",
        "description": "Variable"
      },
      {
        "value": "2",
        "symbolicName": "Fixed",
        "description": "Fixed"
      },
      {
        "value": "3",
        "symbolicName": "TradedAsASpreadLeg",
        "description": "Traded as a spread leg"
      },
      {
        "value": "4",
        "symbolicName": "SettledAsASpreadLeg",
        "description": "Settled as a spread leg"
      }
    ]
  },
  {
    "tag": "1210",
    "name": "NestedInstrAttribType",
    "type": "int",
    "description": "Code to represent the type of instrument attribute"
  },
  {
    "tag": "1211",
    "name": "NestedInstrAttribValue",
    "type": "String",
    "description": "Attribute value appropriate to the NestedInstrAttribType field"
  },
  {
    "tag": "1214",
    "name": "DerivativeSymbol",
    "type": "String",
    "description": "Refer to definition for Symbol(55)"
  },
  {
    "tag": "1215",
    "name": "DerivativeSymbolSfx",
    "type": "String",
    "description": "Refer to definition for SymbolSfx(65)"
  },
  {
    "tag": "1216",
    "name": "DerivativeSecurityID",
    "type": "String",
    "description": "Refer to definition for SecurityID(48)"
  },
  {
    "tag": "1217",
    "name": "DerivativeSecurityIDSource",
    "type": "String",
    "description": "Refer to definition for SecurityIDSoruce(22)"
  },
  {
    "tag": "1218",
    "name": "NoDerivativeSecurityAltID",
    "type": "NumInGroup",
    "description": "Refer to definition for NoSecurityAltID(454)"
  },
  {
    "tag": "1219",
    "name": "DerivativeSecurityAltID",
    "type": "String",
    "description": "Refer to definition for SecurityAltID(455)"
  },
  {
    "tag": "1220",
    "name": "DerivativeSecurityAltIDSource",
    "type": "String",
    "description": "Refer to definition for SecurityAltIDSource(456)"
  },
  {
    "tag": "1221",
    "name": "SecondaryLowLimitPrice",
    "type": "Price",
    "description": "Refer to definition of LowLimitPrice(1148)"
  },
  {
    "tag": "1230",
    "name": "SecondaryHighLimitPrice",
    "type": "Price",
    "description": "Refer to definition of HighLimitPrice(1149)"
  },
  {
    "tag": "1222",
    "name": "MaturityRuleID",
    "type": "String",
    "description": "Allows maturity rule to be referenced via an identifier so that rules do not need to be explicitly enumerated"
  },
  {
    "tag": "1223",
    "name": "StrikeRuleID",
    "type": "String",
    "description": "Allows strike rule to be referenced via an identifier so that rules do not need to be explicitly enumerated"
  },
  {
    "tag": "1225",
    "name": "DerivativeOptPayAmount",
    "type": "Amt",
    "description": "Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount"
  },
  {
    "tag": "1226",
    "name": "EndMaturityMonthYear",
    "type": "MonthYear",
    "description": "Ending maturity month year for an option class"
  },
  {
    "tag": "1227",
    "name": "ProductComplex",
    "type": "String",
    "description": "Identifies an entire suite of products for a given market. In Futures this may be \"interest rates\", \"agricultural\", \"equity indexes\", etc."
  },
  {
    "tag": "1228",
    "name": "DerivativeProductComplex",
    "type": "String",
    "description": "Refer to ProductComplex(1227)"
  },
  {
    "tag": "1229",
    "name": "MaturityMonthYearIncrement",
    "type": "int",
    "description": "Increment between successive maturities for an option class"
  },
  {
    "tag": "1231",
    "name": "MinLotSize",
    "type": "Qty",
    "description": "Minimum lot size allowed based on lot type specified in LotType(1093)"
  },
  {
    "tag": "1232",
    "name": "NoExecInstRules",
    "type": "NumInGroup",
    "description": "Number of execution instructions"
  },
  {
    "tag": "1234",
    "name": "NoLotTypeRules",
    "type": "NumInGroup",
    "description": "Number of Lot Type Rules"
  },
  {
    "tag": "1235",
    "name": "NoMatchRules",
    "type": "NumInGroup",
    "description": "Number of Match Rules"
  },
  {
    "tag": "1236",
    "name": "NoMaturityRules",
    "type": "NumInGroup",
    "description": "Number of maturity rules in MarurityRules component block"
  },
  {
    "tag": "1237",
    "name": "NoOrdTypeRules",
    "type": "NumInGroup",
    "description": "Number of order types"
  },
  {
    "tag": "1239",
    "name": "NoTimeInForceRules",
    "type": "NumInGroup",
    "description": "Number of time in force techniques"
  },
  {
    "tag": "1240",
    "name": "SecondaryTradingReferencePrice",
    "type": "Price",
    "description": "Refer to definition for TradingReferencePrice(1150)"
  },
  {
    "tag": "1241",
    "name": "StartMaturityMonthYear",
    "type": "MonthYear",
    "description": "Starting maturity month year for an option class"
  },
  {
    "tag": "1242",
    "name": "FlexProductEligibilityIndicator",
    "type": "Boolean",
    "description": "Used to indicate if a product or group of product supports the creation of flexible securities"
  },
  {
    "tag": "1243",
    "name": "DerivFlexProductEligibilityIndicator",
    "type": "Boolean",
    "description": "Refer to FlexProductEligibilityIndicator(1242)"
  },
  {
    "tag": "1244",
    "name": "FlexibleIndicator",
    "type": "Boolean",
    "description": "Used to indicate a derivatives security that can be defined using flexible terms. The terms commonly permitted to be defined by market participants are expiration date and strike price. FlexibleIndicator is an alternative CFICode(461) Standard/Non-standard attribute."
  },
  {
    "tag": "1245",
    "name": "TradingCurrency",
    "type": "Currency",
    "description": "Used when the trading currency can differ from the price currency"
  },
  {
    "tag": "1246",
    "name": "DerivativeProduct",
    "type": "int",
    "description": ""
  },
  {
    "tag": "1247",
    "name": "DerivativeSecurityGroup",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1248",
    "name": "DerivativeCFICode",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1249",
    "name": "DerivativeSecurityType",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1250",
    "name": "DerivativeSecuritySubType",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1251",
    "name": "DerivativeMaturityMonthYear",
    "type": "MonthYear",
    "description": ""
  },
  {
    "tag": "1252",
    "name": "DerivativeMaturityDate",
    "type": "LocalMktDate",
    "description": ""
  },
  {
    "tag": "1253",
    "name": "DerivativeMaturityTime",
    "type": "TZTimeOnly",
    "description": ""
  },
  {
    "tag": "1254",
    "name": "DerivativeSettleOnOpenFlag",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1255",
    "name": "DerivativeInstrmtAssignmentMethod",
    "type": "char",
    "description": ""
  },
  {
    "tag": "1256",
    "name": "DerivativeSecurityStatus",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1257",
    "name": "DerivativeInstrRegistry",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1258",
    "name": "DerivativeCountryOfIssue",
    "type": "Country",
    "description": ""
  },
  {
    "tag": "1259",
    "name": "DerivativeStateOrProvinceOfIssue",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1260",
    "name": "DerivativeLocaleOfIssue",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1261",
    "name": "DerivativeStrikePrice",
    "type": "Price",
    "description": ""
  },
  {
    "tag": "1262",
    "name": "DerivativeStrikeCurrency",
    "type": "Currency",
    "description": ""
  },
  {
    "tag": "1263",
    "name": "DerivativeStrikeMultiplier",
    "type": "float",
    "description": ""
  },
  {
    "tag": "1264",
    "name": "DerivativeStrikeValue",
    "type": "float",
    "description": ""
  },
  {
    "tag": "1265",
    "name": "DerivativeOptAttribute",
    "type": "char",
    "description": ""
  },
  {
    "tag": "1266",
    "name": "DerivativeContractMultiplier",
    "type": "float",
    "description": ""
  },
  {
    "tag": "1267",
    "name": "DerivativeMinPriceIncrement",
    "type": "float",
    "description": ""
  },
  {
    "tag": "1268",
    "name": "DerivativeMinPriceIncrementAmount",
    "type": "Amt",
    "description": ""
  },
  {
    "tag": "1269",
    "name": "DerivativeUnitOfMeasure",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1270",
    "name": "DerivativeUnitOfMeasureQty",
    "type": "Qty",
    "description": ""
  },
  {
    "tag": "1271",
    "name": "DerivativeTimeUnit",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1272",
    "name": "DerivativeSecurityExchange",
    "type": "Exchange",
    "description": ""
  },
  {
    "tag": "1273",
    "name": "DerivativePositionLimit",
    "type": "int",
    "description": ""
  },
  {
    "tag": "1274",
    "name": "DerivativeNTPositionLimit",
    "type": "int",
    "description": ""
  },
  {
    "tag": "1275",
    "name": "DerivativeIssuer",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1276",
    "name": "DerivativeIssueDate",
    "type": "LocalMktDate",
    "description": ""
  },
  {
    "tag": "1277",
    "name": "DerivativeEncodedIssuerLen",
    "type": "Length",
    "description": ""
  },
  {
    "tag": "1278",
    "name": "DerivativeEncodedIssuer",
    "type": "data",
    "description": ""
  },
  {
    "tag": "1279",
    "name": "DerivativeSecurityDesc",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1280",
    "name": "DerivativeEncodedSecurityDescLen",
    "type": "Length",
    "description": ""
  },
  {
    "tag": "1281",
    "name": "DerivativeEncodedSecurityDesc",
    "type": "data",
    "description": ""
  },
  {
    "tag": "1282",
    "name": "DerivativeSecurityXMLLen",
    "type": "Length",
    "description": "Refer to definition SecurityXMLLen(1184)"
  },
  {
    "tag": "1283",
    "name": "DerivativeSecurityXML",
    "type": "data",
    "description": "Refer to definition of SecurityXML(1185)"
  },
  {
    "tag": "1284",
    "name": "DerivativeSecurityXMLSchema",
    "type": "String",
    "description": "Refer to definition of SecurityXMLSchema(1186)"
  },
  {
    "tag": "1285",
    "name": "DerivativeContractSettlMonth",
    "type": "MonthYear",
    "description": ""
  },
  {
    "tag": "1286",
    "name": "NoDerivativeEvents",
    "type": "NumInGroup",
    "description": ""
  },
  {
    "tag": "1287",
    "name": "DerivativeEventType",
    "type": "int",
    "description": ""
  },
  {
    "tag": "1288",
    "name": "DerivativeEventDate",
    "type": "LocalMktDate",
    "description": ""
  },
  {
    "tag": "1289",
    "name": "DerivativeEventTime",
    "type": "UTCTimestamp",
    "description": ""
  },
  {
    "tag": "1290",
    "name": "DerivativeEventPx",
    "type": "Price",
    "description": ""
  },
  {
    "tag": "1291",
    "name": "DerivativeEventText",
    "type": "String",
    "description": ""
  },
  {
    "tag": "1292",
    "name": "NoDerivativeInstrumentParties",
    "type": "NumInGroup",
    "description": "Refer to definition of NoParties(453)"
  },
  {
    "tag": "1293",
    "name": "DerivativeInstrumentPartyID",
    "type": "String",
    "description": "Refer to definition of PartyID(448)"
  },
  {
    "tag": "1294",
    "name": "DerivativeInstrumentPartyIDSource",
    "type": "String",
    "description": "Refer to definition of PartyIDSource(447)"
  },
  {
    "tag": "1295",
    "name": "DerivativeInstrumentPartyRole",
    "type": "int",
    "description": "REfer to definition of PartyRole(452)"
  },
  {
    "tag": "1296",
    "name": "NoDerivativeInstrumentPartySubIDs",
    "type": "NumInGroup",
    "description": "Refer to definition for NoPartySubIDs(802)"
  },
  {
    "tag": "1297",
    "name": "DerivativeInstrumentPartySubID",
    "type": "String",
    "description": "Refer to definition for PartySubID(523)"
  },
  {
    "tag": "1298",
    "name": "DerivativeInstrumentPartySubIDType",
    "type": "int",
    "description": "Refer to definition for PartySubIDType(803)"
  },
  {
    "tag": "1299",
    "name": "DerivativeExerciseStyle",
    "type": "char",
    "description": "Type of exercise of a derivatives security"
  },
  {
    "tag": "1300",
    "name": "MarketSegmentID",
    "type": "String",
    "description": "Identifies the market segment"
  },
  {
    "tag": "1301",
    "name": "MarketID",
    "type": "Exchange",
    "description": "Identifies the Market"
  },
  {
    "tag": "1302",
    "name": "MaturityMonthYearIncrementUnits",
    "type": "int",
    "description": "Unit of measure for the Maturity Month Year Increment",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Months",
        "description": "Months"
      },
      {
        "value": "1",
        "symbolicName": "Days",
        "description": "Days"
      },
      {
        "value": "2",
        "symbolicName": "Weeks",
        "description": "Weeks"
      },
      {
        "value": "3",
        "symbolicName": "Years",
        "description": "Years"
      }
    ]
  },
  {
    "tag": "1303",
    "name": "MaturityMonthYearFormat",
    "type": "int",
    "description": "Format used to generate the MaturityMonthYear for each option",
    "enum": [
      {
        "value": "0",
        "symbolicName": "YearMonthOnly",
        "description": "YearMonth Only (default)"
      },
      {
        "value": "1",
        "symbolicName": "YearMonthDay",
        "description": "YearMonthDay"
      },
      {
        "value": "2",
        "symbolicName": "YearMonthWeek",
        "description": "YearMonthWeek"
      }
    ]
  },
  {
    "tag": "1304",
    "name": "StrikeExerciseStyle",
    "type": "int",
    "description": "Expiration Style for an option class:"
  },
  {
    "tag": "1305",
    "name": "SecondaryPriceLimitType",
    "type": "int",
    "description": "Describes the how the price limits are expressed"
  },
  {
    "tag": "1306",
    "name": "PriceLimitType",
    "type": "int",
    "description": "Describes the how the price limits are expressed",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Price",
        "description": "Price"
      },
      {
        "value": "1",
        "symbolicName": "Ticks",
        "description": "Ticks"
      },
      {
        "value": "2",
        "symbolicName": "Percentage",
        "description": "Percentage"
      }
    ]
  },
  {
    "tag": "1308",
    "name": "ExecInstValue",
    "type": "char",
    "description": "Indicates execution instructions that are valid for the specified market segment"
  },
  {
    "tag": "1309",
    "name": "NoTradingSessionRules",
    "type": "NumInGroup",
    "description": "Allows trading rules to be expressed by trading session"
  },
  {
    "tag": "1310",
    "name": "NoMarketSegments",
    "type": "NumInGroup",
    "description": "Number of Market Segments on which a security may trade."
  },
  {
    "tag": "1311",
    "name": "NoDerivativeInstrAttrib",
    "type": "NumInGroup",
    "description": ""
  },
  {
    "tag": "1312",
    "name": "NoNestedInstrAttrib",
    "type": "NumInGroup",
    "description": ""
  },
  {
    "tag": "1313",
    "name": "DerivativeInstrAttribType",
    "type": "int",
    "description": "Refer to definition of InstrAttribType(871)"
  },
  {
    "tag": "1314",
    "name": "DerivativeInstrAttribValue",
    "type": "String",
    "description": "Refer to definition of InstrAttribValue(872)"
  },
  {
    "tag": "1315",
    "name": "DerivativePriceUnitOfMeasure",
    "type": "String",
    "description": "Refer to definition for PriceUnitOfMeasure(1191)"
  },
  {
    "tag": "1316",
    "name": "DerivativePriceUnitOfMeasureQty",
    "type": "Qty",
    "description": "Refer to definition of PriceUnitOfMeasureQty(1192)"
  },
  {
    "tag": "1317",
    "name": "DerivativeSettlMethod",
    "type": "char",
    "description": "Refer to definition of SettlMethod(1193)"
  },
  {
    "tag": "1318",
    "name": "DerivativePriceQuoteMethod",
    "type": "String",
    "description": "Refer to definition of PriceQuoteMethod(1196)"
  },
  {
    "tag": "1319",
    "name": "DerivativeValuationMethod",
    "type": "String",
    "description": "Refer to definition of ValuationMethod(1197)."
  },
  {
    "tag": "1320",
    "name": "DerivativeListMethod",
    "type": "int",
    "description": "Indicates whether instruments are pre-listed only or can also be defined via user request"
  },
  {
    "tag": "1321",
    "name": "DerivativeCapPrice",
    "type": "Price",
    "description": "Refer to definition of CapPrice(1199)"
  },
  {
    "tag": "1322",
    "name": "DerivativeFloorPrice",
    "type": "Price",
    "description": "Refer to definition of FloorPrice(1200)"
  },
  {
    "tag": "1323",
    "name": "DerivativePutOrCall",
    "type": "int",
    "description": "Indicates whether an Option is for a put or call"
  },
  {
    "tag": "1324",
    "name": "ListUpdateAction",
    "type": "char",
    "description": "If provided, then Instrument occurrence has explicitly changed"
  },
  {
    "tag": "1358",
    "name": "LegPutOrCall",
    "type": "int",
    "description": "Refer to definition of PutOrCall(201)"
  },
  {
    "tag": "1224",
    "name": "LegUnitOfMeasureQty",
    "type": "Qty",
    "description": "Refer to definition of UnitOfMeasureQty(1147)"
  },
  {
    "tag": "1421",
    "name": "LegPriceUnitOfMeasure",
    "type": "String",
    "description": "Refer to definition for PriceUnitOfMeasure(1191)"
  },
  {
    "tag": "1422",
    "name": "LegPriceUnitOfMeasureQty",
    "type": "Qty",
    "description": "Refer to definition of PriceUnitOfMeasureQty(1192)"
  },
  {
    "tag": "1423",
    "name": "UnderlyingUnitOfMeasureQty",
    "type": "Qty",
    "description": "Refer to definition of UnitOfMeasureQty(1147)"
  },
  {
    "tag": "1424",
    "name": "UnderlyingPriceUnitOfMeasure",
    "type": "String",
    "description": "Refer to definition for PriceUnitOfMeasure(1191)"
  },
  {
    "tag": "1425",
    "name": "UnderlyingPriceUnitOfMeasureQty",
    "type": "Qty",
    "description": "Refer to definition of PriceUnitOfMeasureQty(1192)"
  },
  {
    "tag": "1393",
    "name": "MarketReqID",
    "type": "String",
    "description": "Unique ID of a Market Definition Request message."
  },
  {
    "tag": "1394",
    "name": "MarketReportID",
    "type": "String",
    "description": "Market Definition message identifier."
  },
  {
    "tag": "1395",
    "name": "MarketUpdateAction",
    "type": "char",
    "description": "Specifies the action taken for the specified MarketID(1301) + MarketSegmentID(1300).",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Add",
        "description": "Add"
      },
      {
        "value": "D",
        "symbolicName": "Delete",
        "description": "Delete"
      },
      {
        "value": "M",
        "symbolicName": "Modify",
        "description": "Modify"
      }
    ]
  },
  {
    "tag": "1396",
    "name": "MarketSegmentDesc",
    "type": "String",
    "description": "Description or name of Market Segment"
  },
  {
    "tag": "1397",
    "name": "EncodedMktSegmDescLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedMktSegmDesc(1324) field."
  },
  {
    "tag": "1398",
    "name": "EncodedMktSegmDesc",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the MarketSegmDesc(1396) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the MarketSegmDesc field."
  },
  {
    "tag": "1325",
    "name": "ParentMktSegmID",
    "type": "String",
    "description": "Reference to a parent Market Segment. See MarketSegmentID(1300)"
  },
  {
    "tag": "1326",
    "name": "TradingSessionDesc",
    "type": "String",
    "description": "Trading Session description"
  },
  {
    "tag": "1327",
    "name": "TradSesUpdateAction",
    "type": "char",
    "description": "Specifies the action taken for the specified trading sessions."
  },
  {
    "tag": "1328",
    "name": "RejectText",
    "type": "String",
    "description": "Those will be used by Firms to send a reason for rejecting a trade in an allocate claim model."
  },
  {
    "tag": "1329",
    "name": "FeeMultiplier",
    "type": "float",
    "description": "This is a multiplier that Clearing (Fee system) will use to calculate fees and will be sent to the firms on their confirms."
  },
  {
    "tag": "1330",
    "name": "UnderlyingLegSymbol",
    "type": "String",
    "description": "Refer to definition for Symbol(55)"
  },
  {
    "tag": "1331",
    "name": "UnderlyingLegSymbolSfx",
    "type": "String",
    "description": "Refer to definition for SymbolSfx(65)"
  },
  {
    "tag": "1332",
    "name": "UnderlyingLegSecurityID",
    "type": "String",
    "description": "Refer to definition for SecurityID(48)"
  },
  {
    "tag": "1333",
    "name": "UnderlyingLegSecurityIDSource",
    "type": "String",
    "description": "Refer to definition for SecurityIDSource(22)"
  },
  {
    "tag": "1334",
    "name": "NoUnderlyingLegSecurityAltID",
    "type": "NumInGroup",
    "description": "Refer to definition for NoSecurityAltID(454)"
  },
  {
    "tag": "1335",
    "name": "UnderlyingLegSecurityAltID",
    "type": "String",
    "description": "Refer to definition for SecurityAltID(455)"
  },
  {
    "tag": "1336",
    "name": "UnderlyingLegSecurityAltIDSource",
    "type": "String",
    "description": "Refer to definition for SecurityAltIDSource(456)"
  },
  {
    "tag": "1337",
    "name": "UnderlyingLegSecurityType",
    "type": "String",
    "description": "Refer to definition for SecurityType(167)"
  },
  {
    "tag": "1338",
    "name": "UnderlyingLegSecuritySubType",
    "type": "String",
    "description": "Refer to definition for SecuritySubType(762)"
  },
  {
    "tag": "1339",
    "name": "UnderlyingLegMaturityMonthYear",
    "type": "MonthYear",
    "description": "Refer to definition for MaturityMonthYear(200)"
  },
  {
    "tag": "1343",
    "name": "UnderlyingLegPutOrCall",
    "type": "int",
    "description": "Refer to definition for PutOrCall(201)"
  },
  {
    "tag": "1340",
    "name": "UnderlyingLegStrikePrice",
    "type": "Price",
    "description": "Refer to definition for StrikePrice(202)"
  },
  {
    "tag": "1341",
    "name": "UnderlyingLegSecurityExchange",
    "type": "String",
    "description": "Refer to definition for SecurityExchange(207)"
  },
  {
    "tag": "1342",
    "name": "NoOfLegUnderlyings",
    "type": "NumInGroup",
    "description": "Number of Underlyings, Identifies the Underlying of the Leg"
  },
  {
    "tag": "1344",
    "name": "UnderlyingLegCFICode",
    "type": "String",
    "description": "Refer to definition for CFICode(461)"
  },
  {
    "tag": "1345",
    "name": "UnderlyingLegMaturityDate",
    "type": "LocalMktDate",
    "description": "Date of maturity."
  },
  {
    "tag": "1405",
    "name": "UnderlyingLegMaturityTime",
    "type": "TZTimeOnly",
    "description": "Time of security's maturity expressed in local time with offset to UTC specified"
  },
  {
    "tag": "1391",
    "name": "UnderlyingLegOptAttribute",
    "type": "char",
    "description": "Refer to definition of OptAttribute(206)"
  },
  {
    "tag": "1392",
    "name": "UnderlyingLegSecurityDesc",
    "type": "String",
    "description": "Refer to definition of SecurityDesc(107)"
  },
  {
    "tag": "1400",
    "name": "EncryptedPasswordMethod",
    "type": "int",
    "description": "Enumeration defining the encryption method used to encrypt password fields.\nAt this time there are no encryption methods defined by FPL."
  },
  {
    "tag": "1401",
    "name": "EncryptedPasswordLen",
    "type": "Length",
    "description": "Length of the EncryptedPassword(1402) field"
  },
  {
    "tag": "1402",
    "name": "EncryptedPassword",
    "type": "data",
    "description": "Encrypted password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)"
  },
  {
    "tag": "1403",
    "name": "EncryptedNewPasswordLen",
    "type": "Length",
    "description": "Length of the EncryptedNewPassword(1404) field"
  },
  {
    "tag": "1404",
    "name": "EncryptedNewPassword",
    "type": "data",
    "description": "Encrypted new password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)"
  },
  {
    "tag": "1156",
    "name": "ApplExtID",
    "type": "int",
    "description": "The extension pack number associated with an application message."
  },
  {
    "tag": "1406",
    "name": "RefApplExtID",
    "type": "int",
    "description": "The extension pack number associated with an application message."
  },
  {
    "tag": "1407",
    "name": "DefaultApplExtID",
    "type": "int",
    "description": "The extension pack number that is the default for a FIX session."
  },
  {
    "tag": "1408",
    "name": "DefaultCstmApplVerID",
    "type": "String",
    "description": "The default custom application version ID that is the default for a session."
  },
  {
    "tag": "1409",
    "name": "SessionStatus",
    "type": "int",
    "description": "Status of a FIX session",
    "enum": [
      {
        "value": "0",
        "symbolicName": "SessionActive",
        "description": "Session active"
      },
      {
        "value": "1",
        "symbolicName": "SessionPasswordChanged",
        "description": "Session password changed"
      },
      {
        "value": "2",
        "symbolicName": "SessionPasswordDueToExpire",
        "description": "Session password due to expire"
      },
      {
        "value": "3",
        "symbolicName": "NewSessionPasswordDoesNotComplyWithPolicy",
        "description": "New session password does not comply with policy"
      },
      {
        "value": "4",
        "symbolicName": "SessionLogoutComplete",
        "description": "Session logout complete"
      },
      {
        "value": "5",
        "symbolicName": "InvalidUsernameOrPassword",
        "description": "Invalid username or password"
      },
      {
        "value": "6",
        "symbolicName": "AccountLocked",
        "description": "Account locked"
      },
      {
        "value": "7",
        "symbolicName": "LogonsAreNotAllowedAtThisTime",
        "description": "Logons are not allowed at this time"
      },
      {
        "value": "8",
        "symbolicName": "PasswordExpired",
        "description": "Password expired"
      }
    ]
  },
  {
    "tag": "1410",
    "name": "DefaultVerIndicator",
    "type": "Boolean",
    "description": ""
  },
  {
    "tag": "809",
    "name": "NoUsernames",
    "type": "NumInGroup",
    "description": "Number of Usernames to which this this response is directed"
  },
  {
    "tag": "1367",
    "name": "LegAllocSettlCurrency",
    "type": "Currency",
    "description": "Identifies settlement currency for the leg level allocation."
  },
  {
    "tag": "1361",
    "name": "TotNoFills",
    "type": "int",
    "description": "Total number of fill entries across all messages. Should be the sum of all NoFills(1362) in each message that has repeating list of fill entries related to the same ExecID(17). Used to support fragmentation."
  },
  {
    "tag": "1362",
    "name": "NoFills",
    "type": "NumInGroup",
    "description": ""
  },
  {
    "tag": "1363",
    "name": "FillExecID",
    "type": "String",
    "description": "Refer to ExecID(17). Used when multiple partial fills are reported in single Execution Report. ExecID and FillExecID should not overlap,"
  },
  {
    "tag": "1364",
    "name": "FillPx",
    "type": "Price",
    "description": "Price of Fill. Refer to LastPx(31)."
  },
  {
    "tag": "1365",
    "name": "FillQty",
    "type": "Qty",
    "description": "Quantity of Fill. Refer to LastQty(32)."
  },
  {
    "tag": "1366",
    "name": "LegAllocID",
    "type": "String",
    "description": "The AllocID(70) of an individual leg of a multileg order."
  },
  {
    "tag": "1368",
    "name": "TradSesEvent",
    "type": "int",
    "description": "Identifies an event related to a TradSesStatus(340). An event occurs and is gone, it is not a state that applies for a period of time.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "TradingResumes",
        "description": "Trading resumes (after Halt)"
      },
      {
        "value": "1",
        "symbolicName": "ChangeOfTradingSession",
        "description": "Change of Trading Session"
      },
      {
        "value": "2",
        "symbolicName": "ChangeOfTradingSubsession",
        "description": "Change of Trading Subsession"
      },
      {
        "value": "3",
        "symbolicName": "ChangeOfTradingStatus",
        "description": "Change of Trading Status"
      }
    ]
  },
  {
    "tag": "1369",
    "name": "MassActionReportID",
    "type": "String",
    "description": "Unique identifier of Order Mass Cancel Report or Order Mass Action Report message as assigned by sell-side (broker, exchange, ECN)"
  },
  {
    "tag": "1370",
    "name": "NoNotAffectedOrders",
    "type": "NumInGroup",
    "description": "Number of not affected orders in the repeating group of order ids."
  },
  {
    "tag": "1371",
    "name": "NotAffectedOrderID",
    "type": "String",
    "description": "OrderID(37) of an order not affected by a mass cancel request."
  },
  {
    "tag": "1372",
    "name": "NotAffOrigClOrdID",
    "type": "String",
    "description": "ClOrdID(11) of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests."
  },
  {
    "tag": "1373",
    "name": "MassActionType",
    "type": "int",
    "description": "Specifies the type of action requested",
    "enum": [
      {
        "value": "1",
        "symbolicName": "SuspendOrders",
        "description": "Suspend orders"
      },
      {
        "value": "2",
        "symbolicName": "ReleaseOrdersFromSuspension",
        "description": "Release orders from suspension"
      },
      {
        "value": "3",
        "symbolicName": "CancelOrders",
        "description": "Cancel orders"
      }
    ]
  },
  {
    "tag": "1374",
    "name": "MassActionScope",
    "type": "int",
    "description": "Specifies scope of Order Mass Action Request.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AllOrdersForASecurity",
        "description": "All orders for a security"
      },
      {
        "value": "2",
        "symbolicName": "AllOrdersForAnUnderlyingSecurity",
        "description": "All orders for an underlying security"
      },
      {
        "value": "3",
        "symbolicName": "AllOrdersForAProduct",
        "description": "All orders for a Product"
      },
      {
        "value": "4",
        "symbolicName": "AllOrdersForACFICode",
        "description": "All orders for a CFICode"
      },
      {
        "value": "5",
        "symbolicName": "AllOrdersForASecurityType",
        "description": "All orders for a SecurityType"
      },
      {
        "value": "6",
        "symbolicName": "AllOrdersForATradingSession",
        "description": "All orders for a trading session"
      },
      {
        "value": "7",
        "symbolicName": "AllOrders",
        "description": "All orders"
      },
      {
        "value": "8",
        "symbolicName": "AllOrdersForAMarket",
        "description": "All orders for a Market"
      },
      {
        "value": "9",
        "symbolicName": "AllOrdersForAMarketSegment",
        "description": "All orders for a Market Segment"
      },
      {
        "value": "10",
        "symbolicName": "AllOrdersForASecurityGroup",
        "description": "All orders for a Security Group"
      },
      {
        "value": "11",
        "symbolicName": "CancelForSecurityIssuer",
        "description": "Cancel for Security Issuer"
      },
      {
        "value": "12",
        "symbolicName": "CancelForIssuerOfUnderlyingSecurity",
        "description": "Cancel for Issuer of Underlying Security"
      }
    ]
  },
  {
    "tag": "1375",
    "name": "MassActionResponse",
    "type": "int",
    "description": "Specifies the action taken by counterparty order handling system as a result of the action type indicated in MassActionType of the Order Mass Action Request.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Rejected",
        "description": "Rejected - See MassActionRejectReason(1376)"
      },
      {
        "value": "1",
        "symbolicName": "Accepted",
        "description": "Accepted"
      }
    ]
  },
  {
    "tag": "1376",
    "name": "MassActionRejectReason",
    "type": "int",
    "description": "Reason Order Mass Action Request was rejected",
    "enum": [
      {
        "value": "0",
        "symbolicName": "MassActionNotSupported",
        "description": "Mass Action Not Supported"
      },
      {
        "value": "1",
        "symbolicName": "InvalidOrUnknownSecurity",
        "description": "Invalid or unknown security"
      },
      {
        "value": "2",
        "symbolicName": "InvalidOrUnknownUnderlyingSecurity",
        "description": "Invalid or unknown underlying security"
      },
      {
        "value": "3",
        "symbolicName": "InvalidOrUnknownProduct",
        "description": "Invalid or unknown Product"
      },
      {
        "value": "4",
        "symbolicName": "InvalidOrUnknownCFICode",
        "description": "Invalid or unknown CFICode"
      },
      {
        "value": "5",
        "symbolicName": "InvalidOrUnknownSecurityType",
        "description": "Invalid or unknown SecurityType"
      },
      {
        "value": "6",
        "symbolicName": "InvalidOrUnknownTradingSession",
        "description": "Invalid or unknown trading session"
      },
      {
        "value": "7",
        "symbolicName": "InvalidOrUnknownMarket",
        "description": "Invalid or unknown Market"
      },
      {
        "value": "8",
        "symbolicName": "InvalidOrUnknownMarketSegment",
        "description": "Invalid or unknown Market Segment"
      },
      {
        "value": "9",
        "symbolicName": "InvalidOrUnknownSecurityGroup",
        "description": "Invalid or unknown Security Group"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "10",
        "symbolicName": "InvalidOrUnknownSecurityIssuer",
        "description": "Invalid or unknown Security Issuer"
      },
      {
        "value": "11",
        "symbolicName": "InvalidOrUnknownIssuerOfUnderlyingSecurity",
        "description": "Invalid or unknown Issuer of Underlying Security"
      }
    ]
  },
  {
    "tag": "1377",
    "name": "MultilegModel",
    "type": "int",
    "description": "Specifies the type of multileg order.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "PredefinedMultilegSecurity",
        "description": "Predefined Multileg Security"
      },
      {
        "value": "1",
        "symbolicName": "UserDefinedMultilegSecurity",
        "description": "User-defined Multleg Security"
      },
      {
        "value": "2",
        "symbolicName": "UserDefined",
        "description": "User-defined, Non-Securitized, Multileg"
      }
    ]
  },
  {
    "tag": "1378",
    "name": "MultilegPriceMethod",
    "type": "int",
    "description": "Code to represent how the multileg price is to be interpreted when applied to the legs.\n(See Volume : \"Glossary\" for further value definitions)",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NetPrice",
        "description": "Net Price"
      },
      {
        "value": "1",
        "symbolicName": "ReversedNetPrice",
        "description": "Reversed Net Price"
      },
      {
        "value": "2",
        "symbolicName": "YieldDifference",
        "description": "Yield Difference"
      },
      {
        "value": "3",
        "symbolicName": "Individual",
        "description": "Individual"
      },
      {
        "value": "4",
        "symbolicName": "ContractWeightedAveragePrice",
        "description": "Contract Weighted Average Price"
      },
      {
        "value": "5",
        "symbolicName": "MultipliedPrice",
        "description": "Multiplied Price"
      }
    ]
  },
  {
    "tag": "1379",
    "name": "LegVolatility",
    "type": "float",
    "description": "Specifies the volatility of an instrument leg."
  },
  {
    "tag": "1380",
    "name": "DividendYield",
    "type": "Percentage",
    "description": "The continuously-compounded annualized dividend yield of the underlying(s) of an option. Used as a parameter to theoretical option pricing models."
  },
  {
    "tag": "1381",
    "name": "LegDividendYield",
    "type": "Percentage",
    "description": "Refer to definition for DividendYield(1380)."
  },
  {
    "tag": "1382",
    "name": "CurrencyRatio",
    "type": "float",
    "description": "Specifies the currency ratio between the currency used for a multileg price and the currency used by the outright book defined by the leg. Example: Multileg quoted in EUR, outright leg in USD and 1 EUR = 0,7 USD then CurrencyRatio = 0.7"
  },
  {
    "tag": "1383",
    "name": "LegCurrencyRatio",
    "type": "float",
    "description": "Specifies the currency ratio between the currency used for a multileg price and the currency used by the outright book defined by the leg. Example: Multileg quoted in EUR, outright leg in USD and 1 EUR = 0,7 USD then LegCurrencyRatio = 0.7"
  },
  {
    "tag": "1384",
    "name": "LegExecInst",
    "type": "MultipleCharValue",
    "description": "Refer to ExecInst(18)\nSame values as ExecInst(18)"
  },
  {
    "tag": "1385",
    "name": "ContingencyType",
    "type": "int",
    "description": "Defines the type of contingency.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "OneCancelsTheOther",
        "description": "One Cancels the Other (OCO)"
      },
      {
        "value": "2",
        "symbolicName": "OneTriggersTheOther",
        "description": "One Triggers the Other (OTO)"
      },
      {
        "value": "3",
        "symbolicName": "OneUpdatesTheOtherAbsolute",
        "description": "One Updates the Other (OUO) - Absolute Quantity Reduction"
      },
      {
        "value": "4",
        "symbolicName": "OneUpdatesTheOtherProportional",
        "description": "One Updates the Other (OUO) - Proportional Quantity Reduction"
      }
    ]
  },
  {
    "tag": "1386",
    "name": "ListRejectReason",
    "type": "int",
    "description": "Identifies the reason for rejection of a New Order List message. Note that OrdRejReason(103) is used if the rejection is based on properties of an individual order part of the List.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "BrokerCredit",
        "description": "Broker / Exchange option"
      },
      {
        "value": "2",
        "symbolicName": "ExchangeClosed",
        "description": "Exchange closed"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too late to enter"
      },
      {
        "value": "5",
        "symbolicName": "UnknownOrder",
        "description": "Unknown order"
      },
      {
        "value": "6",
        "symbolicName": "DuplicateOrder",
        "description": "Duplicate Order (e.g. dupe ClOrdID)"
      },
      {
        "value": "11",
        "symbolicName": "UnsupportedOrderCharacteristic",
        "description": "Unsupported order characteristic"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "1387",
    "name": "NoTrdRepIndicators",
    "type": "NumInGroup",
    "description": "Number of trade reporting indicators"
  },
  {
    "tag": "1388",
    "name": "TrdRepPartyRole",
    "type": "int",
    "description": "Identifies the type of party for trade reporting. Same values as PartyRole(452)."
  },
  {
    "tag": "1389",
    "name": "TrdRepIndicator",
    "type": "Boolean",
    "description": "Specifies whether the trade should be reported (or not) to parties of the provided TrdRepPartyRole(1388). Used to override standard reporting behavior by the receiver of the trade report and thereby complements the PublTrdIndicator( tag1390)."
  },
  {
    "tag": "1390",
    "name": "TradePublishIndicator",
    "type": "int",
    "description": "Indicates if a trade should be reported via a market reporting service. The indicator governs all reporting services of the recipient. Replaces PublishTrdIndicator(852).",
    "enum": [
      {
        "value": "0",
        "symbolicName": "DoNotPublishTrade",
        "description": "Do Not Publish Trade"
      },
      {
        "value": "1",
        "symbolicName": "PublishTrade",
        "description": "Publish Trade"
      },
      {
        "value": "2",
        "symbolicName": "DeferredPublication",
        "description": "Deferred Publication"
      }
    ]
  },
  {
    "tag": "1346",
    "name": "ApplReqID",
    "type": "String",
    "description": "Unique identifier for request"
  },
  {
    "tag": "1347",
    "name": "ApplReqType",
    "type": "int",
    "description": "Type of Application Message Request being made.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Retransmission",
        "description": "Retransmission of application messages for the specified Applications"
      },
      {
        "value": "1",
        "symbolicName": "Subscription",
        "description": "Subscription to the specified Applications"
      },
      {
        "value": "2",
        "symbolicName": "RequestLastSeqNum",
        "description": "Request for the last ApplLastSeqNum published for the specified Applications"
      },
      {
        "value": "3",
        "symbolicName": "RequestApplications",
        "description": "Request valid set of Applications"
      },
      {
        "value": "4",
        "symbolicName": "Unsubscribe",
        "description": "Unsubscribe to the specified Applications"
      },
      {
        "value": "5",
        "symbolicName": "CancelRetransmission",
        "description": "Cancel retransmission"
      },
      {
        "value": "6",
        "symbolicName": "CancelRetransmissionUnsubscribe",
        "description": "Cancel retransmission and unsubscribe to the specified applications"
      }
    ]
  },
  {
    "tag": "1348",
    "name": "ApplResponseType",
    "type": "int",
    "description": "Used to indicate the type of acknowledgement being sent.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "RequestSuccessfullyProcessed",
        "description": "Request successfully processed"
      },
      {
        "value": "1",
        "symbolicName": "ApplicationDoesNotExist",
        "description": "Application does not exist"
      },
      {
        "value": "2",
        "symbolicName": "MessagesNotAvailable",
        "description": "Messages not available"
      }
    ]
  },
  {
    "tag": "1349",
    "name": "ApplTotalMessageCount",
    "type": "int",
    "description": "Total number of messages included in transmission."
  },
  {
    "tag": "1350",
    "name": "ApplLastSeqNum",
    "type": "SeqNum",
    "description": "Application sequence number of last message in transmission"
  },
  {
    "tag": "1351",
    "name": "NoApplIDs",
    "type": "NumInGroup",
    "description": "Specifies number of application id occurrences"
  },
  {
    "tag": "1352",
    "name": "ApplResendFlag",
    "type": "Boolean",
    "description": "Used to indicate that a message is being sent in response to an Application Message Request. It is possible for both ApplResendFlag and PossDupFlag to be set on the same message if the Sender's cache size is greater than zero and the message is being resent due to a session level resend request"
  },
  {
    "tag": "1353",
    "name": "ApplResponseID",
    "type": "String",
    "description": "Identifier for the Applicaton Message Request Ack"
  },
  {
    "tag": "1354",
    "name": "ApplResponseError",
    "type": "int",
    "description": "Used to return an error code or text associated with a response to an Application Request.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ApplicationDoesNotExist",
        "description": "Application does not exist"
      },
      {
        "value": "1",
        "symbolicName": "MessagesRequestedAreNotAvailable",
        "description": "Messages requested are not available"
      },
      {
        "value": "2",
        "symbolicName": "UserNotAuthorizedForApplication",
        "description": "User not authorized for application"
      }
    ]
  },
  {
    "tag": "1355",
    "name": "RefApplID",
    "type": "String",
    "description": "Reference to the unique application identifier which corresponds to ApplID(1180) from the Application Sequence Group component"
  },
  {
    "tag": "1356",
    "name": "ApplReportID",
    "type": "String",
    "description": "Identifier for the Application Sequence Reset"
  },
  {
    "tag": "1357",
    "name": "RefApplLastSeqNum",
    "type": "SeqNum",
    "description": "Application sequence number of last message in transmission."
  },
  {
    "tag": "1399",
    "name": "ApplNewSeqNum",
    "type": "SeqNum",
    "description": "Used to specify a new application sequence number."
  },
  {
    "tag": "1426",
    "name": "ApplReportType",
    "type": "int",
    "description": "Type of report",
    "enum": [
      {
        "value": "0",
        "symbolicName": "ApplSeqNumReset",
        "description": "Reset ApplSeqNum to new value specified in ApplNewSeqNum(1399)"
      },
      {
        "value": "1",
        "symbolicName": "LastMessageSent",
        "description": "Reports that the last message has been sent for the ApplIDs Refer to RefApplLastSeqNum(1357) for the application sequence number of the last message."
      },
      {
        "value": "2",
        "symbolicName": "ApplicationAlive",
        "description": "Heartbeat message indicating that Application identified by RefApplID(1355) is still alive. Refer to RefApplLastSeqNum(1357) for the application sequence number of the previous message."
      },
      {
        "value": "3",
        "symbolicName": "ResendComplete",
        "description": "Application message re-send completed."
      }
    ]
  },
  {
    "tag": "1411",
    "name": "Nested4PartySubIDType",
    "type": "int",
    "description": "Refer to definition of PartySubIDType(803)"
  },
  {
    "tag": "1412",
    "name": "Nested4PartySubID",
    "type": "String",
    "description": "Refer to definition of PartySubID(523)"
  },
  {
    "tag": "1413",
    "name": "NoNested4PartySubIDs",
    "type": "NumInGroup",
    "description": "Refer to definition of NoPartySubIDs(802)"
  },
  {
    "tag": "1414",
    "name": "NoNested4PartyIDs",
    "type": "NumInGroup",
    "description": "Refer to definition of NoPartyIDs(453)"
  },
  {
    "tag": "1415",
    "name": "Nested4PartyID",
    "type": "String",
    "description": "Refer to definition of PartyID(448)"
  },
  {
    "tag": "1416",
    "name": "Nested4PartyIDSource",
    "type": "char",
    "description": "Refer to definition of PartyIDSource(447)"
  },
  {
    "tag": "1417",
    "name": "Nested4PartyRole",
    "type": "int",
    "description": "Refer to definition of PartyRole(452)"
  },
  {
    "tag": "1418",
    "name": "LegLastQty",
    "type": "Qty",
    "description": "Fill quantity for the leg instrument"
  },
  {
    "tag": "1427",
    "name": "SideExecID",
    "type": "String",
    "description": "When reporting trades, used to reference the identifier of the execution (ExecID) being reported if different ExecIDs were assigned to each side of the trade."
  },
  {
    "tag": "1428",
    "name": "OrderDelay",
    "type": "int",
    "description": "Time lapsed from order entry until match, based on the unit of time specified in OrderDelayUnit.  Default is seconds if OrderDelayUnit is not specified. Value = 0, indicates the aggressor (the initiating side of the trade)."
  },
  {
    "tag": "1429",
    "name": "OrderDelayUnit",
    "type": "int",
    "description": "Time unit in which the OrderDelay(1428) is expressed",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Seconds",
        "description": "Seconds (default if not specified)"
      },
      {
        "value": "1",
        "symbolicName": "TenthsOfASecond",
        "description": "Tenths of a second"
      },
      {
        "value": "2",
        "symbolicName": "HundredthsOfASecond",
        "description": "Hundredths of a second"
      },
      {
        "value": "3",
        "symbolicName": "Milliseconds",
        "description": "milliseconds"
      },
      {
        "value": "4",
        "symbolicName": "Microseconds",
        "description": "microseconds"
      },
      {
        "value": "5",
        "symbolicName": "Nanoseconds",
        "description": "nanoseconds"
      },
      {
        "value": "10",
        "symbolicName": "Minutes",
        "description": "minutes"
      },
      {
        "value": "11",
        "symbolicName": "Hours",
        "description": "hours"
      },
      {
        "value": "12",
        "symbolicName": "Days",
        "description": "days"
      },
      {
        "value": "13",
        "symbolicName": "Weeks",
        "description": "weeks"
      },
      {
        "value": "14",
        "symbolicName": "Months",
        "description": "months"
      },
      {
        "value": "15",
        "symbolicName": "Years",
        "description": "years"
      }
    ]
  },
  {
    "tag": "1430",
    "name": "VenueType",
    "type": "char",
    "description": "Identifies the type of venue where a trade was executed",
    "enum": [
      {
        "value": "E",
        "symbolicName": "Electronic",
        "description": "Electronic"
      },
      {
        "value": "P",
        "symbolicName": "Pit",
        "description": "Pit"
      },
      {
        "value": "X",
        "symbolicName": "ExPit",
        "description": "Ex-Pit"
      }
    ]
  },
  {
    "tag": "1431",
    "name": "RefOrdIDReason",
    "type": "int",
    "description": "The reason for updating the RefOrdID",
    "enum": [
      {
        "value": "0",
        "symbolicName": "GTCFromPreviousDay",
        "description": "GTC from previous day"
      },
      {
        "value": "1",
        "symbolicName": "PartialFillRemaining",
        "description": "Partial Fill Remaining"
      },
      {
        "value": "2",
        "symbolicName": "OrderChanged",
        "description": "Order Changed"
      }
    ]
  },
  {
    "tag": "1432",
    "name": "OrigCustOrderCapacity",
    "type": "int",
    "description": "The customer capacity for this trade at the time of the order/execution.\nPrimarily used by futures exchanges to indicate the CTICode (customer type indicator) as required by the US CFTC (Commodity Futures Trading Commission).",
    "enum": [
      {
        "value": "1",
        "symbolicName": "MemberTradingForTheirOwnAccount",
        "description": "Member trading for their own account"
      },
      {
        "value": "2",
        "symbolicName": "ClearingFirmTradingForItsProprietaryAccount",
        "description": "Clearing Firm trading for its proprietary account"
      },
      {
        "value": "3",
        "symbolicName": "MemberTradingForAnotherMember",
        "description": "Member trading for another member"
      },
      {
        "value": "4",
        "symbolicName": "AllOther",
        "description": "All other"
      }
    ]
  },
  {
    "tag": "1433",
    "name": "RefApplReqID",
    "type": "String",
    "description": "Used to reference a previously submitted ApplReqID (1346) from within a subsequent ApplicationMessageRequest(MsgType=BW)"
  },
  {
    "tag": "1434",
    "name": "ModelType",
    "type": "int",
    "description": "Type of pricing model used",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UtilityProvidedStandardModel",
        "description": "Utility provided standard model"
      },
      {
        "value": "1",
        "symbolicName": "ProprietaryModel",
        "description": "Proprietary (user supplied) model"
      }
    ]
  },
  {
    "tag": "1435",
    "name": "ContractMultiplierUnit",
    "type": "int",
    "description": "Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit ContractMultiplier(tag 231) is expressed in.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Shares",
        "description": "Shares"
      },
      {
        "value": "1",
        "symbolicName": "Hours",
        "description": "Hours"
      },
      {
        "value": "2",
        "symbolicName": "Days",
        "description": "Days"
      }
    ]
  },
  {
    "tag": "1436",
    "name": "LegContractMultiplierUnit",
    "type": "int",
    "description": "\"Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit LegContractMultiplier(tag 614) is expressed in."
  },
  {
    "tag": "1437",
    "name": "UnderlyingContractMultiplierUnit",
    "type": "int",
    "description": "Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit UndlyContractMultiplier(tag 436) is expressed in."
  },
  {
    "tag": "1438",
    "name": "DerivativeContractMultiplierUnit",
    "type": "int",
    "description": "Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit DerivativeContractMultiplier(tag 1266)is expressed in."
  },
  {
    "tag": "1439",
    "name": "FlowScheduleType",
    "type": "int",
    "description": "The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as \"Western Peak\".",
    "enum": [
      {
        "value": "0",
        "symbolicName": "NERCEasternOffPeak",
        "description": "NERC Eastern Off-Peak"
      },
      {
        "value": "1",
        "symbolicName": "NERCWesternOffPeak",
        "description": "NERC Western Off-Peak"
      },
      {
        "value": "2",
        "symbolicName": "NERCCalendarAllDaysInMonth",
        "description": "NERC Calendar-All Days in month"
      },
      {
        "value": "3",
        "symbolicName": "NERCEasternPeak",
        "description": "NERC Eastern Peak"
      },
      {
        "value": "4",
        "symbolicName": "NERCWesternPeak",
        "description": "NERC Western Peak"
      }
    ]
  },
  {
    "tag": "1440",
    "name": "LegFlowScheduleType",
    "type": "int",
    "description": "The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as \"Western Peak\"."
  },
  {
    "tag": "1441",
    "name": "UnderlyingFlowScheduleType",
    "type": "int",
    "description": "The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as \"Western Peak\"."
  },
  {
    "tag": "1442",
    "name": "DerivativeFlowScheduleType",
    "type": "int",
    "description": "The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as \"Western Peak\"."
  },
  {
    "tag": "1443",
    "name": "FillLiquidityInd",
    "type": "int",
    "description": "Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled"
  },
  {
    "tag": "1444",
    "name": "SideLiquidityInd",
    "type": "int",
    "description": "Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled."
  },
  {
    "tag": "1445",
    "name": "NoRateSources",
    "type": "NumInGroup",
    "description": "Number of rate sources being specified."
  },
  {
    "tag": "1446",
    "name": "RateSource",
    "type": "int",
    "description": "Identifies the source of rate information.\nFor FX, the reference source to be used for the FX spot rate.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Bloomberg",
        "description": "Bloomberg"
      },
      {
        "value": "1",
        "symbolicName": "Reuters",
        "description": "Reuters"
      },
      {
        "value": "2",
        "symbolicName": "Telerate",
        "description": "Telerate"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "1447",
    "name": "RateSourceType",
    "type": "int",
    "description": "Indicates whether the rate source specified is a primary or secondary source.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Primary",
        "description": "Primary"
      },
      {
        "value": "1",
        "symbolicName": "Secondary",
        "description": "Secondary"
      }
    ]
  },
  {
    "tag": "1448",
    "name": "ReferencePage",
    "type": "String",
    "description": "Identifies the reference \"page\" from the rate source.\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate."
  },
  {
    "tag": "1449",
    "name": "RestructuringType",
    "type": "String",
    "description": "A category of CDS credit even in which the underlying bond experiences a restructuring.\nUsed to define a CDS instrument.",
    "enum": [
      {
        "value": "FR",
        "symbolicName": "FullRestructuring",
        "description": "Full Restructuring"
      },
      {
        "value": "MR",
        "symbolicName": "ModifiedRestructuring",
        "description": "Modified Restructuring"
      },
      {
        "value": "MM",
        "symbolicName": "ModifiedModRestructuring",
        "description": "Modified Mod Restructuring"
      },
      {
        "value": "XR",
        "symbolicName": "NoRestructuringSpecified",
        "description": "No Restructuring specified"
      }
    ]
  },
  {
    "tag": "1450",
    "name": "Seniority",
    "type": "String",
    "description": "Specifies which issue (underlying bond) will receive payment priority in the event of a default.\nUsed to define a CDS instrument.",
    "enum": [
      {
        "value": "SD",
        "symbolicName": "SeniorSecured",
        "description": "Senior Secured"
      },
      {
        "value": "SR",
        "symbolicName": "Senior",
        "description": "Senior"
      },
      {
        "value": "SB",
        "symbolicName": "Subordinated",
        "description": "Subordinated"
      }
    ]
  },
  {
    "tag": "1451",
    "name": "NotionalPercentageOutstanding",
    "type": "Percentage",
    "description": "Indicates the notional percentage of the deal that is still outstanding based on the remaining components of the index.\nUsed to calculate the true value of a CDS trade or position."
  },
  {
    "tag": "1452",
    "name": "OriginalNotionalPercentageOutstanding",
    "type": "Percentage",
    "description": "Used to reflect the Original value prior to the application of a credit event. See NotionalPercentageOutstanding(1451)."
  },
  {
    "tag": "1453",
    "name": "UnderlyingRestructuringType",
    "type": "String",
    "description": "See RestructuringType(1449)"
  },
  {
    "tag": "1454",
    "name": "UnderlyingSeniority",
    "type": "String",
    "description": "See Seniority(1450)"
  },
  {
    "tag": "1455",
    "name": "UnderlyingNotionalPercentageOutstanding",
    "type": "Percentage",
    "description": "See NotionalPercentageOutstanding(1451)"
  },
  {
    "tag": "1456",
    "name": "UnderlyingOriginalNotionalPercentageOutstanding",
    "type": "Percentage",
    "description": "See OriginalNotionalPercentageOutstanding(1452)"
  },
  {
    "tag": "1457",
    "name": "AttachmentPoint",
    "type": "Percentage",
    "description": "Lower bound percentage of the loss that the tranche can endure."
  },
  {
    "tag": "1458",
    "name": "DetachmentPoint",
    "type": "Percentage",
    "description": "Upper bound percentage of the loss the tranche can endure."
  },
  {
    "tag": "1459",
    "name": "UnderlyingAttachmentPoint",
    "type": "Percentage",
    "description": "See AttachmentPoint(1457)."
  },
  {
    "tag": "1460",
    "name": "UnderlyingDetachmentPoint",
    "type": "Percentage",
    "description": "See DetachmentPoint(1458)."
  },
  {
    "tag": "1461",
    "name": "NoTargetPartyIDs",
    "type": "NumInGroup",
    "description": "Identifies the number of target parties identified in a mass action."
  },
  {
    "tag": "1462",
    "name": "TargetPartyID",
    "type": "String",
    "description": "PartyID value within an target party repeating group."
  },
  {
    "tag": "1463",
    "name": "TargetPartyIDSource",
    "type": "char",
    "description": "PartyIDSource value within an target party repeating group.\nSame values as PartyIDSource (447)"
  },
  {
    "tag": "1464",
    "name": "TargetPartyRole",
    "type": "int",
    "description": "PartyRole value within an target party repeating group.\nSame values as PartyRole (452)"
  },
  {
    "tag": "1465",
    "name": "SecurityListID",
    "type": "String",
    "description": "Specifies an identifier for a Security List"
  },
  {
    "tag": "1466",
    "name": "SecurityListRefID",
    "type": "String",
    "description": "Specifies a reference from one Security List to another. Used to support a hierarchy of Security Lists."
  },
  {
    "tag": "1467",
    "name": "SecurityListDesc",
    "type": "String",
    "description": "Specifies a description or name of a Security List."
  },
  {
    "tag": "1468",
    "name": "EncodedSecurityListDescLen",
    "type": "Length",
    "description": "Byte length of encoded (non-ASCII characters) EncodedSecurityListDesc (tbd) field."
  },
  {
    "tag": "1469",
    "name": "EncodedSecurityListDesc",
    "type": "data",
    "description": "Encoded (non-ASCII characters) representation of the SecurityListDesc (1467) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the SecurityListDesc field."
  },
  {
    "tag": "1470",
    "name": "SecurityListType",
    "type": "int",
    "description": "Specifies a type of Security List.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "IndustryClassification",
        "description": "Industry Classification"
      },
      {
        "value": "2",
        "symbolicName": "TradingList",
        "description": "Trading List"
      },
      {
        "value": "3",
        "symbolicName": "Market",
        "description": "Market / Market Segment List"
      },
      {
        "value": "4",
        "symbolicName": "NewspaperList",
        "description": "Newspaper List"
      }
    ]
  },
  {
    "tag": "1471",
    "name": "SecurityListTypeSource",
    "type": "int",
    "description": "Specifies a specific source for a SecurityListType. Relevant when a certain type can be provided from various sources.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "ICB",
        "description": "ICB (Industry Classification Benchmark) published by Dow Jones and FTSE - www.icbenchmark.com"
      },
      {
        "value": "2",
        "symbolicName": "NAICS",
        "description": "NAICS (North American Industry Classification System). Replaced SIC (Standard Industry Classification) www.census.gov/naics or  www.naics.com."
      },
      {
        "value": "3",
        "symbolicName": "GICS",
        "description": "GICS (Global Industry Classification Standard) published by Standards & Poor"
      }
    ]
  },
  {
    "tag": "1472",
    "name": "NewsID",
    "type": "String",
    "description": "Unique identifier for a News message"
  },
  {
    "tag": "1473",
    "name": "NewsCategory",
    "type": "int",
    "description": "Category of news mesage.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "CompanyNews",
        "description": "Company News"
      },
      {
        "value": "1",
        "symbolicName": "MarketplaceNews",
        "description": "Marketplace News"
      },
      {
        "value": "2",
        "symbolicName": "FinancialMarketNews",
        "description": "Financial Market News"
      },
      {
        "value": "3",
        "symbolicName": "TechnicalNews",
        "description": "Technical News"
      },
      {
        "value": "99",
        "symbolicName": "OtherNews",
        "description": "Other News"
      }
    ]
  },
  {
    "tag": "1474",
    "name": "LanguageCode",
    "type": "Language",
    "description": "The national language in which the news item is provided."
  },
  {
    "tag": "1475",
    "name": "NoNewsRefIDs",
    "type": "NumInGroup",
    "description": "Number of News reference items"
  },
  {
    "tag": "1476",
    "name": "NewsRefID",
    "type": "String",
    "description": "Reference to another News message identified by NewsID(1474)."
  },
  {
    "tag": "1477",
    "name": "NewsRefType",
    "type": "int",
    "description": "Type of reference to another News Message item. Defines if the referenced news item is a replacement, is in a different language, or is complimentary.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Replacement",
        "description": "Replacement"
      },
      {
        "value": "1",
        "symbolicName": "OtherLanguage",
        "description": "Other Language"
      },
      {
        "value": "2",
        "symbolicName": "Complimentary",
        "description": "Complimentary"
      }
    ]
  },
  {
    "tag": "1478",
    "name": "StrikePriceDeterminationMethod",
    "type": "int",
    "description": "Specifies how the strike price is determined at the point of option exercise. The strike may be fixed throughout the life of the option, set at expiration to the value of the underlying, set to the average value of the underlying , or set to the optimal value of the underlying.  \nConditionally, required if value is other than \"fixed\".",
    "enum": [
      {
        "value": "1",
        "symbolicName": "FixedStrike",
        "description": "Fixed Strike"
      },
      {
        "value": "2",
        "symbolicName": "StrikeSetAtExpiration",
        "description": "Strike set at expiration to underlying or other value (lookback floating)"
      },
      {
        "value": "3",
        "symbolicName": "StrikeSetToAverageAcrossLife",
        "description": "Strike set to average of underlying settlement price across the life of the option"
      },
      {
        "value": "4",
        "symbolicName": "StrikeSetToOptimalValue",
        "description": "Strike set to optimal value"
      }
    ]
  },
  {
    "tag": "1479",
    "name": "StrikePriceBoundaryMethod",
    "type": "int",
    "description": "Specifies the boundary condition to be used for the strike price relative to the underlying price at the point of option exercise.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "LessThan",
        "description": "Less than underlying price is in-the-money (ITM)"
      },
      {
        "value": "2",
        "symbolicName": "LessThanOrEqual",
        "description": "Less than or equal to the underlying price is in-the-money(ITM)"
      },
      {
        "value": "3",
        "symbolicName": "Equal",
        "description": "Equal to the underlying price is in-the-money(ITM)"
      },
      {
        "value": "4",
        "symbolicName": "GreaterThanOrEqual",
        "description": "Greater than or equal to underlying price is in-the-money(ITM)"
      },
      {
        "value": "5",
        "symbolicName": "GreaterThan",
        "description": "Greater than underlying is in-the-money(ITM)"
      }
    ]
  },
  {
    "tag": "1480",
    "name": "StrikePriceBoundaryPrecision",
    "type": "Percentage",
    "description": "Used in combination with StrikePriceBoundaryMethod to specify the percentage of the strike price in relation to the  underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls."
  },
  {
    "tag": "1481",
    "name": "UnderlyingPriceDeterminationMethod",
    "type": "int",
    "description": "Specifies how the underlying price is determined at the point of option exercise. The underlying price may be set to the current settlement price, set to a special reference, set to the optimal value of the underlying during the defined period (\"Look-back\") or set to the average value of the underlying during the defined period (\"Asian option\").",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Regular",
        "description": "Regular"
      },
      {
        "value": "2",
        "symbolicName": "SpecialReference",
        "description": "Special reference"
      },
      {
        "value": "3",
        "symbolicName": "OptimalValue",
        "description": "Optimal value (Lookback)"
      },
      {
        "value": "4",
        "symbolicName": "AverageValue",
        "description": "Average value (Asian option)"
      }
    ]
  },
  {
    "tag": "1482",
    "name": "OptPayoutType",
    "type": "int",
    "description": "Indicates the type of payout that will result from an in-the-money option.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Vanilla",
        "description": "Vanilla"
      },
      {
        "value": "2",
        "symbolicName": "Capped",
        "description": "Capped"
      },
      {
        "value": "3",
        "symbolicName": "Binary",
        "description": "Binary"
      }
    ]
  },
  {
    "tag": "1483",
    "name": "NoComplexEvents",
    "type": "NumInGroup",
    "description": "Number of complex event occurrences."
  },
  {
    "tag": "1484",
    "name": "ComplexEventType",
    "type": "int",
    "description": "Identifies the type of complex event.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Capped",
        "description": "Capped"
      },
      {
        "value": "2",
        "symbolicName": "Trigger",
        "description": "Trigger"
      },
      {
        "value": "3",
        "symbolicName": "KnockInUp",
        "description": "Knock-in up"
      },
      {
        "value": "4",
        "symbolicName": "KockInDown",
        "description": "Kock-in down"
      },
      {
        "value": "5",
        "symbolicName": "KnockOutUp",
        "description": "Knock-out up"
      },
      {
        "value": "6",
        "symbolicName": "KnockOutDown",
        "description": "Knock-out down"
      },
      {
        "value": "7",
        "symbolicName": "Underlying",
        "description": "Underlying"
      },
      {
        "value": "8",
        "symbolicName": "ResetBarrier",
        "description": "Reset Barrier"
      },
      {
        "value": "9",
        "symbolicName": "RollingBarrier",
        "description": "Rolling Barrier"
      }
    ]
  },
  {
    "tag": "1485",
    "name": "ComplexOptPayoutAmount",
    "type": "Amt",
    "description": "Cash amount indicating the pay out associated with an event. For binary options this is a fixed amount."
  },
  {
    "tag": "1486",
    "name": "ComplexEventPrice",
    "type": "Price",
    "description": "Specifies the price at which the complex event takes effect. Impact of the event price is determined by the ComplexEventType(1484)."
  },
  {
    "tag": "1487",
    "name": "ComplexEventPriceBoundaryMethod",
    "type": "int",
    "description": "Specifies the boundary condition to be used for the event price relative to the underlying price at the point the complex event outcome takes effect as determined by the ComplexEventPriceTimeType.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "LessThanComplexEventPrice",
        "description": "Less than ComplexEventPrice(1486)"
      },
      {
        "value": "2",
        "symbolicName": "LessThanOrEqualToComplexEventPrice",
        "description": "Less than or equal to ComplexEventPrice(1486)"
      },
      {
        "value": "3",
        "symbolicName": "EqualToComplexEventPrice",
        "description": "Equal to ComplexEventPrice(1486)"
      },
      {
        "value": "4",
        "symbolicName": "GreaterThanOrEqualToComplexEventPrice",
        "description": "Greater than or equal to ComplexEventPrice(1486)"
      },
      {
        "value": "5",
        "symbolicName": "GreaterThanComplexEventPrice",
        "description": "Greater than ComplexEventPrice(1486)"
      }
    ]
  },
  {
    "tag": "1488",
    "name": "ComplexEventPriceBoundaryPrecision",
    "type": "Percentage",
    "description": "Used in combination with ComplexEventPriceBoundaryMethod to specify the percentage of the strike price in relation to the  underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls."
  },
  {
    "tag": "1489",
    "name": "ComplexEventPriceTimeType",
    "type": "int",
    "description": "Specifies when the complex event outcome takes effect. The outcome of a complex event is a payout or barrier action as specified by the ComplexEventType.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Expiration",
        "description": "Expiration"
      },
      {
        "value": "2",
        "symbolicName": "Immediate",
        "description": "Immediate (At Any Time)"
      },
      {
        "value": "3",
        "symbolicName": "SpecifiedDate",
        "description": "Specified Date/Time"
      }
    ]
  },
  {
    "tag": "1490",
    "name": "ComplexEventCondition",
    "type": "int",
    "description": "Specifies the condition between complex events when more than one event is specified.  \nMultiple barrier events would use an \"or\" condition since only one can be effective at a given time. A set of digital range events would use an \"and\" condition since both conditions must be in effect for a payout to result.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "And",
        "description": "And"
      },
      {
        "value": "2",
        "symbolicName": "Or",
        "description": "Or"
      }
    ]
  },
  {
    "tag": "1491",
    "name": "NoComplexEventDates",
    "type": "NumInGroup",
    "description": "Number of complex event date occurrences for a given complex event."
  },
  {
    "tag": "1492",
    "name": "ComplexEventStartDate",
    "type": "UTCTimestamp",
    "description": "Specifies the start date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options\nComplexEventStartDate must always be less than or equal to ComplexEventEndDate."
  },
  {
    "tag": "1493",
    "name": "ComplexEventEndDate",
    "type": "UTCTimestamp",
    "description": "Specifies the end date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options\nComplexEventEndDate must always be greater than or equal to ComplexEventStartDate."
  },
  {
    "tag": "1494",
    "name": "NoComplexEventTimes",
    "type": "NumInGroup",
    "description": "Number of complex event time occurrences for a given complex event date\nThe default in case of an absence of time fields is 00:00:00-23:59:59."
  },
  {
    "tag": "1495",
    "name": "ComplexEventStartTime",
    "type": "UTCTimeOnly",
    "description": "Specifies the start time of the time range on which a complex event date is effective. \nComplexEventStartTime must always be less than or equal to ComplexEventEndTime."
  },
  {
    "tag": "1496",
    "name": "ComplexEventEndTime",
    "type": "UTCTimeOnly",
    "description": "Specifies the end time of the time range on which a complex event date is effective.\nComplexEventEndTime must always be greater than or equal to ComplexEventStartTime."
  },
  {
    "tag": "1497",
    "name": "StreamAsgnReqID",
    "type": "String",
    "description": "Unique identifier for the stream assignment request provided by the requester."
  },
  {
    "tag": "1498",
    "name": "StreamAsgnReqType",
    "type": "int",
    "description": "Type of stream assignment request.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "StreamAssignmentForNewCustomer",
        "description": "Stream assignment for new customer(s)"
      },
      {
        "value": "2",
        "symbolicName": "StreamAssignmentForExistingCustomer",
        "description": "Stream assignment for existing customer(s)"
      }
    ]
  },
  {
    "tag": "1499",
    "name": "NoAsgnReqs",
    "type": "NumInGroup",
    "description": "Number of assignment requests."
  },
  {
    "tag": "1500",
    "name": "MDStreamID",
    "type": "String",
    "description": "The identifier or name of the price stream."
  },
  {
    "tag": "1501",
    "name": "StreamAsgnRptID",
    "type": "String",
    "description": "Unique identifier of the stream assignment report provided by the respondent."
  },
  {
    "tag": "1502",
    "name": "StreamAsgnRejReason",
    "type": "int",
    "description": "Reason code for stream assignment request reject.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnknownClient",
        "description": "Unknown client"
      },
      {
        "value": "1",
        "symbolicName": "ExceedsMaximumSize",
        "description": "Exceeds maximum size"
      },
      {
        "value": "2",
        "symbolicName": "UnknownOrInvalidCurrencyPair",
        "description": "Unknown or Invalid currency pair"
      },
      {
        "value": "3",
        "symbolicName": "NoAvailableStream",
        "description": "No available stream"
      },
      {
        "value": "99",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "1503",
    "name": "StreamAsgnAckType",
    "type": "int",
    "description": "Type of acknowledgement.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "AssignmentAccepted",
        "description": "Assignment Accepted"
      },
      {
        "value": "1",
        "symbolicName": "AssignmentRejected",
        "description": "Assignment Rejected"
      }
    ]
  },
  {
    "tag": "1617",
    "name": "StreamAsgnType",
    "type": "int",
    "description": "The type of assignment being affected in the Stream Assignment Report.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Assignment",
        "description": "Assignment"
      },
      {
        "value": "2",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "3",
        "symbolicName": "Terminate",
        "description": "Terminate/Unassign"
      }
    ]
  },
  {
    "tag": "1504",
    "name": "RelSymTransactTime",
    "type": "UTCTimestamp",
    "description": "See TransactTime(60)"
  }
]
